(function () {
    'use strict';

    angular
            .module('imnApp', [
                'ngStorage',
                'ngCookies',
                'ngAnimate',
                'ui.bootstrap',
                'ui.router',
                'ui.select',
                'tmh.dynamicLocale',
                'angular-loading-bar',
                'pascalprecht.translate',
                'ngScrollbars',
                'uiSwitch',
                'nvd3',
                'toastr',
                'rzModule',
                'angularUtils.directives.dirPagination'
            ])
            .run(run);

    run.$inject = ['stateHandler', 'translationHandler', '$templateCache'];

    function run(stateHandler, translationHandler, $templateCache) {

        var templateName = 'bootstrap/match.tpl.html';
        var template = $templateCache.get(templateName);
        template = template.replace('caret pull-right', 'icon icon-arrow-select');
        $templateCache.put(templateName, template);

        stateHandler.initialize();
        translationHandler.initialize();

    }
})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .directive('invalidIf', invalidIf);

    function invalidIf() {
        var directive = {
            require: 'ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, elm, attrs, ctrl) {
            var argsObject = scope.$eval(attrs.invalidIf);

            if (!angular.isObject(argsObject)) {
                argsObject = {invalidIf: attrs.invalidIf};
            }

            for (var validationKey in argsObject) {
                scope.$watch(argsObject[validationKey], function (newVal) {
                    ctrl.$setValidity(validationKey, !newVal);
                });
            }
        }
    }
})();
(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('UserData', UserData);

    UserData.$inject = ['UserService', 'Authenticate'];

    function UserData(UserService, Authenticate) {

        return {
            id: null,
            groupName: null,
            isAuthenticated: false,
            sessionExpired: false,
            getCurrentUser: getCurrentUser,
            reset: reset,
            expireSession: expireSession,
            permissions: null
        };

        function getCurrentUser() {

            var _this = this;

            return UserService.getCurrentUser().then(successUser);

            function successUser(data) {
                _this.groupName = data.groupName;
                _this.id = data.id;
                _this.isAuthenticated = true;
                _this.sessionExpired = false;
                _this.permissions = data.permissions;

                // stores permissions in a factory for sharing.
                Authenticate.setPermissions(_this.permissions);

                return data;
            }

        }

        function reset() {
            this.id = null;
            this.groupName = null;
            this.isAuthenticated = false;
            this.sessionExpired = false;
        }

        function expireSession() {
            this.sessionExpired = true;
        }

    }
})();
(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('RequestService', RequestService);

    RequestService.$inject = ['$q', '$rootScope', '$injector', 'API_CONFIG', '$location'];

    function RequestService($q, $rootScope, $injector, API_CONFIG, $location) {

        var service = {
            baseUrl: baseUrl,
            apiUrl: apiUrl,
            cancelRequests: cancelRequests
        };

        return service;

        // Return the base url of the api concatenated with the path passed as parameter
        function baseUrl(path) {
            var api = $location.protocol() + "://" + $location.host() + API_CONFIG.apiPort + '/' + path;
            return api;
        }

        // Return the api url concatenated with the path and method passed as parameters
        function apiUrl(path, method) {
            if (path.charAt(path.length - 1) == '/') {
                path = path.slice(0, path.length - 1);
            }
            return baseUrl('api/' + path + (method ? '/' + method : ''));
        }

        // Cancel the pending requests
        function cancelRequests(urls) {
            var $http = $injector.get('$http');
            $http.pendingRequests.forEach(function (request) {
                // If urls param is passed, should only cancel the request that is in the list
                var cancel = urls ? isCancelable(urls, request) : true;
                // Only cancel GET requests that have the cancel property set to true
                if (cancel && request.cancel) {
                    // Resolve the promise to cancel the request
                    request.cancel.resolve();
                    // Set the canceled flag to true, so canceled errors cannot be triggered again
                    request.canceled = true;
                }
            });
        }

        // Check if the request url is in the urls parameter
        function isCancelable(path, request) {
            if (angular.isArray(path)) {
                // If the path is an array check if url is equal to one of its elements
                for (var i = 0; i < path.length; i++) {
                    if (request.url == apiUrl(path[i])) {
                        return true;
                    }
                }
            } else {
                // If the path is not an array, check if the url contains it
                if (request.url.indexOf(path) > -1) {
                    return true;
                }
            }
            return false;
        }

    }
})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .directive('loaderSection', loaderSection);

    function loaderSection() {

        var loaderTemplate = '' +
                '<div class="loader-container">' +
                '<div class="md-preloader">' +
                '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75">' +
                '<circle cx="37.5" cy="37.5" r="33.5" stroke-width="8"/>' +
                '</svg>' +
                '</div>' +
                '</div>';

        return {
            restrict: 'A',
            link: function (scope, element, attr) {
                scope.$watch(attr.loaderSection, function (value) {
                    if (value) {
                        var loader = angular.element(loaderTemplate);
                        loader.addClass(attr.loaderTheme || 'light')
                        element.append(loader);
                    } else {
                        element.find('.loader-container').remove();
                    }
                })
            }
        }
    }

})();
(function () {
    'use strict';

    angular
            .module('imnApp')
            .directive('stopPropagation', stopPropagation);

    function stopPropagation() {
        return {
            restrict: 'A',
            link: function (scope, element, attr) {
                var eventToStop = attr.stopPropagation || 'click';
                element.on(eventToStop, function (event) {
                    if (!attr.disablePropagation || attr.disablePropagation == 'false') {
                        event.stopPropagation();
                    }
                });
            }
        }
    }

})();
(function () {
    'use strict';

    angular
            .module('imnApp')
            .directive('eventClickout', eventClickout);

    function eventClickout() {
        return {
            restrict: 'A',
            scope: {
                eventAction: '&'
            },
            link: function (scope, element, attr) {
                angular.element(document).on('click', function (evt) {
                    if (!angular.element(evt.target).closest(element).length) {
                        scope.$apply(scope.eventAction);
                    }
                });
            }
        }
    }

})();
(function () {
    'use strict';

    angular
            .module('imnApp')
            .directive('cancelEvent', cancelEvent);

    function cancelEvent() {
        return {
            restrict: 'A',
            link: function (scope, element, attr) {
                element.on(attr.cancelEvent, function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                });
            }
        }
    }

})();
(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('ModalConstructor', ModalConstructor);

    ModalConstructor.$inject = ['$uibModal', '$uibModalStack', 'RequestService'];

    function ModalConstructor($uibModal, $uibModalStack, RequestService) {

        return {
            open: open,
            isOpen: isOpen,
            closeAll: closeAll
        };

        function open(modal) {
            if (modal) {
                var modalInstance = $uibModal.open(modal);
                if (!modal.avoidCancel) {
                    modalInstance.closed.then(function () {
                        RequestService.cancelRequests('/api/')
                    });
                }
                return modalInstance;
            } else {
                throw 'parameter modal cannot be undefined!';
            }
        }

        function isOpen() {
            return !!$uibModalStack.getTop();
        }

        function closeAll() {
            if (isOpen) {
                $uibModalStack.dismissAll();
            }
        }

    }
})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['LoginService'];

    function NavbarController(LoginService) {
        var vm = this;

        vm.logout = function () {
            LoginService.logout();
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function () {
                return $translate.use();
            }, function (selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .factory('modalWaitInterceptor', modalWaitInterceptor);

    modalWaitInterceptor.$inject = ['$q', '$injector'];

    function modalWaitInterceptor($q, $injector) {
        var service = {
            request: request,
            response: response,
            responseError: responseError
        };

        return service;

        function request(config) {
            var path = config.url;
            var method = config.method;
            var modalIsActive = true;
            constructorMethod(method, path, modalIsActive);
            return config;
        }

        function response(response) {
            var path = response.config.url;
            var method = response.config.method;
            var modalIsActive = false;
            constructorMethod(method, path, modalIsActive);
            return response;
        }

        function responseError(rejection) {
            var path = rejection.config.url;
            var method = rejection.config.method;
            var modalIsActive = false;
            constructorMethod(method, path, modalIsActive);
            return $q.reject(rejection);
        }

        // Method handler
        function getInstanceAlertModal() {
            return $injector.get('AlertModalService');
        }

        function constructorMethod(method, path, modalIsActive) {
            var dataValidCall = validCalls(method, path);
            if (dataValidCall.isValidCall) {
                var AlertModalConstructor = getInstanceAlertModal();
                AlertModalConstructor.wait(modalIsActive, dataValidCall.key);
                return;
            }
            return;
        }
        // Method to verify api accept
        function validCalls(method, path) {
            var dataValidCall = {
                isValidCall: false
            };

            if (method == 'PUT' || method == 'POST') {
                // List of api to be intercepted
                var calls = [
                    {method: 'PUT', api: 'setdatetime', key: 'setDateTime', hasPermission: 'oltSetDateTime'},
                    {method: 'PUT', api: 'loadfiles', key: 'loadFiles', hasPermission: 'oltLoadFiles'}
                ];

                calls.forEach(function (item) {
                    var authenticate = $injector.get('Authenticate');
                    if (path.indexOf(item.api) > -1) {
                        var permission = item.hasPermission || item.hasNotPermission;
                        var hasPermission = authenticate.hasPermission(permission);
                        if (item.hasNotPermission) {
                            hasPermission = !hasPermission
                        }

                        if (hasPermission) {
                            dataValidCall = {
                                isValidCall: true,
                                key: item.key
                            };
                        }
                    }
                }, this);
            }
            return dataValidCall;
        }

    }
})();
(function () {
    'use strict';

    angular
            .module('imnApp')
            .factory('globalErrorInterceptor', globalErrorInterceptor);

    globalErrorInterceptor.$inject = ['$q', '$injector', 'RequestService'];

    function globalErrorInterceptor($q, $injector, RequestService) {

        var service = {
            request: request,
            responseError: responseError
        };

        return service;

        // Configure the action to execute when a request starts
        function request(config) {
            // If the request is of type get and the request doesn't have a timeout configured yet
            if ((config.method == 'GET' || config.cancelable) && !config.timeout && !config.ignoreCancel) {
                // Create a deferred object
                var deferred = $q.defer();
                // Add the promise of the deferred to the timeout property of the request
                config.timeout = deferred.promise;
                // Add a reference to the deferred to the request to resolve the promise when needed
                config.cancel = deferred;
            }
            // Return the modified config to the promise chain
            return config;
        }

        // Configure the action to execute when the request finishes with error
        function responseError(response) {

            // List of errors to be intercepted
            var errors = ['500', '-1', '412', '403'];
            // Error status
            var status = response.status.toString();
            // Services injected through $injector to avoid circular dependency
            var $state = $injector.get('$state');
            var UserData = $injector.get('UserData');

            // If any of the errors on the list occur
            if (errors.indexOf(status) > -1) {

                // If the user is trying to access any private page while not authenticated, send to login
                if (!UserData.isAuthenticated && $state.current.name != 'login') {

                    $state.go('login');

                } else {

                    // Inject the AlertModalService and calls it's error method to open the error modal
                    if (!(response.data && response.data.ignore)) {
                        var AlertModalService = $injector.get('AlertModalService');
                        AlertModalService.error(response, 'default', 'global');
                    }

                    // Add the intercepted property to the response, so intercepted errors cannot be triggered again
                    response.intercepted = true;

                }

            }

            // Return a rejection to the promise chain with the modified response as reason
            return $q.reject(response);

        }

    }
})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .factory('dataLoadedInterceptor', dataLoadedInterceptor);

    dataLoadedInterceptor.$inject = ['$q', 'OltData'];

    function dataLoadedInterceptor($q, OltData) {
        var service = {
            request: request,
            requestError: requestError,
            response: response,
            responseError: responseError
        };

        return service;

        function request(config) {
            var method = config.method;
            if (method == 'GET') {
                OltData.dataLoaded = false;
            }
            return config;
        }

        function requestError(rejection) {
            var method = rejection.config.method;
            if (method == 'GET') {
                OltData.dataLoaded = false;
            }
            return $q.reject(rejection);
        }

        function response(response) {
            var method = response.config.method;
            if (method == 'GET') {
                OltData.dataLoaded = true;
            }
            return response;
        }

        function responseError(rejection) {
            var method = rejection.config.method;
            if (method == 'GET') {
                OltData.dataLoaded = false;
            }
            return $q.reject(rejection);
        }
    }
})();
(function () {
    'use strict';

    angular
            .module('imnApp')
            .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$q', '$injector'];

    function authExpiredInterceptor($q, $injector) {

        var service = {
            response: response,
            responseError: responseError
        };

        return service;

        function response(response) {
            // If we have a request and the session was expired we receive a response with status 200 and the following message:
            // "This session has been expired (possibly due to multiple concurrent logins being attempted as the same user)."
            if (response.status === 200
                    && response.data == 'This session has been expired (possibly due to multiple concurrent logins being attempted as the same user).') {

                var UserData = $injector.get('UserData');
                UserData.expireSession();

                doLogout();

                response.data = '';
            }
            return response;
        }

        function responseError(response) {
            // If we have an unauthorized request we redirect to the login page
            // Don't do this check on the account API to avoid infinite loop
            if (response.status === 401 && angular.isDefined(response.data.path) && response.data.path.indexOf('/users/current') < 0) {
                doLogout();
                if (response.data.path.indexOf('/login') < 0) {
                    // Add the intercepted property to the response, so intercepted errors cannot be triggered again
                    response.intercepted = true;
                }
            }
            return $q.reject(response);
        }

        function doLogout() {
            var $state = $injector.get('$state');
            if ($state.current.name != 'login') {

                var LoginService = $injector.get('LoginService');
                var RequestService = $injector.get('RequestService');

                var modalInstance = LoginService.alertNotificationModalConstructor('sessionExpired');
                modalInstance.closed.then(LoginService.logout);

                RequestService.cancelRequests();

            }
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function () {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if (angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null) {
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precedence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$transitions', '$translate', 'LanguageService', 'translationHandler', 'UserData', 'RequestService', 'ModalConstructor'];

    function stateHandler($rootScope, $transitions, $translate, LanguageService, translationHandler, UserData, RequestService, ModalConstructor) {

        return {
            initialize: initialize
        };

        function initialize() {
            // Actions to execute when state change starts
            $transitions.onStart({
                to: function (state) {
                    return state.parent.name == 'app.private';
                }
            }, function (transition) {

                var $state = transition.router.stateService;

                // When loading the page for the first time try to get the
                // current user data to check if the user is already authenticated
                if (!UserData.isAuthenticated) {
                    // Get the current user data and authenticate
                    return UserData.getCurrentUser().catch(errorAuthentication);
                }

                // Function to execute when authentication fails
                function errorAuthentication() {
                    return $state.target('login');
                }

            });

            $transitions.onStart({to: 'login'}, function (transition) {

                var $state = transition.router.stateService;

                // Check if the user is already authenticated
                if (UserData.isAuthenticated) {
                    return false;
                } else if (!transition.redirectedFrom()) {
                    // Get the current user data and authenticate
                    return UserData.getCurrentUser().then(successAuthentication).catch(errorAuthentication);
                }

                // Function to execute when the user is authenticated
                function successAuthentication() {
                    // If it's on login page, redirect to olt
                    return $state.target('olt');
                }

                // Function to execute when authentication fails
                function errorAuthentication() {
                    return true;
                }

            });

            // Actions to execute when state change finishes
            $transitions.onSuccess({to: '*'}, function (transition) {

                var pageTitle = transition.to().data.pageTitle;

                // Set the page title key to the one configured in state or use default one
                var titleKey = pageTitle || 'global.title';
                translationHandler.updateTitle(titleKey);

                // Cancel the pending requests on the "request to be canceled" list
                RequestService.cancelRequests();
                $rootScope.$broadcast('requestsCanceled');

                // Update the language
                LanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });

                // Close all modals
                ModalConstructor.closeAll();

            });
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .filter('patternMeter', patternMeter);

    patternMeter.$inject = ['$filter'];
    function patternMeter($filter) {
        return patterMeterFilter;

        function patterMeterFilter(distance) {

            if (!distance) {
                return '-- m';
            }

            var distanceValid = parseInt(distance);
            var result = null;

            if (distanceValid > 0) {
                result = parseFloat(distance).toFixed(1) + ' km';
            } else {
                result = (distance * 1000).toFixed(1) + ' m';
            }
            result = result.replace('.', ',');

            return result;
        }
    }
})();



(function () {
    'use strict';

    angular
            .module('imnApp')
            .filter('patternDate', patternDate);

    patternDate.$inject = ['$locale', '$filter'];
    function patternDate($locale, $filter) {
        return patterDateFilter;

        function patterDateFilter(input) {
            var langSelected = $locale.id;
            var pattern = null;

            if (langSelected == 'en') {
                pattern = 'MM/dd/yyyy';
            } else {
                pattern = 'dd/MM/yyyy';
            }
            var _date = $filter('date')(new Date(input), pattern);
            return _date;
        }
    }
})();



(function () {
    'use strict';
 
    angular.module('imnApp').directive("fileread", [function () {
        return {
            scope: {
                fileread: "="
            },
            link: function (scope, element, attributes) {
                element.bind("change", function (changeEvent) {
                    var reader = new FileReader();
                    reader.onload = function (loadEvent) {
                        scope.$apply(function () {
                            scope.fileread = changeEvent.target.files[0];
                        });
                    }
                    reader.readAsDataURL(changeEvent.target.files[0]);
                });
            }
        }
    }]);
 
 })();
(function () {
    'use strict';

    angular
            .module('imnApp')
            .directive('fileChange', fileChange);

    fileChange.$inject = ['$parse'];

    function fileChange() {
        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                fileChange: '&'
            },
            link: function link(scope, element, attrs, ctrl) {
                element.on('change', onChange);

                scope.$on('destroy', function () {
                    element.off('change', onChange);
                });

                function onChange() {
                    attrs.multiple ? ctrl.$setViewValue(element[0].files) : ctrl.$setViewValue(element[0].files[0]);
                    scope.$apply(function () {
                        scope.fileChange();
                        element.val('');
                    });
                }
            }
        };
    }
})();
(function () {
    'use strict';

    angular
            .module('imnApp')
            .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "pt-br"');
                $cookies.putObject(name, 'pt-br');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .factory('customErrorHandler', customErrorHandler);

    function customErrorHandler() {
        return function (translationId) {
            return '';
        };
    }
})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('pt-br');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');
        $translateProvider.useMissingTranslationHandler('customErrorHandler');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .config(toastConfig);

    toastConfig.$inject = ['toastrConfig', '$provide', '$injector'];

    function toastConfig(toastrConfig, $provide, $injector) {

        angular.extend(toastrConfig, {
            autoDismiss: false,
            containerId: 'toast-container',
            maxOpened: 1,
            newestOnTop: true,
            positionClass: 'toast-bottom-right',
            preventDuplicates: false,
            preventOpenDuplicates: false,
            target: 'body',
            closeButton: true,
            tapToDismiss: false,
            timeOut: 2000,
            extendedTimeOut: 1000
        });

        $provide.decorator('toastr', toastrDecorator);

        toastrDecorator.$inject = ['$delegate', '$parse', '$state'];

        function toastrDecorator($delegate, $parse, $state) {

            $delegate.alarm = function (config) {
                var message = '<span class="toast-alarm-equipment">' + config.equipment + '</span>';
                message += '<span class="toast-alarm-interface">' + config.interface + '</span>';
                message += '<span class="toast-alarm-type">' + config.type + '</span>';
                openToast(message, config.title, config.severity);
            }

            $delegate.rogue = function (message) {
                openToast(message, null, 'rogue');
            }

            function openToast(message, title, type) {
                $delegate.warning(message, title, {
                    iconClass: 'toast-alarm-' + type,
                    closeHtml: '<button><span class="icon icon-close-toast"></span></button>',
                    allowHtml: true,
                    onTap: function () {
                        $state.go('alarms')
                    }
                });
            }

            return $delegate;

        }
    }
})();
(function () {
    'use strict';

    angular
            .module('imnApp')
            .config(scrollbarConfig);

    scrollbarConfig.$inject = ['ScrollBarsProvider'];

    function scrollbarConfig(ScrollBarsProvider) {
        ScrollBarsProvider.defaults = {
            theme: 'minimal-dark',
            axis: 'y'
        };
    }
})();
(function () {
    'use strict';

    angular
            .module('imnApp')
            .config(loadingBarConfig);

    loadingBarConfig.$inject = ['cfpLoadingBarProvider', '$provide'];

    function loadingBarConfig(cfpLoadingBarProvider, $provide) {

        cfpLoadingBarProvider.includeBar = false;

        cfpLoadingBarProvider.spinnerTemplate = '' +
                '<div class="loader-container dark">' +
                '<div class="md-preloader">' +
                '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75">' +
                '<circle cx="37.5" cy="37.5" r="33.5" stroke-width="8"/>' +
                '</svg>' +
                '</div>' +
                '</div>';

    }
})();
(function () {
    'use strict';

    angular
            .module('imnApp')
            .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider'];

    function httpConfig($urlRouterProvider, $httpProvider) {

        $urlRouterProvider.otherwise('/login');

        $httpProvider.defaults.withCredentials = true;
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('globalErrorInterceptor');
        $httpProvider.interceptors.push('dataLoadedInterceptor');
        $httpProvider.interceptors.push('modalWaitInterceptor');
    }
})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .config(datepickerConfig);

    datepickerConfig.$inject = ['$provide'];

    function datepickerConfig($provide) {

        $provide.decorator('uibDatepickerDirective', datepickerDecorator);

        datepickerDecorator.$inject = ['$delegate'];

        function datepickerDecorator($delegate) {
            angular.forEach($delegate, function (directive) {

                var originalCompile = directive.compile;
                var originalLink = directive.link;

                directive.templateUrl = 'app/shared/datepicker/datepicker.html';

                if (originalCompile) {
                    directive.compile = function () {
                        return function (scope) {
                            scope.$on('$localeChangeSuccess', function () {
                                scope.datepicker.refreshView();
                            });
                            originalLink.apply(this, arguments);
                        };
                    }
                }

            });
            return $delegate;
        }
    }
})();
(function () {
    'use strict';

    angular
            .module('imnApp')
            .directive('autoScroll', autoScroll);

    autoScroll.$inject = ['$timeout'];

    function autoScroll($timeout) {
        return {
            restrict: 'A',
            scope: {autoScroll: '='},
            link: function (scope, element, attr) {

                scope.$watch('autoScroll', scroll);

                function scroll(value) {
                    if (value === true) {
                        var pre = angular.element(element);
                        pre.scrollTop(pre[0].scrollHeight);
                    }
                }

            }
        }
    }

})();
(function () {
    'use strict';

    angular
            .module('imnApp')
            .directive('autoFocus', autoFocus);

    autoFocus.$inject = ['$timeout'];

    function autoFocus($timeout) {
        return {
            restrict: 'A',
            scope: {autoFocus: '='},
            link: function (scope, element, attr) {

                scope.$watch('autoFocus', focus);

                function focus(value) {
                    if (value === true) {
                        element[0].focus();
                    }
                }

            }
        }
    }

})();
(function () {
    'use strict';

    angular
            .module('imnApp')
            .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Authenticate'];

    function hasAuthority(Authenticate) {
        var directive = {
            restrict: 'A',
            replace: true,
            link: linkFunc,
            eventHandle: eventHandle,
            eventCommom: eventCommom
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var value = attrs.hasAuthority.trim();
            var isBehavior = false;
            var notPermissionFlag = value[0] === '!';

            if (notPermissionFlag) {
                value = value.slice(1).trim();
            }
            // verify if behavior exists
            if (attrs.hasBehavior) {
                isBehavior = true;
            }

            function toggleVisibilityBasedOnPermission() {
                var hasPermission = false;
                if (value.indexOf('||') != -1) {
                    var authArray = value.split('||');

                    for (var i = 0; i < authArray.length; i++) {
                        hasPermission = Authenticate.hasPermission(authArray[i]);
                        if (hasPermission) {
                            break;
                        }
                    }
                } else {
                    hasPermission = Authenticate.hasPermission(value);
                }

                // Normal flow
                // variable:hasPermission == true and notPermissionFlag == null
                // ex:userList
                // 1-the user must have permission, releasing a ui that requires valid permission
                //
                // Alternative flow
                // variable:notPermissionFlag == true and hasPermission == false
                // ex:!userList
                // 2-if the directive call contains the character "!"
                // ui will be displayed because it is an alternative ui when the user does
                // not have permission but should view a standard ui.

                if (hasPermission && !notPermissionFlag || !hasPermission && notPermissionFlag) {
                    element.show();
                } else {
                    if (isBehavior) {
                        eventHandle(attrs.hasBehavior, element, attrs, scope);
                    } else {
                        element.hide();
                        eventHandle('hide', element);
                    }
                }
            }
            toggleVisibilityBasedOnPermission();
            // can be used in the future for real-time permission
            // listening for changes to load permissions
            // scope.$on('permissionsChanged', toggleVisibilityBasedOnPermission);
        }

        function eventHandle(event, element) {
            // options for the disable event
            switch (event) {
                case 'hide':
                    element.remove();
                    break;
                case 'disable-default':
                    eventCommom(element);
                    element.addClass('auth-disabled disabled-default');
                    break;
                case 'disable-link':
                    eventCommom(element);
                    element.addClass('auth-disabled disabled-link');
                    break;
                case 'disable-button':
                    eventCommom(element);
                    element.addClass('auth-disabled disabled-button');
                    break;
                case 'disable-button-float':
                    eventCommom(element);
                    element.addClass('auth-disabled disabled-button-float');
                    break;
            }
        }

        function eventCommom(element) {
            // removes the method name in the ng-click attribute
            element.attr('ng-click', '');
            // adds disable attribute for element
            element.prop('disabled', true);
            // disables click event for element
            angular.element(element).off('click');
        }
    }
})();

(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('Authenticate', Authenticate);

    Authenticate.$inject = ['$rootScope'];

    function Authenticate($rootScope) {
        var _methods = {
            setPermissions: setPermissions,
            getPermissions: getPermissions,
            hasPermission: hasPermission,
            permissionList: null
        };

        return _methods;

        function setPermissions(permissions) {
            _methods.permissionList = permissions;
            // can be used in the future for real-time permission
            // $rootScope.$broadcast('permissionsChanged');
        }

        function getPermissions() {
            return _methods.permissionList;
        }

        function hasPermission(permission) {
            permission = permission.trim();

            if (_methods.getPermissions().indexOf(permission) !== -1) {
                return true;
            } else {
                return false;
            }
        }

    }
})();
(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('AlertModalService', AlertModalService);

    AlertModalService.$inject = ['$injector', 'ModalConstructor'];

    function AlertModalService($injector, ModalConstructor) {

        return {
            error: error,
            errorWithMsg: errorWithMsg,
            success: success,
            wait: wait,
            warning: warning
        };

        // Configure and open the error modal
        function error(response, action, state) {

            // Error modal controller dependencies injection
            errorController.$inject = ['$uibModalInstance', '$translate'];

            // Check if the error was already called from the interceptor or cancelled
            if (!response.intercepted && !(response.config && response.config.canceled)) {

                // Configure the error modal
                var errorTemplate = {
                    windowTemplateUrl: 'app/shared/alert/alert-error-modal.html',
                    templateUrl: 'app/shared/alert/alert-error.html',
                    controller: errorController,
                    controllerAs: 'vmAlertError',
                    size: 'sm',
                    windowClass: 'modal-alert modal-error',
                    avoidCancel: true
                };

                // Open the error modal
                return ModalConstructor.open(errorTemplate);

            }

            // Error modal controller
            function errorController($uibModalInstance, $translate) {

                var status = response.status;
                var vm = this;
                vm.close = close;
                vm.detailCollapsed = true;
                vm.toggleDetail = toggleDetail;

                // If the response data has a property cause, concatenate to the status code
                // This is used to create keys for errors 412.1, 412.2, etc
                if (response.data && response.data.cause) {
                    // Cause 5 is the generic cause
                    if (response.data.cause.toString() === '5') {
                        status = response.data.message;
                    } else {
                        status += '.' + response.data.cause;
                    }
                }

                // Generate the translation key based on action, state and error status
                var modalMessage = state + 'Error.responseError.' + action + '.message.error.' + status;

                // Try to translate the key
                $translate(modalMessage).then(translationExists).catch(translationError);

                // If the key exists sets the view message to it
                function translationExists() {
                    vm.modalMessage = modalMessage;

                    // Check for errors with status 412
                    if (response.status.toString() === '412') {
                        // Sets the device name in the error message
                        vm.equipmentName = response.data.name || response.config.data.name;

                        // If the cause is 0 and there is a printout defines the error detail
                        if (response.data.cause.toString() === '0' && response.data.printout) {
                            var errorMessage = response.data.printout.replace(/\r/g, '\n');
                            var firstBreak = errorMessage.indexOf('\n');
                            vm.errorDetail = {
                                command: errorMessage.slice(0, firstBreak),
                                printout: errorMessage.slice(firstBreak, errorMessage.lastIndexOf('\n'))
                            };
                        }
                    }
                }

                // If the translation doesn't exists sets the view message to unknown error
                function translationError() {
                    vm.modalMessage = 'globalError.responseError.default.message.error.500';
                }

                // Close the modal
                function close() {
                    $uibModalInstance.dismiss('cancel');
                }

                // Toggle the error detail
                function toggleDetail() {
                    vm.detailCollapsed = !vm.detailCollapsed;
                    vm.modalSize = vm.detailCollapsed ? 'modal-sm' : 'modal-lg';
                }

            }

        }

        function errorWithMsg(msg) {
            errorWithMsgController.$inject = ['$uibModalInstance'];

            var errorWithMsgTemplate = {
                windowTemplateUrl: 'app/shared/alert/alert-error-modal.html',
                templateUrl: 'app/shared/alert/alert-error.html',
                controller: errorWithMsgController,
                controllerAs: 'vmAlertError',
                size: 'sm',
                windowClass: 'modal-alert modal-error',
                avoidCancel: true
            };

            function errorWithMsgController($uibModalInstance) {
                var vm = this;
                vm.close = close;

                vm.modalMessage = msg;

                function close() {
                    $uibModalInstance.dismiss('cancel');
                }
            }

            // Open the error modal
            return ModalConstructor.open(errorWithMsgTemplate);
        }

        // Configure and open the success modal
        // success ex: success('restart', true, 'olt')
        function success(action, isMultiple, state, dontCloseAll) {

            var UserData = $injector.get('UserData');

            if (!UserData.sessionExpired) {

                var alertType = isMultiple ? 'multiple' : 'single';

                successController.$inject = ['$uibModalInstance'];

                // Configure the success modal
                var successTemplate = {
                    templateUrl: 'app/shared/alert/alert-success.html',
                    controller: successController,
                    controllerAs: 'vmAlertSuccess',
                    size: 'md',
                    windowClass: 'modal-alert modal-success',
                    avoidCancel: true
                };

                // Open the success modal
                return ModalConstructor.open(successTemplate);

            }

            // Success modal controller
            function successController($uibModalInstance) {

                // Generate the translation key based on action and state
                this.modalMessage = state + 'Success.response.' + action + '.message.' + alertType;

                // Close the modal
                this.close = function () {
                    if (!dontCloseAll) {
                        ModalConstructor.closeAll();
                    } else {
                        $uibModalInstance.dismiss('cancel');
                    }
                }

                $uibModalInstance.result.finally(function () {
                    if (!dontCloseAll) {
                        ModalConstructor.closeAll();
                    }
                });
            }

        }

        // Configure and open the wait modal
        function wait(activity, action) {

            // Configure the wait modal
            var waitTemplate = {
                templateUrl: 'app/shared/alert/alert-wait.html',
                controller: waitController,
                controllerAs: 'vmAlertWait',
                size: 'sm',
                windowClass: 'modal-alert modal-wait',
                backdrop: 'static',
                backdropClass: 'backdrop-wait',
                keyboard: false
            };

            // Open the wait modal
            if (activity) {
                ModalConstructor.open(waitTemplate);
            } else {
                ModalConstructor.closeAll();
            }

            // Wait modal controller
            waitController.$inject = ['$uibModalInstance'];
            function waitController($uibModalInstance) {

                // Generate the translation key based on action
                this.modalMessage = 'globalWait.' + action + '.message';

                // Close the modal
                this.close = function () {
                    $uibModalInstance.dismiss('cancel');
                }

            }

        }

        // Configure and open the warning modal
        function warning(list, response, action, state, dontCloseAll) {

            // Configure the warning modal
            var warningTemplate = {
                templateUrl: 'app/shared/alert/alert-warning.html',
                controller: warningController,
                controllerAs: 'vmAlertWarning',
                size: 'sm',
                windowClass: 'modal-alert modal-warning',
                avoidCancel: true
            };

            // Store the original items list
            var originalList = angular.copy(list);

            warningController.$inject = ['$uibModalInstance', '$filter'];

            // Open the warning modal
            return ModalConstructor.open(warningTemplate);

            // Success modal controller
            function warningController($uibModalInstance, $filter) {

                // Generate the translation key based on action and state
                this.modalMessage = state + 'Warning.response.' + action + '.message.error.' + response.status;

                this.list = response.data.map(function (responseItem) {
                    if (!responseItem.name) {
                        return $filter('filter')(originalList, {id: responseItem.id}, true)[0].name;
                    }
                    return responseItem.name;
                }).join(', ');

                // Close the modal
                this.close = function () {
                    if (!dontCloseAll) {
                        ModalConstructor.closeAll();
                    } else {
                        $uibModalInstance.dismiss('cancel');
                    }
                }

                $uibModalInstance.result.finally(function () {
                    if (!dontCloseAll) {
                        ModalConstructor.closeAll();
                    }
                });
            }

        }

    }
})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('UserListController', UserListController);

    UserListController.$inject = ['$scope', '$rootScope', '$translate', '$sce', 'UserService', 'SystemConfigService', 'UserData'];

    function UserListController($scope, $rootScope, $translate, $sce, UserService, SystemConfigService, UserData) {
        var vm = this;
        vm.view = {};
        vm.view.tooltip = {
            systemConfig: '',
            editUser: '',
            deleteUser: ''
        };

        var modalInstance;

        vm.groupName = UserData.groupName;

        getTooltip();

        if (UserData.permissions.indexOf('userList') != -1) {
            UserService.getUserList().then(successList).catch(errorList);
        }
        var selectedUser = null;

        function getTooltip() {
            angular.forEach(vm.view.tooltip, translateTooltip);
        }

        var translateChangeListener = $rootScope.$on('$translateChangeSuccess', getTooltip);
        $rootScope.$on('$destroy', translateChangeListener);

        function translateTooltip(value, key, obj) {
            $translate('tooltip.' + key).then(function (translation) {
                vm.view.tooltip[key] = $sce.trustAsHtml(translation);
            });
        }

        vm.addUser = function () {
            UserService.addUserModalConstructor($scope);
        }

        vm.changePassword = function (id) {
            selectedUser = id;
            modalInstance = UserService.changePasswordModalConstructor(id, $scope);
        }

        vm.editUser = function (id) {
            selectedUser = id;
            UserService.editUserModalConstructor(id, $scope);
        }

        vm.deleteUser = function (user) {
            selectedUser = user.id;
            UserService.deleteUserModalConstructor(user, $scope);
        }

        vm.systemConfig = function () {
            SystemConfigService.systemConfigModalConstructor();
        }

        $scope.$on('userAddSuccess', successAdd);
        $scope.$on('userUpdateSuccess', successUpdate);
        $scope.$on('userEditCancel', function () {
            selectedUser = null;
        });
        $scope.$on('userDeleteSuccess', successDelete);
        $scope.$on('closeModalPassword', function () {
            modalInstance.dismiss('cancel')
        });

        function successList(data) {
            vm.userList = data;
        }

        function errorList(response) {
            UserService.errorModalConstructor(response, 'list');
        }

        function successDelete() {
            UserService.successModalConstructor('delete');
            vm.userList.forEach(function (item, index) {
                if (item.id == selectedUser) {
                    vm.userList.splice(index, 1);
                }
            });
            selectedUser = null;
        }

        function successAdd(event, addedUser) {
            vm.userList.push(addedUser);
        }

        function successUpdate(event, updatedUser) {
            UserService.successModalConstructor('save');
            vm.userList.forEach(function (user, index) {
                if (user.id == updatedUser.id) {
                    user.email = updatedUser.email;
                    user.groupId = updatedUser.groupId;
                    user.groupName = updatedUser.groupName;
                }
            });
        }
    }
})();
(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('UserDeleteController', UserDeleteController);

    UserDeleteController.$inject = ['$scope', '$uibModalInstance', 'UserService', 'userData'];

    function UserDeleteController($scope, $uibModalInstance, UserService, userData) {
        var vm = this;
        vm.requestRunning = false;

        vm.userData = {email: userData.email};

        vm.close = function () {
            if (!vm.requestRunning) {
                $scope.$emit('userEditCancel');
                $uibModalInstance.dismiss('cancel');
            }
        }

        vm.delete = function () {
            vm.requestRunning = true;
            UserService.deleteUser(userData.id).then(successDelete).catch(errorDelete);
        }

        function successDelete(data) {
            vm.requestRunning = false;
            $scope.$emit('userDeleteSuccess', data);
        }

        function errorDelete(response) {
            vm.requestRunning = false;
            UserService.errorModalConstructor(response, 'delete');
        }

    }
})();


(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('UserChangePasswordController', UserChangePasswordController);

    UserChangePasswordController.$inject = ['$scope', 'UserService', 'UserData'];

    function UserChangePasswordController($scope, UserService, UserData) {
        var vm = this;
        vm.requestRunning = false;

        vm.groupName = UserData.groupName;

        vm.close = function () {
            if (!vm.requestRunning) {
                $scope.$emit('closeModalPassword');
            }
        }

        vm.save = function () {
            if (vm.formChangePassword.$valid && !vm.requestRunning && comparePassword()) {
                vm.requestRunning = true;
                UserService.changePassword(vm.changePassword).then(cbSuccess).catch(cbError);
            }
            function cbSuccess() {
                vm.requestRunning = false;
                UserService.successModalConstructor('changePassword');
                clearForm();
                $scope.$emit('closeModalPassword');
            }
            function cbError(response) {
                vm.requestRunning = false;
                UserService.errorModalConstructor(response, 'changePassword');
            }
        }

        // private methods
        function initModelChangePassword() {
            vm.changePassword = {
                id: UserData.id,
                password: '',
                newPassword: '',
                confirmNewPassword: ''
            };
        }

        function clearForm() {
            vm.formChangePassword.$setPristine();
            initModelChangePassword();
        }

        function comparePassword() {
            return vm.changePassword.newPassword == vm.changePassword.confirmNewPassword;
        }

        function initialize() {
            initModelChangePassword();
        }
        initialize();

    }
})();
(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('UserAddController', UserAddController);

    UserAddController.$inject = ['$scope', '$filter', '$uibModalInstance', 'UserService', 'userId'];

    function UserAddController($scope, $filter, $uibModalInstance, UserService, userId) {
        var vm = this;
        vm.requestRunning = false;

        var isEdit = !!userId;
        vm.isEdit = isEdit;

        vm.groups = [];
        vm.dataUser = {
            username: '',
            email: '',
            group: {},
            password: '',
            confirmPassword: ''
        };

        vm.modalTitle = isEdit ? 'editUser' : 'addUser';
        vm.labelButton = isEdit ? 'save' : 'add';

        if (isEdit) {
            vm.requestRunning = true;
            UserService.getUser(userId).then(successUser).catch(errorUser);
        } else {
            getGroups();
        }

        vm.checkPassword = function () {
            return vm.dataUser.password == vm.dataUser.confirmPassword;
        }

        vm.close = function () {
            if (!vm.requestRunning) {
                $scope.$emit('userEditCancel');
                $uibModalInstance.dismiss('cancel');
            }
        }

        vm.save = function () {
            if (vm.formUserAdd.$valid && !vm.requestRunning) {
                vm.requestRunning = true;
                var data = {
                    username: vm.dataUser.username,
                    email: vm.dataUser.email,
                    groupId: vm.dataUser.group.id,
                    groupName: vm.dataUser.group.name,
                    password: vm.dataUser.password,
                    confirmPassword: vm.dataUser.confirmPassword
                };
                if (isEdit) {
                    data.id = vm.dataUser.id;
                    UserService.updateUser(data).then(successUpdate).catch(errorSave);
                } else {
                    UserService.addUser(data).then(successAdd).catch(errorSave);
                }
            }
        }

        function getGroups() {
            return UserService.getGroups().then(successGroups).catch(errorUser);
        }

        function successGroups(data) {
            vm.groups = data;
            if (!isEdit) {
                vm.dataUser.group = {
                    id: data[0].id.toString(),
                    name: data[0].name
                };
            }
        }

        function successUser(data) {
            vm.requestRunning = false;
            vm.dataUser = {
                id: data.id,
                username: data.username,
                email: data.email,
                password: data.password,
                group: {name: data.groupName},
                confirmPassword: data.confirmPassword
            };
            getGroups().then(function () {
                vm.dataUser.group = $filter('filter')(vm.groups, {id: data.groupId}, true)[0];
            });
        }

        function errorUser(response) {
            vm.requestRunning = false;
            UserService.errorModalConstructor(response, 'get');
            vm.close();
        }

        function successAdd(data) {
            vm.requestRunning = false;
            UserService.successModalConstructor('save');
            $scope.$emit('userAddSuccess', data);
        }

        function successUpdate(data) {
            vm.requestRunning = false;
            $scope.$emit('userUpdateSuccess', data);
        }

        function errorSave(response) {
            vm.requestRunning = false;
            UserService.errorModalConstructor(response, isEdit ? 'edit' : 'add');
        }

    }
})();

(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('UserService', UserService);

    UserService.$inject = ['$http', '$q', 'RequestService', 'ModalConstructor', 'AlertModalService'];

    function UserService($http, $q, RequestService, ModalConstructor, AlertModalService) {

        return {
            // Api Methods
            getUserList: getUserList,
            getUser: getUser,
            getCurrentUser: getCurrentUser,
            getLoggedUsers: getLoggedUsers,
            addUser: addUser,
            updateUser: updateUser,
            deleteUser: deleteUser,
            changePassword: changePassword,
            recoverPassword: recoverPassword,
            // Group Methods
            getGroups: getGroups,
            // Modal Methods
            addUserModalConstructor: addUserModalConstructor,
            editUserModalConstructor: editUserModalConstructor,
            changePasswordModalConstructor: changePasswordModalConstructor,
            deleteUserModalConstructor: deleteUserModalConstructor,
            confirmationOltModalConstructor: confirmationOltModalConstructor,
            errorModalConstructor: errorModalConstructor,
            successModalConstructor: successModalConstructor
        };

        // Api Methods
        function getUserList() {
            return $http.get(userApi()).then(responseData);
        }

        function getUser(userId) {
            return $http.get(userApi(userId)).then(responseData);
        }

        function getCurrentUser() {
            return $http
                    .get(userApi('current'), {ignoreCancel: true})
                    .then(responseData);
        }

        function getLoggedUsers() {
            return $http.get(userApi('loggedusers')).then(responseData);
        }

        function addUser(data) {
            return $http.post(userApi(), data).then(responseData);
        }

        function updateUser(data) {
            return $http.put(userApi(), data).then(responseData);
        }

        function deleteUser(userId) {
            return $http.delete(userApi(userId)).then(responseData);
        }

        function changePassword(data) {
            return $http.put(userApi('changepassword'), data).then(responseData);
        }

        function recoverPassword(data) {
            return $http.post(userApi('recoverpassword'), data).then(responseData);
        }

        // Group Methods
        function getGroups() {
            return $http.get(groupApi()).then(responseData);
        }

        // Modal Methods
        function addUserModalConstructor(scope) {
            var modal = userModalConfig(scope);
            ModalConstructor.open(modal);
        }

        function editUserModalConstructor(userId, scope) {
            var modal = userModalConfig(scope);
            modal.resolve.userId = userId;
            ModalConstructor.open(modal);
        }

        function changePasswordModalConstructor(userId, scope) {
            var changePassword = {
                templateUrl: 'app/components/user/user-change-password.html',
                controller: 'UserChangePasswordController',
                controllerAs: 'vmUserChangePassword',
                size: 'sm',
                backdrop: 'static',
                resolve: {userId: userId},
                scope: scope
            };
            return ModalConstructor.open(changePassword);
        }

        function deleteUserModalConstructor(userData, scope) {
            var confirmOlt = {
                templateUrl: 'app/components/user/user-delete.html',
                controller: 'UserDeleteController',
                controllerAs: 'vmUserDelete',
                size: 'sm',
                backdrop: 'static',
                resolve: {userData: userData},
                scope: scope
            };
            ModalConstructor.open(confirmOlt);
        }

        function confirmationOltModalConstructor(oltsData, dataAction) {
            var confirm = {
                templateUrl: 'app/components/user/user-confirm.html',
                controller: 'UserConfirmController',
                controllerAs: 'vmUserConfirm',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    dataAction: function () {
                        return dataAction;
                    },
                    oltList: function () {
                        return oltsData;
                    }
                }
            };
            ModalConstructor.open(confirm);
        }

        function errorModalConstructor(response, action) {
            AlertModalService.error(response, action, 'user');
        }

        function successModalConstructor(action, isMultiple) {
            AlertModalService.success(action, isMultiple, 'user');
        }

        // Helper functions
        function userApi(method) {
            return RequestService.apiUrl('users', method);
        }

        function groupApi(method) {
            return RequestService.apiUrl('groups', method);
        }

        // Return only the data of the response
        function responseData(response) {
            return response.data;
        }

        function userModalConfig(scope) {
            return {
                templateUrl: 'app/components/user/user-add.html',
                controller: 'UserAddController',
                controllerAs: 'vmUserAdd',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    userId: null,
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('user-modals');
                            $translatePartialLoader.addPart('user');
                            return $translate.refresh();
                        }]
                },
                scope: scope
            };
        }

    }

})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('UserController', UserController);

    UserController.$inject = ['$scope', 'UserData'];

    function UserController($scope, UserData) {
        var vm = this;

        vm.groupName = UserData.groupName;
    }
})();
(function () {
  'use strict';
  angular.module('imnApp').factory('TermosAceiteService', TermosAceiteService);

  TermosAceiteService.$inject = ['$http', 'RequestService'];

  function TermosAceiteService($http, RequestService) {
    return {
      informacoesSistema: informacoesSistema
    };

    function informacoesSistema() {
      return $http.get(systemConfigurationApi()).then(responseData);
    }

    function systemConfigurationApi(method) {
      return RequestService.apiUrl('system-configuration', method);
    }
  }
})();

(function () {
  'use strict';

  angular.module('imnApp').controller('TermosAceiteController', TermosAceiteController);

  TermosAceiteController.$inject = ['TermosAceiteService'];

  function TermosAceiteController(TermosAceiteService) {
    var vm = this;
    vm.abreModal = abreModal;
    vm.fecharModal = fecharModal;
    vm.modalAberta = false;

    function abreModal() {
      vm.modalAberta = true;
    }

    function fecharModal() {
      vm.modalAberta = false;
    }
  }
})();

(function () {
  'use strict';
  angular.module('imnApp').factory('RelatorioService', RelatorioService);

  RelatorioService.$inject = ['$http', 'RequestService'];

  function RelatorioService($http, RequestService) {
    return {
      informacoesRelatorioDaOlt: informacoesRelatorioDaOlt,
      sincronizacaoForcada: sincronizacaoForcada
    };

    function informacoesRelatorioDaOlt(olt) {
      return $http.get(syncReportApi(olt.id)).then(responseData);
    }

    function sincronizacaoForcada(olt) {
      return $http.put(syncReportApi(olt.id));
    }

    function responseData(response) {
      return response.data;
    }

    function syncReportApi(method) {
      return RequestService.apiUrl('syncreport', method);
    }
  }
})();

(function () {
  'use strict';

  angular.module('imnApp').controller('RelatorioSchedulerController', RelatorioSchedulerController);

  RelatorioSchedulerController.$inject = ['$interval', 'RelatorioService'];

  function RelatorioSchedulerController($interval, RelatorioService) {
    var vm = this;
    var timer = null;
    vm.abreModal = abreModal;
    vm.fecharModal = fecharModal;
    vm.modalAberta = false;
    vm.sincronizar = sincronizar;

    function abreModal(olt) {
      $interval.cancel(timer);
      vm.oltSelecionada = olt;
      vm.modalAberta = true;
      buscaInformacoesDaOlt();
      recarregaAsInformacoesDaModalDeTemposEmTempos();
    }

    function carregaDadosDaApi(data) {
      /*var dataDeSolicitacaoDoProcessamentoForcado = data.dataDeSolicitacaoDoProcessamentoForcado
             var dataInicioUltimoProcessamento = data.dataInicioUltimoProcessamento
             var dataFinalUltimoProcessamento = data.dataFinalUltimoProcessamento
             var aindaNaoComecouSincronizacaoForcada = dataDeSolicitacaoDoProcessamentoForcado > dataInicioUltimoProcessamento
             var oSchedulerJaComecou = dataDeSolicitacaoDoProcessamentoForcado < dataInicioUltimoProcessamento
             var dataFinalEhValida = dataFinalUltimoProcessamento != null && dataFinalUltimoProcessamento > dataInicioUltimoProcessamento
             var oSchedulerJaTerminou = dataFinalEhValida && oSchedulerJaComecou
             vm.aindaNaoComecouSincronizacaoForcada = aindaNaoComecouSincronizacaoForcada
             vm.oSchedulerJaComecou = oSchedulerJaComecou
             vm.oSchedulerJaTerminou = oSchedulerJaTerminou*/
      var onuReports = data.onuReports;
      var bridgeReports = data.bridgeReports;
      vm.servicosRemovidos = bridgeReports;
      vm.onusRemovidas = onuReports;
    }
    function fecharModal() {
      vm.modalAberta = false;
      paraDeRecarregarAsInformacoesDaModal();
    }
    function recarregaAsInformacoesDaModalDeTemposEmTempos() {
      timer = $interval(buscaInformacoesDaOlt, 5000);
    }
    function buscaInformacoesDaOlt() {
      if (vm.oltSelecionada) RelatorioService.informacoesRelatorioDaOlt(vm.oltSelecionada).then(carregaDadosDaApi);
      else fecharModal();
    }
    function paraDeRecarregarAsInformacoesDaModal() {
      $interval.cancel(timer);
    }
    function sincronizar(olt) {
      vm.oltSelecionada = olt;
      RelatorioService.sincronizacaoForcada(vm.oltSelecionada);
    }
  }
})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('ProvisioningFilterController', ProvisioningFilterController);

    ProvisioningFilterController.$inject = ['$scope', '$state', '$stateParams', '$rootScope', 'OltService', 'OnuService', 'AlarmService'];

    function ProvisioningFilterController($scope, $state, $stateParams, $rootScope, OltService, OnuService, AlarmService) {

        // Variables
        var vm = this;
        vm.selected = {olt: null, onu: null};
        vm.porta = '';
        vm.placeholder = {olt: '', onu: ''};
        vm.onuName = '';
        vm.listOlts = [];
        vm.listOnus = [];
        vm.listGponPortas = [{value: ''},{value: '1'},{value: '2'},{value: '3'},{value: '4'},{value: '5'},{value: '6'},{value: '7'},{value: '8'}];

        // Method handler
        vm.changeOltItemSelected = changeOltItemSelected;
        vm.filter = filter;
        vm.clear = clear;

        // Method handler
        function changeOltItemSelected(item) {
            vm.selected.onu = null;
            getOnus(item.id || null);
        }

        function filter() {
            var oltId = vm.selected && vm.selected.olt && vm.selected.olt.id;
            //var onuId = vm.selected && vm.selected.onu && vm.selected.onu.id;
            var name = null;
            var portNumber = null;

            if (vm.porta != '') {
                portNumber = vm.porta.value;
            }
            if (vm.onuName != '') {
                name = vm.onuName;
            }
            var data = {
                oltId: oltId,
                //onuId: onuId,
                onuName: name,
                porta: portNumber
            };
           
            $scope.$emit('newDataFilter', data);
        }

        function verifyParams() {
            if ($stateParams.id && $stateParams.name && $stateParams.type) {
                angular.forEach(vm.listOlts, function (item) {
                    if (item.id == $stateParams.id) {
                        vm.selected.olt = item;
                        changeOltItemSelected(item);
                        filter();
                    }
                });
            }
        }

        function clear() {
            vm.selected.olt = vm.listOlts[0];
            vm.porta = '';
            vm.onuName = '';
            $scope.$emit('newClearFilter', {});
            //changeOltItemSelected({});            
        }

        // Method api
        function getOlts() {
            vm.placeholder.olt = 'global.common.loading';
            OltService.listOlts({}, true).then(getOltSuccess).catch(getOltError);
        }

        function getOnus(oltId) {
            vm.listOnus = [];
            vm.placeholder.onu = 'global.common.loading';
            OnuService.getAuthorizedOnuVmList({oltId: oltId}, true).then(getOnuSuccess).catch(getOnuError);
        }

        // Method response
        function getOltSuccess(data) {
            vm.listOlts = data;
            if (data.length) {
                vm.placeholder.olt = '';
                vm.listOlts.unshift({});
            } else {
                vm.placeholder.olt = 'provisioning.placeholder.noOltFound';
            }
            verifyParams();
        }

        function getOltError(response) {
            AlarmService.errorModalConstructor(response, 'getOltList');
        }

        function getOnuSuccess(data) {
            vm.listOnus = data;
            if (data.length) {
                vm.placeholder.onu = '';
                vm.listOnus.unshift({});
                vm.selected.onu = vm.listOnus[0];
            } else {
                vm.placeholder.onu = 'provisioning.placeholder.noOnuFound';
            }
        }

        function getOnuError(response) {
            AlarmService.errorModalConstructor(response, 'getOnuList');
        }

        var cancelListener = $rootScope.$on('cleanFilter', function (event, forceClean) {
            if (forceClean || (vm.selected.olt && vm.selected.olt.id) || (vm.selected.onu && vm.selected.onu.id)) {
                clear();
            }
        });
        $rootScope.$on('$destroy', cancelListener);

        // Initialize
        function initialize() {
            getOlts();

            if ($stateParams.id != null) {
                getOnus();
            }
        }
        initialize();
    }
})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
                .state('provisioning', {
                    parent: 'app.private',
                    url: '/provisioning',
                    data: {
                        pageTitle: 'provisioning.title'
                    },
                    params: {
                        id: {value: null},
                        name: {value: null},
                        type: {value: null},
                        hiddenParam: 'YES'
                    },
                    views: {
                        'content@app.private': {
                            templateUrl: 'app/components/provisioning/provisioning.html',
                            controller: 'ProvisioningController',
                            controllerAs: 'vmProvisioning'
                        },
                        'filter@provisioning': {
                            templateUrl: 'app/components/provisioning/provisioning-filter.html',
                            controller: 'ProvisioningFilterController',
                            controllerAs: 'vmProvisioningFilter'
                        },
                        'bridge@provisioning': {
                            templateUrl: 'app/components/bridge/bridge-list.html',
                            controller: 'BridgeListController',
                            controllerAs: 'vmBridgeList'
                        },
                        'gtp@provisioning': {
                            templateUrl: 'app/components/gtp/gtp-list.html',
                            controller: 'GtpController',
                            controllerAs: 'vmGtp'
                        },
                        'packetRule@provisioning': {
                            templateUrl: 'app/components/packet-rule/packet-rule-list.html',
                            controller: 'PacketRuleListController',
                            controllerAs: 'vmPacketRuleList'
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('provisioning');
                                $translatePartialLoader.addPart('bridge');
                                $translatePartialLoader.addPart('gtp');
                                $translatePartialLoader.addPart('packet-rule');
                                return $translate.refresh();
                            }]
                    }
                })
    }

})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('ProvisioningController', ProvisioningController);

    ProvisioningController.$inject = ['$scope', '$state', '$rootScope'];

    function ProvisioningController($scope, $state, $rootScope) {

        $scope.$on('newDataFilter', function (event, data) {
            $scope.$broadcast('eventFilter', data);
        });

        $scope.$on('newClearFilter', function (data) {
            $scope.$broadcast('clearFilter', data);
        });

    }
})();
(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('PacketRuleListController', PacketRuleListController);

    PacketRuleListController.$inject = ['$scope', '$stateParams', '$rootScope', '$filter', '$sce', '$translate', '$timeout', 'Authenticate', 'PacketRuleService'];

    function PacketRuleListController($scope, $stateParams, $rootScope, $filter, $sce, $translate, $timeout, Authenticate, PacketRuleService) {
        var vm = this;

        if (!Authenticate.hasPermission('packetRuleList')) {
            return;
        }

        // Variables
        vm.packetRuleList = [];
        vm.requestRunning = false;
        vm.view = {};
        vm.view.tooltip = '';
        vm.typeList = null;
        var hasError = false;
        var searchParams = null;

        // Methods Api
        vm.addPacketRule = addPacketRule;
        vm.editPacketRule = editPacketRule;
        vm.deletePacketRule = deletePacketRule;

        // Methods handle
        vm.toggle = toggle;
        vm.isListEmpty = isListEmpty;
        vm.hasErrorList = hasErrorList;


        // Action Functions
        function addPacketRule() {
            PacketRuleService.addPacketRuleModalConstructor($scope);
        }

        function editPacketRule(packetRuleItem) {
            PacketRuleService.editPacketRuleModalConstructor(packetRuleItem.id, $scope);
        }

        function deletePacketRule(packetRuleItem) {
            var dataAction = {
                action: 'delete',
                methodService: 'deletePacketRule',
                methodExtra: function (packetRuleItem) {
                    vm.packetRuleList.forEach(function (item, index, array) {
                        if (item.id === packetRuleItem[0].id) {
                            array.splice(index, 1);
                        }
                    });
                }
            };
            PacketRuleService.confirmationModalConstructor([packetRuleItem], dataAction);
        }

        function getTooltip() {
            translateTooltip()
            var translateChangeListener = $rootScope.$on('$translateChangeSuccess', translateTooltip);
            $rootScope.$on('$destroy', translateChangeListener);
        }

        function translateTooltip() {
            $translate('tooltip.addPacketRule').then(function (translation) {
                vm.view.tooltip = $sce.trustAsHtml(translation);
            });
        }

        function getPacketRuleList(data) {
            vm.packetRuleList = [];
            vm.requestRunning = true;
            PacketRuleService.listPacketRule(data).then(successListPacketRule).catch(errorListPacketRule);

        }

        function toggle(id) {
            vm.packetRuleList.forEach(function (item) {
                if (item.id == id) {
                    item.opened = !item.opened;
                } else {
                    item.opened = false;
                }
            });
        }

        function isListEmpty() {
            return !vm.requestRunning && !vm.packetRuleList.length && !hasError;
        }

        function hasErrorList() {
            return !vm.requestRunning && !vm.packetRuleList.length && hasError;
        }

        function listenerUpdate() {
            var packetRuleUpdateSuccess = $rootScope.$on('packetRuleUpdateSuccess', function (event, data) {
                vm.packetRuleList.forEach(function (packetRule, index, arrayList) {
                    if (packetRule.id == data.id) {
                        arrayList[index] = parsePacketRule(angular.copy(data));
                        arrayList[index].opened = true;
                    }
                });
            })
            $rootScope.$on('$destroy', packetRuleUpdateSuccess);
        }

        function listenerAdd() {
            var packetRuleAddSuccess = $rootScope.$on('packetRuleAddSuccess', function (event, data) {
                var packetRuleItem = parsePacketRule(angular.copy(data));
                vm.packetRuleList.push(packetRuleItem);
            })
            $rootScope.$on('$destroy', packetRuleAddSuccess);
        }

        // Request Callbacks
        function successListPacketRule(data) {
            vm.requestRunning = false;
            vm.packetRuleList = data.map(parsePacketRule);
            hasError = false;
        }

        function errorListPacketRule() {
            vm.requestRunning = false;
            hasError = true;
        }

        function parsePacketRule(item) {
            if (item.type) {
                item.type = $filter('filter')(vm.typeList, {value: item.type}, true)[0];
            }
            return item;
        }

        function initialize() {
            getTypeList();
            if (!$stateParams.id) {
                getPacketRuleList(searchParams);
            }
            getTooltip();
            listenerUpdate();
            listenerAdd();
        }

        function getTypeList() {
            PacketRuleService.getTypeList().then(function (data) {
                vm.typeList = data;
            });
        }

        $scope.$on('eventFilter', function (event, data) {
            searchParams = data;
            getPacketRuleList(searchParams);
        });

        initialize();

    }
})();
(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('PacketRuleConfirmController', PacketRuleConfirmController);

    PacketRuleConfirmController.$inject = ['$scope', '$uibModalInstance', 'PacketRuleService', 'packetRuleItem', 'dataAction'];

    function PacketRuleConfirmController($scope, $uibModalInstance, PacketRuleService, packetRuleItem, dataAction) {
        var vm = this;
        vm.requestRunning = false;


        if (dataAction) {
            vm.action = dataAction.action;
            vm.packetRuleData = packetRuleItem[0];
            vm.itemOne = true;

            vm.close = function () {
                if (!vm.requestRunning) {
                    $uibModalInstance.dismiss('cancel');
                }
            }

            vm.confirmAction = function () {
                vm.requestRunning = true;
                PacketRuleService[dataAction.methodService](vm.packetRuleData).then(success).catch(error);
            }
        }
        function success() {
            vm.requestRunning = false;
            var isMultiple = !vm.itemOne;

            PacketRuleService.successModalConstructor(vm.action, isMultiple);
            if (dataAction.methodExtra) {
                dataAction.methodExtra(packetRuleItem);
            }
        }

        function error(response) {
            vm.requestRunning = false;
            PacketRuleService.errorModalConstructor(response, vm.action);
        }

    }
})();
(function () {
    'use strict';
    angular
            .module('imnApp')
            .controller('PacketRuleAddController', PacketRuleAddController);

    PacketRuleAddController.$inject = ['$scope', '$state', '$rootScope', '$filter', '$uibModalInstance', '$translate', 'PacketRuleService', 'OltService', 'packetRuleId'];

    function PacketRuleAddController($scope, $state, $rootScope, $filter, $uibModalInstance, $translate, PacketRuleService, OltService, packetRuleId) {

        // Variables
        var vm = this;
        vm.requestRunning = false;
        vm.arrayOlts = null;
        vm.arrayGroups = null;
        vm.arrayTypes = null;
        vm.typeList = null;
        vm.isEdit = !!packetRuleId;
        vm.modalTitle = vm.isEdit ? 'edit' : 'add';
        vm.labelButton = vm.isEdit ? 'save' : 'add';
        vm.values = null;
        vm.groupDisabled = true;

        vm.oltRules = {
            OLT8820G: {
                max: 2147483647
            },
            Intelbras8820i: {
                max: 32
            }
        }

        vm.packetRuleModel = {
            id: '',
            olt: '',
            group: '',
            newGroup: {value: '', tooltip: ''},
            name: '',
            member: {value: '', tooltip: ''},
            type: '',
            values: []
        }

        // Methods Handler
        vm.changeOlt = changeOlt;
        vm.changeGroup = changeGroup;
        vm.changeType = changeType;
        vm.close = close;
        vm.save = save;

        // Method API
        function getAllOlt() {
            if (!vm.isEdit) {
                vm.requestRunning = true;
                OltService.getOlt().then(successOlt).catch(errorOlt);
            }
        }

        function isEdit() {
            if (vm.isEdit) {
                vm.requestRunning = true;
                PacketRuleService.getPacketRule(packetRuleId).then(successPacketRules).catch(errorPacketRules);
            }
        }

        // Methods Handler
        function changeOlt(olt) {
            vm.requestRunning = true;
            if (!vm.isEdit) {
                var oltRule = vm.oltRules[olt.model];
                vm.packetRuleModel.member.max = oltRule.max;
                vm.packetRuleModel.newGroup.max = oltRule.max;
                $translate('tooltip.packetRuleGroupValue', oltRule).then(setTooltip('newGroup'));
                $translate('tooltip.packetRuleMemberValue', oltRule).then(setTooltip('member'));
                PacketRuleService.listGroups(olt.id).then(successGroup).catch(errorGroup);
                cleanFields();
            }
            PacketRuleService.listTypes(olt.id).then(successType).catch(errorType);
        }

        function setTooltip(input) {
            return function (translation) {
                vm.packetRuleModel[input].tooltip = translation;
            }
        }

        function changeGroup() {
            vm.groupDisabled = !!vm.packetRuleModel.group.id;
        }

        function changeType(type) {
            vm.packetRuleModel.values = {};
            vm.values = type.values;
        }

        function getTypeList() {
            PacketRuleService.getTypeList().then(function (data) {
                vm.typeList = data;
            });
        }

        function close() {
            if (!vm.requestRunning) {
                $uibModalInstance.dismiss('cancel');
            }
        }

        function cleanFields() {
            vm.packetRuleModel.group = '';
            vm.packetRuleModel.member.value = '';
            vm.packetRuleModel.type = '';
            vm.groupDisabled = true;
            vm.packetRuleModel.newGroup.value = '';
        }

        function save() {
            if (vm.formPacketRuleAdd.$valid && !vm.requestRunning) {
                var data = {
                    name: vm.packetRuleModel.name.toUpperCase(),
                    member: vm.packetRuleModel.member.value,
                    type: vm.packetRuleModel.type.value,
                    values: []
                };

                for (var key in vm.packetRuleModel.values) {
                    data.values.push({
                        name: key,
                        value: vm.packetRuleModel.values[key]
                    });
                }

                if (!vm.isEdit) {
                    data.oltId = vm.packetRuleModel.olt.id;
                    if (vm.packetRuleModel.group.id == null) {
                        data.groupIdEquipment = vm.packetRuleModel.newGroup.value;
                    } else {
                        data.groupId = vm.packetRuleModel.group.id;
                    }
                } else {
                    data.id = vm.packetRuleModel.id;
                }

                vm.requestRunning = true;
                if (vm.isEdit) {
                    PacketRuleService.updatePacketRule(data).then(successSave).catch(errorSave);
                } else {
                    PacketRuleService.addPacketRule(data).then(successSave).catch(errorSave);
                }
            }
        }

        // Method response
        function successOlt(data) {
            var itens = [];
            vm.requestRunning = false;
            for (var i = 0; i < data.length; i++) {

                if (data[i].model != 'Intelbras8820i') {
                    itens.push(data[i]);
                    vm.arrayOlts = itens;

                }
            }
        }

        function errorOlt(response) {
            vm.requestRunning = false;
            PacketRuleService.errorModalConstructor(response, 'getOltList');
            close();
        }

        function successGroup(data) {
            vm.requestRunning = false;
            vm.arrayGroups = data;
            var newGroup = {
                id: null,
                groupIdEquipment: $filter('translate')('packetRule.modal.new')
            };
            vm.arrayGroups.push(newGroup);
        }

        function errorGroup(response) {
            vm.requestRunning = false;
            PacketRuleService.errorModalConstructor(response, 'getGroupList');
            close();
        }

        function successType(data) {
            vm.requestRunning = false;
            vm.arrayTypes = data.map(function (item) {
                var type = $filter('filter')(vm.typeList, {value: item.type}, true)[0];
                type.values = item.ruleValueNames;
                return type;
            });
        }

        function errorType(response) {
            vm.requestRunning = false;
            PacketRuleService.errorModalConstructor(response, 'getTypeList');
            close();
        }

        function successPacketRules(data) {
            vm.requestRunning = false;
            vm.packetRuleModel = angular.copy(data);
            vm.packetRuleModel.member = {value: data.member};
            vm.packetRuleModel.olt = {
                id: data.oltId,
                name: data.oltName
            };
            changeOlt(vm.packetRuleModel.olt);
            if (data.type) {
                vm.packetRuleModel.type = $filter('filter')(vm.typeList, {value: vm.packetRuleModel.type}, true)[0];
                vm.packetRuleModel.values = {};
                vm.values = data.values.map(function (item) {
                    vm.packetRuleModel.values[item.name] = item.value;
                    return item.name;
                });
            }
        }

        function errorPacketRules(response) {
            vm.requestRunning = false;
            PacketRuleService.errorModalConstructor(response, 'getPacketRule');
            close();
        }

        function successSave(data) {
            vm.requestRunning = false;
            var modalInstance = PacketRuleService.successModalConstructor('save');
            modalInstance.result.finally(function () {
                if (vm.isEdit) {
                    $rootScope.$emit('packetRuleUpdateSuccess', data);
                } else {
                    $rootScope.$emit('packetRuleAddSuccess', data);
                    $rootScope.$emit('cleanFilter');
                }
            });
        }

        function errorSave(response) {
            vm.requestRunning = false;
            PacketRuleService.errorModalConstructor(response, 'save');
        }

        function initialize() {
            getTypeList();
            isEdit();
            getAllOlt();
        }

        initialize();
    }

})();

(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('PacketRuleService', PacketRuleService);

    PacketRuleService.$inject = ['$http', '$q', 'RequestService', 'ModalConstructor', 'AlertModalService'];

    function PacketRuleService($http, $q, RequestService, ModalConstructor, AlertModalService) {

        var service = {
            // API Methods
            listPacketRule: listPacketRule,
            getTypeList: getTypeList,
            listGroups: listGroups,
            listTypes: listTypes,
            getPacketRule: getPacketRule,
            addPacketRule: addPacketRule,
            updatePacketRule: updatePacketRule,
            deletePacketRule: deletePacketRule,
            // Modal Methods
            successModalConstructor: successModalConstructor,
            errorModalConstructor: errorModalConstructor,
            confirmationModalConstructor: confirmationModalConstructor,
            addPacketRuleModalConstructor: addPacketRuleModalConstructor,
            editPacketRuleModalConstructor: editPacketRuleModalConstructor
        };

        return service;

        function listPacketRule(filters) {
            var expressionFilter = constructFilter(filters || {});
            return $http.get(apiUrl(), {params: expressionFilter, ignoreLoadingBar: true}).then(responseData);
        }

        function getTypeList() {
            return $q.resolve([
                {label: 'ACL Allow', value: 'allow'},
                {label: 'DHCP Relay', value: 'bridgedhcprelay'},
                {label: 'Forbid OUI', value: 'bridgeforbidoui'},
                {label: 'Insert OptionDhcpV4Relay ', value: 'bridgeinsertdhcpv4relayoptions'},
                {label: 'Insert OptionDhcpV6Relay', value: 'bridgeinsertdhcpv6relayoptions'},
                {label: 'Insert Option82', value: 'bridgeinsertoption82'},
                {label: 'Insert PPPoE Vendor Tag', value: 'bridgeinsertpppoevendortag'},
                {label: 'Bridge Storm Detection', value: 'bridgestormdetect'},
                {label: 'Color Aware Rate Limit Discard', value: 'colorawareratelimitdiscard'},
                {label: 'ACL Deny', value: 'deny'},
                {label: 'DSCP To CoS', value: 'dscptocos'},
                {label: 'Destination MAC Swap Dynamic ', value: 'dstmacswapdynamic'},
                {label: 'Destination MAC Swap Static', value: 'dstmacswapstatic'},
                {label: 'Filter First Encapsulation VLAN', value: 'filterfirstencapsulationvlan'},
                {label: 'Promote First Encapsulation VLAN', value: 'promotefirstencapsulationvlan'},
                {label: 'Rate Limit Discard', value: 'ratelimitdiscard'},
                {label: 'Access List', value: 'accesslist'},
                {label: 'Storm Control', value: 'stormcontrol'},
            ]);
        }

        function listGroups(oltId, hideLoader) {
            return $http
                    .get(apiUrl(oltId + '/groups'), {ignoreLoadingBar: !!hideLoader})
                    .then(function (response) {
                        if (response.data.length) {
                            response.data.unshift({id: null, groupIdEquipment: null});
                        }
                        return response.data;
                    });
        }

        function listTypes(oltId) {
            return $http.get(apiUrl(oltId + '/types')).then(responseData);
        }

        function getPacketRule(packetRuleId) {
            return $http.get(apiUrl(packetRuleId)).then(responseData);
        }

        function addPacketRule(data) {
            return $http.post(apiUrl(), data).then(responseData);
        }

        function updatePacketRule(data) {
            return $http.put(apiUrl(), data).then(responseData);
        }

        function deletePacketRule(packetRuleData) {
            return $http.delete(apiUrl(packetRuleData.id)).then(responseData);
        }

        // Helper Functions
        function apiUrl(method) {
            return RequestService.apiUrl('packetrules/', method);
        }

        function constructFilter(filter) {
            var result = {oltId: null};
            if (filter.oltId) {
                result.oltId = filter.oltId;
            }
            return result;
        }

        // Return only the data of the response
        function responseData(response) {
            return response.data;
        }

        // Modal Methods
        function successModalConstructor(action, isMultiple) {
            return AlertModalService.success(action, isMultiple, 'packetRules');
        }

        function errorModalConstructor(response, action) {
            AlertModalService.error(response, action, 'packetRules');
        }

        function confirmationModalConstructor(packetRuleData, dataAction) {
            var confirm = {
                templateUrl: 'app/components/packet-rule/packet-rule-confirm.html',
                controller: 'PacketRuleConfirmController',
                controllerAs: 'vmPacketRulesConfirm',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    dataAction: function () {
                        return dataAction;
                    },
                    packetRuleItem: function () {
                        return packetRuleData
                    }
                }
            };
            ModalConstructor.open(confirm);
        }

        function addPacketRuleModalConstructor(scope) {
            var modal = packetRulesModalConfig();
            ModalConstructor.open(modal);
        }

        function editPacketRuleModalConstructor(packetRuleId, scope) {
            var modal = packetRulesModalConfig();
            modal.scope = scope;
            modal.resolve.packetRuleId = packetRuleId;
            ModalConstructor.open(modal);
        }

        function packetRulesModalConfig() {
            return {
                templateUrl: 'app/components/packet-rule/packet-rule-add.html',
                controller: 'PacketRuleAddController',
                controllerAs: 'vmPacketRuleAdd',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    packetRuleId: null,
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('packet-rule');
                            return $translate.refresh();
                        }]
                }
            };
        }

    }

})();
(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('OnuUpdateFirmwareController', OnuUpdateFirmwareController);

    OnuUpdateFirmwareController.$inject = ['$rootScope', '$scope', '$uibModalInstance', 'OnuService', 'onuItem'];

    function OnuUpdateFirmwareController($rootScope, $scope, $uibModalInstance, OnuService, onuItem) {

        // Variables and Objects
        var vm = this;

        vm.requestRunning = false;
        vm.selectedFile = null;
        vm.selectedOnus = [];
        vm.currentPage = 1;
        vm.totalItems = 0;
        var serverData = {};
        var onuIds = [];
        var item = false;

        // Method handler
        vm.close = close;
        vm.changePage = changePage;

        // Method API
        vm.updateFirmware = updateFirmware;

        initialize();

        function close() {
            if (!vm.requestRunning) {
                $uibModalInstance.dismiss('cancel');
            }
        }

        function updateFirmware() {
            setOnusSelected();
            if (vm.formUpdateOnuFirmware.$valid && vm.selectedOnus.length && !vm.requestRunning) {
                vm.requestRunning = true;
                var data = {
                    file: vm.selectedFile,
                    onuIds: vm.selectedOnus
                };

                if (data.onuIds.length >= 2) {
                    item = true;
                } else {
                    item = false;
                }
                OnuService.updateOnu(data).then(successUpdate).catch(errorUpdate);
            }
        }

        function setOnusSelected() {
            vm.selectedOnus = [];
            vm.modelFirmware.onus.forEach(function (item) {
                if (item.checked) {
                    vm.selectedOnus.push(item.onuId);
                }
            });
        }

        function setPage(page) {
            vm.modelFirmware = angular.copy(serverData[page - 1]);
        }

        function changePage() {
            vm.selectedFile = null;
            vm.selectedOnus = [];
            vm.formUpdateOnuFirmware.$setPristine();
            setPage(vm.currentPage);
        }

        // Requests Callbacks
        function successGetFiles(data) {
            serverData = data;
            vm.totalItems = data.length;
            setPage(1);
        }

        function errorGetFiles(response) {
            OnuService.errorModalConstructor(response, 'getFiles');
            close();
        }

        function successUpdate(response) {
            vm.requestRunning = false;
            var isMultiple = item;

            if (response.status == 207) {
                OnuService.warningModalConstructor(response.data, response, 'delete');
            } else {
                if (vm.totalItems > 1 || vm.modelFirmware.onus.length > 1) {
                    OnuService.successModalConstructorNotClose('update', isMultiple);
                } else {
                    OnuService.successModalConstructor('update', isMultiple);
                }
            }

            $rootScope.$emit('onuUpdateFirmware', response.data);
        }

        function errorUpdate(response) {
            vm.requestRunning = false;
            OnuService.errorModalConstructor(response, 'update');
        }

        function initialize() {
            vm.modelFirmware = {
                oltId: 0,
                oltName: '',
                onus: [],
                files: []
            };
            onuItem.forEach(function (item) {
                onuIds.push(item.id);
            });

            OnuService.getFiles(onuIds).then(successGetFiles).catch(errorGetFiles);
        }

    }

})();
(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('OnuStatusVoipController', OnuStatusVoipController);

    OnuStatusVoipController.$inject = ['$uibModalInstance', 'AlertModalService', 'OnuService', 'idOnu'];

    function OnuStatusVoipController($uibModalInstance, AlertModalService, OnuService, idOnu) {

        var vm = this;

        vm.statusVoipList = [];

        // Flag to avoid closing modal when request is running
        vm.requestRunning = false;

        // Form Actions
        vm.init = init;
        vm.reload = reload;
        vm.close = close;
        vm.getStatusVoip = getStatusVoip;
        vm.setStatusVoip = setStatusVoip;

        function init() {
            getStatusVoip();
        }

        function reload() {
            getStatusVoip();
        }

        function close() {
            if (!vm.requestRunning) {
                $uibModalInstance.dismiss('cancel');
            }
        }

        function getStatusVoip() {
            OnuService.getONTStatusVoip(idOnu).then(function (data) {
                vm.setStatusVoip(data);
            })
                    .catch(function (error) {
                        AlertModalService.errorWithMsg("onuStatusVoip.onuOff");
                        vm.close();
                    });
        }

        function setStatusVoip(data) {
            vm.statusVoipList = data;
            vm.statusVoipList.forEach(function (element) {
                element.phoneNumber = element.phoneNumber != null ? element.phoneNumber : '--';
                element.registrationStatus = element.registrationStatus != null ? element.registrationStatus : '--';
                element.callStatus = element.callStatus != null ? element.callStatus : '--';
            });

        }

    }
})();
(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('OnuData', OnuData);

    OnuData.$inject = ['$rootScope', 'RequestService'];

    function OnuData($rootScope, RequestService) {

        return {
            triggerItemAuthorized: function (data) {
                $rootScope.$broadcast('onuNewItemAuthorized', data);
            },
            triggerItemAuthorizedWithStatus: function (data) {
                $rootScope.$broadcast('getOnuStatus', data);
            },
            parseOnu: function (item) {
                item.statusGpon = item.statusGpon ? item.statusGpon.toLowerCase() : '--';
                item.rxPower = item.rxPower ? item.rxPower.toFixed(1) : '--';
                item.txPower = item.txPower ? item.txPower.toFixed(1) : '--';
                item.softwareVersion = item.softwareVersion ? item.softwareVersion : '--';
                if (!item.mostCriticalAlarm || item.mostCriticalAlarm == 'NONE') {
                    item.mostCriticalAlarm = '';
                }
                item.mostCriticalAlarm = item.mostCriticalAlarm.toLowerCase();
                return item;
            },
            isSearch: false,
            setSearch: function (isSearch) {
                this.isSearch = isSearch;
            },
            search: function (searchData) {
                for (var key in searchData) {
                    if (!searchData[key]) {
                        delete searchData[key];
                    }
                }
                $rootScope.$broadcast('onuSearch', searchData);
            }
        };
    }
})();
(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('OnuService', OnuService);

    OnuService.$inject = ['$http', '$q', '$filter', 'RequestService', 'ModalConstructor', 'AlertModalService', 'OnuData'];

    function OnuService($http, $q, $filter, RequestService, ModalConstructor, AlertModalService, OnuData) {

        var service = {
            getOnu: getOnu,
            getUnauthorizedOnuList: getUnauthorizedOnuList,
            getAuthorizedOnuList: getAuthorizedOnuList,
            getGponSlot: getGponSlot,
            getModelList: getModelList,
            authorizeOnu: authorizeOnu,
            restartOnu: restartOnu,
            deleteOnu: deleteOnu,
            updateOnu: updateOnu,
            resetOnu: resetOnu,
            updateNameOnu: updateNameOnu,
            getFiles: getFiles,
            saveOnuCredentials: saveOnuCredentials,
            getONTStatusVoip: getONTStatusVoip,
            getOnuCpeMgr: getOnuCpeMgr,
            deleteAllCpeMgr: deleteAllCpeMgr,
            // Methods Onu Settings
            getSettingsWifi: getSettingsWifi,
            updateSettingsWifi: updateSettingsWifi,
            // Modal Methods
            editOnuModalConstructor: editOnuModalConstructor,
            configAccessModalConstructor: configAccessModalConstructor,
            authorizeOnuModalConstructor: authorizeOnuModalConstructor,
            successModalConstructorNotClose: successModalConstructorNotClose,
            successModalConstructor: successModalConstructor,

            warningModalConstructor: warningModalConstructor,
            errorModalConstructor: errorModalConstructor,
            confirmationModalConstructor: confirmationModalConstructor,
            configOnuModalConstructor: configOnuModalConstructor,
            openModalONTStatusVoip: openModalONTStatusVoip,
            openModalOnuRemoteMgmt: openModalOnuRemoteMgmt,
            updateOnuModalConstructor: updateOnuModalConstructor,
            infoModalConstructor: infoModalConstructor,
            getAuthorizedOnuVmList: getAuthorizedOnuVmList
        };

        return service;

        function getUnauthorizedOnuList(data, hideSpinner) {
            checkSearch(data);            
            return $http.get(onuApi('unauthorized'), {params: data, ignoreLoadingBar: !!hideSpinner}).then(responseData);
        }

        function getAuthorizedOnuList(data, hideSpinner) {
            checkSearch(data);
            //return $http.get(onuApi(), {params: data, ignoreLoadingBar: !!hideSpinner}).then(responseData);
            return $http.get(onuApi(), {params: data, ignoreLoadingBar: !!hideSpinner});
        }

        function getAuthorizedOnuVmList(data, hideSpinner) {
            //console.log(!!hideSpinner);
            checkSearch(data);
            //return $http.get(onuApi(), {params: data, ignoreLoadingBar: !!hideSpinner}).then(responseData);
            return $http.get(onuApi('authorizedvm'), {params: data, ignoreLoadingBar: !!hideSpinner});
        }

        function getGponSlot(gponPortId) {
            return $http.get(onuApi(gponPortId + '/availablegponslots')).then(responseData);
        }

        function getModelList() {
            return $http.get(onuApi('/meprofilelist')).then(responseData);
        }

        function authorizeOnu(data) {
            return $http.post(onuApi(), data).then(responseData);
        }

        function updateNameOnu(onuId, onuName) {
            var onuData = {
                id: onuId,
                name: onuName
            }
            return $http.put(onuApi(), onuData).then(responseData);
        }

        function saveOnuCredentials(data) {
            return $http.put(onuApi('credentials'), data).then(responseData);
        }

        function deleteOnu(onuData) {
            var onuIds = onuData.map(onuId);
            return $http.delete(onuApi(onuIds));
        }

        function restartOnu(onuData) {
            var onuIds = onuData.map(onuId);
            return $http.put(onuApi(onuIds + '/restart'));
        }

        function getFiles(onuIds) {
            return $http.get(onuApi('oltfiles/' + onuIds)).then(responseData);
        }

        function updateOnu(data) {
            return $http.put(onuApi('fwupdate'), data).then(responseData);
        }

        function resetOnu(data) {
            var onuIds = data.map(onuId);
            return $http.put(onuApi(onuIds + '/reset'));
        }

        // Methods for Onu Settings
        function getSettingsWifi(onuId) {
            return $http.get(configApi(onuId + '/wifi')).then(responseData);
        }

        function updateSettingsWifi(data) {
            return $http.put(configApi('wifi'), data).then(responseData);
        }

        // Helper Functions

        // API Functions
        function onuApi(method) {
            return RequestService.apiUrl('onus', method);
        }

        function configApi(method) {
            return RequestService.apiUrl('onuconfig', method);
        }

        // Return only the data of the response
        function responseData(response) {
            return response.data;
        }

        function onuId(item) {
            return item.id;
        }

        function checkSearch(data) {
            OnuData.setSearch(false);
            if (data && !data.noSearch) {
                var params = Object.keys(data);
                if (params.length) {
                    OnuData.setSearch(true);
                }
            }
        }

        // Modal Methods
        function editOnuModalConstructor(onuItem) {
            var modal = {
                templateUrl: 'app/components/onu/onu-edit-authorized.html',
                controller: 'EditAuthorizedOnuController',
                controllerAs: 'vmEditAuthorizedOnu',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    onuItem: function () {
                        return onuItem
                    },
                }
            };
            ModalConstructor.open(modal);
        }

        function configAccessModalConstructor(onuItem) {
            var modal = {
                templateUrl: 'app/components/onu/onu-config-access.html',
                controller: 'ConfigAccessOnuController',
                controllerAs: 'vmConfigAccessOnu',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    onuItem: function () {
                        return onuItem
                    },
                }
            };
            ModalConstructor.open(modal);
        }

        function authorizeOnuModalConstructor(onuItem) {
            var authorizeOnu = {
                templateUrl: 'app/components/onu/onu-authorize.html',
                controller: 'AuthorizeOnuController',
                controllerAs: 'vmAuthorizeOnu',
                size: 'sm',
                windowClass: 'modal-onu-authorize',
                backdrop: 'static',
                resolve: {
                    onuItem: function () {
                        return onuItem
                    },
                }
            };
            ModalConstructor.open(authorizeOnu);
        }

        function confirmationModalConstructor(onusData, dataAction) {
            var confirm = {
                templateUrl: 'app/components/onu/onu-confirm.html',
                controller: 'OnuConfirmController',
                controllerAs: 'vmOnuConfirm',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    dataAction: function () {
                        return dataAction;
                    },
                    onuList: function () {
                        return onusData;
                    }
                },
                avoidCancel: true
            };
            ModalConstructor.open(confirm);
        }

        function configOnuModalConstructor(onuItem, isOnu) {
            var modal = {
                templateUrl: 'app/components/onu/onu-config.html',
                controller: 'ConfigOnuController',
                controllerAs: 'vmConfigOnu',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    onuItem: function () {
                        return onuItem
                    },
                    isOnu: function () {
                        return isOnu
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('onu-modals');
                            return $translate.refresh();
                        }]
                }
            };
            return ModalConstructor.open(modal);
        }

        function getONTStatusVoip(idOnu) {
            return $http.get(onuApi(idOnu + '/statusVoip')).then(responseData);
        }

        function openModalONTStatusVoip(idOnu) {
            var modal = {
                templateUrl: 'app/components/onu/onu-status-voip.html',
                controller: 'OnuStatusVoipController',
                controllerAs: 'vmOnuStatusVoip',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    idOnu: function () {
                        return idOnu
                    }
                }
            };
            return ModalConstructor.open(modal);
        }

        function getOnuCpeMgr(idOnu) {
            return $http.get(onuApi(idOnu + "/cpemgr")).then(responseData);
        }

        function getOnu(idOnu) {
            return $http.get(onuApi(idOnu)).then(responseData);
        }
        
        function deleteAllCpeMgr(oltId) {
            return $http.delete(onuApi('cpemgr' + '?oltId=' + oltId));
        }

        function openModalOnuRemoteMgmt(idOnu) {
            var modal = {
                templateUrl: 'app/components/onu/onu-remote-mgmt.html',
                controller: 'OnuRemoteMgmtController',
                controllerAs: 'vmOnuRemoteMgmt',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    idOnu: function () {
                        return idOnu
                    }
                }
            };
            return ModalConstructor.open(modal);
        }

        function updateOnuModalConstructor(onuItem) {
            var modal = {
                templateUrl: 'app/components/onu/onu-update-firmware.html',
                controller: 'OnuUpdateFirmwareController',
                controllerAs: 'vmOnuUpdateFirmware',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    onuItem: function () {
                        return onuItem
                    },
                }
            };
            ModalConstructor.open(modal);
        }

        function successModalConstructorNotClose(action, isMultiple) {

            var alertType = 'single';

            if (isMultiple) {
                alertType = 'multiple';
            }

            var successTemplate = {
                templateUrl: 'app/shared/alert/alert-success.html',
                controller: successController,
                controllerAs: 'vmAlertSuccess',
                size: 'sm',
                windowClass: 'modal-alert modal-success',
                avoidCancel: true
            };

            ModalConstructor.open(successTemplate);

            successController.$inject = ['$uibModalInstance'];
            function successController($uibModalInstance) {

                // Generate the translation key based on action and state
                this.modalMessage = 'onu' + 'Success.response.' + action + '.message.' + alertType;

                this.close = function () {
                    $uibModalInstance.dismiss('cancel');
                };
            }
        }

        function successModalConstructor(action, isMultiple) {
            return AlertModalService.success(action, isMultiple, 'onu');
        }

        function warningModalConstructor(list, response, action) {
            AlertModalService.warning(list, response, action, 'onu');
        }

        function errorModalConstructor(response, action) {
            AlertModalService.error(response, action, 'onu');
        }

        function infoModalConstructor(dataAction) {
            var info = {
                templateUrl: 'app/components/onu/onu-info.html',
                controller: 'OnuInfoController',
                controllerAs: 'vmOnuInfo',
                size: 'sm',
                resolve: {
                    dataAction: function () {
                        return dataAction;
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('onu-modals');
                            return $translate.refresh();
                        }]
                },
                avoidCancel: true
            };
            ModalConstructor.open(info);
        }

    }
})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('OnuSearchController', OnuSearchController);

    OnuSearchController.$inject = ['$scope', '$stateParams', '$state', '$timeout', 'OnuData', 'OnuService', 'OltService'];

    function OnuSearchController($scope, $stateParams, $state, $timeout, OnuData, OnuService, OltService) {
        var vm = this;
        vm.gponPortList = [
            {value: ''},
            {value: '1'},
            {value: '2'},
            {value: '3'},
            {value: '4'},
            {value: '5'},
            {value: '6'},
            {value: '7'},
            {value: '8'}
        ];

        vm.listOlts = [];
        vm.selected = {olt: null};
        vm.placeholder = {olt: ''};

        initialize();

        vm.ipTooltip = 'tooltip.ip.tip';

        vm.changeTooltip = function () {
            if (vm.formSearch.searchIp.$invalid) {
                vm.ipTooltip = 'tooltip.ip.invalid';
            } else {
                vm.ipTooltip = 'tooltip.ip.tip';
            }
        }

        vm.searchOnus = function () {
            if (vm.formSearch.$valid) {
                var data = angular.copy(vm.searchData);
                data.gponPort = vm.searchData.gponPort.value;
                if (vm.selected.olt) {
                    data.oltId = vm.selected.olt.id;
                }
                OnuData.search(data);
            }
        }

        vm.cleanFilter = function () {
            vm.searchData = {
                name: '',
                serialNumber: '',
                meProfile: '',
                olt: {value: ''},
                oltId: '',
                gponPort: {value: ''}
            };
            vm.selected.olt = vm.listOlts[0];
            OnuData.search();
        }

        function getOlts() {
            vm.placeholder.olt = 'global.common.loading';
            OltService.listOlts({}, true).then(getOltSuccess).catch(getOltError);
            vm.selected.olt = vm.listOlts[0];
        }

        function getOltSuccess(data) {
            vm.listOlts = data;
            if (data.length) {
                vm.placeholder.olt = '';
                vm.listOlts.unshift({});
            } else {
                vm.placeholder.olt = 'provisioning.placeholder.noOltFound';
            }
            verifyParamsOlt();
        }

        function getOltError(response) {
            AlarmService.errorModalConstructor(response, 'getOltList');
        }
   
        function verifyParamsOlt() {
            if ($stateParams.name) {
                angular.forEach(vm.listOlts, function (item) {
                    if (item.name == $stateParams.name) {
                        vm.selected.olt = item;
                    }
                });
                if ($stateParams.port) {
                    vm.searchData.gponPort = vm.gponPortList[$stateParams.port];
                }
                var data = angular.copy(vm.searchData);
                data.gponPort = vm.searchData.gponPort.value;
                data.oltId = vm.selected.olt.id;
                OnuData.search(data);
            }   
        }

        function initialize() {
            vm.searchData = {
                name: '',
                serialNumber: '',
                meProfile: '',
                olt: {value: ''},
                oltId: '',
                gponPort: {value: ''}
            };
            getOlts();
           
        }
    }
})();
(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('OnuRemoteMgmtController', OnuRemoteMgmtController);

    OnuRemoteMgmtController.$inject = ['$uibModalInstance', 'AlertModalService', 'OnuService', 'idOnu'];

    function OnuRemoteMgmtController($uibModalInstance, AlertModalService, OnuService, idOnu) {

        var vm = this;
        vm.modalMessage = "onuRemoteManagement.waitGenerate";
        vm.modalLink = "";

        // Flag to avoid closing modal when request is running
        vm.requestRunning = false;

        // Form Actions
        vm.init = init;
        vm.reload = reload;
        vm.close = close;
        vm.getOnuCpeMgr = getOnuCpeMgr;
        vm.setLinkCpeMgr = setLinkCpeMgr;

        function init() {
            getOnuCpeMgr();
        }

        function reload() {
            getOnuCpeMgr();
        }

        function close() {
            if (!vm.requestRunning) {
                $uibModalInstance.dismiss('cancel');
            }
        }

        function getOnuCpeMgr() {
        	OnuService.getOnu(idOnu).then(function(data){
        		console.log(data)
        		if(data.meProfile === 'Default'){
        			if(!data.vendor){
        				AlertModalService.errorWithMsg("onuRemoteManagement.noVendor");
            			vm.close();
            			return;
        			}
        		}
        		OnuService.getOnuCpeMgr(idOnu).then(function (data) {
        			console.log(data)
        			vm.setLinkCpeMgr(data);
        		})
        		.catch(function (error) {
        			AlertModalService.errorWithMsg("onuRemoteManagement.error");
        			vm.close();
        		});
        	})
        }

        function setLinkCpeMgr(data) {
            if (data.firstCreate) {
                vm.modalMessage = "onuRemoteManagement.waitUp";
            } else {
                vm.modalMessage = "onuRemoteManagement.avaiable";
            }
            vm.modalLink = "http://" + data.publicInterfaceIp + ":" + data.httpPort;
        }

    }
})();
(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('OnuUnauthorizedController', OnuUnauthorizedController);

    OnuUnauthorizedController.$inject = ['$scope', '$stateParams', '$rootScope', '$sce', '$translate', 'OnuService', 'RequestService', 'Authenticate', 'OnuData'];

    function OnuUnauthorizedController($scope, $stateParams, $rootScope, $sce, $translate, OnuService, RequestService, Authenticate, OnuData) {

        if (!Authenticate.hasPermission('onuList')) {
            return;
        }

        var vm = this;
        var hasError = false;
        vm.requestRunning = false;
        vm.dataSearch = {};

        vm.onuList = [];
        vm.list = {};
        vm.view = {};
        vm.orderSelected = '';
        vm.view.labelOrderSelected = '';
        vm.view.tooltip = '';
        vm.searchIsActive = false;

        vm.list.typeOrder = [
            {translateKey: 'alphabeticalOrderAToZ', name: 'Ordem alfabética (a-z)', paramObjectOrder: 'serialNumber'},
            {translateKey: 'alphabeticalOrderZToA', name: 'Ordem alfabética (z-a)', paramObjectOrder: '-serialNumber'},
            {translateKey: 'inclusionFirstOrder', name: 'Ordem de inclusão (asc)', paramObjectOrder: 'id'},
            {translateKey: 'inclusionLastOrder', name: 'Ordem de inclusão (desc)', paramObjectOrder: '-id'}
        ];

        // Actions
        vm.getUnauthorizedOnuList = getUnauthorizedOnuList;
        vm.removeAuthorizedOnu = removeAuthorizedOnu;
        vm.reload = reload;
        vm.setTypeOrder = setTypeOrder;
        vm.hasSearch = hasSearch;
        vm.hasNoSearch = hasNoSearch;
        vm.hasErrorList = hasErrorList;
        vm.toggle = toggle;
        vm.authorize = authorize;

        // Action Functions
        function setLabelOrderText(type) {
            switch (type) {
                case 'serialNumber':
                    vm.view.labelOrderSelected = vm.list.typeOrder[0]['translateKey'];
                    break;
                case '-serialNumber':
                    vm.view.labelOrderSelected = vm.list.typeOrder[1]['translateKey'];
                    break;
                case 'id':
                    vm.view.labelOrderSelected = vm.list.typeOrder[2]['translateKey'];
                    break;
                case '-id':
                    vm.view.labelOrderSelected = vm.list.typeOrder[3]['translateKey'];
                    break;
            }
        }

        function getUnauthorizedOnuList(data) {

            vm.onuList.length = 0;
            RequestService.cancelRequests(['onus/unauthorized']);
            setRequestEnd();

            if (data && data.name) {
                OnuData.isSearch = true;
            } else {
                setRequestStart();
                OnuService.getUnauthorizedOnuList(data, true).then(successListOnu).catch(errorListOnu);
            }

        }

        function removeAuthorizedOnu(id) {
            vm.onuList.forEach(function (item, index, array) {
                if (item.serialNumber == id) {
                    array.splice(index, 1);
                }
            })
        }

        function listenerNewItemAuthorize() {
            $scope.$on('onuNewItemAuthorized', function (event, result) {
                removeAuthorizedOnu(result.serialNumber);
            });
        }

        function reload() {
            getUnauthorizedOnuList(vm.dataSearch);
        }

        function setTypeOrder(type) {
            toggle(null);
            vm.orderSelected = type;
            setLabelOrderText(type);
        }

        function hasSearch() {
            return !vm.requestRunning && OnuData.isSearch && !vm.onuList.length && !hasError;
        }

        function hasNoSearch() {
            return !vm.requestRunning && !OnuData.isSearch && !vm.onuList.length && !hasError;
        }

        function hasErrorList() {
            return !vm.requestRunning && !vm.onuList.length && hasError;
        }

        function toggle(id) {
            vm.onuList.forEach(function (item) {
                if (item.id == id) {
                    item.opened = !item.opened;
                } else {
                    item.opened = false;
                }
            });
        }

        function getTooltip() {
            translateTooltip()
            var translateChangeListener = $rootScope.$on('$translateChangeSuccess', translateTooltip);
            $rootScope.$on('$destroy', translateChangeListener);
        }

        function translateTooltip() {
            $translate('tooltip.updateOnuList').then(function (translation) {
                vm.view.tooltip = $sce.trustAsHtml(translation);
            });
        }

        function authorize(onuItem) {
            OnuService.authorizeOnuModalConstructor(onuItem);
        }

        // Request Callbacks
        function successListOnu(data) {
            var id = 1;
            vm.onuList = data.map(function (item) {
                item.id = id;
                id++;
                return item;
            });
            hasError = false;
            setRequestEnd();
        }

        function errorListOnu(response) {
            if (response.status != -1) {
                hasError = true;
                setRequestEnd();
            }
        }

        function setRequestStart() {
            vm.requestRunning = true;
        }

        function setRequestEnd() {
            vm.requestRunning = false;
        }

        function initialize() {
            if (!$stateParams.name) {
                getUnauthorizedOnuList();
            }
            vm.orderSelected = 'id';
            setLabelOrderText('id');
            getTooltip();
            listenerNewItemAuthorize();
        }

        initialize();

        $scope.$on('onuSearch', function (event, data) {
            OnuData.isSearch = false;
            vm.dataSearch = data;
            getUnauthorizedOnuList(data);
        });

        $scope.$on('onuItemDeleted', reload);
    }

})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('OnuListAuthorizedController', OnuListAuthorizedController);

    OnuListAuthorizedController.$inject = ['$scope', '$stateParams', '$rootScope', '$filter', '$sce', '$translate', '$q', 'OnuData', 'OnuService', 'OltService', 'RequestService', 'Authenticate', 'BridgeService'];

    function OnuListAuthorizedController($scope, $stateParams, $rootScope, $filter, $sce, $translate, $q, OnuData, OnuService, OltService, RequestService, Authenticate, BridgeService) {

        if (!Authenticate.hasPermission('onuList')) {
            return;
        }

        // Variables and Objects
        var vm = this;
        var hasError = false;
        var dataSearch = {};
        vm.requestRunning = false;

        vm.currentPage = 1;
        vm.totalCount = 0;
        vm.itemsPerPage = 50; 

        vm.arrayOnus = [];
        vm.selectedOnus = []

        vm.list = {};
        vm.view = {};
        vm.list.checkBoxEnable = false;
        vm.orderSelected = '';
        vm.view.labelOrderSelected = '';
        vm.view.menuSelectAll = 'disable';
        vm.view.menuSelectIndividual = 'disable';
        vm.view.panelButton = false;

        vm.list.typeOrder = [
            {translateKey: 'alphabeticalOrderAToZ', name: 'Ordem alfabética (a-z)', paramObjectOrder: 'name'},
            {translateKey: 'alphabeticalOrderZToA', name: 'Ordem alfabética (z-a)', paramObjectOrder: '-name'},
            {translateKey: 'inclusionFirstOrder', name: 'Ordem de inclusão (asc)', paramObjectOrder: 'id'},
            {translateKey: 'inclusionLastOrder', name: 'Ordem de inclusão (desc)', paramObjectOrder: '-id'}
        ];
        vm.view.tooltip = '';
        vm.searchIsActive = false;

        // Method handler
        vm.toggleCollapse = toggleCollapse;
        vm.unselectAll = unselectAll;
        vm.typeSelection = typeSelection;
        vm.addAndRemoveItem = addAndRemoveItem;
        vm.setTypeOrder = setTypeOrder;
        vm.hasSearch = hasSearch;
        vm.hasNoSearch = hasNoSearch;
        vm.hasErrorList = hasErrorList;
        vm.hasWiFi = hasWiFi;
        vm.reload = reload;
        vm.disableSelection = disableSelection;
        vm.isONTAndONU110Gi = isONTAndONU110Gi;
        vm.isOltIntelbras = isOltIntelbras;
        vm.isNotONU110G = isNotONU110G;

        // Method Api
        vm.restartOnu = restartOnu;
        vm.deleteOnu = deleteOnu;
        vm.editOnu = editOnu;
        vm.updateOnu = updateOnu;
        vm.resetOnu = resetOnu;
        vm.isONT = isONT;
        vm.getStatusVoip = getStatusVoip;
        vm.configAccess = configAccess;
        vm.configOnu = configOnu;
        vm.getOnuCpeMgr = getOnuCpeMgr;
        vm.getData = getData;

        vm.addBridge = addBridge;

        function addBridge(onuItem) {
            BridgeService.addBridgeOnuModalConstructor($scope, onuItem);
        }

        initialize();

        // Method handler
        function setTypeOrder(type) {
            toggleCollapse(null);
            vm.orderSelected = type;
            setLabelOrderText(type);
        }

        // Update the OLT data when it is edited
        var cleanListener = $rootScope.$on('onuUpdateSuccess', updateOnuData);
        $scope.$on('$destroy', cleanListener);

        // Clear the ONU checkbox when it is deleted and restarted
        var listener = $rootScope.$on('onuActionSuccess', clearSelection);
        $scope.$on('$destroy', listener);

        var firmwareListener = $rootScope.$on('onuUpdateFirmware', reload);
        $scope.$on('$destroy', listener);

        function typeSelection(typeSelection) {
            vm.list.checkBoxEnable = true;
            toggleCollapse(null);

            switch (typeSelection) {
                case 'selectAll':
                    if (checkStatusOption(vm.view.isActiveOptionAll)) {
                        toggleMenuActive(false);
                        return;
                    }
                    selectAll();
                    toggleMenuActive('selectAll');
                    break;
                case 'selectIndividual':
                    if (checkStatusOption(vm.view.isActiveOptionIndividual)) {
                        toggleMenuActive(false);
                        return;
                    }
                    selectIndividual();
                    toggleMenuActive('selectIndividual');
                    break;
            }
        }

        function addAndRemoveItem(item) {

            if (item.selected) {
                vm.selectedOnus.push(item);
                showPanelButton();
            } else {
                angular.forEach(vm.selectedOnus, function (itemDetail, index) {
                    if (!item.selected && itemDetail.id == item.id) {
                        vm.selectedOnus.splice(index, 1);
                    }
                });
                if (vm.selectedOnus.length == 0) {
                    hidePanelButton();
                }
            }
        }

        function selectAll() {
            vm.selectedOnus = [];
            showPanelButton();
            angular.forEach(vm.arrayOnus, function (item) {
                item.selected = true;
                vm.selectedOnus.push({
                    id: item.id,
                    name: item.name,
                    mostCriticalAlarm: item.mostCriticalAlarm,
                    selected: true
                });
            });
        }

        function selectIndividual() {
            unselectAll();
            vm.selectedOnus = [];

            if (vm.selectedOnus.length == 0) {
                hidePanelButton();
            }
        }

        function unselectAll() {
            vm.selectedOnus = [];
            hidePanelButton();
            angular.forEach(vm.arrayOnus, function (item) {
                item.selected = false;
            });
        }

        function toggleMenuActive(option) {
            if (option) {
                if (option == 'selectAll') {
                    vm.view.isActiveOptionAll = true;
                    vm.view.isActiveOptionIndividual = false;
                    vm.view.menuSelectAll = 'enable';
                    vm.view.menuSelectIndividual = 'disable';
                } else {
                    vm.view.isActiveOptionAll = false;
                    vm.view.isActiveOptionIndividual = true;
                    vm.view.menuSelectAll = 'disable';
                    vm.view.menuSelectIndividual = 'enable';
                }
            } else {
                vm.view.isActiveOptionAll = false;
                vm.view.isActiveOptionIndividual = false;
                vm.view.menuSelectAll = 'disable';
                vm.view.menuSelectIndividual = 'disable';
            }
        }

        function hasSearch() {
            return !vm.requestRunning && OnuData.isSearch && !vm.arrayOnus.length && !hasError;
        }

        function hasNoSearch() {
            return !vm.requestRunning && !OnuData.isSearch && !vm.arrayOnus.length && !hasError;
        }

        function hasErrorList() {
            return !vm.requestRunning && !vm.arrayOnus.length && hasError;
        }

        // Function to control the show or not the button ONU config according the me profile
        function hasWiFi(onuItem) {
            return onuItem.meProfile == 'intelbras-142ng';
        }

        // private method
        function checkStatusOption(status) {
            if (status) {
                unselectAll();
                vm.list.checkBoxEnable = false;
                return true;
            }
            return false;
        }

        function setLabelOrderText(type) {
            switch (type) {
                case 'name':
                    vm.view.labelOrderSelected = vm.list.typeOrder[0]['translateKey'];
                    break;
                case '-name':
                    vm.view.labelOrderSelected = vm.list.typeOrder[1]['translateKey'];
                    break;
                case 'id':
                    vm.view.labelOrderSelected = vm.list.typeOrder[2]['translateKey'];
                    break;
                case '-id':
                    vm.view.labelOrderSelected = vm.list.typeOrder[3]['translateKey'];
                    break;
            }
        }

        function hidePanelButton() {
            vm.view.panelButton = false;
        }

        function showPanelButton() {
            vm.view.panelButton = true;
        }


        function isONTAndONU110Gi(meProfile) {
            if (meProfile === 'intelbras-1420g' || meProfile === 'intelbras-142ng' || meProfile == 'intelbras-110gi' || meProfile == 'intelbras-121w' || meProfile == 'intelbras-142nw' || meProfile == 'intelbras-default') {
                return true;
            }
            return false;
        }

        function isOltIntelbras(onuItem) {
            if (onuItem.oltModel == 'Intelbras8820i') {
                return true;
            }
            return false;

        }

        function toggleCollapse(id) {
            vm.arrayOnus.forEach(function (item) {
                if (item.id == id) {
                    item.opened = !item.opened;
                    if (item.description != null) {
                        item.name = item.description;
                    }
                } else {
                    item.opened = false;
                }
            });
        }

        function reload() {
            getAuthorizedOnuList(dataSearch);
            clearSelection();
        }

        function clearSelection(event) {
            vm.selectedOnus = [];
            hidePanelButton();
            vm.list.checkBoxEnable = false;
            toggleMenuActive(false);
        }

        function getTooltip() {
            translateTooltip()
            var translateChangeListener = $rootScope.$on('$translateChangeSuccess', translateTooltip);
            $rootScope.$on('$destroy', translateChangeListener);
        }

        function translateTooltip() {
            $translate('tooltip.updateOnuList').then(function (translation) {
                vm.view.tooltip = $sce.trustAsHtml(translation);
            });
        }

        function updateOnuData(event, data) {
            vm.arrayOnus.forEach(function (onu) {
                if (onu.id == data.id) {
                    if (onu.name != data.name) {
                        onu.name = data.name
                    }
                    if (onu.accessUser != data.accessUser) {
                        onu.accessUser = data.accessUser
                    }
                    if (onu.accessPassword != data.accessPassword) {
                        onu.accessPassword = data.accessPassword
                    }
                }
            });
        }

        // Method API
        function addOnu(event, data) {
            vm.arrayOnus.push(OnuData.parseOnu(data));
            if (vm.list.checkBoxEnable) {
                clearSelection();
            }
        }

        function getAuthorizedOnuList(data) {
            RequestService.cancelRequests(['onus']);
            dataSearch = angular.copy(data);         
            getData(vm.currentPage);
        }

        /*
        function getOnuStatus(event, data) {
            var params = {
                name: data.name,
                getStatus: true,
                noSearch: true
            };
            //OnuService.getAuthorizedOnuList(params, true).then(successListWithStatus);
        }

        function successList(data) {
            if (Object.keys(data).length) {
                vm.arrayOnus = data.map(OnuData.parseOnu);
                var params = angular.copy(dataSearch);
                params.getStatus = true;
                params.noSearch = true;
                //OnuService.getAuthorizedOnuList(params, true).then(successListWithStatus);
            }
            hasError = false;
            setRequest();
        }

        function successListWithStatus(data) {
            vm.arrayOnus.forEach(function (onu) {
                var onuWithStatus = $filter('filter')(data, {id: onu.id}, true);
                if (onuWithStatus.length) {
                    onuWithStatus = OnuData.parseOnu(onuWithStatus[0]);
                    onu.statusGpon = onuWithStatus.statusGpon;
                    onu.rxPower = onuWithStatus.rxPower;
                    onu.txPower = onuWithStatus.txPower;
                    onu.distance = onuWithStatus.distance;
                    onu.softwareVersion = onuWithStatus.softwareVersion;
                }
            });
        }

        function errorListOnu(response) {
            if (response.status != -1) {
                hasError = true;
                setRequest();
            }
        }
        */

        function setRequestStart() {
            vm.requestRunning = true;
        }

        function setRequestEnd() {
            vm.requestRunning = false;
        }

        function restartOnu(onu) {
            var dataAction = {
                action: 'restart',
                methodService: 'restartOnu',
                methodExtra: function (onuList, onuErrorList) {

                    vm.selectedOnus = [];

                    vm.arrayOnus.forEach(function (item) {
                        item.selected = false;
                    });

                    if (onuErrorList) {

                        onuErrorList.forEach(function (onuError) {
                            vm.arrayOnus.forEach(function (onu, index, array) {
                                if (onu.id == onuError.id) {
                                    onu.selected = true;
                                    addAndRemoveItem(onu);
                                }
                            });
                        });

                    } else {
                        hidePanelButton();
                        checkStatusOption(true);
                        toggleMenuActive(false);
                    }
                }
            };

            OnuService.confirmationModalConstructor(onu ? [onu] : vm.selectedOnus, dataAction);
        }

        function deleteOnu(onu) {
            var dataAction = {
                action: 'delete',
                methodService: 'deleteOnu',
                methodExtra: function (onuList, onuErrorList) {

                    if (onuErrorList) {
                        // Remove onus with error on delete from selected list
                        onuErrorList.forEach(function (onuError) {
                            onuList.forEach(function (selectedOnu, index, array) {
                                if (onuError.id == selectedOnu.id) {
                                    array.splice(index, 1);
                                }
                            });
                        });
                    }

                    // Remove deleted onus from onu list
                    onuList.forEach(function (selectedOnu) {
                        vm.arrayOnus.forEach(function (onu, index, array) {
                            if (onu.id == selectedOnu.id) {
                                array.splice(index, 1);
                            }
                        });
                    });

                    vm.selectedOnus = [];
                    hidePanelButton();
                    $rootScope.$broadcast('onuItemDeleted');
                }
            };
            OnuService.confirmationModalConstructor(onu ? [onu] : vm.selectedOnus, dataAction);
        }

        function editOnu(onuItem) {
            OnuService.editOnuModalConstructor(onuItem);
        }

        function updateOnu(onu) {
            OnuService.updateOnuModalConstructor(onu ? [onu] : vm.selectedOnus);
        }

        function resetOnu(onu) {
            checkGtp(onu.oltId).then(function () {
                var dataAction = {
                    action: 'reset',
                    methodService: 'resetOnu',
                    confirmation: true,
                    afterConfirmAction: 'confirmReset'
                };
                OnuService.confirmationModalConstructor([onu], dataAction);
            });
        }

        function isONT(meProfile) {
            if (meProfile === 'intelbras-1420g' || meProfile === 'intelbras-142ng' || meProfile === 'intelbras-default') {
                return true;
            } else {
                return false;
            }

        }

        function getStatusVoip(idOnu) {
            OnuService.openModalONTStatusVoip(idOnu);
        }

        function getOnuCpeMgr(idOnu) {
            OnuService.openModalOnuRemoteMgmt(idOnu);
        }

        function isNotONU110G(meProfile) {
            if (meProfile === 'intelbras-110g' || meProfile === 'intelbras-110b') {
                return false;
            } else {
                return true;
            }
        }

        function configAccess(onuItem) {
            OnuService.configAccessModalConstructor(onuItem);
        }

        function configOnu(onuItem, typeCall) {
            OnuService.configOnuModalConstructor(onuItem, true);
            disableSelection();
        }

        function disableSelection() {
            if (vm.list.checkBoxEnable) {
                clearSelection();
            }
        }

        function checkGtp(oltId) {
            return OltService.getOlt(oltId)
                    .then(function (data) {
                        if (!data.gtpCpeMgrId) {
                            return OltService.gtpCpeMgrModalConstructor(oltId, $scope, true).result;
                        }
                        return $q.resolve();
                    });
        }


        function getData(pageNumber) {
            setRequestStart();
            vm.currentPage = pageNumber;   
            if (dataSearch) {
                var data = angular.copy(dataSearch);         
                data.currentPage = (pageNumber - 1);
            } else {
                var data = {
                    currentPage : (pageNumber - 1)
                }
            }

            vm.arrayOnus = []; 
            
            OnuService.getAuthorizedOnuList(data, true).then(function(response){
                vm.arrayOnus = response.data.content;  // data to be displayed on current page.
                vm.totalCount = response.data.totalElements; // total data count.
                setRequestEnd();
            });
            
        }
 
        function initialize() {
            if (!$stateParams.name) {
                getData(vm.currentPage);
            }
            vm.orderSelected = 'id';
            setLabelOrderText('id');
            getTooltip();
        }

        $scope.$on('onuSearch', function (event, data) {
            vm.unselectAll();
            vm.list.checkBoxEnable = false;
            toggleMenuActive(false);
            getAuthorizedOnuList(data);
            dataSearch = data || {};
        });

        $scope.$on('onuNewItemAuthorized', addOnu);
        //$scope.$on('getOnuStatus', getOnuStatus);
    }
})();
(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('OnuInfoController', OnuInfoController);

    OnuInfoController.$inject = ['$scope', '$rootScope', '$uibModalInstance', 'dataAction'];

    function OnuInfoController($scope, $rootScope, $uibModalInstance, dataAction) {
        var vm = this;
        vm.requestRunning = false;

        if (dataAction) {
            vm.action = dataAction.action;

            vm.close = function () {
                if (!vm.requestRunning) {
                    $uibModalInstance.dismiss('cancel');
                }
            };

        }

    }
})();


(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('EditAuthorizedOnuController', EditAuthorizedOnuController);

    EditAuthorizedOnuController.$inject = ['$rootScope', '$scope', '$uibModalInstance', 'OnuData', 'OnuService', 'onuItem'];

    function EditAuthorizedOnuController($rootScope, $scope, $uibModalInstance, OnuData, OnuService, onuItem) {

        // Variables and Objects
        var vm = this;
        vm.requestRunning = false;
        vm.dataOnu = {};

        // Method handler
        vm.close = close;

        // Method API
        vm.update = update;

        // Initialize
        vm.initialize = initialize;


        // Method handler
        function close() {
            if (!vm.requestRunning) {
                $uibModalInstance.dismiss('cancel');
            }
        }

        // Method API
        function update() {
            if (vm.formEditAuthorizedOnu.$valid && !vm.requestRunning) {
                vm.requestRunning = true;
                OnuService.updateNameOnu(vm.dataOnu.id, vm.dataOnu.name.toUpperCase(), vm.dataOnu.description)
                        .then(successUpdate)
                        .catch(errorUpdate);
            }
        }

        // Method request
        function successUpdate(data) {
            vm.requestRunning = false;
            OnuService.successModalConstructor('edit');
            $rootScope.$emit('onuUpdateSuccess', data);
        }

        function errorUpdate(response) {
            vm.requestRunning = false;
            OnuService.errorModalConstructor(response, 'edit');
        }

        // Initialize
        function initialize() {
            vm.dataOnu = {
                id: onuItem.id,
                oltName: onuItem.oltName,
                description: onuItem.description,
                name: onuItem.name,
                meProfile: onuItem.meProfile,
                gponPort: onuItem.gponPort,
                gponSlot: onuItem.gponSlot
            };
        }
        initialize();
    }

})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('OnuConfirmController', OnuConfirmController);

    OnuConfirmController.$inject = ['$scope', '$rootScope', '$uibModalInstance', 'OnuService', 'onuList', 'dataAction'];

    function OnuConfirmController($scope, $rootScope, $uibModalInstance, OnuService, onuList, dataAction) {
        var vm = this;
        vm.requestRunning = false;

        if (dataAction) {
            vm.action = dataAction.action;

            if (onuList.length == 1) {
                vm.onuData = onuList[0];
                vm.itemOne = true;
            } else {
                var names = '';
                var arrayNames = [];
                onuList.forEach(function (olt) {
                    arrayNames.push(olt.name);
                });
                names = arrayNames.join(', ');
                vm.onuData = {
                    amount: onuList.length,
                    names: names
                };
                vm.itemOne = false;
            }

            vm.close = function () {
                if (!vm.requestRunning) {
                    $uibModalInstance.dismiss('cancel');
                }
            };

            vm.confirmAction = function () {
                if (dataAction.confirmation) {
                    vm.close();

                    var postDataAction = {
                        action: dataAction.afterConfirmAction,
                        methodService: dataAction.methodService,
                        methodExtra: dataAction.methodExtra
                    };

                    OnuService.confirmationModalConstructor(onuList, postDataAction);
                } else {
                    vm.requestRunning = true;
                    OnuService[dataAction.methodService](onuList).then(success).catch(error);
                }
            };

        }

        function success(response) {
            vm.requestRunning = false;
            var isMultiple = !vm.itemOne;
            var data = null;

            if (response.status == 207) {
                OnuService.warningModalConstructor(onuList, response, vm.action);
                data = response.data;
            } else {
                OnuService.successModalConstructor(vm.action, isMultiple);
            }

            if (dataAction.methodExtra) {
                dataAction.methodExtra(onuList, data);
            }

            $rootScope.$emit('onuActionSuccess', data);

            OnuService.infoModalConstructor(dataAction);
        }

        function error(response) {
            vm.requestRunning = false;
            OnuService.errorModalConstructor(response, vm.action);
        }

    }
})();


(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('ConfigAccessOnuController', ConfigAccessOnuController);

    ConfigAccessOnuController.$inject = ['$rootScope', '$scope', '$uibModalInstance', 'OnuData', 'OnuService', 'onuItem'];

    function ConfigAccessOnuController($rootScope, $scope, $uibModalInstance, OnuData, OnuService, onuItem) {

        // Variables and Objects
        var vm = this;
        vm.requestRunning = false;
        vm.dataOnu = {
            id: onuItem.id,
            oltName: onuItem.oltName,
            name: onuItem.name,
            meProfile: onuItem.meProfile,
            gponPort: onuItem.gponPort,
            gponSlot: onuItem.gponSlot,
            accessUser: onuItem.accessUser,
            accessPassword: onuItem.accessPassword
        };

        // Method handler
        vm.close = close;
        vm.save = save;

        // Method handler
        function close() {
            if (!vm.requestRunning) {
                $uibModalInstance.dismiss('cancel');
            }
        }

        // Method API
        function save() {
            if (vm.formConfigAccessOnu.$valid && !vm.requestRunning) {
                var data = {
                    id: vm.dataOnu.id,
                    accessUser: vm.dataOnu.accessUser,
                    accessPassword: vm.dataOnu.accessPassword
                };
                vm.requestRunning = true;
                OnuService.saveOnuCredentials(data)
                        .then(successSave)
                        .catch(errorSave);
            }
        }

        // Method request
        function successSave(data) {
            vm.requestRunning = false;
            OnuService.successModalConstructor('credentials');
            $rootScope.$emit('onuUpdateSuccess', data);
        }

        function errorSave(response) {
            vm.requestRunning = false;
            OnuService.errorModalConstructor(response, 'credentials');
        }

    }

})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('ConfigOnuController', ConfigOnuController);

    ConfigOnuController.$inject = ['$scope', '$rootScope', '$filter', '$timeout', '$uibModalInstance', '$q', 'OnuService', 'OltService', 'onuItem', 'isOnu'];

    function ConfigOnuController($scope, $rootScope, $filter, $timeout, $uibModalInstance, $q, OnuService, OltService, onuItem, isOnu) {

        var vm = this;

        // Flag to avoid closing modal when request is running
        vm.requestRunning = false;

        // Form Model
        vm.data = {};

        // Form Actions
        vm.close = close;
        vm.saveSettingsWifi = saveSettingsWifi;

        vm.setSecurityAuth = setSecurityAuth;
        vm.checkSsidInvalid = checkSsidInvalid;
        vm.setSsid = setSsid;
        vm.getSecurityEncryptList = getSecurityEncryptList;

        var encryptOptionsList = [];
        var securityList = [];
        var securityOptionsList = []

        // Settings Slider modal WiFi
        vm.slider = {
            options: {
                floor: 20,
                ceil: 100,
                step: 20,
                hideLimitLabels: true,
                translate: function (value) {
                    return value + '%';
                },
                showSelectionBar: true
            }
        }

        initialize();

        function initialize() {

            vm.data = {
                ssidActive: 0,
                bandwidth: '',
                channel: '',
                sideband: '',
                power: 20,
                ssids: [
                    {
                        ssid: 1,
                        enable: false,
                        name: '',
                        securityAuth: '',
                        securityEncrypt: '',
                        password: '',
                    },
                    {
                        ssid: 2,
                        enable: false,
                        name: '',
                        securityAuth: '',
                        securityEncrypt: '',
                        password: '',
                    },
                    {
                        ssid: 3,
                        enable: false,
                        name: '',
                        securityAuth: '',
                        securityEncrypt: '',
                        password: '',
                    },
                    {
                        ssid: 4,
                        enable: false,
                        name: '',
                        securityAuth: '',
                        securityEncrypt: '',
                        password: '',
                    }]
            };

            // Comboboxes content
            vm.bandwidthList = ['20', '40'];
            vm.channelList = ['Auto', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'];
            vm.sidebandList = [{label: 'upper', value: 'UPPER'}, {label: 'lower', value: 'LOWER'}];
            vm.securityAuthList = [];
            securityOptionsList = [
                {label: 'mixedWpa2Wpa', value: 'MIXED_WPA2_WPA'},
                {label: 'open', value: 'OPEN'},
                {label: 'shared', value: 'SHARED'}
            ];
            securityList = [
                {label: 'wpa2', value: 'WPA2'},
                {label: 'wpa2Psk', value: 'WPA2_PSK'},
                {label: 'mixedWpa2Psk', value: 'MIXED_WPA2_WPA_PSK'},
                {label: 'wpa', value: 'WPA'},
                {label: 'wpaPsk', value: 'WPA_PSK'},
                {label: 'auth', value: 'AUTH_802_1X'}
            ];
            encryptOptionsList = {
                MIXED_WPA2_WPA: [
                    {label: 'AES', value: 'AES'},
                    {label: 'AES/TKIP', value: 'TKIP_AES'}
                ],
                OPEN: [
                    {label: '', value: null},
                    {label: 'WEP', value: 'WEP'}
                ],
                SHARED: [
                    {label: 'WEP', value: 'WEP'}
                ],
                DEFAULT: [
                    {label: 'AES', value: 'AES'},
                    {label: 'AES/TKIP', value: 'TKIP_AES'},
                    {label: 'WEP', value: 'WEP'}
                ]
            };

            $rootScope.$emit('onuConfigLoaded');

            if (isOnu) {
                checkGtpProgress(onuItem).then(function () {
                    getSettings(onuItem.id);
                }).catch(function () {
                    vm.close();
                });
            }

        }
        var clearListener = $rootScope.$on('bridgeClosed', function () {
            checkGtpProgress(onuItem).then(function () {
                getSettings(onuItem.id);
            }).catch(function () {
                vm.close();
            });
        });
        $scope.$on('$destroy', clearListener);

        function setSsid() {
            var securityAuth = vm.data.ssids[vm.data.ssidActive].securityAuth;
            var list = angular.copy(securityOptionsList);
            if (securityAuth) {
                var listItem = $filter('filter')(securityList, {value: securityAuth.value}, true);
                if (listItem.length) {
                    list.unshift(securityAuth);
                }
            }
            vm.securityAuthList = list;
        }

        function getSecurityEncryptList() {
            return encryptOptionsList[vm.data.ssids[vm.data.ssidActive].securityAuth.value] || encryptOptionsList.DEFAULT;
        }

        function setSecurityAuth(selectedAuth) {
            if (selectedAuth.value == 'SHARED') {
                vm.data.ssids[vm.data.ssidActive].securityEncrypt = {label: 'WEP', value: 'WEP'};
            } else {
                vm.data.ssids[vm.data.ssidActive].securityEncrypt = '';
            }
        }

        function checkSsidInvalid(index) {
            var invalid = false;
            angular.forEach(vm.data.ssids[index], function (item, key) {
                if (!(key == 'securityEncrypt' && vm.data.ssids[index].securityAuth.value == 'OPEN')) {
                    if (item === '' || angular.isUndefined(item)) {
                        invalid = true;
                    }
                }
            });
            return vm.formSettingsWifi.$submitted && invalid;
        }

        // Actions methods
        function getSettings(id) {
            vm.requestRunning = true;
            vm.slider.options.disabled = true;
            OnuService.getSettingsWifi(id).then(successWifiSettings).catch(errorWifiSettings);
        }

        function close() {
            if (!vm.requestRunning) {
                $uibModalInstance.dismiss('cancel');
            }
        }

        function saveSettingsWifi() {
            checkGtp(onuItem).then(function (result) {
                if (result) {
                    var ssidValid = true;
                    vm.data.ssids.forEach(function (item, index) {
                        if (checkSsidInvalid(index)) {
                            ssidValid = false;
                        }
                    });
                    if (vm.formSettingsWifi.$valid && ssidValid && !vm.requestRunning) {
                        vm.requestRunning = true;
                        var data = {
                            onuId: vm.data.onuId,
                            bandwidth: vm.data.bandwidth,
                            channel: vm.data.channel,
                            sideband: vm.data.sideband.value,
                            power: vm.data.power,
                            ssids: vm.data.ssids.map(function (item) {
                                var itemSend = {
                                    ssid: item.ssid,
                                    enable: item.enable
                                }
                                if (item.name) {
                                    itemSend.name = item.name
                                }
                                if (item.securityAuth) {
                                    itemSend.securityAuth = item.securityAuth.value
                                }
                                if (item.securityEncrypt && item.securityEncrypt.value) {
                                    itemSend.securityEncrypt = item.securityEncrypt.value;
                                }
                                if (item.password) {
                                    itemSend.password = item.password
                                }
                                return itemSend;
                            })
                        };
                        OnuService.updateSettingsWifi(data).then(successSaveWifi).catch(errorSaveWifi);
                    }
                }
            });
        }

        // Requests Callbacks
        function successWifiSettings(data) {
            vm.requestRunning = false;
            vm.slider.options.disabled = false;
            vm.data = data;
            vm.data.bandwidth = data.bandwidth.toString();
            vm.data.sideband = $filter('filter')(vm.sidebandList, {value: vm.data.sideband}, true)[0];
            vm.data.ssids = data.ssids.map(function (ssid) {
                if (ssid.securityAuth) {
                    var security = ssid.securityAuth;
                    ssid.securityAuth = $filter('filter')(securityOptionsList, {value: ssid.securityAuth}, true)[0];
                    if (!ssid.securityAuth) {
                        ssid.securityAuth = $filter('filter')(securityList, {value: security}, true)[0];
                    }
                    if (ssid.securityEncrypt) {
                        ssid.securityEncrypt = $filter('filter')(encryptOptionsList[ssid.securityAuth.value] || encryptOptionsList.DEFAULT, {value: ssid.securityEncrypt}, true)[0];
                    }
                }
                return ssid;
            });
            vm.data.ssidActive = 0;
            setSsid(0);
            $timeout(function () {
                $scope.$broadcast('rzSliderForceRender');
            });
        }

        function errorWifiSettings(response) {
            vm.requestRunning = false;
            OnuService.errorModalConstructor(response, 'getConfig');
            close();
        }

        function successSaveWifi() {
            vm.requestRunning = false;
            OnuService.successModalConstructor('configWifi', true);
        }

        function errorSaveWifi(response) {
            vm.requestRunning = false;
            OnuService.errorModalConstructor(response, 'configWifi');
        }

        function checkGtpProgress(onuItem) {

            return OltService.getOlt(onuItem.oltId)
                    .then(function (data) {

                        if (!data.gtpCpeMgrId) {
                            var modalInstance = OltService.gtpCpeMgrModalConstructor(data.id, $scope, true);
                            return modalInstance.result;
                        } else {
                            return $q.resolve()
                        }

                    });

        }

        function checkGtp(item) {
            var deferred = $q.defer();
            OltService.getOlt(item.oltId)
                    .then(function (data) {
                        if (!data.gtpCpeMgrId) {
                            OltService.gtpCpeMgrModalConstructor(item.oltId, $scope, true);
                            deferred.resolve(false);
                        }
                        deferred.resolve(true);
                    });
            return deferred.promise;
        }
    }
})();
(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('AuthorizeOnuController', AuthorizeOnuController);

    AuthorizeOnuController.$inject = ['$scope', '$uibModalInstance', 'OnuData', 'OnuService', 'onuItem', 'BridgeService'];

    function AuthorizeOnuController($scope, $uibModalInstance, OnuData, OnuService, onuItem, BridgeService) {

        var vm = this;

        vm.requestRunning = false;
        vm.postRunning = false;
        vm.configure = false;
        vm.gponSlotList = [];
        vm.modelList = [];
        vm.dataOnu = {
            name: onuItem.serialNumber,
            description: onuItem.description,
            serialNumber: onuItem.serialNumber,
            model: onuItem.model,
            oltName: onuItem.oltName,
            oltIp: onuItem.oltIp,
            oltId: onuItem.oltId,
            sernoId: onuItem.sernoId,
            gponPort: onuItem.gponPort,
            oltMacAddress: onuItem.oltMacAddress,
            gponPortId: onuItem.gponPortId,
            gponSlot: onuItem.gponSlot,
            vendor: onuItem.vendor
        };

        // Request
        vm.requestRunning = true;
        OnuService.getGponSlot(vm.dataOnu.gponPortId).then(successGet).catch(errorGet);

        vm.close = function () {
            if (!vm.postRunning) {
                $uibModalInstance.dismiss('cancel');
            }
        }

        vm.authorize = function (provisioning) {
            if (vm.formAuthorizeOnu.$valid && !vm.postRunning && vm.dataOnu.gponSlot !== '--') {
                vm.dataOnu.name = vm.dataOnu.name.toUpperCase();
                if (vm.dataOnu.description == null) {
                    vm.dataOnu.description = vm.dataOnu.name.toUpperCase();
                }
                vm.postRunning = true;
                OnuService.authorizeOnu(vm.dataOnu).then(successAuthorize).catch(errorAuthorize);
                vm.configure = provisioning;
            }
        }

        // Requests Callbacks
        function successGet(data) {
            vm.requestRunning = false;
            if (data.length === 0 && data) {
                vm.gponSlotList = ['--'];
            } else {
                vm.gponSlotList = data;
            }
            vm.dataOnu.gponSlot = vm.gponSlotList[0];
        }

        function errorGet(response) {
            vm.requestRunning = false;
            OnuService.errorModalConstructor(response, 'get');
            vm.close();
        }

        function successAuthorize(data) {
            var modalInstance;
            vm.postRunning = false;
            if (vm.configure) {
                var bridgeData = {
                    oltId: onuItem.oltId,
                    oltName: onuItem.oltName,
                    gponPort: onuItem.gponPort,
                    onuId: data.id,
                    onuName: data.name,
                    description: data.description
                };
                modalInstance = BridgeService.addBridgeSimpleModalConstructor(bridgeData);
                modalInstance.result.finally(vm.close);
            } else {
                modalInstance = OnuService.successModalConstructor('authorize');
            }
            data.serialNumber = vm.dataOnu.serialNumber;
            OnuData.triggerItemAuthorized(data);

            $uibModalInstance.closed.then(function () {
                OnuData.triggerItemAuthorizedWithStatus(data);
            });
        }

        function errorAuthorize(response) {
            vm.postRunning = false;
            OnuService.errorModalConstructor(response, 'authorize');
        }

        function initialize() {
            if (vm.dataOnu.model === '') {
                OnuService.getModelList().then(successGetModelList).catch(errorGet);
            }
        }

        initialize();

        function successGetModelList(data) {
            vm.requestRunning = false;
            if (data.length === 0 && data) {
                vm.modelList = ['--'];
            } else {
                vm.modelList = data;
            }
        }

    }

})();
(function () {
    'use strict';

    angular
            .module('imnApp')
            .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
                .state('onu', {
                    parent: 'app.private',
                    url: '/onu',
                    data: {
                        pageTitle: 'onu.title'
                    },
                    params: {
                        name: {value: null},
                        ip: {value: null},
                        port: {value: null}
                    },
                    views: {
                        'content@app.private': {
                            templateUrl: 'app/components/onu/onu.html',
                            controller: 'OnuController',
                            controllerAs: 'vmOnu'
                        },
                        'search@onu': {
                            templateUrl: 'app/components/onu/onu-search.html',
                            controller: 'OnuSearchController',
                            controllerAs: 'vmOnuSearch'
                        },
                        'favorites@onu': {
                            templateUrl: 'app/components/favorites/favorites.html',
                            controller: 'FavoritesController',
                            controllerAs: 'vmFavorites'
                        },
                        'unauthorized@onu': {
                            templateUrl: 'app/components/onu/onu-list-unauthorized.html',
                            controller: 'OnuUnauthorizedController',
                            controllerAs: 'vmOnuUnauthorized'
                        },
                        'authorized@onu': {
                            templateUrl: 'app/components/onu/onu-list-authorized.html',
                            controller: 'OnuListAuthorizedController',
                            controllerAs: 'vmListAuthorized'
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('onu');
                                $translatePartialLoader.addPart('onu-modals');
                                $translatePartialLoader.addPart('tooltip');
                                $translatePartialLoader.addPart('bridge');
                                return $translate.refresh();
                            }]
                    }
                })
    }

})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('OnuController', OnuController);

    OnuController.$inject = ['$scope', '$state', 'OnuService'];

    function OnuController($scope, $state, OnuService) {

    }
})();
(function () {
    'use strict';

    angular.module('imnApp').controller('OltUploadTftpController', OltUploadTftpController);

    OltUploadTftpController.$inject = ['$scope', '$uibModalInstance', 'OltService', 'OltData', 'oltId'];

    function OltUploadTftpController($scope, $uibModalInstance, OltService, OltData, oltId) {

        // Variables and Objects
        var vm = this;
        vm.requestRunning = false;

        // Set the message in the modal according the OLT Model
        vm.description = is8820G() ? '8820G' : '8820i';

        // Method handler
        vm.close = close;

        // Method API
        vm.uploadFileName = uploadFileName;

        initialize();

        function close() {
            if (!vm.requestRunning) {
                $uibModalInstance.dismiss('cancel');
            }
        }

        function uploadFileName() {
            if (vm.formUploadTftp.$valid && !vm.requestRunning) {
                var data = {
                    oltId: vm.modelUpload.oltId,
                    fileName: vm.modelUpload.fileName
                };

                OltService.uploadTftpFileToOlt(data).then(successUpload).catch(errorUpload);
            } else {
                errorUpload({status: 400, config: {}});
            }
        }

        function successUpload(data) {
            vm.requestRunning = false;
            OltService.successModalConstructor('loadFiles');
        }

        function errorUpload(response) {
            vm.requestRunning = false;
            OltService.errorModalConstructor(response, 'loadFiles');
        }

        function is8820G() {
            return OltData.detail.model != 'Intelbras8820i';
        }

        function initialize() {
            vm.modelUpload = {
                oltId: 0,
                oltName: '',
                fileName: ''
            };
            OltService.getFiles(oltId).then(sucessGetFiles).catch(errorGetFiles);
        }

        // Request Callbacks
        function sucessGetFiles(data) {
            vm.modelUpload = {
                oltId: data.oltId,
                oltName: data.oltName
            };
        }

        function errorGetFiles(response) {
            OltService.errorModalConstructor(response, 'getFiles');
            close();
        }
        
    }
})();
(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('OltUpdateFirmwareController', OltUpdateFirmwareController);

    OltUpdateFirmwareController.$inject = ['$scope', '$uibModalInstance', 'OltService', 'OltData', 'oltId'];

    function OltUpdateFirmwareController($scope, $uibModalInstance, OltService, OltData, oltId) {

        // Variables and Objects
        var vm = this;
        vm.requestRunning = false;
        vm.selectedFiles = [];

        // Set the message in the modal according the OLT Model
        vm.description = is8820G() ? '8820G' : '8820i';

        // Method handler
        vm.close = close;

        // Method API
        vm.updateFirmware = updateFirmware;

        initialize();

        function close() {
            if (!vm.requestRunning) {
                $uibModalInstance.dismiss('cancel');
            }
        }

        function updateFirmware() {
            vm.selectedFiles = [];
            vm.modelFirmware.files.forEach(function (item) {
                if (item.checked) {
                    vm.selectedFiles.push(item.name);
                }
            });
            if (is8820G() && vm.selectedFiles.length > 2) {
                errorUpdate({status: '400.1', config: {}})
            } else if (!is8820G() && vm.selectedFiles.length > 1) {
                errorUpdate({status: '400.2', config: {}})
            } else if (vm.formUpdateOlt.$valid && vm.selectedFiles.length && !vm.requestRunning) {
                var data = {
                    files: vm.selectedFiles,
                    oltId: vm.modelFirmware.oltId
                }

                var dataAction = {
                    action: 'updateOltConfirm',
                    methodService: 'updateOltFirmware',
                };
                OltService.confirmationOltModalConstructor([data], dataAction);
            }
        }

        // Request Callbacks
        function sucessGetFiles(data) {
            vm.modelFirmware = {
                oltId: data.oltId,
                oltName: data.oltName,
                files: data.files.map(function (item) {
                    return {name: item, checked: false}
                })
            };
        }

        function errorGetFiles(response) {
            OltService.errorModalConstructor(response, 'getFiles');
            close();
        }

        function successUpdate(data) {
            vm.requestRunning = false;
            OltService.successModalConstructor('updateFirmware');
        }

        function errorUpdate(response) {
            vm.requestRunning = false;
            OltService.errorModalConstructor(response, 'updateFirmware');
        }

        function is8820G() {
            return OltData.detail.model != 'Intelbras8820i';
        }

        function initialize() {
            vm.modelFirmware = {
                oltId: 0,
                oltName: '',
                files: []
            };
            OltService.getFiles(oltId).then(sucessGetFiles).catch(errorGetFiles);
        }
    }
})();
(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('OltData', OltData);

    OltData.$inject = ['$rootScope'];

    function OltData($rootScope) {

        return {
            arrayOlts: [],
            setArrayOlts: function (list) {
                list.forEach(parseOlt);
                this.arrayOlts = list;
            },
            addOltOnList: function (olt) {
                this.arrayOlts.push(parseOlt(olt));
            },
            removeOlts: function (oltList) {
                var _this = this;
                this.detail = null;
                oltList.forEach(function (selectedOlt) {
                    _this.arrayOlts.forEach(function (olt, index, array) {
                        if (olt.id == selectedOlt.id) {
                            array.splice(index, 1);
                        }
                    });
                });
                $rootScope.$broadcast('oltDelete');
            },
            isSearch: false,
            setSearch: function (isSearch) {
                this.isSearch = isSearch;
                if (isSearch) {
                    $rootScope.$broadcast('oltSearch');
                }
            },
            dataLoaded: false,
            detail: null,
            setDetail: function (detail) {
                this.detail = detail;
                $rootScope.$broadcast('oltDetailLoad');
            },
            triggerItemSelected: function () {
                $rootScope.$broadcast('oltItemSelectedLoad');
            },
            selected: [],
            reset: function () {
                this.arrayOlts = [];
                this.isSearch = false;
                this.dataLoaded = false;
                this.detail = null;
                this.selected = [];
            },
            requestRunning: false
        };

        function parseOlt(item) {

            if (item.mostCriticalAlarm == 'NONE' && item.onLine) {
                item.mostCriticalAlarm = 'online'
            } else if (!item.onLine) {
                item.mostCriticalAlarm = 'offline'
            }

            item.mostCriticalAlarm = item.mostCriticalAlarm.toLowerCase();
            return item;
        }

    }
})();
(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('OltSearchController', OltSearchController);

    OltSearchController.$inject = ['$scope', '$rootScope', 'OltData', 'OltService'];

    function OltSearchController($scope, $rootScope, OltData, OltService) {
        var vm = this;

        initialize();

        vm.ipTooltip = 'tooltip.ip.tip';

        vm.changeTooltip = function () {
            if (vm.formSearch.searchIp.$invalid) {
                vm.ipTooltip = 'tooltip.ip.invalid';
            } else {
                vm.ipTooltip = 'tooltip.ip.tip';
            }
        }

        vm.searchOlts = function () {
            if (vm.formSearch.$valid) {
                getList();
            }
        }

        vm.cleanFilter = function () {
            initialize();
            getList();
        }

        function getList() {
            OltData.setArrayOlts([]);
            OltData.requestRunning = true;
            OltService.listOlts(vm.searchData, true).then(function (data) {
                OltData.setArrayOlts(data);
                OltData.requestRunning = false;
            });
        }

        var cancelListener = $rootScope.$on('cleanOltFilter', function () {
            if (vm.searchData.name || vm.searchData.ip) {
                vm.cleanFilter();
            }
        });
        $rootScope.$on('$destroy', cancelListener);

        function initialize() {
            vm.searchData = {
                name: '',
                ip: ''
            };
        }
    }
})();
(function () {
    'use strict';

    angular.module('imnApp').controller('OltRestoreBackupController', OltRestoreBackupController);

    OltRestoreBackupController.$inject = ['$scope', '$uibModalInstance', 'OltService', 'OltData', 'oltId', 'SystemConfigService'];

    function OltRestoreBackupController($scope, $uibModalInstance, OltService, OltData, oltId, SystemConfigService) {

        // Variables and Objects
        var vm = this;
        vm.requestRunning = false;

        var OLT_MODEL_INTELBRAS = 'Intelbras8820i';
        var MAX_UPLOAD_FILES_SIZE_BYTES = 209715200; // 200MB
        var INVALID_FILE_NAME_INTELBRAS_REGEX = /[^a-zA-Z0-9._\-]/; // Special
        // characters
        var INVALID_FILE_NAME_ZHONE_REGEX = /[^a-zA-Z0-9._\- ]/; // Special

        // Set the message in the modal according the OLT Model
        vm.description = is8820G() ? '8820G' : '8820i';

        // Method handler
        vm.close = close;

        // Method API
        vm.uploadFileName = uploadFileName;

        SystemConfigService.getSystemConfig().then(successGet).catch(errorGet);

        initialize();

        function close() {
            if (!vm.requestRunning) {
                $uibModalInstance.dismiss('cancel');
            }
        }

        function uploadFileName() {
            vm.requestRunning = true;            
            if (vm.modelUpload.file && vm.modelUpload.file.size > 0) {
                var data = {
                    oltId: vm.modelUpload.oltId,
                    file: vm.modelUpload.file
                };
                OltService.restoreOltToFile(data).then(successUpload).catch(errorUpload);
            }else if (vm.modelUpload.fileName) {
                var data = {
                    oltId: vm.modelUpload.oltId,
                    fileName: vm.modelUpload.fileName
                };
                OltService.restoreOltToFileName(data).then(successUpload).catch(errorUpload);
            }else {
                errorUpload({status: 400, config: {}});
            }
        }

        function successUpload(data) {
            vm.requestRunning = false;
            OltService.successModalConstructor('loadFiles');
        }

        function errorUpload(response) {
            vm.requestRunning = false;
            OltService.errorModalConstructor(response, 'loadFiles');
        }

        function is8820G() {
            return OltData.detail.model != 'Intelbras8820i';
        }

        function initialize() {
            vm.modelUpload = {
                oltId: 0,
                oltName: '',
                fileName: ''
            };
            OltService.getFiles(oltId).then(sucessGetFiles).catch(errorGetFiles);
        }

        // Request Callbacks
        function sucessGetFiles(data) {
            vm.modelUpload = {
                oltId: data.oltId,
                oltName: data.oltName
            };
        }

        function errorGetFiles(response) {
            OltService.errorModalConstructor(response, 'getFiles');
            close();
        }

        function successGet(data) {
            vm.requestRunning = false;
            if (data) {
                vm.fromSIG = data.fromSig;
            }
        }

        function errorGet(response) {
            vm.requestRunning = false;
            SystemConfigService.errorModalConstructor(response, 'get');
        }

        /*
		function validateFiles(file) {
            console.log('validando');
            var invalidFileNameRegex = (vm.data.detail.model === OLT_MODEL_INTELBRAS) ? INVALID_FILE_NAME_INTELBRAS_REGEX : INVALID_FILE_NAME_ZHONE_REGEX;
            var totalFilesSize = 0;
            
            //for (var i = 0; i < files.length; ++i) {
                //var file = vm.files[i];
                var regexMatch = file.name.match(invalidFileNameRegex);
                if (regexMatch !== null) {
                    return false;
                }
                totalFilesSize += file.size;
            //}
            if (totalFilesSize > MAX_UPLOAD_FILES_SIZE_BYTES) {
                return false;
            }
            console.log('era pra ir');
            return true;
        }*/


        
    }
})();
(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('OltRestoreController', OltRestoreController);

    OltRestoreController.$inject = ['$scope', 'OltService', '$uibModalInstance', 'OltData'];

    function OltRestoreController($scope, OltService, $uibModalInstance, OltData) {

        var vm = this;

        vm.data = OltData;
        vm.backupList = [];
        vm.selectedBackup = null;

        OltService.getBackupOlt(vm.data.detail.id).then(successBackup).catch(errorBackup);

        vm.close = function () {
            $uibModalInstance.dismiss('cancel');
        }

        function successBackup(data) {
            vm.backupList = formatDate(data);
        }

        function errorBackup(response) {
            OltService.errorModalConstructor(response, 'getBackup');
        }

        vm.isSearchEmpty = function () {
            return !vm.backupList.length;
        }

        vm.restore = function () {
            var dataAction = {
                action: 'restore',
                methodService: 'restoreOltBackup'
            };
            var restoreData = {
                oltId: vm.data.detail.id,
                oltBackupId: vm.selectedBackup,
                name: vm.data.detail.name
            };
            OltService.confirmationOltModalConstructor([restoreData], dataAction);
        }

        function formatDate(data) {
            data.forEach(function (item) {
                item.creationDate = new Date(item.creationDate);
            });
            return data;
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('OltOptionRestoreController', OltOptionRestoreController);

    OltOptionRestoreController.$inject = ['$scope', '$uibModalInstance', 'OltData', 'OltService'];

    function OltOptionRestoreController($scope, $uibModalInstance, OltData, OltService) {
        var vm = this;

        vm.close = function () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.configDefault = function () {
            vm.close();
            var dataAction = {
                action: 'reset',
                confirmation: true,
                afterConfirmAction: 'confirmReset',
                methodService: 'resetOlt',
                methodExtra: function (oltList) {
                    OltData.removeOlts(oltList)
                }
            };
            OltService.confirmationOltModalConstructor([OltData.detail], dataAction);
        }

        vm.restoreConfig = function () {
            vm.close()
            //OltService.restoreModalConstructor();
            OltService.restoreBackupOltModalConstructor(OltData.detail.id);
        }
    }
})();
(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('OltManagementController', OltManagementController);

    OltManagementController.$inject = ['$scope', 'OltService', 'OltData'];

    function OltManagementController($scope, OltService, OltData) {

        var vm = this;

        vm.data = OltData;
        var oltList = null;
        var names = '';
        var arrayNames = [];
        vm.arrayIds = [];

        vm.loadItems = function () {
            oltList = vm.data.selected;
            arrayNames = [];
            vm.arrayIds = [];

            oltList.forEach(function (olt) {
                arrayNames.push(olt.name);
                vm.arrayIds.push(olt.id);
            });
            names = arrayNames.join(', ');
            vm.oltData = {
                amount: vm.data.selected.length,
                names: names
            };
            toggleMessage(oltList);

        }
        $scope.$on('oltItemSelectedLoad', vm.loadItems);

        // Public Methods
        vm.delete = function () {
            var dataAction = {
                action: 'delete',
                methodService: 'deleteOlts',
                methodExtra: function (oltList, oltErrorList) {
                    if (oltErrorList) {
                        // Remove onus with error on delete from selected list
                        oltErrorList.forEach(function (oltError) {
                            oltList.forEach(function (selectedOlt, index, array) {
                                if (oltError.id == selectedOlt.id) {
                                    array.splice(index, 1);
                                }
                            });
                        });
                    }

                    // Remove deleted onus from onu list
                    OltData.removeOlts(oltList);
                }
            };
            OltService.confirmationOltModalConstructor(OltData.selected, dataAction);
        }

        vm.restart = function () {
            var dataAction = {
                action: 'restart',
                methodService: 'restartOlts'
            };
            OltService.confirmationOltModalConstructor(OltData.selected, dataAction);
        }

        vm.backup = function () {
            var dataAction = {
                action: 'backup',
                methodService: 'backupOlts'
            };
            OltService.confirmationOltModalConstructor(OltData.selected, dataAction);
        }

        vm.initialize = function () {
            vm.loadItems();
        }
        vm.initialize();

        // Private Methods
        function toggleMessage(oltList) {
            if (oltList.length == 1) {
                vm.itemOne = true;
            } else {
                vm.itemOne = false;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('OltListController', OltListController);

    OltListController.$inject = ['$scope', 'OltData', 'OltService'];

    function OltListController($scope, OltData, OltService) {

        var vm = this;
        var oltParent = $scope.$parent;

        vm.data = OltData;
        vm.list = {};
        vm.view = {};
        vm.list.checkBoxEnable = false;
        vm.orderSelected = '';
        vm.view.labelOrderSelected = '';
        vm.view.singlePanel = false;
        vm.view.manyDataPanel = false;
        vm.view.menuSelectAll = 'disable';
        vm.view.menuSelectIndividual = 'disable';
        vm.view.menuSelection = false;

        oltParent.panelIsVisible = false;

        vm.list.typeOrder = [
            {translateKey: 'alphabeticalOrderAToZ', name: 'Ordem alfabética (a-z)', paramObjectOrder: 'name'},
            {translateKey: 'alphabeticalOrderZToA', name: 'Ordem alfabética (z-a)', paramObjectOrder: '-name'},
            {translateKey: 'inclusionFirstOrder', name: 'Ordem de inclusão (asc)', paramObjectOrder: 'id'},
            {translateKey: 'inclusionLastOrder', name: 'Ordem de inclusão (desc)', paramObjectOrder: '-id'}
        ];

        vm.clickOltItem = function (olt) {

            //OltService.waitModalConstructor(true);
            // Event olt item
            // if return true will open the olt detail, otherwise checkbox will enable/disable
            if (menuSelectionIsDisable(olt)) {
                if (vm.data.detail) {
                    if (vm.data.detail.id == olt.id && vm.view.singlePanel) {
                        vm.hidePanel();
                        vm.data.detail = null;
                        olt.active = false;
                        return;
                    }
                }

                OltData.setDetail({
                    id: olt.id,
                    name: olt.name,
                    onLine: olt.onLine,
                    mostCriticalAlarm: olt.mostCriticalAlarm
                });

                vm.showPanel();
                vm.unselectAll();
                markAsActive(olt.id);
                vm.view.singlePanel = true;
                vm.list.checkBoxEnable = false;

                //OltService.waitModalConstructor(false);

            }
        }

        $scope.$on('requestsCanceled', closeDetail);
        $scope.$on('oltDelete', closeDetail);
        $scope.$on('oltSearch', closeDetail);

        function closeDetail() {
            vm.hidePanel();
            vm.unselectAll();
            vm.data.detail = null;
            vm.view.singlePanel = false;
            vm.view.manyDataPanel = false;
            vm.list.checkBoxEnable = false;
            vm.toggleMenuActive(false);
        }

        // Mark only the current open olt as active on the list
        function markAsActive(id) {
            vm.data.arrayOlts.forEach(function (item) {
                item.active = item.id == id;
            });
        }

        vm.setTypeOrder = function (type) {
            vm.orderSelected = type;
            setLabelOrderText(type);
        }

        vm.typeSelection = function (typeSelection) {
            vm.list.checkBoxEnable = true;
            if (vm.view.singlePanel) {
                vm.data.selected = [];
                vm.data.detail = null;
                markAsActive('');
            }
            switch (typeSelection) {
                case 'selectAll':
                    if (checkStatusOption(vm.view.isActiveOptionAll)) {
                        vm.toggleMenuActive(false);
                        vm.view.menuSelection = false;
                        return;
                    }
                    vm.selectAll();
                    vm.showPanel();
                    vm.toggleMenuActive('selectAll');
                    break;
                case 'selectIndividual':
                    if (checkStatusOption(vm.view.isActiveOptionIndividual)) {
                        vm.toggleMenuActive(false);
                        vm.view.menuSelection = false;
                        return;
                    }
                    vm.selectIndividual();
                    vm.toggleMenuActive('selectIndividual');
                    break;
            }
        }

        vm.addAndRemoveItem = function (item) {
            if (vm.view.singlePanel) {
                vm.data.selected = [];
            }
            if (item.selected) {
                vm.data.selected.push(item);
                OltData.triggerItemSelected();
                vm.showPanel();
            } else {
                angular.forEach(vm.data.selected, function (itemDetail, index) {
                    if (!item.selected && itemDetail.id == item.id) {
                        vm.data.selected.splice(index, 1);
                        OltData.triggerItemSelected();
                    }
                });
                if (vm.data.selected.length == 0) {
                    vm.hidePanel();
                }
            }
        }

        vm.selectAll = function () {
            vm.data.selected = [];
            vm.view.singlePanel = false;
            vm.view.menuSelection = true;
            angular.forEach(vm.data.arrayOlts, function (oltItem) {
                oltItem.selected = true;
                vm.data.selected.push({
                    id: oltItem.id,
                    name: oltItem.name,
                    mostCriticalAlarm: oltItem.mostCriticalAlarm,
                    selected: true
                });
            });
            OltData.triggerItemSelected();
        };

        vm.selectIndividual = function () {
            vm.unselectAll();
            vm.data.selected = [];
            vm.view.singlePanel = false;
            vm.view.menuSelection = true;
            if (vm.data.selected.length == 0) {
                vm.hidePanel();
            }
        }

        vm.unselectAll = function () {
            vm.data.selected = [];
            angular.forEach(vm.data.arrayOlts, function (oltItem) {
                oltItem.selected = false;
            });
            vm.view.menuSelection = false;
        }

        vm.showPanel = function () {
            oltParent.panelIsVisible = true;
        }

        vm.hidePanel = function () {
            oltParent.panelIsVisible = false;
        }

        vm.toggleMenuActive = function (option) {
            if (option) {
                if (option == 'selectAll') {
                    vm.view.isActiveOptionAll = true;
                    vm.view.isActiveOptionIndividual = false;
                    vm.view.menuSelectAll = 'enable';
                    vm.view.menuSelectIndividual = 'disable';
                } else {
                    vm.view.isActiveOptionAll = false;
                    vm.view.isActiveOptionIndividual = true;
                    vm.view.menuSelectAll = 'disable';
                    vm.view.menuSelectIndividual = 'enable';
                }
            } else {
                vm.view.isActiveOptionAll = false;
                vm.view.isActiveOptionIndividual = false;
                vm.view.menuSelectAll = 'disable';
                vm.view.menuSelectIndividual = 'disable';
            }
        }

        vm.isSearchEmpty = function () {
            return !OltData.requestRunning && !OltData.arrayOlts.length && OltData.isSearch;
        }

        // private method
        function checkStatusOption(status) {
            if (status) {
                vm.unselectAll();
                vm.hidePanel();
                vm.list.checkBoxEnable = false;
                return true;
            }
            return false;
        }

        function setLabelOrderText(type) {
            switch (type) {
                case 'name':
                    vm.view.labelOrderSelected = vm.list.typeOrder[0]['translateKey'];
                    break;
                case '-name':
                    vm.view.labelOrderSelected = vm.list.typeOrder[1]['translateKey'];
                    break;
                case 'id':
                    vm.view.labelOrderSelected = vm.list.typeOrder[2]['translateKey'];
                    break;
                case '-id':
                    vm.view.labelOrderSelected = vm.list.typeOrder[3]['translateKey'];
                    break;
            }
        }

        function menuSelectionIsDisable(olt) {
            if (vm.view.isActiveOptionAll || vm.view.isActiveOptionIndividual) {
                olt.selected = !olt.selected
                vm.addAndRemoveItem(olt);
                return false;
            }
            return true;
        }

        function initialize() {
            vm.orderSelected = 'id';
            setLabelOrderText('id');
        }
        initialize();
    }
})();
(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('OltHistoryController', OltHistoryController);

    OltHistoryController.$inject = ['$scope', '$rootScope', '$locale', '$filter', 'OltService', 'OltData'];

    function OltHistoryController($scope, $rootScope, $locale, $filter, OltService, OltData) {

        var vm = this;
        var historyData;
        /* global d3 */

        var charts = {
            memory: {name: 'memory', color: '#fec45a'},
            cpu: {name: 'cpu', color: '#00a9d5'}
        };

        vm.chart = {};
        vm.selectedChart = 'memory';

        function getHistory() {
            OltService.getHistory(OltData.detail.id).then(historySuccess);
        }
        getHistory();

        $scope.$on('oltDetailLoad', getHistory);

        function historySuccess(data) {
            historyData = data;
            vm.selectedChart = 'memory';
            createChart();
        }

        function createChart() {
            vm.chart.data = generateData();
            vm.chart.options = generateOptions();
            vm.chart.api.refresh();
        }

        vm.changeChart = function () {
            vm.selectedChart = vm.selectedChart == 'memory' ? 'cpu' : 'memory';
            createChart();
        };

        var cleanListener = $rootScope.$on('$translateChangeSuccess', function () {
            vm.chart.api.refresh();
        });
        $scope.$on('$destroy', cleanListener);

        function generateData() {
            return [{
                    values: historyData.map(function (item) {
                        return {
                            x: new Date(item.dateTime),
                            y: item[vm.selectedChart].toFixed(2)
                        };
                    }),
                    key: charts[vm.selectedChart].name,
                    color: charts[vm.selectedChart].color
                }];
        }

        function generateOptions() {
            return {
                chart: {
                    type: 'lineChart',
                    margin: {
                        top: 5,
                        right: 20,
                        bottom: 20,
                        left: 30
                    },
                    height: 100,
                    showLegend: false,
                    noData: $filter('translate')('olt.detail.noData'),
                    yDomain: [0, 100],
                    xScale: d3.time.scale(),
                    xAxis: {
                        tickFormat: d3.time.format('%d/%m %H:%M'),
                        showMaxMin: false
                    },
                    yAxis: {
                        tickFormat: function (value) {
                            return value + '%';
                        },
                        ticks: 6
                    },
                    tooltip: {
                        enabled: false
                    },
                    pointSize: 0,
                    zoom: {
                        verticalOff: true
                    }
                }
            };
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('OltGtpCpeMgrController', OltGtpCpeMgrController);

    OltGtpCpeMgrController.$inject = ['$scope', '$uibModalInstance', '$state', 'OltService', 'GtpService', 'oltId', 'showMessage', 'OnuService'];

    function OltGtpCpeMgrController($scope, $uibModalInstance, $state, OltService, GtpService, oltId, showMessage, OnuService) {
        var vm = this;
        vm.requestRunning = false;
        vm.listGtps = [];
        vm.gtpNameSelected = null;
        vm.isInvalid = false;

        if (!showMessage) {
            vm.showMessage = false;
        } else {
            vm.showMessage = showMessage;
        }

        // methods
        vm.setGtp = setGtp;
        vm.save = save;
        vm.close = close;

        vm.dataGtpCpeMgr = {
            id: oltId,
            gtpCpeMgrId: ''
        };

        function close() {
            if (!vm.requestRunning) {
                $uibModalInstance.dismiss('cancel');
            }
        }

        // Api
        function save() {
            if (vm.formAddGtp.$valid && !vm.requestRunning) {
                vm.requestRunning = true;

                if (vm.gtp.id) {
                    vm.dataGtpCpeMgr.gtpCpeMgrId = vm.gtp.id;
                } else {
                    vm.dataGtpCpeMgr.gtpCpeMgrId = null;
                }
                OltService.setGtpCpeMgrId(vm.dataGtpCpeMgr).then(successSave).catch(errorSave);
            }
        }

        function getOltData() {
            OltService.getOlt(oltId).then(successGetOlt).catch(errorGetOlt);
        }

        function getGptList() {
            var data = {
                oltId: oltId
            };
            GtpService.listGtp(data).then(successGetGtp).catch(errorGetGtp);
        }

        // Helpers
        function findDataGtpCurrent(gtpId) {
            vm.listGtps.forEach(function (gtp) {
                if (gtp.id == gtpId) {
                    vm.gtp = gtp;
                }
            });
        }

        function setGtp(gtp) {
            vm.gtp = gtp;
        }

        // Requests
        function successGetOlt(data) {
            vm.requestRunning = false;
            vm.dataGtpCpeMgr.gtpCpeMgrId = data.gtpCpeMgrId;
            getGptList();
        }

        function errorGetOlt(response) {
            vm.requestRunning = false;
            OltService.errorModalConstructor(response, 'get');
            vm.close();
        }

        function successGetGtp(data) {
            vm.requestRunning = false;
            vm.listGtps = data;
            if ($state.current.name == 'olt') {
                var gtpEmpty = {
                    name: ''
                };
                vm.listGtps.splice(0, 0, gtpEmpty);
            }
            findDataGtpCurrent(vm.dataGtpCpeMgr.gtpCpeMgrId);
        }

        function errorGetGtp(response) {
            vm.requestRunning = false;
            GtpService.errorModalConstructor(response, 'getOltList');
            vm.close();
        }

        function successSave(data) {
            vm.requestRunning = false;
            var modalInstance = OltService.successModalConstructor('gtpCpeMgr', null, true);
            modalInstance.closed.then(function (data) {
                $uibModalInstance.close();
            });
            deleteAllCpeMgr();
        }

        function deleteAllCpeMgr() {
            OnuService.deleteAllCpeMgr(oltId);
        }

        function errorSave(response) {
            vm.requestRunning = false;
            OltService.errorModalConstructor(response, 'gtpCpeMgr');
        }

        initialize();
        function initialize() {
            getOltData();
        }

    }
})();

(function () {
    angular.module('imnApp').controller('OltDetailController', OltDetailController);

    OltDetailController.$inject = [
        '$scope',
        '$filter',
        'OltService',
        'RequestService',
        'ConsoleWebService',
        'OltData',
        'SystemConfigService'
    ];

    function OltDetailController(
            $scope,
            $filter,
            OltService,
            RequestService,
            ConsoleWebService,
            OltData,
            SystemConfigService
            ) {
        var vm = this;

        vm.requestRunning = {
            ports: false,
            status: false,
            config: false
        };

        var OLT_MODEL_INTELBRAS = 'Intelbras8820i';
        var MAX_UPLOAD_FILES_SIZE_BYTES = 209715200; // 200MB
        var INVALID_FILE_NAME_INTELBRAS_REGEX = /[^a-zA-Z0-9._\-]/; // Special
        // characters
        var INVALID_FILE_NAME_ZHONE_REGEX = /[^a-zA-Z0-9._\- ]/; // Special
        // characters
        // and empty
        // spaces

        // Get the selected OLT data from shared service
        vm.data = OltData;
        var oltId = OltData.detail.id;

        // Menu actions
        vm.restartOlt = restartOlt;
        vm.uploadFilesToOlt = uploadFilesToOlt;
        vm.uploadFilesTftp = uploadFilesTftp;
        vm.restore = restore;
        vm.updateFirmware = updateFirmware;
        vm.backup = backup;
        vm.deleteOlt = deleteOlt;
        vm.editOlt = editOlt;
        vm.accessCode = accessCode;
        vm.setGtpCpeMgrOlt = setGtpCpeMgrOlt;
        // Apply datetime action
        vm.setDateOlt = setDateOlt;
        vm.abreModalAlarmShow = abreModalAlarmShow;
        vm.setAutoConfig = setAutoConfig;
        vm.isOlt8820i = isOlt8820i;

        // Call of Service Get User
        SystemConfigService.getSystemConfig().then(successGet).catch(errorGet);

        // Reset default values and load status data
        if (vm.data.detail) {
            initialize();
        }
        $scope.$on('oltDetailLoad', initialize);

        // Update the OLT data when it is edited
        $scope.$on('oltUpdateSuccess', updateOltData);

        // Action functions
        function accessCode() {
            ConsoleWebService.consoleWebModalConstructor(OltData.detail.id);
        }

        function restartOlt() {
            var dataAction = {
                action: 'restart',
                methodService: 'restartOlts'
            };
            OltService.confirmationOltModalConstructor([OltData.detail], dataAction);
        }

        function uploadFilesToOlt() {
            if (vm.files.length > 0) {
                if (validateFiles(vm.files)) {
                    var data = {
                        oltId: OltData.detail.id,
                        files: vm.files
                    };
                    OltService.uploadFilesToOlt(data).then(successUpload).catch(errorUpload);
                } else {
                    errorUpload({status: 400, config: {}});
                }
            }
        }

        function uploadFilesTftp() {
            OltService.uploadFilesTftpModalConstructor(OltData.detail.id);
        }

        function validateFiles(files) {
            var invalidFileNameRegex =
                    vm.data.detail.model === OLT_MODEL_INTELBRAS
                    ? INVALID_FILE_NAME_INTELBRAS_REGEX
                    : INVALID_FILE_NAME_ZHONE_REGEX;
            var totalFilesSize = 0;
            for (var i = 0; i < files.length; ++i) {
                var file = vm.files[i];
                var regexMatch = file.name.match(invalidFileNameRegex);
                if (regexMatch !== null) {
                    return false;
                }
                totalFilesSize += file.size;
            }
            return totalFilesSize <= MAX_UPLOAD_FILES_SIZE_BYTES;

        }

        function restore() {
            OltService.optionRestoreModalConstructor();
        }

        function backup() {
            var dataAction = {
                action: 'backup',
                methodService: 'backupOlts'
            };
            OltService.confirmationOltModalConstructor([OltData.detail], dataAction);
        }

        function deleteOlt() {
            var dataAction = {
                action: 'delete',
                methodService: 'deleteOlts',
                methodExtra: function (oltList) {
                    OltData.removeOlts(oltList);
                }
            };
            OltService.confirmationOltModalConstructor([OltData.detail], dataAction);
        }

        function editOlt() {
            OltService.editOltModalConstructor(OltData.detail.id, $scope);
        }

        function updateFirmware() {
            OltService.updateFirmwareOnuModalConstructor(OltData.detail.id);
        }

        function setGtpCpeMgrOlt() {
            OltService.gtpCpeMgrModalConstructor(OltData.detail.id, $scope);
        }

        function setDateOlt() {
            var data = {
                date: $filter('date')(vm.datepicker.selected, 'yyyy-MM-dd'),
                time: vm.time.hour + ':' + vm.time.minute
            };
            OltService.updateOltDateTime(OltData.detail.id, data).then(successDate).catch(errorDate);
        }

        // Reset default configuration of status information and call status
        // requests
        function initialize() {
            vm.statusDisabled = true;

            vm.data.detail.model = vm.data.arrayOlts.find(function (olt) {
                return olt.id === vm.data.detail.id;
            }).model;

            vm.statusOlt = {
                uptime: '--h --min',
                temperature: '-- °C',
                ip: '--.--.--.--',
                coolerStatus: false,
                cardMemoryStatus: false,
                softwareVersion: '--.--.--'
            };

            /* eslint-disable angular/controller-as-vm */
            vm.datepicker = {
                toggle: function () {
                    this.opened = !this.opened;
                },
                opened: false,
                format: 'dd-MMMM-yyyy',
                selected: '--',
                options: {
                    formatYear: 'yy',
                    minDate: new Date(2000, 0, 1),
                    startingDay: 1,
                    showWeeks: false,
                    formatMonth: 'MMM'
                }
            };

            vm.time = {
                hours: listHours(),
                minutes: listMinutes(),
                hour: '--',
                minute: '--'
            };
            /* eslint-enable angular/controller-as-vm */

            cancelRequests();
            getOltStatus();

            oltId = OltData.detail.id;
        }

        // Requests
        function getOltStatus() {
            if (vm.data.detail.onLine) {
                vm.requestRunning.ports = true;
                OltService.getAllPorts(OltData.detail.id).then(successPorts);
                vm.requestRunning.status = true;
                OltService.getOltDetail(OltData.detail.id).then(successDetail).catch(errorDetail);
            }
        }

        // Cancel requests
        $scope.$on('$destroy', cancelRequests);
        function cancelRequests() {
            RequestService.cancelRequests(['ports/' + oltId, 'olts/' + oltId + '/details', 'history/' + oltId]);
        }

        // Request callbacks
        function successPorts(data) {
            for (var portType in data) {
                data[portType].forEach(function (item) {
                    item.mostCriticalAlarm = item.mostCriticalAlarm.toLowerCase();
                    item.status = item.status.toLowerCase().replace('_', '');
                });
            }
            vm.ports = data;
            vm.requestRunning.ports = false;
        }

        function successDetail(data) {
            vm.statusOlt = data;
            vm.datepicker.selected = new Date(data.date + ' 00:00:00');
            vm.statusDisabled = false;

            var time = data.time.split(':');
            vm.time.hour = time[0];
            vm.time.minute = time[1];
            vm.requestRunning.status = false;

            vm.automatedProvisioning = data.automatedProvisioning;
            vm.autoService = data.autoService;
        }

        function errorDetail(response) {
            OltService.errorModalConstructor(response, 'detail');
            vm.requestRunning.status = false;
        }

        function successDate(data) {
            OltService.successModalConstructor('setDateTime');
        }

        function errorDate(response) {
            OltService.errorModalConstructor(response, 'setDateTime');
        }

        function successUpload(data) {
            var isMultiple = vm.files.length > 1;
            OltService.successModalConstructor('loadFiles', isMultiple);
        }

        function errorUpload(response) {
            OltService.errorModalConstructor(response, 'loadFiles');
        }

        function updateOltData(event, data) {
            vm.statusOlt.ip = data.ip;
            OltData.detail.name = data.name;
        }

        // Helper functions
        function listHours() {
            var hours = [];
            for (var i = 0; i < 24; i++) {
                hours.push((i < 10 ? '0' : '') + i);
            }
            return hours;
        }

        function listMinutes() {
            var minutes = [];
            for (var i = 0; i < 60; i++) {
                minutes.push((i < 10 ? '0' : '') + i);
            }
            return minutes;
        }

        function successGet(data) {
            vm.requestRunning.config = false;

            if (data) {
                vm.fromSIG = data.fromSig;
            }
        }

        function errorGet(response) {
            vm.requestRunning.config = false;
            SystemConfigService.errorModalConstructor(response, 'get');
        }

        function abreModalAlarmShow() {
            OltService.abreModalAlarmShowConstructor();
        }

        function setAutoConfig() {
            if (vm.autoService && isOlt8820i()) {
                vm.automatedProvisioning = true;
            }

            var data = {
                id: OltData.detail.id,
                automatedProvisioning: vm.automatedProvisioning,
                autoService: vm.autoService
            };

            OltService.setAutoConfig(data);
        }

        function isOlt8820i() {
            // get olt fw version to compare with static fw version without dot separator.
            var oltVersion = vm.statusOlt.softwareVersion;
            var regex = /\D+/gi;
            var oltVersionReplaced = oltVersion.toString().replace(regex, "");
            return OltData.detail.model === 'Intelbras8820i' && parseInt(oltVersionReplaced) >= "262";
        }

    }
})();

(function () {
  angular.module('imnApp').controller('OltConfirmController', OltConfirmController);

  OltConfirmController.$inject = ['$scope', '$uibModalInstance', 'OltService', 'oltList', 'dataAction', 'OltData'];

  function OltConfirmController($scope, $uibModalInstance, OltService, oltList, dataAction, OltData) {
    var vm = this;
    vm.requestRunning = false;

    if (dataAction) {
      vm.action = dataAction.action;

      if (oltList.length == 1) {
        vm.oltData = oltList[0];
        vm.itemOne = true;
      } else {
        var names = '';
        var arrayNames = [];
        oltList.forEach(function (olt) {
          arrayNames.push(olt.name);
        });
        names = arrayNames.join(', ');
        vm.oltData = {
          amount: oltList.length,
          names: names
        };
        vm.itemOne = false;
      }

      vm.close = function () {
        if (!vm.requestRunning) {
          $uibModalInstance.dismiss('cancel');
        }
      };

      vm.confirmAction = function () {
        if (dataAction.confirmation) {
          vm.close();

          var postDataAction = {
            action: dataAction.afterConfirmAction,
            methodService: dataAction.methodService,
            methodExtra: dataAction.methodExtra
          };

          OltService.confirmationOltModalConstructor([OltData.detail], postDataAction);
        } else {
          vm.requestRunning = true;
          OltService[dataAction.methodService](oltList).then(success).catch(error);
        }
      };
    }

    function success(response) {
      vm.requestRunning = false;
      var isMultiple = !vm.itemOne;
      var data = null;

      if (response.status == 207) {
        OltService.warningModalConstructor(oltList, response, 'delete');
        data = response.data;
      } else {
        OltService.successModalConstructor(vm.action, isMultiple);
      }

      if (dataAction.methodExtra) {
        dataAction.methodExtra(oltList, data);
      }
    }

    function error(response) {
      vm.requestRunning = false;
      OltService.errorModalConstructor(response, vm.action);
    }
  }
})();

(function () {
  angular.module('imnApp').controller('OltAddController', OltAddController);

  OltAddController.$inject = ['$scope', '$rootScope', '$uibModalInstance', '$filter', 'OltService', 'OltData', 'oltId'];

  function OltAddController($scope, $rootScope, $uibModalInstance, $filter, OltService, OltData, oltId) {
    var vm = this;
    vm.data = OltData;
    vm.requestRunning = false;
    vm.accessTypeList = [
      { label: 'SSH', value: 'SSH', portSugestion: 22 },
      { label: 'Telnet', value: 'TELNET', portSugestion: 23 }
    ];
    // vm.accessTypeList = [{ label: 'Telnet', value: 'TELNET', portSugestion: 23 }];

    var isEdit = !!oltId;

    vm.olt = {
      name: '',
      ip: '',
      // port: 22,
      port: 23,
      mac: '',
      // accessType: { label: 'SSH', value: 'SSH' , portSugestion: 22 },
      accessType: { label: 'Telnet', value: 'TELNET', portSugestion: 23 },
      accessUser: '',
      accessPassword: ''
    };

    vm.modalTitle = isEdit ? 'edit' : 'add';
    vm.labelButton = isEdit ? 'save' : 'add';

    if (isEdit) {
      vm.requestRunning = true;
      OltService.getOlt(oltId).then(successGetOlt).catch(errorGetOlt);
    }

    vm.close = function () {
      if (!vm.requestRunning) {
        $uibModalInstance.dismiss('cancel');
      }
    };
    vm.setPort = function () {
      if (vm.olt.accessType.label == 'Telnet' && (vm.olt.port == null || vm.olt.port == '' || vm.olt.port == 22)) {
        vm.olt.port = vm.olt.accessType.portSugestion;
      } else if (vm.olt.accessType.label == 'SSH' && (vm.olt.port == null || vm.olt.port == '' || vm.olt.port == 23)) {
        vm.olt.port = vm.olt.accessType.portSugestion;
      }
    };
    vm.save = function () {
      if (vm.formAddOlt.$valid && !vm.requestRunning) {
        var data = {
          name: vm.olt.name.toUpperCase(),
          ip: vm.olt.ip,
          port: vm.olt.port,
          accessType: vm.olt.accessType.value,
          accessUser: vm.olt.accessUser,
          accessPassword: vm.olt.accessPassword
        };

        if (vm.olt.mac) {
          data.mac = vm.olt.mac;
        }

        if (isEdit) {
          data.id = vm.olt.id;
        }

        vm.requestRunning = true;
        if (isEdit) {
          OltService.updateOlt(data).then(successUpdate).catch(errorSave);
        } else {
          OltService.addOlt(data).then(successAdd).catch(errorSave);
        }
      }
    };

    function successGetOlt(data) {
      vm.requestRunning = false;
      vm.olt = data;
      vm.olt.accessType = $filter('filter')(vm.accessTypeList, { value: vm.olt.accessType }, true)[0];
    }

    function errorGetOlt(response) {
      vm.requestRunning = false;
      OltService.errorModalConstructor(response, 'get');
      vm.close();
    }

    function successUpdate(data) {
      vm.requestRunning = false;
      OltService.successModalConstructor('save');
      OltData.arrayOlts.forEach(function (olt) {
        if (olt.id == data.id && olt.name != data.name) {
          olt.name = data.name;
        }
      });
      $scope.$emit('oltUpdateSuccess', data);
    }

    function successAdd(data) {
      vm.requestRunning = false;
      OltService.successModalConstructor('save');
      var newOlt = {
        id: data.id,
        name: data.name,
        ip: data.ip,
        port: data.port,
        model: data.model,
        mostCriticalAlarm: 'NONE',
        onLine: true
      };
      OltData.addOltOnList(newOlt);
      $rootScope.$emit('cleanOltFilter', data);
    }

    function errorSave(response) {
      vm.requestRunning = false;
      OltService.errorModalConstructor(response, 'add');
    }
  }
})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
                .state('olt', {
                    parent: 'app.private',
                    url: '/olt',
                    data: {
                        pageTitle: 'olt.title'
                    },
                    views: {
                        'content@app.private': {
                            templateUrl: 'app/components/olt/olts.html',
                            controller: 'OltController',
                            controllerAs: 'vmOlt'
                        },
                        'search@olt': {
                            templateUrl: 'app/components/olt/olt-search.html',
                            controller: 'OltSearchController',
                            controllerAs: 'vmOltSearch'
                        },
                        'favorites@olt': {
                            templateUrl: 'app/components/favorites/favorites.html',
                            controller: 'FavoritesController',
                            controllerAs: 'vmFavorites'
                        },
                        'list@olt': {
                            templateUrl: 'app/components/olt/olt-list.html',
                            controller: 'OltListController',
                            controllerAs: 'vmOltList'
                        },
                        'detail@olt': {
                            templateUrl: 'app/components/olt/olt-detail.html',
                            controller: 'OltDetailController',
                            controllerAs: 'vmOltDetail'
                        },
                        'history@olt': {
                            templateUrl: 'app/components/olt/olt-history.html',
                            controller: 'OltHistoryController',
                            controllerAs: 'vmOltHistory'
                        },
                        'management@olt': {
                            templateUrl: 'app/components/olt/olt-management.html',
                            controller: 'OltManagementController',
                            controllerAs: 'vmOltManagement'
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('olt');
                                $translatePartialLoader.addPart('olt-modals');
                                return $translate.refresh();
                            }]
                    }
                })
    }

})();

(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('OltService', OltService);

    OltService.$inject = ['$http', '$q', 'RequestService', 'ModalConstructor', 'AlertModalService', 'cfpLoadingBar', 'OltData'];

    function OltService($http, $q, RequestService, ModalConstructor, AlertModalService, cfpLoadingBar, OltData) {

        return {
            // Api Methods
            listOlts: listOlts,
            getOlt: getOlt,
            getOltDetail: getOltDetail,
            addOlt: addOlt,
            updateOlt: updateOlt,
            updateOltDateTime: updateOltDateTime,
            deleteOlts: deleteOlts,
            restartOlts: restartOlts,
            resetOlt: resetOlt,
            uploadFilesToOlt: uploadFilesToOlt,
            uploadTftpFileToOlt: uploadTftpFileToOlt,
            setGtpCpeMgrId: setGtpCpeMgrId,
            // Backup methods
            backupOlts: backupOlts,
            getBackupOlt: getBackupOlt,
            restoreOltBackup: restoreOltBackup,
            // Ports method
            getAllPorts: getAllPorts,
            // History chart method
            getHistory: getHistory,
            // Firmware update methods
            getFiles: getFiles,
            updateOltFirmware: updateOltFirmware,
            // Modal Methods
            addOltModalConstructor: addOltModalConstructor,
            editOltModalConstructor: editOltModalConstructor,
            confirmationOltModalConstructor: confirmationOltModalConstructor,
            errorModalConstructor: errorModalConstructor,
            successModalConstructor: successModalConstructor,
            warningModalConstructor: warningModalConstructor,
            optionRestoreModalConstructor: optionRestoreModalConstructor,
            restoreModalConstructor: restoreModalConstructor,
            updateFirmwareOnuModalConstructor: updateFirmwareOnuModalConstructor,
            gtpCpeMgrModalConstructor: gtpCpeMgrModalConstructor,
            waitModalConstructor: waitModalConstructor,
            uploadFilesTftpModalConstructor: uploadFilesTftpModalConstructor,
            restoreBackupOltModalConstructor: restoreBackupOltModalConstructor,
            restoreOltToFile: restoreOltToFile,
            restoreOltToFileName: restoreOltToFileName,
            abreModalAlarmShowConstructor: abreModalAlarmShowConstructor,
            setAutoConfig: setAutoConfig

        };

        // Api Methods
        function listOlts(data, hideSpinner) {
            return $http.get(oltApi(), {params: listParams(data), ignoreLoadingBar: !!hideSpinner}).then(responseData);
        }

        function getOlt(oltId) {
            return $http.get(oltApi(oltId)).then(responseData);
        }

        function getOltDetail(oltId) {
            return $http.get(oltApi(oltId + '/details'), {ignoreLoadingBar: true}).then(responseData);
        }

        function addOlt(data) {
            return $http.post(oltApi(), data).then(responseData);
        }

        function updateOlt(data) {
            return $http.put(oltApi(), data).then(responseData);
        }

        function updateOltDateTime(oltId, data) {
            return $http.put(oltApi(oltId + '/setdatetime'), data, {ignoreLoadingBar: true}).then(responseData);
        }

        function deleteOlts(oltData) {
            var oltIds = oltData.map(oltId);
            return $http.delete(oltApi(oltIds));
        }

        function restartOlts(oltData) {
            var oltIds = oltData.map(oltId);
            return $http.put(oltApi(oltIds + '/restart')).then(responseData);
        }

        function resetOlt(oltData) {
            var oltIds = oltData.map(oltId);
            return $http.put(oltApi(oltIds + '/reset'), null, {ignoreLoadingBar: true}).then(responseData);
        }

        function uploadFilesToOlt(data) {
            return $http
                    .put(oltApi(data.oltId + '/loadfiles'), uploadDataConfig(data), {
                        headers: {
                            'Content-Type': undefined
                        },
                        ignoreLoadingBar: true
                    })
                    .then(responseData);
        }

        function uploadFilesTftpModalConstructor(oltId) {
            var modal = {
                templateUrl: 'app/components/olt/olt-upload-tftp.html',
                controller: 'OltUploadTftpController',
                controllerAs: 'vmOltUploadTftp',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    oltId: function () {
                        return oltId
                    },
                }
            };
            ModalConstructor.open(modal);
        }

        function restoreBackupOltModalConstructor(oltId) {
            var modal = {
                templateUrl: 'app/components/olt/olt-restore-backup.html',
                controller: 'OltRestoreBackupController',
                controllerAs: 'vmOltRestoreBackup',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    oltId: function () {
                        return oltId
                    },
                }
            };
            ModalConstructor.open(modal);
        }

        function uploadTftpFileToOlt(data) {
            return $http.put(oltApi(data.oltId + '/' + data.fileName + '/loadTftpfileName')).then(responseData);
        }

        function restoreOltToFileName(data) {
            return $http.put(oltApi(data.oltId + '/' + data.fileName + '/restoreFileName')).then(responseData);
        }

        function restoreOltToFile(data) {
            console.log('enviando');
            //return $http.put(oltApi(data.oltId + '/' + data.fileName + '/restoreFile')).then(responseData);
            var formData = new FormData();
            formData.append('file', data.file);
            return $http
                    .put(oltApi(data.oltId + '/restoreFile'), formData, {
                        headers: {
                            'Content-Type': undefined
                        },
                        ignoreLoadingBar: true
                    })
                    .then(responseData);
        }

        function backupOlts(oltData) {
            var oltIds = oltData.map(oltId);
            return $http.post(oltApi(oltIds + '/backup')).then(responseData);
        }

        function getBackupOlt(oltId) {
            return $http.get(oltApi(oltId + '/backup')).then(responseData);
        }

        function restoreOltBackup(data) {
            return $http.put(oltApi(data[0].oltId + '/restore/' + data[0].oltBackupId)).then(responseData);
        }

        function getAllPorts(oltId) {
            return $http.get(portApi(oltId), {ignoreLoadingBar: true}).then(responseData);
        }

        function getHistory(oltId) {
            return $http.get(historyApi(oltId), {ignoreLoadingBar: true}).then(responseData);
        }

        function getFiles(oltId) {
            return $http.get(oltApi('oltfiles/' + oltId)).then(responseData);
        }

        function updateOltFirmware(data) {
            data = data[0]
            return $http.put(oltApi('fwupdate'), data).then(responseData);
        }

        function setGtpCpeMgrId(data) {
            return $http.put(oltApi('gtpcpemgr'), data).then(responseData);
        }

        // Modal Methods
        function addOltModalConstructor() {
            var modal = oltModalConfig();
            ModalConstructor.open(modal);
        }

        function editOltModalConstructor(oltId, scope) {
            var modal = oltModalConfig();
            modal.scope = scope;
            modal.resolve.oltId = oltId;
            ModalConstructor.open(modal);
        }

        function confirmationOltModalConstructor(oltsData, dataAction) {
            var confirmOlt = {
                templateUrl: 'app/components/olt/olt-confirm.html',
                controller: 'OltConfirmController',
                controllerAs: 'vmOltConfirm',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    dataAction: function () {
                        return dataAction;
                    },
                    oltList: function () {
                        return oltsData;
                    }
                },
                avoidCancel: true
            };
            ModalConstructor.open(confirmOlt);
        }

        function errorModalConstructor(response, action) {
            var modalInstance = AlertModalService.error(response, action, 'olt');
            if (response.status == 404) {
                if (action == 'detail') {
                    removeOlts();
                } else {
                    modalInstance.closed.then(removeOlts);
                }
            }
            function removeOlts() {
                var oltList = OltData.detail ? [OltData.detail] : OltData.selected;
                OltData.removeOlts(oltList);
            }
        }

        function successModalConstructor(action, isMultiple, isNotCloseModal) {
            return AlertModalService.success(action, isMultiple, 'olt', isNotCloseModal);
        }

        function warningModalConstructor(list, response, action) {
            AlertModalService.warning(list, response, action, 'olt');
        }

        function optionRestoreModalConstructor() {
            var modal = {
                templateUrl: 'app/components/olt/olt-option-restore.html',
                controller: 'OltOptionRestoreController',
                controllerAs: 'vmOltOptionRestore',
                size: 'sm',
                backdrop: 'static'
            };
            ModalConstructor.open(modal);
        }

        //TODO regilson aqui abre o popup
        function restoreModalConstructor() {
            alert('aqui abre o popup');
            var modal = {
                templateUrl: 'app/components/olt/olt-restore.html',
                controller: 'OltRestoreController',
                controllerAs: 'vmOltRestore',
                size: 'lg',
                backdrop: 'static'
            };
            ModalConstructor.open(modal);
        }

        function updateFirmwareOnuModalConstructor(oltId) {
            var modal = {
                templateUrl: 'app/components/olt/olt-update-firmware.html',
                controller: 'OltUpdateFirmwareController',
                controllerAs: 'vmOltUpdateFirmware',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    oltId: function () {
                        return oltId
                    },
                }
            };
            ModalConstructor.open(modal);
        }

        function gtpCpeMgrModalConstructor(oltId, scope, showMessage) {
            var modal = oltModalGtpCpeMgrConfig();
            var modalInstance = null;
            modal.scope = scope;
            modal.resolve.oltId = oltId;
            modal.resolve.showMessage = showMessage;
            modalInstance = ModalConstructor.open(modal);
            return modalInstance;
        }

        // Api functions
        function oltApi(method) {
            return RequestService.apiUrl('olts', method);
        }

        function portApi(method) {
            return RequestService.apiUrl('ports', method);
        }

        function historyApi(method) {
            return RequestService.apiUrl('history', method);
        }

        // Return only the data of the response
        function responseData(response) {
            return response.data;
        }

        // Helper functions
        function oltId(item) {
            return item.id;
        }

        function listParams(data) {
            var params = {};
            OltData.setSearch(false);
            if (data) {
                OltData.setSearch(true);
                if (data.name) {
                    params.name = data.name;
                }
                if (data.ip) {
                    params.ip = data.ip;
                }
            }
            return params;
        }

        function uploadDataConfig(data) {
            var formData = new FormData();
            var lengthArrayFiles = data.files.length;
            for (var i = 0; i < lengthArrayFiles; i++) {
                formData.append('file', data.files[i]);
            }
            return formData;
        }

        function oltModalConfig() {
            return {
                templateUrl: 'app/components/olt/olt-add.html',
                controller: 'OltAddController',
                controllerAs: 'vmOltAdd',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    oltId: null,
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('olt-modals');
                            $translatePartialLoader.addPart('olt');
                            return $translate.refresh();
                        }]
                }
            };
        }

        function oltModalGtpCpeMgrConfig() {
            return {
                templateUrl: 'app/components/olt/olt-gtp-cpe-mgr.html',
                controller: 'OltGtpCpeMgrController',
                controllerAs: 'vmOltGtpCpeMgr',
                size: 'sm',
                backdrop: 'static',
                avoidCancel: true,
                resolve: {
                    oltId: null,
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('olt-modals');
                            $translatePartialLoader.addPart('olt');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }]
                }
            };
        }

        function waitModalConstructor(activity, action) {
            return AlertModalService.wait(activity, action);
        }

        function abreModalAlarmShowConstructor() {
            var modal = {
                templateUrl: 'app/components/alarm/alarm-show.html',
                controller: 'AlarmShowController',
                controllerAs: 'alarmShowVm',
                size: 'lg',
                backdrop: 'static',
                windowClass: 'modal-console'
            };
            ModalConstructor.open(modal);
        }

        function setAutoConfig(data) {
            return $http.put(oltApi('autoConfig'), data).then(responseData);
        }

    }
})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('OltController', OltController);

    OltController.$inject = ['$scope', 'OltService', 'OltData'];

    function OltController($scope, OltService, OltData) {
        var vm = this;
        OltData.reset();
        vm.data = OltData;

        OltData.requestRunning = true;
        OltService.listOlts(null, true).then(function (data) {
            OltData.setArrayOlts(data);
            OltData.requestRunning = false;
        });

        vm.addOlt = function () {
            OltService.addOltModalConstructor();
        }

        vm.hasNoOlt = function () {
            return !OltData.arrayOlts.length && OltData.dataLoaded == true && !OltData.isSearch;
        }

        vm.hasOltOrSearch = function () {
            return OltData.arrayOlts.length || OltData.isSearch;
        }

    }
})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('SupportController', SupportController);

    SupportController.$inject = ['$scope', '$uibModalInstance'];

    function SupportController($scope, $uibModalInstance) {
        var vm = this;

        vm.close = function () {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('RecoverController', RecoverController);

    RecoverController.$inject = ['$scope', '$locale', '$uibModalInstance', 'UserService', 'LoginService'];

    function RecoverController($scope, $locale, $uibModalInstance, UserService, LoginService) {
        var vm = this;

        vm.email = '';
        vm.requestRunning = false;

        vm.close = function () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.recover = function () {
            if (vm.recoverPassword.$valid) {
                var data = {
                    email: vm.email,
                    language: $locale.id
                };
                vm.requestRunning = true;
                UserService.recoverPassword(data).then(sucessRecover).catch(errorRecover);
            }
        }

        function sucessRecover() {
            vm.requestRunning = false;
            LoginService.successModalConstructor('recoverPassword');
        }

        function errorRecover(response) {
            vm.requestRunning = false;
            LoginService.errorModalConstructor(response, 'recoverPassword');
        }
    }
})();
(function () {
    'use strict';

    angular
            .module('imnApp')
            .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
                .state('login', {
                    parent: 'app.public',
                    url: '/login',
                    data: {
                        pageTitle: 'login.title'
                    },
                    views: {
                        'main@': {
                            templateUrl: 'app/components/login/login.html',
                            controller: 'LoginController',
                            controllerAs: 'vmLogin'
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('login');
                                return $translate.refresh();
                            }]
                    }
                });
    }

})();
(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('LoginService', LoginService);

    LoginService.$inject = ['$http', '$state', 'RequestService', 'ModalConstructor', 'AlertModalService', 'UserData'];

    function LoginService($http, $state, RequestService, ModalConstructor, AlertModalService, UserData) {

        return {
            // Login Methods
            login: login,
            logout: logout,
            // Modal Methods
            recoverLoginModalConstructor: recoverLoginModalConstructor,
            alertNotificationModalConstructor: alertNotificationModalConstructor,
            supportLoginModalConstructor: supportLoginModalConstructor,
            errorModalConstructor: errorModalConstructor,
            successModalConstructor: successModalConstructor
        };

        // Login Methods
        function login(credentials) {
            return $http.post(apiUrl('login'), credentials, configLogin()).then(responseData);
        }

        function logout() {
            return $http
                    .post(apiUrl('logout'))
                    .then(function () {
                        ModalConstructor.closeAll();
                        UserData.reset();
                        $state.go('login');
                    });
        }

        // Modal Methods
        function recoverLoginModalConstructor() {
            var recover = {
                templateUrl: 'app/components/login/login-recover-password.html',
                controller: 'RecoverController',
                controllerAs: 'vmRecover',
                size: 'sm',
                backdrop: 'static'
            };
            ModalConstructor.open(recover);
        }

        function alertNotificationModalConstructor(action) {
            var warning = {
                templateUrl: 'app/components/login/login-alert-notification.html',
                controller: alertNotificationController,
                controllerAs: 'vmAlertNotification',
                size: 'sm',
                windowClass: 'modal-alert modal-warning',
                avoidCancel: true,
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('login');
                            return $translate.refresh();
                        }]
                }
            };

            alertNotificationController.$inject = ['$uibModalInstance'];
            function alertNotificationController($uibModalInstance) {
                this.modalMessage = 'loginWarning.' + action + '.message';
                this.close = function () {
                    $uibModalInstance.dismiss('cancel');
                }
            }

            return ModalConstructor.open(warning);
        }

        function supportLoginModalConstructor() {
            var support = {
                templateUrl: 'app/components/login/login-support.html',
                controller: 'SupportController',
                controllerAs: 'vmSupportController',
                size: 'sm',
                backdrop: 'static'
            };
            ModalConstructor.open(support);
        }

        function errorModalConstructor(response, action) {
            if (response.status == 401 && response.data.message == 'Authentication Failed: Maximum number of accesses reached') {
                response.status = '401.1';
            }
            AlertModalService.error(response, action, 'login');
        }

        function successModalConstructor(action, isMultiple) {
            AlertModalService.success(action, isMultiple, 'login');
        }

        // Helper functions
        function apiUrl(method) {
            return RequestService.baseUrl(method);
        }

        // Return only the data of the response
        function responseData(response) {
            return response.data;
        }

        function configLogin() {
            return {
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                transformRequest: function (obj) {
                    var str = [];
                    for (var p in obj) {
                        str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
                    }
                    return str.join('&');
                }
            };
        }

    }
})();
(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('LoginController', LoginController);

    LoginController.$inject = ['$scope', '$state', 'LoginService', 'UserData', 'Authenticate', '$timeout', 'RequestService'];

    function LoginController($scope, $state, LoginService, UserData, Authenticate, $timeout, RequestService) {

        var vm = this;

        vm.requestRunning = true;
        vm.desabilitaButtonLogin = true;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.credentials = {username: '', password: ''};

        vm.init = init;


        vm.login = function () {
            LoginService.login(vm.credentials).then(successLogin).catch(errorLogin);
        }

        vm.recoverPassword = function () {
            LoginService.recoverLoginModalConstructor();
        }

        function successLogin(data) {
            UserData.getCurrentUser().then(function (data) {
                $state.go('olt').then(function () {
                    if (data.notifications.pwdChanged === true) {
                        LoginService.alertNotificationModalConstructor('passwordChanged');
                    }
                    if (data.notifications.lastSystemBackupOk === false) {
                        LoginService.alertNotificationModalConstructor('backupFailed');
                    }
                });
            });
        }

        function errorLogin(response) {
            LoginService.errorModalConstructor(response, 'authentication');
        }

        vm.supportLogin = function () {
            LoginService.supportLoginModalConstructor();
        }

        function setRequestStart() {
            vm.requestRunning = true;
        }

        function setRequestEnd() {
            vm.requestRunning = false;
        }

        function init() {
            
            setRequestStart();

            fetch(RequestService.baseUrl('swagger-ui.html')).then(function (response) {
                console.log("swagger - response: ", response);
                vm.desabilitaButtonLogin = false;
                setRequestEnd();
                $scope.$apply();
                $timeout(init, 360000);
            }).catch(function (err) {
                console.log("Something went wrong!", err);
                vm.desabilitaButtonLogin = true;
                $timeout(init, 2000);
            });
        }

        init();

    }
})();
(function () {
    'use strict';

    angular
            .module('imnApp')
            .factory('LanguageService', LanguageService);

    LanguageService.$inject = ['$q', '$translate', 'LANGUAGES'];

    function LanguageService($q, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll() {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent() {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sr': 'Srpski',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'vi': 'Tiếng Việt',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('LanguageController', LanguageController);

    LanguageController.$inject = ['$translate', 'LanguageService', 'tmhDynamicLocale'];

    function LanguageController($translate, LanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        LanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage(languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('imnApp')

            /*
             Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
             They are written in English to avoid character encoding issues (not a perfect solution)
             */
            .constant('LANGUAGES', [
                'pt-br',
                'en'
            ]);
})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('GtpController', GtpController);

    GtpController.$inject = ['$scope', '$rootScope', '$translate', '$stateParams', '$sce', '$timeout', 'GtpService', 'RequestService', 'Authenticate'];

    function GtpController($scope, $rootScope, $translate, $stateParams, $sce, $timeout, GtpService, RequestService, Authenticate) {
        var vm = this;

        if (!Authenticate.hasPermission('gtpList')) {
            return;
        }

        // Variables
        vm.gtpList = [];
        var searchParams = null;

        var hasError = false;
        vm.requestRunning = false;

        vm.view = {};
        vm.view.tooltip = '';

        // Methods Api
        vm.addGtp = addGtp;
        vm.editGtp = editGtp;
        vm.deleteGtp = deleteGtp;

        // Methods handlers
        vm.toggle = toggle;
        vm.isListEmpty = isListEmpty;
        vm.hasErrorList = hasErrorList;

        // Validation rules
        var rules = GtpService.getRules();

        // Methods Api
        function addGtp() {
            GtpService.addGtpModalConstructor($scope);
        }

        function editGtp(gtpItem) {
            if (gtpItem.gtpId > rules[gtpItem.oltModel].gtpId.max) {
                GtpService.errorModalConstructor({status: 'reserved', config: {}}, 'edit');
            } else {
                GtpService.editGtpModalConstructor(gtpItem.id, $scope);
            }
        }

        function deleteGtp(gtpItem) {
            if (gtpItem.gtpId > rules[gtpItem.oltModel].gtpId.max) {
                GtpService.errorModalConstructor({status: 'reserved', config: {}}, 'delete');
            } else {
                var dataAction = {
                    action: 'delete',
                    methodService: 'deleteGtp',
                    methodExtra: function (gtpItem) {
                        vm.gtpList.forEach(function (item, index, array) {
                            if (item.id === gtpItem[0].id) {
                                array.splice(index, 1);
                            }
                        });
                    }
                };
                GtpService.confirmationModalConstructor([gtpItem], dataAction);
            }
        }

        function getTooltip() {
            translateTooltip()
            var translateChangeListener = $rootScope.$on('$translateChangeSuccess', translateTooltip);
            $rootScope.$on('$destroy', translateChangeListener);
        }

        function translateTooltip() {
            $translate('tooltip.addGtp').then(function (translation) {
                vm.view.tooltip = $sce.trustAsHtml(translation);
            });
        }

        function getGtpList() {
            RequestService.cancelRequests(['gtps']);
            vm.gtpList = [];
            vm.requestRunning = true;
            GtpService.listGtp(searchParams, true).then(successListGtp).catch(errorListGtp);
        }

        // Methods handle
        function toggle(id) {
            vm.gtpList.forEach(function (item) {
                if (item.id == id) {
                    item.opened = !item.opened;
                } else {
                    item.opened = false;
                }
            });
        }

        function isListEmpty() {
            return !vm.requestRunning && !vm.gtpList.length && !hasError;
        }

        function hasErrorList() {
            return !vm.requestRunning && !vm.gtpList.length && hasError;
        }

        var listenerUpdate = $rootScope.$on('gtpUpdateSuccess', function (event, data) {
            vm.gtpList.forEach(function (gtp, index, arrayList) {
                if (gtp.id == data.id) {
                    arrayList[index] = angular.copy(data);
                    arrayList[index].opened = true;
                }
            });
        })
        $rootScope.$on('$destroy', listenerUpdate);

        var listenerAdd = $rootScope.$on('gtpAddSuccess', function (event, data) {
            var gtpItem = angular.copy(data);
            vm.gtpList.push(gtpItem);
        })
        $rootScope.$on('$destroy', listenerAdd);

        // Request Callbacks
        function successListGtp(data) {
            vm.requestRunning = false;
            vm.gtpList = data;
            hasError = false;
        }

        function errorListGtp(response) {
            vm.requestRunning = false;
            GtpService.errorModalConstructor(response, 'list');
            hasError = true;
        }

        function initialize() {
            if (!$stateParams.id) {
                getGtpList();
            }
            getTooltip();
        }

        $scope.$on('eventFilter', function (event, data) {
            searchParams = data;
            getGtpList();
        });

        $scope.$on('$viewContentLoaded', function () {
            vm.requestRunning = true;
            $timeout(initialize);
        });

    }
})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('GtpConfirmController', GtpConfirmController);

    GtpConfirmController.$inject = ['$scope', '$uibModalInstance', 'GtpService', 'gtpItem', 'dataAction'];

    function GtpConfirmController($scope, $uibModalInstance, GtpService, gtpItem, dataAction) {
        var vm = this;
        vm.requestRunning = false;

        if (dataAction) {
            vm.action = dataAction.action;
            vm.gtpData = gtpItem[0];
            vm.itemOne = true;

            vm.close = function () {
                if (!vm.requestRunning) {
                    $uibModalInstance.dismiss('cancel');
                }
            }

            vm.confirmAction = function () {
                vm.requestRunning = true;
                GtpService[dataAction.methodService](vm.gtpData).then(success).catch(error);
            }

        }

        function success() {
            vm.requestRunning = false;
            var isMultiple = !vm.itemOne;

            GtpService.successModalConstructor(vm.action, isMultiple);
            if (dataAction.methodExtra) {
                dataAction.methodExtra(gtpItem);
            }
        }

        function error(response) {
            vm.requestRunning = false;
            GtpService.errorModalConstructor(response, vm.action);
        }

    }
})();


(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('GtpAddController', GtpAddController);

    GtpAddController.$inject = ['$scope', '$rootScope', '$uibModalInstance', '$translate', '$filter', 'OltService', 'GtpService', 'gtpId'];

    function GtpAddController($scope, $rootScope, $uibModalInstance, $translate, $filter, OltService, GtpService, gtpId) {

        // Variables
        var vm = this;
        vm.requestRunning = false;
        vm.arrayOlts = null;
        vm.arrayInputs = null;
        vm.oltModelIsIntelbras = null;
        vm.isEdit = !!gtpId;
        vm.modalTitle = vm.isEdit ? 'edit' : 'add';
        vm.labelButton = vm.isEdit ? 'save' : 'create';

        vm.gtpModel = {
            name: '',
            olt: '',
            gtpId: {value: ''},
            guaranteedUpstreamBw: {value: 0},
            trafficClass: 'UBR',
            compensated: false,
            shared: false,
            dbaEnabled: false,
            dbaFixedUsUbrBw: {value: 0},
            dbaFixedUsCbrBw: {value: 0},
            dbaAssuredUsBw: {value: 0},
            dbaMaxUsBw: {value: 0},
            dbaExtraUsBwType: 'BESTEFFORT'
        };

        // Validations
        var rules = GtpService.getRules();

        // Method apis
        vm.getAllOlt = getAllOlt;

        // Method handler
        vm.changeOlt = changeOlt;
        vm.changeSwitch = changeSwitch;
        vm.disableOrEnableInputs = disableOrEnableInputs;
        vm.validateRange = validateRange;
        vm.save = save;
        vm.close = close;
        vm.toggleSwitch = toggleSwitch;

        // Method apis
        function getAllOlt() {
            if (!vm.isEdit) {
                OltService.getOlt().then(successOlt).catch(errorOlt);
            }
        }

        function getOltById(oltId) {
            OltService.getOlt(oltId).then(successOlt).catch(errorOlt);
        }

        // Method handler
        function mainSettings() {
            if (vm.isEdit) {
                vm.requestRunning = true;
                GtpService.getGtp(gtpId).then(successGtp).catch(errorGtp);
            }
        }

        function close() {
            if (!vm.requestRunning) {
                $uibModalInstance.dismiss('cancel');
            }
        }

        function changeOlt(olt) {
            // Build the list of inputs that have value validation
            var inputs = angular.copy(vm.arrayInputs);
            inputs.unshift('gtpId', 'guaranteedUpstreamBw');

            // Validation rules to the selected OLT
            var oltRules = rules[olt.model];

            // Build the list of validation attributes
            var keys = Object.keys(oltRules.defaultBw);
            var rule = '', tooltip = '';

            // Set the validation rule for each input
            inputs.forEach(function (input) {
                // Check and set each validation rule
                keys.forEach(function (key) {
                    // Check if the rule exists for the field, else get the default value
                    rule = oltRules[input] && angular.isDefined(oltRules[input][key]) ? input : 'defaultBw';
                    // Set the right validation value in the model
                    vm.gtpModel[input][key] = oltRules[rule][key];
                });
                // Set the right tooltip for the field checking if it allow zero or not
                tooltip = 'tooltip.gtpBw' + (vm.gtpModel[input].allowZero ? '' : 'NonZero');
                $translate(tooltip, vm.gtpModel[input]).then(setTooltip(input));
            });

            // Set the tooltip for the gtpId field
            $translate('tooltip.gtpId', vm.gtpModel.gtpId).then(setTooltip('gtpId'));

            // Disable or enable inputs according to the OLT selected
            disableOrEnableInputs(olt);
        }

        function setTooltip(input) {
            return function (translation) {
                vm.gtpModel[input].tooltip = translation;
            }
        }

        function changeSwitch(switchField) {
            // Check if it is the DBA enabled switch
            if (switchField == 'dbaEnabled') {
                // Get the switch value
                var dbaEnabled = !!vm.gtpModel.dbaEnabled;
                // Get the Guaranteed bandwidth field
                var field = 'guaranteedUpstreamBw';
                // Set the Guaranteed bandwidth field tooltip according with DBA enabled value
                var tooltip = 'tooltip.gtpBw' + (dbaEnabled ? '' : 'NonZero');
                // Set the allowZero property of Guaranteed bandwidth field according with DBA enabled value
                vm.gtpModel[field].allowZero = rules.Zhone8820G[field].allowZero = dbaEnabled;
                // Set the tooltip translation
                $translate(tooltip, vm.gtpModel[field]).then(setTooltip(field));
            }
        }

        // Enable or Disable the inputs based in olt model type
        function disableOrEnableInputs(olt) {
            vm.oltModelIsIntelbras = olt.model == 'Intelbras8820i';
        }

        // Validate the value of the field according to the rules defined in its model
        function validateRange(key) {
            var input = vm.gtpModel[key];
            var valid = true;

            // Check if value is multiple of the value defined
            valid = valid && input.value !== 0 && (input.value % input.multiple) === 0;
            // Check if the value is in the range defined
            valid = valid && input.value >= input.min && input.value <= input.max;
            // Check if the value is zero, only if field has allowZero set to true
            if (input.allowZero) {
                valid = valid || input.value === 0
            }

            return valid;
        }

        function toggleSwitch(elementToggle) {
            if (elementToggle) {
                vm.gtpModel[elementToggle] = !vm.gtpModel[elementToggle];
            }
        }

        // Method Private
        function createArrayInputFields() {
            vm.arrayInputsSwitch = ['compensated', 'shared', 'dbaEnabled'];
            vm.arrayInputs = ['dbaFixedUsUbrBw', 'dbaFixedUsCbrBw', 'dbaAssuredUsBw', 'dbaMaxUsBw'];
        }

        function save() {
            if (vm.formGtpAdd.$valid && !vm.requestRunning) {
                vm.requestRunning = true;

                var data = {};
                var gtpModel = vm.gtpModel;

                var statusError = '';
                var sum = 0;
                var oltModel = gtpModel.olt.model;

                if (oltModel == 'Zhone8820G' && gtpModel.dbaEnabled) {
                    sum = gtpModel.dbaFixedUsUbrBw.value + gtpModel.dbaFixedUsCbrBw.value;
                    if (sum < rules[oltModel].defaultBw.min) {
                        statusError = '400.1';
                    }
                    sum += gtpModel.dbaAssuredUsBw.value;
                    if (sum > gtpModel.dbaMaxUsBw.value) {
                        statusError = '400.2';
                    }
                } else if (oltModel == 'Intelbras8820i') {
                    sum = gtpModel.dbaFixedUsUbrBw.value + gtpModel.dbaFixedUsCbrBw.value + gtpModel.dbaAssuredUsBw.value;
                    if (sum > gtpModel.dbaMaxUsBw.value) {
                        statusError = '400.3';
                    }
                    if (sum === 0 && gtpModel.dbaExtraUsBwType != 'BESTEFFORT') {
                        statusError = '400.4';
                    }
                }

                if (statusError) {
                    errorSaveGtp({status: statusError, config: {}});
                } else {
                    for (var field in gtpModel) {
                        if (gtpModel[field] && angular.isDefined(gtpModel[field].value)) {
                            data[field] = gtpModel[field].value;
                        } else {
                            data[field] = gtpModel[field];
                        }
                    }
                    data.name = gtpModel.name.toUpperCase();
                    data.oltId = gtpModel.olt.id;
                    if (gtpModel.olt.model == 'Intelbras8820i') {
                        delete data.guaranteedUpstreamBw;
                    }
                    delete data.olt;

                    if (vm.isEdit) {
                        data.id = gtpId;
                        GtpService.updateGtp(data).then(successSaveGtp).catch(errorSaveGtp);
                    } else {
                        GtpService.addGtp(data).then(successSaveGtp).catch(errorSaveGtp);
                    }
                }
            }
        }

        function successGtp(data) {
            for (var field in vm.gtpModel) {
                if (angular.isDefined(vm.gtpModel[field].value)) {
                    vm.gtpModel[field].value = data[field];
                } else {
                    vm.gtpModel[field] = data[field];
                }
            }
            vm.gtpModel.olt = {
                id: data.oltId,
                name: data.oltName
            };
            getOltById(data.oltId);
        }

        function errorGtp(errorType) {
            vm.requestRunning = false;
            GtpService.errorModalConstructor(errorType, 'get');
            close();
        }

        // Method response
        function successOlt(data) {
            vm.requestRunning = false;

            if (vm.isEdit) {
                vm.gtpModel.olt.model = data.model;
                changeOlt(data);
                changeSwitch('dbaEnabled');
            } else {
                vm.arrayOlts = data;
            }
        }

        function errorOlt(response) {
            vm.requestRunning = false;
            GtpService.errorModalConstructor(response, 'getOltList');
        }


        function successSaveGtp(data) {
            vm.requestRunning = false;
            var modalInstance = GtpService.successModalConstructor('save');
            modalInstance.result.finally(function () {
                if (vm.isEdit) {
                    $rootScope.$emit('gtpUpdateSuccess', data);
                } else {
                    $rootScope.$emit('gtpAddSuccess', data);
                    $rootScope.$emit('cleanFilter');
                }
            });
        }

        function errorSaveGtp(response) {
            vm.requestRunning = false;
            GtpService.errorModalConstructor(response, 'save');
        }

        function initialize() {
            createArrayInputFields();
            mainSettings();
            getAllOlt();
        }
        initialize();
    }
})();

(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('GtpService', GtpService);

    GtpService.$inject = ['$http', 'RequestService', 'ModalConstructor', 'AlertModalService'];

    function GtpService($http, RequestService, ModalConstructor, AlertModalService) {

        var service = {
            // API Methods
            listGtp: listGtp,
            deleteGtp: deleteGtp,
            addGtp: addGtp,
            getGtp: getGtp,
            updateGtp: updateGtp,

            // Validation rules
            getRules: getRules,

            // Modal Methods
            successModalConstructor: successModalConstructor,
            errorModalConstructor: errorModalConstructor,
            confirmationModalConstructor: confirmationModalConstructor,
            addGtpModalConstructor: addGtpModalConstructor,
            editGtpModalConstructor: editGtpModalConstructor
        };

        return service;

        function deleteGtp(data) {
            return $http.delete(apiUrl(data.id)).then(responseData);
        }

        function getGtp(gtpId) {
            return $http.get(apiUrl(gtpId)).then(responseData);
        }

        function listGtp(filters, hideSpinner) {
            var expressionFilter = constructFilter(filters || {});
            return $http.get(apiUrl(), {params: expressionFilter, ignoreLoadingBar: !!hideSpinner}).then(responseData);
        }

        function addGtp(data) {
            return $http.post(apiUrl(), data).then(responseData);
        }

        function updateGtp(data) {
            return $http.put(apiUrl(), data).then(responseData);
        }

        // Validation rules
        function getRules() {
            return {
                Zhone8820G: {
                    gtpId: {min: 1, max: 2147483647},
                    defaultBw: {min: 128, max: 1048576, multiple: 64, allowZero: true},
                    guaranteedUpstreamBw: {min: 512, multiple: 512, allowZero: false},
                    dbaFixedUsCbrBw: {min: 512, max: 454208},
                    dbaAssuredUsBw: {min: 256}
                },
                Intelbras8820i: {
                    gtpId: {min: 1, max: 128},
                    defaultBw: {min: 256, max: 1240640, multiple: 64, allowZero: true},
                    dbaFixedUsCbrBw: {max: 833024},
                    dbaMaxUsBw: {allowZero: false}
                }
            };
        }

        // Helper Function
        function apiUrl(method) {
            return RequestService.apiUrl('gtps', method);
        }

        function constructFilter(filter) {
            var result = {oltId: null};
            if (filter.oltId) {
                result.oltId = filter.oltId;
            }
            return result;
        }

        // Return only the data of the response
        function responseData(response) {
            return response.data;
        }

        // Modal Methods
        function successModalConstructor(action, isMultiple) {
            return AlertModalService.success(action, isMultiple, 'gtp');
        }

        function errorModalConstructor(response, action) {
            AlertModalService.error(response, action, 'gtp');
        }

        function confirmationModalConstructor(gtpData, dataAction) {

            var confirm = {
                templateUrl: 'app/components/gtp/gtp-confirm.html',
                controller: 'GtpConfirmController',
                controllerAs: 'vmGtpConfirm',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    dataAction: function () {
                        return dataAction;
                    },
                    gtpItem: function () {
                        return gtpData;
                    }
                }
            };
            ModalConstructor.open(confirm);
        }

        function addGtpModalConstructor(scope) {
            var modal = gtpModalConfig();
            ModalConstructor.open(modal);
        }

        function editGtpModalConstructor(gtpId, scope) {
            var modal = gtpModalConfig();
            modal.scope = scope;
            modal.resolve.gtpId = gtpId;
            ModalConstructor.open(modal);
        }

        function gtpModalConfig() {
            return {
                templateUrl: 'app/components/gtp/gtp-add.html',
                controller: 'GtpAddController',
                controllerAs: 'vmGtpAdd',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    gtpId: null,
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('gtp');
                            return $translate.refresh();
                        }]
                }
            };
        }

    }
})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('FavoritesListController', FavoritesListController);

    FavoritesListController.$inject = ['$scope', '$state', '$uibModalInstance', 'OltService', 'FavoritesService'];

    function FavoritesListController($scope, $state, $uibModalInstance, OltService, FavoritesService) {
        var vm = this;

        vm.favoriteList = [];
        vm.selectedFavorites = [];
        vm.requestRunning = false;

        // Call of service
        vm.requestRunning = true;
        FavoritesService.getFavoritables().then(successGetFavorite).catch(errorGetFavorite);

        vm.close = function () {
            if (!vm.requestRunning) {
                $uibModalInstance.dismiss('cancel');
            }
        }

        function successGetFavorite(data) {
            vm.requestRunning = false;
            vm.favoriteList = data;
        }

        function errorGetFavorite(response) {
            vm.requestRunning = false;
            FavoritesService.errorModalConstructor(response, 'getFavoritables');
            vm.close();
        }

        vm.save = function () {
            vm.selectedFavorites = [];
            vm.favoriteList.forEach(function (item) {
                if (item.userFavorite) {
                    vm.selectedFavorites.push(item.id);
                }
            });
            vm.requestRunning = true;
            FavoritesService.saveFavorites(vm.selectedFavorites).then(successSaveFavorites).catch(errorSaveFavorites);
        }

        function successSaveFavorites(data) {
            vm.requestRunning = false;
            FavoritesService.successModalConstructor('save');
            $scope.$emit('favoritesSaved');
        }

        function errorSaveFavorites(response) {
            vm.requestRunning = false;
            FavoritesService.errorModalConstructor(response, 'save');
        }

    }
})();
(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('FavoritesDeleteController', FavoritesDeleteController);

    FavoritesDeleteController.$inject = ['$scope', '$uibModalInstance', '$translate', 'FavoritesService', 'favorite'];

    function FavoritesDeleteController($scope, $uibModalInstance, $translate, FavoritesService, favorite) {
        var vm = this;
        vm.requestRunning = false;

        $translate('favorites.' + favorite.action).then(function (translation) {
            vm.favorite = {action: translation};
        });

        vm.close = function () {
            if (!vm.requestRunning) {
                $uibModalInstance.dismiss('cancel');
            }
        }

        vm.delete = function () {
            vm.requestRunning = true;
            FavoritesService.deleteFavorite(favorite.id).then(successDelete).catch(errorDelete);
        }

        function successDelete(data) {
            FavoritesService.successModalConstructor('delete');
            vm.requestRunning = false;
            $scope.$emit('favoriteDeleted', data);
        }

        function errorDelete(response) {
            vm.requestRunning = false;
            FavoritesService.errorModalConstructor(response, 'delete');
        }

    }
})();
(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('FavoritesData', FavoritesData);

    function FavoritesData() {

        return {
            oltList: {
                type: 'state',
                state: 'olt'
            },
            oltAdd: {
                type: 'modal',
                service: 'OltService',
                method: 'addOltModalConstructor'
            },
            alarmList: {
                type: 'state',
                state: 'alarms'
            },
            onuList: {
                type: 'state',
                state: 'onu'
            },
            bridgeList: {
                type: 'state',
                state: 'provisioning'
            },
            bridgeAdd: {
                type: 'modal',
                service: 'BridgeService',
                method: 'addBridgeModalConstructor'
            },
            gtpList: {
                type: 'state',
                state: 'provisioning'
            },
            gtpAdd: {
                type: 'modal',
                service: 'GtpService',
                method: 'addGtpModalConstructor'
            },
            packetRuleList: {
                type: 'state',
                state: 'provisioning'
            },
            packetRuleAdd: {
                type: 'modal',
                service: 'PacketRuleService',
                method: 'addPacketRuleModalConstructor'
            },
            userList: {
                type: 'state',
                state: 'config'
            },
            userAdd: {
                type: 'modal',
                service: 'UserService',
                method: 'addUserModalConstructor'
            },
            systemConfiguration: {
                type: 'state',
                state: 'config'
            },
            systemBackup: {
                type: 'modal',
                service: 'SystemConfigService',
                method: 'backupFromFavorite'
            },
            systemBackupRestore: {
                type: 'modal',
                service: 'SystemConfigService',
                method: 'listBackupModalConstructor'
            }
        };

    }
})();
(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('FavoritesService', FavoritesService);

    FavoritesService.$inject = ['$http', '$injector', '$state', 'RequestService', 'ModalConstructor', 'AlertModalService', 'UserData', 'FavoritesData'];

    function FavoritesService($http, $injector, $state, RequestService, ModalConstructor, AlertModalService, UserData, FavoritesData) {

        var service = {
            // Api Methods
            getFavoritables: getFavoritables,
            getFavorites: getFavorites,
            saveFavorites: saveFavorites,
            deleteFavorite: deleteFavorite,
            openFavorite: openFavorite,
            // Modal Methods
            addFavoriteModalConstructor: addFavoriteModalConstructor,
            deleteFavoriteModalConstructor: deleteFavoriteModalConstructor,
            errorModalConstructor: errorModalConstructor,
            successModalConstructor: successModalConstructor,
        };

        return service;

        // API Methods
        function getFavoritables(userId) {
            return $http.get(favoriteApi(userId, 'favoritable')).then(responseData);
        }

        function getFavorites(userId) {
            return $http.get(favoriteApi(userId), {ignoreLoadingBar: true}).then(responseData);
        }

        function saveFavorites(favoriteId, userId) {
            return $http.put(favoriteApi(userId, favoriteId));
        }

        function deleteFavorite(favoriteId, userId) {
            return $http.delete(favoriteApi(userId, favoriteId));
        }

        // Helper functions
        function favoriteApi(userId, method) {
            userId = userId || UserData.id;
            method = userId + '/' + (method || '');
            return RequestService.apiUrl('favorites', method);
        }

        // Return only the data of the response
        function responseData(response) {
            return response.data;
        }

        // Open favorite method
        function openFavorite(action) {
            var favorite = FavoritesData[action];
            switch (favorite.type) {
                case 'modal':
                    var service = $injector.get(favorite.service);
                    service[favorite.method]();
                    break;
                case 'state':
                    $state.go(favorite.state);
                    break;
            }
        }

        // Modal Methods
        function addFavoriteModalConstructor(scope) {
            var addFavorite = {
                templateUrl: 'app/components/favorites/favorites-list.html',
                controller: 'FavoritesListController',
                controllerAs: 'vmFavoritesList',
                size: 'lg',
                backdrop: 'static',
                scope: scope
            };
            ModalConstructor.open(addFavorite);
        }

        function deleteFavoriteModalConstructor(favorite, scope) {
            var deleteFavorite = {
                templateUrl: 'app/components/favorites/favorites-delete.html',
                controller: 'FavoritesDeleteController',
                controllerAs: 'vmFavoriteDelete',
                size: 'sm',
                backdrop: 'static',
                resolve: {favorite: favorite},
                scope: scope
            };
            ModalConstructor.open(deleteFavorite);
        }

        function errorModalConstructor(response, action) {
            AlertModalService.error(response, action, 'favorites');
        }

        function successModalConstructor(action, isMultiple) {
            AlertModalService.success(action, isMultiple, 'favorites');
        }

    }
})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('FavoritesController', FavoritesController);

    FavoritesController.$inject = ['$scope', '$state', '$rootScope', '$sce', '$translate', '$injector', 'FavoritesService'];

    function FavoritesController($scope, $state, $rootScope, $sce, $translate, $injector, FavoritesService) {
        var vm = this;
        var selectedFavorite = null;
        vm.favoriteUserList = [];
        vm.requestRunning = false;
        vm.view = {};
        vm.view.tooltip = '';

        function initialize() {
            vm.requestRunning = true;
            // There is no error callback because the possible errors are already catched by the global error interceptor
            FavoritesService.getFavorites().then(successUserFavorites);
            getTooltip();
        }
        initialize();

        function getTooltip() {
            translateTooltip();
            var translateChangeListener = $rootScope.$on('$translateChangeSuccess', translateTooltip);
            $rootScope.$on('$destroy', translateChangeListener);
        }

        function translateTooltip() {
            $translate('tooltip.addFavorite').then(function (translation) {
                vm.view.tooltip = $sce.trustAsHtml(translation);
            });
        }

        $scope.$on('favoritesSaved', initialize);

        function successUserFavorites(data) {
            vm.favoriteUserList = data;
            vm.requestRunning = false;
        }

        vm.addFavorite = function () {
            FavoritesService.addFavoriteModalConstructor($scope);
        }

        vm.removeFavoriteItem = function (favorite) {
            selectedFavorite = favorite.id;
            FavoritesService.deleteFavoriteModalConstructor(favorite, $scope);
        }

        $scope.$on('favoriteDeleted', successDelete);

        function successDelete() {
            vm.favoriteUserList.forEach(function (item, index) {
                if (item.id == selectedFavorite) {
                    vm.favoriteUserList.splice(index, 1);
                }
            });
            selectedFavorite = null;
        }

        vm.openFavorite = FavoritesService.openFavorite;
    }
})();
(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('ConsoleWebService', ConsoleWebService);

    ConsoleWebService.$inject = ['$http', 'RequestService', 'ModalConstructor', 'AlertModalService'];

    function ConsoleWebService($http, RequestService, ModalConstructor, AlertModalService) {

        return {
            sendCommand: sendCommand,
            disconnect: disconnect,
            consoleWebModalConstructor: consoleWebModalConstructor,
            errorModalConstructor: errorModalConstructor
        };

        function sendCommand(oltId, command) {
            return $http
                    .post(apiUrl(oltId + '/sendcmd'), command, requestConfig())
                    .then(responseData);
        }

        function disconnect(oltId) {
            return $http.post(apiUrl(oltId + '/disconnect'), null, {ignoreLoadingBar: true}).then(responseData);
        }

        // Modal Methods
        function consoleWebModalConstructor(oltId) {
            var consoleWeb = {
                templateUrl: 'app/components/console-web/console-web.html',
                controller: 'ConsoleWebController',
                controllerAs: 'vmConsoleWeb',
                size: 'lg',
                backdrop: 'static',
                windowClass: 'modal-console',
                resolve: {oltId: oltId}
            };
            ModalConstructor.open(consoleWeb);
        }

        function errorModalConstructor(response, action) {
            AlertModalService.error(response, action, 'console');
        }

        // Helper functions
        function apiUrl(method) {
            return RequestService.apiUrl('olts/console', method);
        }

        // Return only the data of the response
        function responseData(response) {
            return response.data;
        }

        function requestConfig() {
            return {
                headers: {
                    'Content-Type': 'text/plain; charset=UTF-8',
                    'Accept': 'text/plain,application/json; charset=UTF-8'
                },
                cancelable: true,
                ignoreLoadingBar: true
            };
        }

    }
})();
(function () {
  angular.module('imnApp').controller('ConsoleWebController', ConsoleWebController);

  ConsoleWebController.$inject = [
    '$scope',
    '$uibModalInstance',
    '$document',
    '$timeout',
    'ConsoleWebService',
    'ConsoleHistoryService',
    'RequestService',
    'OltData'
  ];

  function ConsoleWebController(
    $scope,
    $uibModalInstance,
    $document,
    $timeout,
    ConsoleWebService,
    ConsoleHistoryService,
    RequestService,
    OltData
  ) {
    var vm = this;
    var oltId = OltData.detail.id;
    var defaultPrompt = '';
    var MORE_PAGINATION = '--More--';

    vm.input = '';
    vm.content = '';
    vm.prompt = '';
    vm.requestRunning = false;
    vm.autoFocus = false;
    vm.autoScroll = false;

    vm.sendCommand = sendCommand;
    vm.disconnect = disconnect;
    vm.verifyMouseEvent = verifyMouseEvent;

    $uibModalInstance.rendered.then(function () {
      vm.autoFocus = true;
      sendCommand({ which: 13 });
    });

    // Actions
    function sendCommand(keyEvent) {
      switch (keyEvent.which) {
        case 13:
          if ((vm.input == 'exit' || vm.input == 'logout') && vm.prompt === defaultPrompt) {
            ConsoleWebService.disconnect(oltId).finally(close);
          } else {
            vm.requestRunning = true;
            vm.autoFocus = false;
            vm.autoScroll = false;
            if (vm.input && vm.prompt === defaultPrompt) {
              ConsoleHistoryService.add(vm.input);
            }
            ConsoleWebService.sendCommand(oltId, vm.input || ' ')
              .then(successSend)
              .catch(errorSend);
          }
          break;
        case 38:
          vm.input = ConsoleHistoryService.prev();
          break;
        case 40:
          vm.input = ConsoleHistoryService.next();
          break;
      }
    }

    function disconnect() {
      RequestService.cancelRequests(['olts/console/' + oltId + '/sendcmd']);
      ConsoleWebService.disconnect(oltId).finally(close);
    }

    function verifyMouseEvent() {
      var textIsSelected = $document[0].getSelection().toString();
      vm.autoFocus = false;
      if (!textIsSelected.trim()) {
        $timeout(function () {
          vm.autoFocus = true;
        });
      }
    }

    // Request callbacks
    function successSend(data) {
      if (data.includes(MORE_PAGINATION)) {
        vm.content += vm.prompt + data.replace(/ *$/, '').replace(MORE_PAGINATION, '');
        vm.prompt = MORE_PAGINATION;
        ConsoleWebService.sendCommand(oltId, 'r').then(successSend).catch(errorSend);
        return;
      }

      if (vm.prompt === MORE_PAGINATION) {
        vm.prompt = '';
        data = data.trim() + ' ';
      }

      var pos = data.lastIndexOf('\n');
      var content = vm.prompt + data.substring(0, pos) + '\n';
      var prompt = data.substring(pos + 1);

      if (!vm.prompt) {
        defaultPrompt = prompt;
      }
      vm.content += content;
      vm.prompt = prompt;
      vm.input = '';

      vm.requestRunning = false;
      vm.autoFocus = true;
      vm.autoScroll = true;
    }

    function errorSend(response) {
      vm.requestRunning = false;
      vm.autoFocus = true;
      ConsoleWebService.errorModalConstructor(response, 'sendCommand');
      close();
    }

    function close() {
      $uibModalInstance.dismiss('cancel');
    }
  }
})();

(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('ConsoleHistoryService', ConsoleHistoryService);

    function ConsoleHistoryService() {

        var index = 0;
        var commands = [];

        var service = {
            add: add,
            prev: prev,
            next: next
        };

        return service;

        function add(command) {
            commands.push(command);
            index = commands.length;
        }

        function prev() {
            if (index > 0) {
                return commands[--index];
            }
            return commands[index];
        }

        function next() {
            if (index < commands.length) {
                return commands[++index];
            }
            return '';
        }

    }
})();
(function () {
    'use strict';

    angular
            .module('imnApp')
            .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
                .state('config', {
                    parent: 'app.private',
                    url: '/config',
                    data: {
                        pageTitle: 'systemConfig.title'
                    },
                    views: {
                        'content@app.private': {
                            templateUrl: 'app/components/config/config.html',
                            controller: 'SystemConfigController',
                            controllerAs: 'vmSystemConfig'
                        },
                        'smtp@config': {
                            templateUrl: 'app/components/config/config-smtp.html'
                        },
                        'access-control@config': {
                            templateUrl: 'app/components/config/config-access-control.html'
                        },
                        'backup@config': {
                            templateUrl: 'app/components/backup-db/backup.html'
                        },
                        'user-list@config': {
                            templateUrl: 'app/components/user/user-list.html',
                            controller: 'UserListController',
                            controllerAs: 'vmUserList'
                        },
                        'user-password@config': {
                            templateUrl: 'app/components/user/user-change-password.html',
                            controller: 'UserChangePasswordController',
                            controllerAs: 'vmUserChangePassword'
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('user');
                                $translatePartialLoader.addPart('user-modals');
                                $translatePartialLoader.addPart('config');
                                return $translate.refresh();
                            }]
                    }
                })
    }

})();

(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('SystemConfigService', SystemConfigService);

    SystemConfigService.$inject = ['$http', '$q', 'RequestService', 'ModalConstructor', 'AlertModalService', 'LoginService'];

    function SystemConfigService($http, $q, RequestService, ModalConstructor, AlertModalService, LoginService) {

        return {
            // Api Methods
            getSystemConfig: getSystemConfig,
            getBackupList: getBackupList,
            updateSystemConfig: updateSystemConfig,
            doBackup: doBackup,
            backupFromFavorite: backupFromFavorite,
            restoreBackup: restoreBackup,
            // Modal Methods
            listBackupModalConstructor: listBackupModalConstructor,
            errorModalConstructor: errorModalConstructor,
            successModalConstructor: successModalConstructor,
            confirmationModalConstructor: confirmationModalConstructor,
            restoreAppConfigInitial: restoreAppConfigInitial
        };

        // Api Methods
        function getSystemConfig() {
            return $http.get(configUrl()).then(responseData);
        }

        // Api Methods
        function getBackupList(data) {
            return $http.get(backupUrl(), {params: {path: data}}).then(responseData);
        }

        function updateSystemConfig(data) {
            return $http.put(configUrl(), data).then(responseData);
        }

        function doBackup(data) {
            return $http.post(backupUrl(), {path: data}).then(responseData);
        }

        function restoreAppConfigInitial(data) {
            return $http.post(backupUrl('restoreApp'), {path: data}).then(responseRestoreApp); 
        }

        function backupFromFavorite() {
            var dataAction = {
                action: 'backup',
                getPath: true,
                methodService: 'doBackup'
            };
            confirmationModalConstructor(dataAction);
        }

        function restoreBackup(data) {
            return $http.post(backupUrl('restore'), {file: data.filename, path: data.path}).then(responseData);
        }

        function listBackupModalConstructor(scope, backupPath) {
            var backupList = {
                templateUrl: 'app/components/backup-db/backup-list.html',
                controller: 'BackupListController',
                controllerAs: 'vmBackupList',
                backdrop: 'static',
                scope: scope,
                resolve: {
                    backupFolderPath: function () {
                        return backupPath
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('config');
                            return $translate.refresh();
                        }]
                }
            };
            return ModalConstructor.open(backupList);
        }

        function errorModalConstructor(response, action) {
            return AlertModalService.error(response, action, 'systemConfig');
        }

        function successModalConstructor(action, isMultiple) {
            return AlertModalService.success(action, isMultiple, 'systemConfig');
        }

        function confirmationModalConstructor(dataAction, confirmData) {
            var confirm = {
                templateUrl: 'app/components/backup-db/backup-confirm.html',
                controller: 'BackupConfirmController',
                controllerAs: 'vmBackupConfirm',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    dataAction: function () {
                        return dataAction
                    },
                    confirmData: function () {
                        return confirmData
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('config');
                            return $translate.refresh();
                        }]
                },
                avoidCancel: true
            };
            ModalConstructor.open(confirm);
        }

        // Helper functions
        function configUrl(method) {
            return RequestService.apiUrl('systemconfig', method);
        }

        function backupUrl(method) {
            return RequestService.apiUrl('systembackups', method);
        }

        // Return only the data of the response
        function responseData(response) {
            return response.data;
        }

        function responseRestoreApp(response) {
            LoginService.logout();
            return response.data;
        }

    }
})();
(function () {
  'use strict';

  angular.module('imnApp').controller('SystemConfigController', SystemConfigController);

  SystemConfigController.$inject = ['$scope', '$rootScope', '$filter', 'SystemConfigService', 'Authenticate'];

  function SystemConfigController($scope, $rootScope, $filter, SystemConfigService, Authenticate) {
    if (!Authenticate.hasPermission('systemConfiguration')) {
      return;
    }

    var vm = this;
    vm.requestRunning = false;

    var originalData = initializeData();
    vm.config = initializeData();

    vm.dateTime = {
      days: listDays(),
      hours: listHours(),
      minutes: listMinutes()
    };

    vm.save = save;
    vm.cancel = cancel;
    vm.doBackup = doBackup;
    vm.restoreBackup = restoreBackup;
    vm.allowBackup = allowBackup;
    vm.setPeriodDay = setPeriodDay;
    vm.setPeriodHour = setPeriodHour;
    vm.setPeriodMinute = setPeriodMinute;
    vm.setTooltip = setTooltip;
    vm.restoreAppConfigInitial = restoreAppConfigInitial;

    // Call of Service Get User
    vm.requestRunning = true;
    SystemConfigService.getSystemConfig().then(successGet).catch(errorGet);

    function setTooltip() {
      if (!!originalData.backup.path != !!vm.config.backup.path) {
        vm.tooltip = 'backupNotAllowed';
      } else if (!originalData.backup.path) {
        vm.tooltip = 'backupNotAllowedPathEmpty';
      }
    }

    function save() {
      if (vm.formConfig.$valid && !vm.requestRunning) {
        var data = {
          mailServerSmtp: vm.config.smtp.server,
          mailServerPort: vm.config.smtp.port,
          mailServerUseTls: vm.config.smtp.tls,
          mailServerEmail: vm.config.smtp.email,
          mailServerPassword: vm.config.smtp.password,
          userMaxSimultaneousAccess: vm.config.accessControl,

          tftpServerAddress: vm.config.ipTftp,
          fromSig: vm.config.fromSIG,
          sincronizarAlarme: vm.config.sincronizarAlarme,

          systemBackupConfig: {
            path: vm.config.backup.path,
            periodicActive: vm.config.backup.periodic,
            periodicIntervalDay: vm.config.backup.day.value,
            periodicIntervalTime: vm.config.backup.hour
              ? vm.config.backup.hour.value + ':' + vm.config.backup.minute.value
              : null
          }
        };

        vm.requestRunning = true;
        SystemConfigService.updateSystemConfig(data).then(successUpdate).catch(errorUpdate);
      }
    }

    function cancel() {
      vm.config = angular.copy(originalData);
      vm.formConfig.$setPristine();
    }

    function doBackup() {
      if (allowBackup()) {
        var backupPath = vm.config.backup.path;
        var dataAction = {
          action: 'backup',
          methodParam: backupPath,
          methodService: 'doBackup'
        };
        SystemConfigService.confirmationModalConstructor(dataAction, backupPath);
      }
    }

    function restoreBackup() {
      if (allowBackup()) {
        var backupPath = vm.config.backup.path;
        SystemConfigService.listBackupModalConstructor($scope, backupPath);
      }
    }

    function restoreAppConfigInitial(data) {
      var backupPath = vm.config.backup.path;
      var dataAction = {
        action: 'restoreApp',
        methodService: 'restoreAppConfigInitial'
      };
      SystemConfigService.confirmationModalConstructor(dataAction);
      //return $http.post(backupUrl('restoreApp'), {path: data}).then(responseData);
    }

    function allowBackup() {
      return !vm.requestRunning && vm.config.backup.path && vm.config.backup.path == originalData.backup.path;
    }

    function setPeriodDay($select) {
      if (vm.config.backup.day) {
        vm.dateTime.hours = listHours(0);
      } else {
        $select != null ? ($select.activeIndex = 0) : '';
        vm.config.backup.minute = { label: '00min', value: '00' };
        vm.dateTime.hours = listHours(1);
        if (vm.config.backup.hour && vm.config.backup.hour.value == '00') {
          vm.config.backup.hour = '';
        }
      }
    }

    function setPeriodHour($select) {
      if (!vm.config.backup.hours) {
        $select.activeIndex = 0;
      }
    }

    function setPeriodMinute($select) {
      if (!vm.config.backup.minute) {
        $select.activeIndex = 0;
      }
    }

    function successGet(data) {
      vm.requestRunning = false;

      if (data) {
        originalData.smtp.server = data.mailServerSmtp;
        originalData.smtp.port = data.mailServerPort;
        originalData.smtp.tls = data.mailServerUseTls;
        originalData.smtp.email = data.mailServerEmail;
        originalData.smtp.password = data.mailServerPassword;
        originalData.accessControl = data.userMaxSimultaneousAccess;

        originalData.ipTftp = data.tftpServerAddress;
        originalData.fromSIG = data.fromSig;
        originalData.sincronizarAlarme = data.sincronizarAlarme;

        originalData.backup.path = data.systemBackupConfig.path;
        originalData.backup.periodic = data.systemBackupConfig.periodicActive;

        var intervalDay = data.systemBackupConfig.periodicIntervalDay;
        var intervalHour = data.systemBackupConfig.periodicIntervalTime.split(':');

        originalData.backup.day = $filter('filter')(vm.dateTime.days, { value: parseInt(intervalDay) }, true)[0];
        originalData.backup.hour = $filter('filter')(vm.dateTime.hours, { value: intervalHour[0] }, true)[0];
        originalData.backup.minute = $filter('filter')(vm.dateTime.minutes, { value: intervalHour[1] }, true)[0];
        vm.aceiteDoContrato = data.aceiteDoContrato;
        if (!originalData.backup.day) {
          originalData.backup.day = '';
        }

        vm.config = angular.copy(originalData);
        setPeriodDay(null);
        setTooltip();
      }
    }

    function errorGet(response) {
      vm.requestRunning = false;
      SystemConfigService.errorModalConstructor(response, 'get');
    }

    function successUpdate(data) {
      successGet(data);
      SystemConfigService.successModalConstructor('updateConfig');
    }

    function errorUpdate(response) {
      vm.requestRunning = false;
      SystemConfigService.errorModalConstructor(response, 'updateConfig');
    }

    // Helper Functions
    function initializeData() {
      return {
        smtp: {
          server: '',
          port: '',
          tls: false,
          email: '',
          password: ''
        },
        accessControl: '',

        ipTftp: '',
        fromSIG: true,
        sincronizarAlarme: true,

        backup: {
          path: '',
          periodic: '',
          day: '',
          hour: '',
          minute: ''
        }
      };
    }

    $scope.$on(
      '$destroy',
      $rootScope.$on('$translateChangeSuccess', function () {
        vm.dateTime.days = listDays();
        if (vm.config.backup.day) {
          vm.config.backup.day = $filter('filter')(vm.dateTime.days, { value: vm.config.backup.day.value }, true)[0];
        }
      })
    );

    function listDays() {
      var days = [''],
        day,
        suffix = ' ' + $filter('translate')('systemConfig.backupConfig.days');
      for (var i = 1; i < 32; i++) {
        day = (i < 10 ? '0' : '') + i;
        days.push({
          label: day + suffix,
          value: i
        });
      }
      return days;
    }

    function listHours(start) {
      start = start || 0;
      var hours = [''],
        hour;
      for (var i = start; i < 24; i++) {
        hour = (i < 10 ? '0' : '') + i;
        hours.push({
          label: hour + 'h',
          value: hour
        });
      }
      return hours;
    }

    function listMinutes() {
      var minutes = [''],
        minute;
      for (var i = 0; i < 60; i++) {
        minute = (i < 10 ? '0' : '') + i;
        minutes.push({
          label: minute + 'min',
          value: minute
        });
      }
      return minutes;
    }
  }
})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('BridgeSimpleAddController', BridgeSimpleAddController);

    BridgeSimpleAddController.$inject = ['$scope', '$uibModalInstance', '$q', '$filter', '$translate', 'BridgeService', 'OltService', 'OnuService', 'onuItem'];
    function BridgeSimpleAddController($scope, $uibModalInstance, $q, $filter, $translate, BridgeService, OltService, OnuService, onuItem) {

        var vm = this;
        vm.requestRunning = false;

        // Comboboxes content
        vm.portList = [];
        vm.typesList = [];
        vm.multicastList = [];
        vm.rgModeList = [];

        // Comboboxes and radio buttons actions
        vm.setService = setService;
        vm.setMulticastList = setMulticastList;

        // Form actions
        vm.close = close;
        vm.save = save;
        vm.advancedSettings = advancedSettings;
        vm.setRgMode = setRgMode;

        // Return the path of the partial view
        vm.partial = partial;

        // Get validation rules
        var validationRules = BridgeService.getValidationRules();

        initialize();

        // Action Functions

        // Set the selected service
        function setService() {
            // Actions that are specific to each type
            if (vm.bridge.service == 'video') {
                // Enable the Multicast List combo
                setMcl();
                // Enable the maximum multicast streams input
                vm.bridge.maxMulticastStreams.disabled = false;
            } else {
                // Disable the IGMP Send IP input
                vm.bridge.multicastList.disabled = true;
                // Disable the maximum multicast streams input
                vm.bridge.maxMulticastStreams.disabled = true;
            }
        }

        // Set the selected multicast control list
        function setMulticastList(multicastList) {
            // Enable the maximum multicast streams input
            vm.bridge.maxMulticastStreams.disabled = false;
        }

        function close() {
            if (!vm.requestRunning) {
                $uibModalInstance.dismiss('cancel');
            }
        }

        // Set the selected MCL
        function setMcl() {
            if (vm.bridge.service == 'video' && vm.bridge.olt.model.id && vm.multicastList.length) {
                vm.bridge.multicastList.disabled = false;
            } else {
                vm.bridge.multicastList.disabled = true;
            }
        }

        function initialize() {

            vm.bridge = {
                name: {value: '', maxlength: 60},
                interface: {value: 'ONU', disabled: true},
                olt: {model: {id: onuItem.oltId, name: onuItem.oltName}},
                port: {model: ''},
                onu: {model: {id: onuItem.onuId, name: onuItem.onuName}},
                type: {label: 'Downlink', value: 'DOWNLINK'},
                vlanMode: 'tagged',
                vlan: {value: ''},
                service: 'data',
                video: {disabled: false},
                voice: {disabled: true},
                multicastList: {model: '', disabled: true},
                maxMulticastStreams: {value: '', disabled: true},
                macLimit: '',
                rgMode: ''
            };

            disableSave();
            $q.all([
                getOltInfo(onuItem.oltId),
                getPortInfo(),
                getOnuInfo({oltId: onuItem.oltId, name: onuItem.onuName}),
                BridgeService.getTypes().then(setList('typesList')),
                BridgeService.getMulticastLists({oltId: onuItem.oltId}).then(setList('multicastList')),
            ]).then(function () {
                enableSave();
                getRgMode();
            }).catch(close);

        }

        function getRgMode() {
            var meProfile = vm.bridge.onu.model.meProfile;
            vm.bridge.rgMode = {model: {label: 'OMCI', value: ''}, disabled: false};

            if (vm.bridge.olt.model.model === 'Intelbras8820i') {
                if (meProfile === 'intelbras-110' || meProfile === 'intelbras-110g' || meProfile === 'intelbras-110b') {
                    vm.bridge.rgMode.disabled = true;
                } else {
                    BridgeService.getRgModesIntelbras(meProfile).then(setList('rgModeList'));
                }
            } else {
                if (meProfile === 'intelbras-110' || meProfile === 'intelbras-110g' || meProfile === 'intelbras-110b') {
                    vm.bridge.rgMode.disabled = true;
                } else {
                    BridgeService.getRgModesOLT8820G(meProfile).then(setList('rgModeList'));
                }
            }

        }

        // Set the RG Mode selected
        function setRgMode(rgMode) {
            advancedSettings();
        }

        function save() {

            if (vm.formAddBridge.$valid && !vm.requestRunning) {

                var data = {
                    name: vm.bridge.name.value.toUpperCase(),
                    oltId: vm.bridge.olt.model.id,
                    portNumber: vm.bridge.port.model.value,
                    portType: vm.bridge.port.model.type,
                    onuId: vm.bridge.onu.model.id,
                    type: vm.bridge.type.value,
                    vlanMode: vm.bridge.vlanMode.toUpperCase(),
                    vlan: vm.bridge.vlan.value,
                    serviceType: vm.bridge.service.toUpperCase()
                };

                if (vm.bridge.macLimit !== '' && vm.bridge.macLimit !== null) {
                    data.maxUnicast = vm.bridge.macLimit
                }

                if (vm.bridge.service == 'video') {
                    if (vm.bridge.multicastList.model.id) {
                        data.multicastControlListId = vm.bridge.multicastList.model.id;
                    }
                    data.maxMulticastStreams = vm.bridge.maxMulticastStreams.value;
                }

                if (vm.bridge.rgMode.model && vm.bridge.rgMode.model.value) {
                    data.rgMode = vm.bridge.rgMode.model.value
                }

                disableSave();
                BridgeService.addBridge(data).then(successAdd).catch(errorAdd);

            }
        }

        function advancedSettings() {
            var modalInstance = BridgeService.addBridgeModalConstructor(null, vm.bridge);
            modalInstance.result.finally(vm.close);
        }

        // Get OLT info to apply validation
        function getOltInfo(oltId) {
            return OltService
                    .getOlt(oltId)
                    .then(function (olt) {
                        vm.bridge.olt.model = olt;

                        // Apply validation rules and tooltip according to OLT model
                        angular.forEach(validationRules[olt.model], function (ruleValue, ruleName) {
                            if (vm.bridge[ruleName]) {
                                angular.forEach(ruleValue, function (value, key) {
                                    vm.bridge[ruleName][key] = value;
                                });
                                $translate('tooltip.' + ruleName, vm.bridge[ruleName]).then(setTooltip(ruleName));
                            }
                        });
                    });
        }

        function getPortInfo() {
            return BridgeService
                    .getPorts()
                    .then(function (data) {
                        vm.bridge.port.model = $filter('filter')(data['ONU'], {value: onuItem.gponPort})[0];
                    });
        }

        // Get onu info to enable/disable ONU Interface fields
        function getOnuInfo(data) {
            return OnuService
                    .getAuthorizedOnuList(data)
                    .then(function (onuList) {
                        vm.bridge.onu.model.meProfile = onuList[0].meProfile;
                    });
        }


        // Requests Callbacks
        function successAdd(data) {
            enableSave();
            BridgeService.successModalConstructor('add');
        }

        function errorAdd(response) {
            enableSave();
            BridgeService.errorModalConstructor(response, 'add');
        }

        // Utilities
        function disableSave() {
            vm.requestRunning = true;
        }

        function enableSave() {
            vm.requestRunning = false;
        }

        // Return a function that set the content of the defined list (used in comboboxes) when the promise is resolved
        function setList(list) {
            return function (data) {
                vm[list] = data;
            }
        }

        function partial(block) {
            return 'app/components/bridge/partials/bridge-config-' + block + '.html';
        }

        function setTooltip(input) {
            return function (translation) {
                vm.bridge[input].tooltip = translation;
            }
        }

    }
})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('BridgeListController', BridgeListController);

    BridgeListController.$inject = ['$scope', '$rootScope', '$translate', '$stateParams', '$sce', '$q', '$timeout', '$filter', 'BridgeService', 'RequestService', 'Authenticate', 'OltService'];

    function BridgeListController($scope, $rootScope, $translate, $stateParams, $sce, $q, $timeout, $filter, BridgeService, RequestService, Authenticate, OltService) {
        var vm = this;

        if (!Authenticate.hasPermission('bridgeList')) {
            return;
        }

        vm.currentPage = 1;
        vm.totalCount = 0;
        vm.itemsPerPage = 50; 
        
        var bridgeListFull = [];
        vm.bridgeList = [];
        vm.portType = {GE1: 'ETH', GE10: '10GE', GPON: 'Gpon'};

        vm.listTipo = [{value: 'omci'},{value: 'pppoe'},{value: 'telefonia'},{value: 'router'}];
        vm.tipo = '';
        vm.nome = '';

        vm.requestRunning = false;
        var hasError = false;
        vm.view = {};
        vm.view.tooltip = '';

        var searchParams = null;
        vm.searchVlan = '';

        vm.addBridge = addBridge;
        vm.configBridge = configBridge;
        vm.deleteBridge = deleteBridge;
        vm.isBridgeListEmpty = isBridgeListEmpty;
        vm.hasErrorList = hasErrorList;
        vm.toggle = toggle;
        vm.isVlanVisible = isVlanVisible;
        vm.getData = getData;
        vm.getBridgeList = getBridgeList;
        vm.bridgeIdPreparedForUpdate = 0;

        // Action Functions
        function addBridge() {
            BridgeService.addBridgeModalConstructor($scope);
        }

        function configBridge(bridgeId) {
            vm.bridgeIdPreparedForUpdate = bridgeId;
            BridgeService.editBridgeModalConstructor($scope, bridgeId);
        }

        function deleteBridge(bridgeItem) {
            var dataAction = {
                action: 'delete',
                methodService: 'deleteBridge',
                methodDependency: function (bridgeItem) {
                    return checkGtp(bridgeItem);
                },
                methodExtra: function (bridgeData) {
                    bridgeListFull.forEach(function (bridge, index, array) {
                        if (bridge.id == bridgeData.id) {
                            array.splice(index, 1);
                        }
                    });
                    getBridgeList()
                }
            };
            BridgeService.confirmationModalConstructor(bridgeItem, dataAction)
        }

        function getTooltip() {
            translateTooltip()
            var translateChangeListener = $rootScope.$on('$translateChangeSuccess', translateTooltip);
            $rootScope.$on('$destroy', translateChangeListener);
        }

        function translateTooltip() {
            $translate('tooltip.addBridge').then(function (translation) {
                vm.view.tooltip = $sce.trustAsHtml(translation);
            });
        }

        function getBridgeList() {
            RequestService.cancelRequests(['bridges']);
            getData(vm.currentPage);
        }

        function isBridgeListEmpty() {
            return !vm.requestRunning && !vm.bridgeList.length && !hasError;
        }

        function hasErrorList() {
            return !vm.requestRunning && !vm.bridgeList.length && hasError;
        }

        function isVlanVisible() {
            return !bridgeListFull.length || vm.requestRunning || vm.hasErrorList();
        }

        function toggle(id) {
            vm.bridgeList.forEach(function (item) {
                if (item.id == id) {
                    item.opened = !item.opened;
                } else {
                    item.opened = false;
                }
            });
        }
        
        function updateList() {
            //vm.bridgeList = $filter('filter')(bridgeListFull, {vlan: vm.searchVlan ? vm.searchVlan : (vm.searchVlan === 0 ? vm.searchVlan : '')});
            getBridgeList();
        }

        var cancelListenerAdd = $rootScope.$on('bridgeAddSuccess', function (event, data) {
            if (vm.searchVlan) {
                vm.searchVlan = '';
            }

            data.forEach(function (item) {
                bridgeListFull.push(parseBridge(item));
            });

            getBridgeList()
        });
        $rootScope.$on('$destroy', cancelListenerAdd);

        var cancelListenerEdit = $rootScope.$on('bridgeUpdateSuccess', function (event, data) {
            data.forEach(function (bridgeUpdated) {
                var isBridgeOnList = false;

                bridgeListFull.forEach(function (bridgeFromList, index) {
                    if (bridgeFromList.id == vm.bridgeIdPreparedForUpdate) {
                        isBridgeOnList = true;
                        bridgeListFull[index] = parseBridge(bridgeUpdated);
                        vm.bridgeIdPreparedForUpdate = 0;
                    }

                });

                if (!isBridgeOnList) {
                    bridgeListFull.push(parseBridge(bridgeUpdated));
                }
            });

            updateList();
        });
        $rootScope.$on('$destroy', cancelListenerEdit);

        function checkGtp(item) {
            var deferred = $q.defer();
            if (!item.onuId) {
                deferred.resolve(true);
            } else {
                OltService.getOlt(item.oltId)
                        .then(function (data) {
                            if (!data.gtpCpeMgrId && data.model == "Intelbras8820i") {
                                OltService.gtpCpeMgrModalConstructor(item.oltId, $scope, true);
                                deferred.resolve(false);
                            }
                            deferred.resolve(true);
                        });
            }
            return deferred.promise;
        }

        // Request Callbacks
        function successListBridge(data) {

            setRequestEnd();
            //bridgeListFull = data.map(parseBridge);
            bridgeListFull = data.data.content.map(parseBridge);
            vm.totalCount = data.data.totalElements; // total data count.

            vm.bridgeList = angular.copy(bridgeListFull);
            hasError = false;


            for (var i = 0; i < data.length; i++) {

                if (data[i].serviceType == 'VOICE') {


                    for (var j = 0; j < data[i].fxs.length; j++) {


                        var fxs = data[i].fxs[j].dialNumber;
                    }
                }
            }
        }        
        
        function errorListBridge() {
            setRequestEnd();
            hasError = true;
        }

        function parseBridge(item) {
            item.status = item.status.toLowerCase();
            item.type = item.type.toLowerCase();
            item.vlanMode = item.vlanMode.toLowerCase();
            item.vlan = item.vlan == null ? '--' : item.vlan;
            item.slan = item.slan == null ? '--' : item.slan;
            return item;
        }

        function setRequestStart() {
            vm.requestRunning = true;
        }

        function setRequestEnd() {
            vm.requestRunning = false;
        }

        if (searchParams && vm.searchVlan) {
            var data = angular.copy(searchParams);
            data.vlan = (vm.searchVlan);                
        } else if (vm.searchVlan) {
            var data = {
                vlan : vm.searchVlan
            }
            searchParams = data;
            vm.searchVlan = '';
        }

        function getData(pageNumber) {
            setRequestStart();
            var data;
            vm.currentPage = pageNumber;   
            if (searchParams) {
                data = angular.copy(searchParams);
                data.currentPage = (vm.currentPage - 1);
            } else {
                data = {
                    currentPage : (vm.currentPage - 1)
                }
            }
            if (vm.tipo != '') {
                data.tipo = vm.tipo.value;
            }
            if (vm.nome != '') {
                data.bridgeName = vm.nome;
            }
            if (vm.searchVlan) {
                data.vlan = (vm.searchVlan);                
            }    
            
            vm.bridgeList = [];
            BridgeService.listBridgePages(data).then(successListBridge).catch(errorListBridge);
        }

        function initialize() {
            if (!$stateParams.id) {
                getBridgeList();
            }
            getTooltip();
        }

        $scope.$on('eventFilter', function (event, data) {
            searchParams = data;
            getBridgeList();
        });

        $scope.$on('$viewContentLoaded', function () {
            $timeout(initialize);
        });

        $scope.$on('clearFilter', function () {
            vm.tipo = '';
            vm.nome = '';
            vm.searchVlan = '';
            searchParams = null;
            getBridgeList();
        });
    }
})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('BridgeConfirmController', BridgeConfirmController);

    BridgeConfirmController.$inject = ['$scope', '$uibModalInstance', 'BridgeService', 'dataAction', 'bridgeData'];

    function BridgeConfirmController($scope, $uibModalInstance, BridgeService, dataAction, bridgeData) {
        var vm = this;
        vm.requestRunning = false;
        vm.name = '';

        if (dataAction) {
            vm.action = dataAction.action;
            vm.name = bridgeData.name;

            vm.close = function () {
                if (!vm.requestRunning) {
                    $uibModalInstance.dismiss('cancel');
                }
            }

            vm.confirmAction = function () {
                if (dataAction.methodDependency) {
                    dataAction.methodDependency(bridgeData).then(function (result) {
                        if (result) {
                            vm.requestRunning = true;
                            var data = dataAction.action == 'update' ? bridgeData : bridgeData.id;
                            BridgeService[dataAction.methodService](data).then(success).catch(error);
                        }
                    });
                } else {
                    vm.requestRunning = true;
                    var data = dataAction.action == 'update' ? bridgeData : bridgeData.id;
                    BridgeService[dataAction.methodService](data).then(success).catch(error);
                }
            }
        }

        function success(data) {
            vm.requestRunning = false;

            if (!dataAction.noSuccessMessage) {
                BridgeService.successModalConstructor(vm.action);
            }

            if (dataAction.methodExtra) {
                var returnData = dataAction.action == 'update' ? data : bridgeData;
                dataAction.methodExtra(returnData);
            }

            if (dataAction.closeOnSuccess) {
                vm.close();
            }
        }

        function error(response) {
            vm.requestRunning = false;
            BridgeService.errorModalConstructor(response, vm.action);
        }

    }
})();

(function () {
    'use strict';

    angular.module('imnApp').controller('BridgeAddController', BridgeAddController);

    BridgeAddController.$inject = [
        '$scope',
        '$rootScope',
        '$filter',
        '$q',
        '$uibModalInstance',
        '$translate',
        'BridgeService',
        'OltService',
        'OnuService',
        'GtpService',
        'PacketRuleService',
        'bridgeId',
        'bridgeData'
    ];

    function BridgeAddController(
        $scope,
        $rootScope,
        $filter,
        $q,
        $uibModalInstance,
        $translate,
        BridgeService,
        OltService,
        OnuService,
        GtpService,
        PacketRuleService,
        bridgeId,
        bridgeData
    ) {
        var vm = this;

        vm.showAlertVisible = false;
        vm.showAlertMessage = '';

        vm.isAdvanced = true;
        vm.isEdit = !!bridgeId;
        vm.fromSimple = !!bridgeData;
        var isNew = (!vm.fromSimple && !vm.isEdit) || vm.fromSimple;
        //var isNew = (!vm.fromSimple && !vm.isEdit);


        vm.modalTitle = vm.isEdit ? 'edit' : 'add';
        vm.buttonLabel = vm.isEdit ? 'save' : 'add';

        // Flag to avoid closing modal when request is running
        vm.requestRunning = false;

        // Comboboxes content
        vm.oltList = [];
        vm.onuList = [];
        vm.typesList = [];
        vm.portList = [];
        vm.multicastList = [];
        vm.packetRuleList = [];
        vm.gtpList = [];
        vm.rgModeList = [];
        vm.ipModeList = [];
        vm.ipProfileList = [];
        vm.serverProfileList = [];
        vm.featuresProfileList = [];
        vm.featuresStaticProfileList = [];
        vm.mediaProfileList = [];
        vm.zhoneFeaturesList = [];
        vm.cpeVoipIpProfileList = [];

        // Comboboxes and radio buttons actions
        vm.setInterface = setInterface;
        vm.setOlt = setOlt;
        vm.setPort = setPort;
        vm.setOnu = setOnu;
        vm.setType = setType;
        vm.setService = setService;
        vm.setGtp = setGtp;
        vm.setRgMode = setRgMode;
        vm.setProfile = setProfile;
        vm.setIpMode = setIpMode;
        vm.setUniPort = setUniPort;
        vm.cpeVoipIpProfile = null;

        vm.serverProfile = '';
        vm.featuresProfile = '';
        vm.mediaProfile = '';
        vm.profileFeature = '';
        vm.zhoneFeatures = '';
        vm.enderecoIp = '';

        // Form actions
        vm.close = close;
        vm.save = save;

        // Form model
        vm.bridge = {};

        // Return the path of the partial view
        vm.partial = partial;

        // Show fields according to the option of RG Mode or IP Mode selected
        vm.checkRgMode = checkRgMode;
        vm.isWifi = isWifi;
        vm.is8820G = isOlt8820G;
        vm.isLanPortDisabled = isLanPortDisabled;

        vm.changeConfigIndex = changeConfigIndex;
        vm.changeModoRouted = changeModoRouted;
        vm.validateSaveSipFx = validateSaveSipFx;

        // Get validation rules
        var validationRules = BridgeService.getValidationRules();
        var fxsValidationRules = BridgeService.getFxsValidationRules();

        // Input select reference
        var selectReference = {
            selectOltPort: null,
            selectOnu: null
        };

        initialize();

        // Action Functions

        // Set interface as OLT or ONU
        function setInterface() {
            var selectedInterface = vm.bridge.interface.value;

            // When occur the changing in the interface option, the select olt port will be reset.
            if (selectReference.selectOltPort) {
                resetSelectIndex('selectOltPort');
            }
            // Clear port combo
            vm.bridge.port.model = '';

            // Clear and disable ONU combo
            vm.bridge.onu.model = '';
            vm.bridge.onu.disabled = true;

            // Check if the bridge type selected for the previous interface does not exist
            // for the new interface selected, if it doesn't exist, select the first option
            checkType();

            // Actions that are specific to each interface
            switch (selectedInterface) {
                case 'OLT':
                    // Disable the video service
                    vm.bridge.video.disabled = true;

                    // Disable the voice service
                    vm.bridge.voice.disabled = true;

                    // Hide the ONU Interface column
                    vm.bridge.onuInterface.hidden = true;

                    // If video or voice is selected, change to data
                    if (vm.bridge.service != 'data') {
                        setService('data');
                    }

                    // Disable config ONU (wifi) button
                    vm.bridge.wlan.disabled = true;

                    // Change the size of the modal in order to hide the "ONU Interface" column
                    vm.modalSize = '';

                    break;

                case 'ONU':
                    // Clear GEM port
                    vm.bridge.gemPort.value = '';

                    // There is no untagged mode for ONU
                    // if untagged is selected, change to tagged
                    if (vm.bridge.vlanMode == 'untagged') {
                        vm.bridge.vlanMode = 'tagged';
                    }

                    // Enable the video service
                    vm.bridge.video.disabled = false;

                    // Show the ONU Interface column
                    vm.bridge.onuInterface.hidden = false;

                    // Clear RG mode
                    vm.bridge.rgMode.model = {label: 'OMCI', value: ''};
                    setRgMode(vm.bridge.rgMode.model);
                    vm.bridge.rgMode.disabled = true;

                    // Change the size of the modal in order to show the "ONU Interface" column
                    vm.modalSize = 'modal-xl';

                    break;
            }

            isStpDisabled();
        }

        function validateSaveSipFxCheckOne() {
            var fxs0Nao = !vm.bridge.fxs[0].username && !vm.bridge.fxs[0].password;
            var fxs1Nao = !vm.bridge.fxs[1].username && !vm.bridge.fxs[1].password;
            if (fxs0Nao && fxs1Nao)
                return true;
        }

        function validateSaveSipFx(porta) {
            if (
                ((vm.bridge.fxs[porta - 1].username && vm.bridge.fxs[porta - 1].password) ||
                    (!vm.bridge.fxs[porta - 1].username && !vm.bridge.fxs[porta - 1].password)) &&
                !validateSaveSipFxCheckOne()
            )
                return false;
            return true;
        }

        function changeConfigIndex(modoVoip) {
            vm.serverProfile = '';
            vm.featuresProfile = '';
            vm.mediaProfile = '';
            vm.profileFeature = '';
            vm.zhoneFeatures = '';
            /*
             vm.bridge.fxs.forEach(function(item, index, fxs) {
             fxs[index].serverProfile = '';
             fxs[index].featuresProfile = '';
             fxs[index].mediaProfile = '';
             }); */

            // Clean the fxs ports
            vm.bridge.fxs.forEach(function (port) {
                port.enablePort = false;
                port.dialNumber = '';
                port.username = '';
                port.password = '';
                port.rxGain = 0;
                port.txGain = 0;
            });
        }

        // On select OLT
        function setOlt(selectedOlt) {
            // When occur the changing in the olt option, the select onu will be reset.
            if (selectReference.selectOnu) {
                resetSelectIndex('selectOnu');
            }

            isStpDisabled();

            // Reload the types list according to the selected OLT
            BridgeService.getTypes(selectedOlt.model, null)
                // Apply the content to the list model
                .then(setList('typesList'))
                // Check if the bridge type selected for the previous interface does not exist
                // for the new interface selected, if it doesn't exist, select the first option
                .then(checkType);

            if (isNew) {
                // Clear port combo
                if (vm.bridge.port.model !== '') {
                    vm.bridge.port.model = '';
                }

                // Enable the port combo when an OLT is selected
                BridgeService.getPorts(vm.bridge.olt.model.model).then(setList('portList'));
                vm.bridge.port.disabled = false;
                vm.bridge.port.placeholder = 'global.common.select';
                setPort(vm.bridge.port.model);

                // Clear MCL
                vm.bridge.multicastList.model = {};

                // Clear GTP
                vm.bridge.gtp.model = {};

                // Clear IP Profile
                vm.bridge.ipProfile.model = '';

                // Clear Packet Rule
                vm.bridge.iPacketRule.model = {};
                vm.bridge.ePacketRule.model = {};
            }

            // Load multicast, gtp and packet rule lists according to the selected OLT
            // When editing these content are loaded on get bridge callback
            if (!vm.isEdit) {
                getMulticastLists(selectedOlt.id, true)
                    .then(setMcl)
                    .catch(close);
                getGtpList(selectedOlt.id, true)
                    .then(setGtp)
                    .catch(close);
                PacketRuleService.listGroups(selectedOlt.id, true)
                    .then(successPacketRuleList)
                    .catch(close);
            }

            // Apply validation rules and tooltip according to the selected OLT
            angular.forEach(validationRules[selectedOlt.model], function (ruleValue, ruleName) {
                angular.forEach(ruleValue, function (value, key) {
                    vm.bridge[ruleName][key] = value;
                });
                $translate('tooltip.' + ruleName, vm.bridge[ruleName]).then(setTooltip(ruleName));
            });

            // Apply FXS validation pattern and tooltip according to the selected OLT
            vm.fxsCredentials.pattern = fxsValidationRules[selectedOlt.model].credentials.pattern;
            $translate('tooltip.accessUser.' + selectedOlt.model).then(setFxsTooltip('username'));
            $translate('tooltip.accessPassword.' + selectedOlt.model).then(setFxsTooltip('password'));
        }

        // Set the selected port
        function setPort(selectedPort, $select) {
            // Get the olt select reference and stored in a variable for be handler.
            if (selectReference.selectOltPort == null && $select != null) {
                setSelectReference('selectOltPort', $select);
            }

            // When occur the changing in the olt port option, the select onu will be reset.
            if (selectReference.selectOnu) {
                resetSelectIndex('selectOnu');
            }

            // Clear and request the ONU list filtered by OLT and port
            if (selectedPort && selectedPort.value && vm.bridge.interface.value == 'ONU') {
                var data = {
                    oltId: vm.bridge.olt.model.id,
                    gponPort: selectedPort.value
                };

                // Clear ONU list and ONU model
                vm.onuList = [];
                vm.bridge.onu.model = '';
                vm.bridge.onu.disabled = true;
                vm.bridge.onu.placeholder = 'global.common.loading';

                // Disable Voice Service
                vm.bridge.voice.disabled = true;

                // If voice is selected, change to data
                if (!vm.isEdit && vm.bridge.service == 'voice') {
                    setService('data');
                }

                disableSave();
                //OnuService.getAuthorizedOnuList(data, true).then(successOnuList);
                OnuService.getAuthorizedOnuVmList(data, true).then(successOnuList);

                // Clear RG Mode
                vm.bridge.rgMode.model = {label: 'OMCI', value: ''};
                setRgMode(vm.bridge.rgMode.model);
                vm.bridge.rgMode.disabled = true;
            }
        }

        // Set the selected ONU
        function setOnu(selectedOnu, $select) {
            // Get the onu select reference and stored in a variable for be handler.

            if (selectReference.selectOnu == null && $select != null) {
                setSelectReference('selectOnu', $select);
            }
            // Check features that depend on ONU model
            var meProfile = selectedOnu.meProfile;

            //SOU-249 SOU-236
            //var portModel = 
            if (vm.fromSimple && (selectedOnu != null && $select == null)) {
                if (meProfile == 'Intelbras110') {
                    meProfile = 'intelbras-110';
                } else if (meProfile == 'Intelbras110b') {
                    meProfile = 'intelbras-110b';
                } else if (meProfile == 'Intelbras110g') {
                    meProfile = 'intelbras-110g';
                } else if (meProfile == 'Intelbras110gi') {
                    meProfile = 'intelbras-110gi';
                } else if (meProfile == 'Intelbras120ac') {
                    meProfile = 'intelbras-120ac';
                } else if (meProfile == 'Intelbras121ac') {
                    meProfile = 'intelbras-121ac';
                } else if (meProfile == 'Intelbras121w') {
                    meProfile = 'intelbras-121w';
                } else if (meProfile == 'Intelbras1200r') {
                    meProfile = 'intelbras-1200r';
                } else if (meProfile == 'Intelbras1420g') {
                    meProfile = 'intelbras-1420g';
                } else if (meProfile == 'Intelbras142ng') {
                    meProfile = 'intelbras-142ng';
                } else if (meProfile == 'Intelbras142nw') {
                    meProfile = 'intelbras-142nw';
                } else if (meProfile == 'Intelbrasax1800') {
                    meProfile = 'intelbras-ax1800';
                } else if (meProfile == 'Intelbrasax1800v') {
                    meProfile = 'intelbras-ax1800v';
                } else if (meProfile == 'IntelbrasR1') {
                    meProfile = 'intelbras-r1';
                } else if (meProfile == 'Default') {
                    meProfile = 'intelbras-default';
                } else {
                    meProfile = 'intelbras-110';
                }
                vm.bridge.port = {
                    model: {
                        label: 'Gpon ' + selectedOnu.gponPort,
                        value: selectedOnu.gponPort,
                        type: 'GPON'
                    }
                }
                vm.bridge.onu.model.meProfile = meProfile;
            }

            var noRgMode =
                !(meProfile === 'intelbras-110' && vm.bridge.olt.model.model === 'Intelbras8820i') &&
                meProfile != 'intelbras-110gi' &&
                meProfile != 'intelbras-120ac' &&
                meProfile != 'intelbras-121ac' &&
                meProfile != 'intelbras-121w' &&
                meProfile != 'intelbras-1200r' &&
                meProfile != 'intelbras-142ng' &&
                meProfile != 'intelbras-142nw' &&
                meProfile != 'intelbras-ax1800' &&
                meProfile != 'intelbras-ax1800v' &&
                meProfile != 'intelbras-1420g' &&
                meProfile != 'intelbras-r1' &&
                meProfile != 'intelbras-default';

            console.log("disable rgMode: ", noRgMode);
            // Enable or disable RG Mode according to the selected ONU
            vm.bridge.rgMode.disabled = noRgMode;

            var noVoice = meProfile != 'intelbras-142ng' && meProfile != 'intelbras-1420g' && meProfile != 'intelbras-ax1800v' && meProfile != 'intelbras-default';

            // Enable or disable Voice Service according to the selected ONU
            vm.bridge.voice.disabled = noVoice;

            //console.log('meProfile==>' + meProfile);
            var noVideo = meProfile == 'intelbras-142nw' || meProfile == 'intelbras-121w';
            // Enable the video service
            vm.bridge.video.disabled = noVideo;

            // Get RG Modes by model and meProfile
            if (vm.bridge.olt.model.model === 'Intelbras8820i') {
                BridgeService.getRgModesIntelbras(meProfile).then(setList('rgModeList'));
            } else {
                BridgeService.getRgModesOLT8820G(meProfile).then(setList('rgModeList'));
            }

            if (isNew) {


                // If voice is selected, but ONU has no voice service, change to data
                if (noVoice && vm.bridge.service == 'voice') {
                    setService('data');
                }

                // Clear RG Model
                if ((vm.bridge.olt.model.model !== 'Intelbras8820i') &&
                    (meProfile === 'intelbras-1420g' || meProfile === 'intelbras-142ng' || meProfile === 'intelbras-default')) {
                    vm.bridge.rgMode.model = {label: 'Roteamento (RG)', value: 'RG_ROTEAMENTO'};
                } else {
                    vm.bridge.rgMode.model = {label: 'OMCI', value: ''};
                }
            } else {
                // If is edit or coming from simple, apply the actions according to the selected service
                setService();
            }

            // Apply the actions according to the selected RG Mode

            setRgMode(vm.bridge.rgMode.model);

        }

        // Set the selected type
        function setType(selectedType) {
            vm.bridge.type = selectedType;

            // Actions that are specific to each type
            if (vm.bridge.interface.value == 'OLT') {
                // Only Uplink has video service for OLT
                if (selectedType.value == 'UPLINK') {
                    // Enable the video service
                    vm.bridge.video.disabled = false;
                } else {
                    // Disable the video service
                    vm.bridge.video.disabled = true;
                    // If video is selected, change to data
                    if (vm.bridge.service == 'video') {
                        setService('data');
                    }
                }

                // Bridge Rlink must use STP
                if (selectedType.value == 'RLINK') {
                    // Check and disable the STP switch
                    vm.bridge.stp.value = true;
                    vm.bridge.stp.disabled = true;
                } else {
                    // Uncheck and enable the STP switch
                    vm.bridge.stp.value = false;
                    vm.bridge.stp.disabled = false;
                }
            }
        }

        // Check if the bridge type selected for the previous interface does not exist for
        // the new interface selected, if it doesn't exists, it selects the first option
        function checkType() {
            var selectedInterface = vm.bridge.interface.value;
            if (!$filter('filter')(vm.typesList[selectedInterface], vm.bridge.type.value, true).length) {
                setType(vm.typesList[selectedInterface][0]);
            }
        }

        // Set the selected service
        function setService(service) {
            // If a service is received as an argument, use it
            if (service) {
                vm.bridge.service = service;
            }

            // Enable WLAN Ports and don't show the button 'Add Bridge and Config Wifi'
            setRgMode(vm.bridge.rgMode.model);

            // Actions that are specific to each type
            if (vm.bridge.service == 'video') {
                // Check the IGMP Proxy switch
                vm.bridge.igmpProxy.value = true;
                // Enable the IGMP Send IP input
                vm.bridge.igmpSendIp.disabled = false;

                // If there's an OLT selected, enable the Multicast Control List input
                setMcl();
                // Enable the maximum multicast streams input
                vm.bridge.maxMulticastStreams.disabled = false;
            } else {
                // Uncheck the IGMP Proxy switch
                vm.bridge.igmpProxy.value = false;
                // Disable the IGMP Send IP input
                vm.bridge.igmpSendIp.disabled = true;

                // Disable the Multicast Control List input
                vm.bridge.multicastList.disabled = true;
                // Disable the maximum multicast streams input
                vm.bridge.maxMulticastStreams.disabled = true;

                if (vm.bridge.service == 'voice') {
                    if (!vm.isEdit) {
                        // Clean the fxs ports
                        vm.bridge.fxs.forEach(function (port) {
                            port.enablePort = false;
                            port.dialNumber = '';
                            port.username = '';
                            port.password = '';
                            port.rxGain = 0;
                            port.txGain = 0;
                            //port.serverProfile = '';
                            //port.featuresProfile = '';
                            //port.mediaProfile = '';
                            //port.zhoneFeatures = '';
                        });

                        // Clear the model and reload Profile list according to the selected OLT
                        /*
                         vm.bridge.fxs.forEach(function(item, index, fxs) {
                         fxs[index].serverProfile = '';
                         fxs[index].featuresProfile = '';
                         fxs[index].mediaProfile = '';
                         fxs[index].zhoneFeatures = '';
                         }); */

                        vm.serverProfile = '';
                        vm.featuresProfile = '';
                        vm.mediaProfile = '';
                        vm.profileFeature = '';
                        vm.zhoneFeatures = '';
                    }

                    // Load the profiles
                    vm.bridge.profiles.placeholder = 'global.common.loading';
                    vm.serverProfileList = [];
                    vm.featuresProfileList = [];
                    vm.featuresStaticProfileList = [];
                    vm.mediaProfileList = [];
                    vm.zhoneFeaturesList = [];
                    disableSave();
                    BridgeService.getSipProfiles(vm.bridge.olt.model.id)
                        .then(successSipProfilesList)
                        .catch(function () {
                            enableSave();
                            close();
                        });

                    if (vm.enderecoIp != '0.0.0.0') {
                        BridgeService.getCpeVoipProfiles(vm.bridge.olt.model.id, vm.bridge.olt.model.model, vm.enderecoIp)
                            .then(successCpeVoipProfilesList)
                            .catch(function () {
                                enableSave();
                                close();
                            });
                    } else {
                        BridgeService.getCpeVoipProfiles(vm.bridge.olt.model.id, vm.bridge.olt.model.model)
                            .then(successCpeVoipProfilesList)
                            .catch(function () {
                                enableSave();
                                close();
                            });
                    }

                    // Select the first port
                    vm.selectedFxs = 1;

                    // Disable WLAN Ports and don't show the button 'Add Bridge and Config Wifi'
                    vm.bridge.wlan.disabled = true;
                }
            }

            // Show/hide ONU Interface according to the selected service
            if (vm.bridge.interface.value == 'ONU') {
                vm.bridge.onuInterface.hidden = vm.bridge.service == 'voice';
            }
        }

        // Set the selected MCL
        function setMcl() {
            // If there's an OLT selected, enable the MCL field
            if (vm.bridge.service == 'video' && vm.bridge.olt.model.id && vm.multicastList.length) {
                vm.bridge.multicastList.disabled = false;
            } else {
                vm.bridge.multicastList.disabled = true;
            }
        }

        // Set the selected GTP
        function setGtp() {
            // If there's an OLT selected, enable the GTP field
            if (!vm.bridge.gtp.automatic && vm.bridge.olt.model.id && vm.gtpList.length) {
                vm.bridge.gtp.disabled = false;
            } else {
                vm.bridge.gtp.disabled = true;
            }
        }

        // Set the RG Mode selected
        function setRgMode(rgMode) {
            var promise = null;

//            console.log('rgMode-----------', rgMode.value);
//
//            console.log('isOlt8820i()-------------' + isOlt8820i());
//            console.log('isOnu110()-------------' + isOnu110());
//            console.log('isOnu110G()-------------' + isOnu110G());
//            console.log('isOnu110Gi()-------------' + isOnu110Gi());
//            console.log('isOnuR1()-------------' + isOnuR1());
//            console.log('isOnu121ac()-------------' + isOnu121ac());
//            console.log('isOnu1420g()-------------' + isOnu1420g());

            switch (rgMode.value) {
                case '':
                    // Lan Ports must only be enabled on OMCI mode if there's an OLT and
                    // an ONU selected and if the selected OLT is an 8820i model
                    vm.bridge.lanPort.disabled = !vm.bridge.onu.model || isOnuUnknown() || !isOlt8820i();

                    // Wlan ports and Lan Mode fields are disabled in OMCI mode
                    vm.bridge.wlan.disabled = true;
                    vm.bridge.onuInterface.disabled = true;

                    // If is not edit select only the first LAN port

                    if (vm.isEdit && (isOnu121w() || isOnu120ac() || isOnu121ac() || isOnu1200r() || isOnuax1800() || isOnuax1800v() || isOnu142nw())) {
                        vm.bridge.lanPort.disabled = false;
                    } else if (!vm.isEdit) {
                        vm.bridge.lanPort.model[1] = true;
                        if (isOnu121w() || isOnu120ac() || isOnu121ac() || isOnu1200r()) {
                            vm.bridge.lanPort.disabled = false;
                            vm.bridge.lanPort.model[2] = true;
                            vm.bridge.lanPort.model[3] = false;
                            vm.bridge.lanPort.model[4] = false;
                        } else if (isOnu142nw() || isOnuax1800() || isOnuax1800v()) {
                            vm.bridge.lanPort.disabled = false;
                            vm.bridge.lanPort.model[2] = true;
                            vm.bridge.lanPort.model[3] = true;
                            vm.bridge.lanPort.model[4] = true;
                        } else if (isOlt8820i()) {
                            vm.bridge.lanPort.model[2] = !(isOnu110() || isOnu110G() || isOnu110Gi() || isOnuR1());
                            vm.bridge.lanPort.model[3] = !(isOnu110() || isOnu110G() || isOnu110Gi() || isOnuR1());
                            vm.bridge.lanPort.model[4] = !(isOnu110() || isOnu110G() || isOnu110Gi() || isOnuR1());
                        }
                    }

                    BridgeService.getTypes().then(setList('typesList'));

                    break;

                case 'RG_BROUTED_ITBS':
                    vm.bridge.lanPort.disabled = true;
                    vm.bridge.wlan.disabled = true;
                    vm.bridge.onuInterface.disabled = true;
                    BridgeService.getTypes().then(setList('typesList'));

                    break;

                case 'RG_ROTEAMENTO':
                    //Interface OLT
                    BridgeService.getTypes(null, rgMode.value).then(setList('typesList'));

                    //Configurações de Vídeo
                    vm.bridge.maxMulticastStreams.disabled = true;

                    //Regras de Pacotes
                    vm.bridge.iPacketRule.disabled = true;
                    vm.bridge.ePacketRule.disabled = true;

                    //Interface ONU
                    vm.bridge.onuInterface.disabled = true;
                    vm.bridge.lanPort.disabled = true;
                    vm.bridge.wlan.disabled = true;

                    break;

                case 'RG_BROUTED':
                    // Disable/enable RG Mode Routed fields according to the selected OLT
                    vm.bridge.ipProfile.disabled = isOnuUnknown() || isOlt8820i(); // Disabled for Intelbras
                    vm.bridge.ipMode.disabled = isOnuUnknown() || isOlt8820G(); // Disabled for Zhone
                    vm.bridge.ipAddress.disabled = true;
                    vm.bridge.subnetMask.disabled = true;
                    vm.bridge.gateway.disabled = true;

                    // Clear RG Mode Routed fields
                    vm.bridge.ipProfile.model = '';
                    vm.bridge.ipMode.model = '';
                    vm.bridge.ipAddress.value = '';
                    vm.bridge.subnetMask.value = '';
                    vm.bridge.gateway.value = '';

                    // Load Profile list according to the selected OLT
                    promise = getIpProfiles(vm.bridge.olt.model.id);

                // Falls through
                default:
                    // Check features that depend on ONU model

                    var meProfile = vm.bridge.onu.model.meProfile;
                    var noWlan = meProfile != 'intelbras-142ng';

                    if (!isOnuUnknown()) {
                        // LAN ports are always enabled for modes other than OMCI
                        vm.bridge.lanPort.disabled = false;
                    }

                    // Disable WLAN ports according to the selected ONU
                    vm.bridge.wlan.disabled = noWlan;

                    // LAN mode fields are always enabled for modes other than OMCI
                    if (!isOnuUnknown()) {
                        vm.bridge.onuInterface.disabled = false;
                    }

                    // Check all lan ports if it is not editing
                    if (!vm.isEdit) {
                        if (isOlt8820i()) {
                            vm.bridge.lanPort.model[1] = false;
                            vm.bridge.lanPort.model[2] = false;
                            vm.bridge.lanPort.model[3] = false;
                            vm.bridge.lanPort.model[4] = false;
                        } else {
                            vm.bridge.lanPort.model[1] = true;
                            vm.bridge.lanPort.model[2] = !(isOnu110() || isOnu110G() || isOnu110Gi() || isOnuR1());
                            vm.bridge.lanPort.model[3] = !(isOnu110() || isOnu110G() || isOnu110Gi() || isOnuR1());
                            vm.bridge.lanPort.model[4] = !(isOnu110() || isOnu110G() || isOnu110Gi() || isOnuR1());
                        }
                    }

                    BridgeService.getTypes().then(setList('typesList'));
            }
            setUniPort();
            return promise || $q.resolve();
        }

        // Set the Profile selected
        function setProfile(selectedProfile) {
            // Set IP Mode Value according to the selected profile
            //vm.bridge.ipMode.model = $filter('filter')(vm.ipModeList, { value: selectedProfile.ipMode }, true)[0];
            //setIpMode(vm.bridge.ipMode.model);
        }

        function changeModoRouted() {
            vm.bridge.ipProfile.model = '';
            vm.bridge.ipAddress.value = '';
        }

        // Set the IP Mode selected
        function setIpMode(selectedIpMode) {
            var ipProfile = vm.bridge.ipProfile.model;

            // Clear or sets IP Address, Subnet Mask and Gateway according to the selected IP Mode
            switch (selectedIpMode.value) {
                case 'STATIC':
                    // IP Address is empty and enabled
                    vm.bridge.ipAddress.value = '';
                    vm.bridge.ipAddress.disabled = false;

                    // Subnet Mask is empty and enabled
                    vm.bridge.subnetMask.value = ipProfile.subnetMask || '';
                    vm.bridge.subnetMask.disabled = isOlt8820G(); // Disabled for Zhone

                    // Gateway is empty and enabled
                    vm.bridge.gateway.value = ipProfile.gateway || '';
                    vm.bridge.gateway.disabled = isOlt8820G(); // Disabled for Zhone

                    break;

                case 'DHCP':
                    // IP Address is set and disabled
                    vm.bridge.ipAddress.value = isOlt8820G() ? '0.0.0.0' : ipProfile.ipAddress;
                    vm.bridge.ipAddress.disabled = true;

                    // Subnet Mask is empty and disabled
                    vm.bridge.subnetMask.value = ipProfile.subnetMask;
                    vm.bridge.subnetMask.disabled = true;

                    // Gateway is empty and disabled
                    vm.bridge.gateway.value = ipProfile.gateway;
                    vm.bridge.gateway.disabled = true;
            }
        }

        function setUniPort(index) {
            vm.showAlertVisible = false;
            vm.showAlertMessage = '';

            /*
             if(isOlt8820i() && vm.bridge.rgMode.model.value != '' && portObjectToArray(vm.bridge.lanPort.model).length > 1)  {
             vm.showAlertVisible = true;
             vm.showAlertMessage = ' A quantidade de portas não pode ser maior do que uma neste caso.';
             vm.bridge.lanPort.model[index] = false;
             return;
             }
             */
            if (isOlt8820i() && vm.bridge.onu.model && portObjectToArray(vm.bridge.lanPort.model).length > 1) {
                vm.bridge.gemPort.automatic = true;
                vm.bridge.gemPort.automaticDisabled = true;
                vm.bridge.name.maxlength = 56;
            } else {
                vm.bridge.gemPort.automaticDisabled = false;
                vm.bridge.name.maxlength = 60;
            }
            $translate('tooltip.name', vm.bridge.name).then(setTooltip('name'));
        }

        function checkGtp(interfaceModel) {
            var deferred = $q.defer();
            if (interfaceModel == 'ONU' && isOlt8820i()) {
                OltService.getOlt(vm.bridge.olt.model.id).then(function (data) {
                    if (!data.gtpCpeMgrId) {
                        OltService.gtpCpeMgrModalConstructor(vm.bridge.olt.model.id, $scope, true);
                        deferred.resolve(false);
                    }
                    deferred.resolve(true);
                });
            } else {
                deferred.resolve(true);
            }
            return deferred.promise;
        }

        function initialize() {
            vm.showAlertVisible = false;
            vm.showAlertMessage = '';

            vm.bridge = {
                name: {value: '', maxlength: 60},
                interface: {value: 'OLT', disabled: false},
                olt: {model: '', disabled: false},
                port: {model: '', disabled: true, placeholder: 'bridgeModal.placeholder.selectOlt'},
                onu: {model: '', disabled: true, placeholder: 'bridgeModal.placeholder.selectOltAndPort'},
                gemPort: {value: '', automatic: true, automaticDisabled: false},
                type: {label: 'Uplink', value: 'UPLINK'},
                vlanMode: 'untagged',
                vlan: {value: ''},
                cos: '',
                outcosall: '',
                slan: {value: ''},
                scos: '',
                soutcosall: '',
                service: 'data',
                video: {disabled: false},
                voice: {disabled: true},
                igmpProxy: {value: false, disabled: true},
                igmpSendIp: {value: '', disabled: true},
                multicastList: {model: '', disabled: true},
                maxMulticastStreams: {value: '', disabled: true},
                iPacketRule: {model: '', disabled: true},
                ePacketRule: {model: '', disabled: true},
                macLimit: '',
                gtp: {model: '', automatic: true, disabled: true},
                onuInterface: {disabled: true, hidden: true},
                rgMode: {model: {label: 'OMCI', value: ''}, disabled: true},
                ipProfile: {model: '', disabled: true},
                ipMode: {model: '', disabled: true},
                ipAddress: {value: '', disabled: true, required: false},
                subnetMask: {value: '', disabled: true, required: false},
                gateway: {value: '', disabled: true, required: false},
                user: '',
                password: '',
                lanPort: {model: {1: true, 2: true, 3: true, 4: true}, disabled: true},
                wlan: {model: {1: true, 2: false, 3: false, 4: false}, disabled: true},
                uniVlanMode: 'untagged',
                uniVlan: '',
                uniSlan: '',
                serverProfile: '',
                featuresProfile: '',
                mediaProfile: '',
                zhoneFeatures: '',
                fxs: [1, 2].map(function (index) {
                    return {
                        portNumber: index,
                        enablePort: false,
                        dialNumber: '',
                        username: '',
                        password: '',
                        rxGain: 0,
                        txGain: 0,
                        //serverProfile: '',
                        //featuresProfile: '',
                        //mediaProfile: '',
                        //zhoneFeatures: '',
                        get invalid() {
                            var form = vm.formAddBridge;
                            if (form.$submitted) {
                                for (var prop in form) {
                                    /* eslint-disable angular/controller-as-vm */
                                    if (prop.indexOf('fxs' + this.portNumber) > -1 && form[prop].$invalid) {
                                        return true;
                                    }
                                    /* eslint-enable angular/controller-as-vm */
                                }
                            }
                            return false;
                        }
                    };
                }),
                profiles: {placeholder: 'global.common.loading'},
                stp: {value: false, disabled: false}
            };

            vm.fxsCredentials = {pattern: '', username: {tooltip: ''}, password: {tooltip: ''}};

            disableSave();

            // Group all requests promises to enable save button only when all are resolved
            var promises = [
                BridgeService.getTypes().then(setList('typesList')),
                BridgeService.getPorts().then(setList('portList')),
                BridgeService.getRgModesOLT8820G().then(setList('rgModeList')),
                BridgeService.getIpModes().then(setList('ipModeList'))
            ];


            // Check if there is data coming from simple add modal
            if (vm.fromSimple) {
                // Get the values from simple add form

                for (var key in bridgeData) {
                    vm.bridge[key] = bridgeData[key];
                }
                // Get OLT and ONU info to enable/disable ONU Interface fields
                promises.push(getOltAndOnuInfo(vm.bridge.olt.model.id));

                // Show the ONU Interface column
                vm.bridge.onuInterface.hidden = false;

                // Change the size of the modal in order to show the "ONU Interface" column
                vm.modalSize = 'modal-xl';
            } else if (!vm.isEdit) {
                promises.push(OltService.listOlts().then(setList('oltList')));
            }

            if (vm.isEdit) {
                promises.push(
                    BridgeService.getBridge(bridgeId)
                        .then(successBridge)
                        .catch(errorBridge)
                );
            }

            // Enable save button only when all promises are resolved
            $q.all(promises).then(enableSave);
        }

        function close() {
            if (!vm.requestRunning) {
                $uibModalInstance.dismiss('cancel');
            }
        }

        function save(openOnuSettings) {
            if (!vm.formAddBridge.$valid) {
                vm.showAlertVisible = true;
                vm.showAlertMessage = ' Todos os campos em vermelho são obrigatórios.';
                return;
            }

            if ((isOnu121w() || isOnu120ac() || isOnu121ac() || isOnu1200r() || isOnuax1800() || isOnuax1800v() || isOnu142nw() || isOnuR1()) && !vm.bridge.lanPort.disabled && portObjectToArray(vm.bridge.lanPort.model).length != 1) {
                vm.showAlertVisible = true;
                vm.showAlertMessage = ' Selecionar somente uma porta, quando a ONU selecionada for ITBS.';
                return;
            }

            if (vm.formAddBridge.$valid && !vm.requestRunning) {
                vm.showAlertVisible = false;
                vm.showAlertMessage = '';

                checkGtp(vm.bridge.interface.value).then(function (result) {
                    if (result) {
                        var data = {
                            name: vm.bridge.name.value.toUpperCase(),
                            oltId: vm.bridge.olt.model.id,
                            portNumber: vm.bridge.port.model.value,
                            portType: vm.bridge.port.model.type,
                            type: vm.bridge.type.value,
                            vlanMode: vm.bridge.vlanMode.toUpperCase(),
                            serviceType: vm.bridge.service.toUpperCase()
                        };

                        if (vm.bridge.id) {
                            data.id = vm.bridge.id;
                        }

                        if (vm.bridge.vlan.value !== '' && vm.bridge.vlan.value !== null) {
                            data.vlan = vm.bridge.vlan.value;
                        }
                        if (vm.bridge.cos !== '' && vm.bridge.cos !== null) {
                            data.cos = vm.bridge.cos;
                        }
                        if (vm.bridge.outcosall !== '' && vm.bridge.outcosall !== null) {
                            data.outcosall = vm.bridge.outcosall;
                        }

                        if (vm.bridge.vlanMode == 'stagged') {
                            if (vm.bridge.slan.value !== '' && vm.bridge.slan.value !== null) {
                                data.slan = vm.bridge.slan.value;
                            }
                            if (vm.bridge.scos !== '' && vm.bridge.scos !== null) {
                                data.scos = vm.bridge.scos;
                            }
                            if (vm.bridge.soutcosall !== '' && vm.bridge.soutcosall !== null) {
                                data.soutcosall = vm.bridge.soutcosall;
                            }
                        }

                        if (vm.bridge.iPacketRule.model.id) {
                            data.iPacketRuleGroupId = vm.bridge.iPacketRule.model.id;
                        }
                        if (vm.bridge.ePacketRule.model.id) {
                            data.ePacketRuleGroupId = vm.bridge.ePacketRule.model.id;
                        }

                        if (vm.bridge.macLimit !== '' && vm.bridge.macLimit !== null) {
                            data.maxUnicast = vm.bridge.macLimit;
                        }

                        switch (vm.bridge.interface.value) {
                            case 'OLT':
                                data.stp = vm.bridge.stp.value;

                                if (vm.bridge.service == 'video') {
                                    data.igmpProxy = vm.bridge.igmpProxy.value;

                                    if (vm.bridge.igmpSendIp.value) {
                                        data.igmpSendIp = vm.bridge.igmpSendIp.value;
                                    }
                                }

                                break;

                            case 'ONU':
                                data.onuId = vm.bridge.onu.model.id;
                                if (!vm.bridge.gemPort.automatic && vm.bridge.gemPort.value) {
                                    data.gem = vm.bridge.gemPort.value;
                                }

                                switch (vm.bridge.service) {
                                    case 'video':
                                        if (vm.bridge.multicastList.model.id) {
                                            data.multicastControlListId = vm.bridge.multicastList.model.id;
                                        }
                                        data.maxMulticastStreams = vm.bridge.maxMulticastStreams.value;
                                        break;
                                    case 'voice':
                                        data.fxs = vm.bridge.fxs.map(function (item, index) {
                                            var port = angular.copy(item);
                                            port.fxsPortNumber = index + 1;
                                            port.adminState = item.enablePort ? 'UP' : 'DOWN';
                                            delete port.enablePort;
                                            return port;
                                        });
                                        data.cpeVoipProfile = {
                                            index: vm.cpeVoipIpProfile.index,
                                            profileName: vm.cpeVoipIpProfile.profileName,
                                            gateway: vm.cpeVoipIpProfile.gateway
                                        };

                                        if (vm.serverProfile) {
                                            data.serverProfile = vm.serverProfile;
                                        }
                                        if (vm.featuresProfile) {
                                            data.featuresProfile = vm.featuresProfile;
                                        }
                                        if (vm.mediaProfile) {
                                            data.mediaProfile = vm.mediaProfile;
                                        }
                                        if (vm.profileFeature) {
                                            data.profileFeature = vm.profileFeature;
                                        }
                                        if (vm.zhoneFeatures) {
                                            data.zhoneFeatures = vm.zhoneFeatures;
                                        }
                                }

                                if (!vm.bridge.gtp.automatic && vm.bridge.gtp.model.id) {
                                    data.gponTrafficProfileId = vm.bridge.gtp.model.id;
                                }

                                if (!vm.bridge.onuInterface.hidden) {
                                    if (!vm.bridge.rgMode.disabled && vm.bridge.rgMode.model.value) {
                                        data.rgMode = vm.bridge.rgMode.model.value;

                                        switch (data.rgMode) {
                                            case 'RG_BROUTED':
                                                if (vm.bridge.ipProfile.model) {
                                                    data.ipProfile = vm.bridge.ipProfile.model.profileName;
                                                    data.ipMode = vm.bridge.ipProfile.model.modo;
                                                    if (vm.bridge.ipProfile.model.modo == 'STATIC') {
                                                        data.ipAddress = vm.bridge.ipAddress.value;
                                                    }
                                                    data.subnetMask = vm.bridge.ipProfile.model.netmask;
                                                    data.gateway = vm.bridge.ipProfile.model.gateway;
                                                }
                                                /*
                                                 if(vm.bridge.ipProfile.model.name) { data.ipProfile = vm.bridge.ipProfile.model.name }
                                                 if(vm.bridge.ipMode.model.value) { data.ipMode = vm.bridge.ipMode.model.value }
                                                 if(vm.bridge.ipAddress.value) {
                                                 if(vm.bridge.ipMode.model.value == 'STATIC') {
                                                 data.ipAddress = vm.bridge.ipAddress.value;
                                                 }
                                                 }
                                                 if(vm.bridge.subnetMask.value) { data.subnetMask = vm.bridge.subnetMask.value }
                                                 if(vm.bridge.gateway.value) { data.gateway = vm.bridge.gateway.value }
                                                 */
                                                break;

                                            case 'RG_BPPPOE':
                                                data.pppoeUser = vm.bridge.user;
                                                data.pppoePassword = vm.bridge.password;
                                                break;
                                        }
                                    }

                                    if (!vm.bridge.lanPort.disabled) {
                                        var lanPorts = portObjectToArray(vm.bridge.lanPort.model);
                                        if (lanPorts.length) {
                                            data.lanPorts = lanPorts;
                                        }
                                    }

                                    if (!vm.bridge.onuInterface.disabled) {
                                        var wlanAps = portObjectToArray(vm.bridge.wlan.model);
                                        if (!vm.bridge.wlan.disabled && wlanAps.length) {
                                            data.wlanAps = wlanAps;
                                        }

                                        if (vm.bridge.uniVlanMode != 'untagged') {
                                            data.uniVlan = vm.bridge.uniVlan;
                                        }
                                        if (vm.bridge.uniVlanMode == 'stagged') {
                                            data.uniSlan = vm.bridge.uniSlan;
                                        }
                                    }
                                }
                                data.meProfile = vm.bridge.onu.model.meProfile;
                        }
                        if (data.id) {
//                            console.log("update bridge: ", data);
                            var dataAction = {
                                action: 'update',
                                methodService: 'updateBridge',
                                methodExtra: successSave(openOnuSettings, 'update'),
                                closeOnSuccess: openOnuSettings,
                                noSuccessMessage: true
                            };
                            BridgeService.confirmationModalConstructor(data, dataAction);
                        } else {
//                            console.log("add new bridge: ", data);
                            disableSave();
                            BridgeService.addBridge(data)
                                .then(successSave(openOnuSettings, 'add'))
                                .catch(errorAdd);
                        }
                    }
                });
            }
        }

        // Requests Callbacks
        function successBridge(data) {
            vm.bridge.id = data.id;
            vm.bridge.name.value = data.name;
            vm.bridge.interface.value = data.onuId ? 'ONU' : 'OLT';
            vm.bridge.interface.disabled = true;
            vm.bridge.vlanMode = data.vlanMode.toLowerCase();
            vm.bridge.service = data.serviceType.toLowerCase();

            vm.bridge.olt.model = {
                id: data.oltId,
                name: data.oltName
            };

            vm.bridge.port.model = $filter('filter')(
                vm.portList[vm.bridge.interface.value],
                {value: data.portNumber, type: data.portType},
                true
            )[0];

            if (data.vlan != null) {
                vm.bridge.vlan.value = data.vlan;
            }
            if (data.cos != null) {
                vm.bridge.cos = data.cos;
            }
            if (data.outcosall != null) {
                vm.bridge.outcosall = data.outcosall;
            }

            if (vm.bridge.vlanMode == 'stagged') {
                if (data.slan != null) {
                    vm.bridge.slan.value = data.slan;
                }
                if (data.scos != null) {
                    vm.bridge.scos = data.scos;
                }
                if (data.soutcosall != null) {
                    vm.bridge.soutcosall = data.soutcosall;
                }
            }

            PacketRuleService.listGroups(data.oltId)
                .then(function (result) {
                    successPacketRuleList(result);
                    if (data.iPacketRuleGroupId) {
                        vm.bridge.iPacketRule.model = $filter('filter')(vm.packetRuleList, {id: data.iPacketRuleGroupId}, true)[0];
                    }
                    if (data.ePacketRuleGroupId) {
                        vm.bridge.ePacketRule.model = $filter('filter')(vm.packetRuleList, {id: data.ePacketRuleGroupId}, true)[0];
                    }
                })
                .catch(close);

            if (data.maxUnicast != null) {
                vm.bridge.macLimit = data.maxUnicast;
            }

            getOltInfo(data.oltId).then(function () {
                vm.bridge.type = $filter('filter')(vm.typesList[vm.bridge.interface.value], {value: data.type}, true)[0];
                setType(vm.bridge.type);

                switch (vm.bridge.interface.value) {
                    case 'OLT':
                        vm.bridge.stp.value = data.stp;

                        if (vm.bridge.service == 'video') {
                            vm.bridge.igmpProxy.value = data.igmpProxy;
                            vm.bridge.igmpSendIp.disabled = false;

                            if (data.igmpSendIp) {
                                vm.bridge.igmpSendIp.value = data.igmpSendIp;
                            }
                        }

                        vm.modalSize = '';

                        break;

                    case 'ONU':
                        vm.bridge.onu.model = {id: data.onuId, name: data.onuName};

                        if (data.gem) {
                            vm.bridge.gemPort.value = data.gem;
                            vm.bridge.gemPort.automatic = false;
                        }

                        switch (vm.bridge.service) {
                            case 'video':
                                getMulticastLists(data.oltId).then(function () {
                                    if (data.multicastControlListId) {
                                        vm.bridge.multicastList.model = $filter('filter')(
                                            vm.multicastList,
                                            {id: data.multicastControlListId},
                                            true
                                        )[0];
                                        setMcl();
                                    }
                                });
                                vm.bridge.maxMulticastStreams.value = data.maxMulticastStreams;
                                break;
                            case 'voice':
                                if (data.serverProfile) {
                                    vm.serverProfile = data.serverProfile;
                                }
                                if (data.featuresProfile) {
                                    vm.featuresProfile = data.featuresProfile;
                                }
                                if (data.mediaProfile) {
                                    vm.mediaProfile = data.mediaProfile;
                                }
                                if (data.profileFeature) {
                                    vm.profileFeature = data.profileFeature;
                                }
                                if (data.zhoneFeatures) {
                                    vm.zhoneFeatures = data.zhoneFeatures;
                                }

                                if (data.fxs) {
                                    data.fxs.forEach(function (port, index) {
                                        var model = vm.bridge.fxs[index];
                                        model.portNumber = port.fxsPortNumber;
                                        model.enablePort = port.adminState == 'UP';
                                        model.dialNumber = port.dialNumber;
                                        model.username = port.username;
                                        model.password = port.password;
                                        model.rxGain = port.rxGain;
                                        model.txGain = port.txGain;
                                        //model.serverProfile = port.serverProfile;
                                        //model.featuresProfile = port.featuresProfile;
                                        //model.mediaProfile = port.mediaProfile;
                                        //model.zhoneFeatures = port.zhoneFeatures;
                                    });
                                }

                                vm.enderecoIp = data.cpeVoipProfile.gateway;
                        }

                        getGtpList(data.oltId).then(function () {
                            if (data.gponTrafficProfileId) {
                                vm.bridge.gtp.model = $filter('filter')(vm.gtpList, {id: data.gponTrafficProfileId}, true)[0];
                                vm.bridge.gtp.automatic = false;
                                vm.bridge.gtp.disabled = false;
                            }
                        });

                        getOnuInfo({oltId: data.oltId, name: data.onuName}).then(function () {
                            if (vm.bridge.service != 'voice') {
                                if (data.rgMode) {
                                    vm.bridge.rgMode.model = $filter('filter')(vm.rgModeList, {value: data.rgMode}, true)[0];

                                    setRgMode(vm.bridge.rgMode.model).then(function () {
                                        switch (data.rgMode) {
                                            case 'RG_BROUTED':
                                                var routedSelected = {
                                                    modo: data.ipMode,
                                                    profileName: data.ipProfile,
                                                    gateway: data.gateway,
                                                    netmask: data.subnetMask
                                                };

                                                vm.bridge.ipProfile.model = routedSelected;

                                                if (vm.bridge.ipProfile.model.modo == 'STATIC') {
                                                    vm.bridge.ipAddress.value = data.ipAddress;
                                                }

                                                if (data.ipMode == 'DHCP') {
                                                    vm.bridge.ipMode.model = vm.cpeVoipIpProfileList[0];
                                                } else {
                                                    vm.bridge.ipMode.model = vm.cpeVoipIpProfileList[1];
                                                }

                                                //vm.bridge.ipProfile.model = $filter('filter')(vm.cpeVoipIpProfileList, { name: data.ipProfile }, true)[0];
                                                //console.log( vm.bridge.ipProfile.model);

                                                /*
                                                 if(data.ipProfile) {
                                                 vm.bridge.ipProfile.model = $filter('filter')(vm.ipProfileList, { name: data.ipProfile }, true)[0];
                                                 if(!isOnuUnknown()) {
                                                 setProfile(vm.bridge.ipProfile.model);
                                                 }
                                                 }
                                                 
                                                 
                                                 
                                                 if(data.ipMode) {
                                                 vm.bridge.ipMode.model = $filter('filter')(vm.ipModeList, { value: data.ipMode }, true)[0];
                                                 if(!isOnuUnknown()) {
                                                 setIpMode(vm.bridge.ipMode.model);
                                                 }
                                                 
                                                 if(data.ipAddress) { vm.bridge.ipAddress.value = data.ipAddress }
                                                 if(data.subnetMask) { vm.bridge.subnetMask.value = data.subnetMask }
                                                 if(data.gateway) { vm.bridge.gateway.value = data.gateway }
                                                 }
                                                 */

                                                break;

                                            case 'RG_BPPPOE':
                                                if (data.pppoeUser) {
                                                    vm.bridge.user = data.pppoeUser;
                                                }
                                                if (data.pppoePassword) {
                                                    vm.bridge.password = data.pppoePassword;
                                                }
                                        }
                                    });
                                } else {
                                    vm.bridge.rgMode.model = {label: 'OMCI', value: ''};
                                    setRgMode(vm.bridge.rgMode.model);
                                }
                            }
                        });

                        if (data.lanPorts) {
                            vm.bridge.lanPort.model = portArrayToObject(data.lanPorts);
                        } else {
                            for (var port in vm.bridge.lanPort.model) {
                                vm.bridge.lanPort.model[port] = false;
                            }
                        }

                        if (data.wlanAps) {
                            vm.bridge.wlan.model = portArrayToObject(data.wlanAps);
                        } else {
                            for (var ap in vm.bridge.wlan.model) {
                                vm.bridge.wlan.model[ap] = false;
                            }
                        }

                        vm.bridge.uniVlanMode = 'untagged';
                        if (data.uniVlan != null) {
                            vm.bridge.uniVlan = data.uniVlan;
                            vm.bridge.uniVlanMode = 'tagged';
                        }
                        if (data.uniSlan != null) {
                            vm.bridge.uniSlan = data.uniSlan;
                            vm.bridge.uniVlanMode = 'stagged';
                        }

                        // Show the ONU Interface column
                        vm.bridge.onuInterface.hidden = false;

                        // Change the size of the modal in order to show/hide the "ONU Interface" column
                        vm.modalSize = 'modal-xl';
                }
            });
        }

        // Get OLT and ONU info to enable/disable ONU Interface fields
        function getOltAndOnuInfo(oltId) {
            return getOltInfo(oltId).then(function (olt) {
                return getOnuInfo({oltId: olt.id, name: vm.bridge.onu.model.name});
            });
        }

        function getOltInfo(oltId) {
            return OltService.getOlt(oltId).then(function (olt) {
                vm.bridge.olt.model.model = olt.model;
                setOlt(olt);
                return olt;
            });
        }

        function getOnuInfo(data) {
            return OnuService.getAuthorizedOnuList(data).then(function (onuList) {
                vm.bridge.onu.model.meProfile = onuList.data.content[0].meProfile;
                setOnu(onuList.data.content[0], null);
            });
        }

        function errorBridge(response) {
            enableSave();
            BridgeService.errorModalConstructor(response, 'get');
            close();
        }

        // Load GTP list according to the selected OLT
        function getGtpList(oltId, hideLoader) {
            vm.bridge.gtp.disabled = true;
            return GtpService.listGtp({oltId: oltId}, hideLoader)
                .then(setList('gtpList'))
                .catch(close);
        }

        // Load MCL list according to the selected OLT
        function getMulticastLists(oltId, hideLoader) {
            vm.bridge.multicastList.disabled = true;
            return BridgeService.getMulticastLists({oltId: oltId}, hideLoader)
                .then(setList('multicastList'))
                .catch(close);
        }

        function getIpProfiles(oltId) {
            BridgeService.getCpeVoipProfiles(vm.bridge.olt.model.id, vm.bridge.olt.model.model)
                .then(successCpeVoipProfilesList)
                .catch(function () {
                    enableSave();
                    close();
                });

            if (isOlt8820G()) {
                disableSave();
                vm.bridge.ipProfile.disabled = true;
                vm.bridge.ipProfile.placeholder = 'global.common.loading';
                return BridgeService.getIpProfiles(oltId)
                    .then(function (data) {
                        enableSave();
                        if (!isOnuUnknown()) {
                            vm.bridge.ipProfile.disabled = false;
                        }
                        vm.bridge.ipProfile.placeholder = '';
                        //setList('ipProfileList')(data);
                        //setList('ipProfileList')(data);
                        vm.featuresProfileList = data.profilesIndexConfiguracaoDinamico;
                        vm.featuresStaticProfileList = data.profilesIndexConfiguracaoEstatico;
                    })
                    .catch(function () {
                        enableSave();
                        close();
                    });
            }
            return $q.resolve();
        }

        // Request callbacks
        function successOnuList(data) {
            enableSave();
            if (data.data.length) {
                vm.onuList = data.data;
                vm.bridge.onu.disabled = false;
                vm.bridge.onu.placeholder = 'global.common.select';
            } else {
                vm.bridge.onu.placeholder = 'bridgeModal.placeholder.noOnuFound';
                vm.bridge.rgMode.model = {label: 'OMCI', value: ''};
                vm.bridge.lanPort.disabled = true;
                vm.bridge.wlan.disabled = true;
                vm.bridge.onuInterface.disabled = true;
                vm.bridge.rgMode.disabled = true;
            }
        }

        function successPacketRuleList(data) {
            vm.packetRuleList = data;
            vm.bridge.iPacketRule.disabled = !data.length;
            vm.bridge.ePacketRule.disabled = !data.length;
        }

        function successSipProfilesList(data) {
            enableSave();

            vm.serverProfileList = data.profilesIndexServidor;

            vm.featuresProfileList = data.profilesIndexConfiguracaoDinamico;
            vm.featuresStaticProfileList = data.profilesIndexConfiguracaoEstatico;

            vm.mediaProfileList = data.profilesIndexMedia;
            vm.zhoneFeaturesList = data.profilesFeature;

            //vm.serverProfileList = data.server;
            //vm.featuresProfileList = data.features;
            //vm.mediaProfileList = data.media;
            vm.bridge.profiles.placeholder = '';
        }

        function successCpeVoipProfilesList(data) {
            enableSave();
            vm.cpeVoipIpProfileList = data;

            if (vm.enderecoIp != '' && vm.enderecoIp != '0.0.0.0')
                vm.cpeVoipIpProfile = data[1];
            else
                vm.cpeVoipIpProfile = data[0];
        }

        function successSave(openOnuSettings, action) {
            var onuData = {
                id: vm.bridge.onu.model.id,
                oltId: vm.bridge.olt.model.id
            };

            return function (response) {
                enableSave();

                if (openOnuSettings) {
                    if (response.status == 207) {
                        // When response status is 207, the config modal must open only after the warning modal is closed
                        var modalWarningInstance = BridgeService.warningModalConstructor(response.data, response, action, true);
                        modalWarningInstance.closed.then(function () {
                            openOnuConfig(onuData, response, action);
                        });
                    } else {
                        // When response status is 200, the config modal must be open
                        openOnuConfig(onuData, response, action);
                    }
                } else {
                    var modalInstance;
                    if (response.status == 207) {
                        // For response status 207 opens the warning modal
                        modalInstance = BridgeService.warningModalConstructor(response.data, response, action);
                    } else {
                        // For response status 200 opens the success modal
                        modalInstance = BridgeService.successModalConstructor(action, response.data.length > 1);
                    }
                    // Update the list when success/warning modal is closed
                    modalInstance.result.finally(updateList(response, action));
                }
            };
        }

        function openOnuConfig(onuData, response, action) {
            var modalInstance = OnuService.configOnuModalConstructor(onuData, false);
            modalInstance.result.finally(updateList(response, action));
        }

        function updateList(response, action) {
            return function () {
                if (response.status == 207) {
                    // Always clean filter when response status is 207
                    $rootScope.$emit('cleanFilter', true);
                } else {
                    // Emmit event to update list (adding and/or updating the bridges)
                    var actionEvent = action.charAt(0).toUpperCase() + action.slice(1);
                    $rootScope.$emit('bridge' + actionEvent + 'Success', response.data);

                    if (isOlt8820G() && vm.bridge.stp.value) {
                        // Always clean filter if bridge is STP in 8820G
                        $rootScope.$emit('cleanFilter', true);
                    } else if (action == 'add') {
                        // Only emmit the clean event when adding
                        $rootScope.$emit('cleanFilter');
                    }
                }
            };
        }

        $uibModalInstance.closed.then(function () {
            $rootScope.$emit('bridgeClosed');
        });

        var clearListener = $rootScope.$on('onuConfigLoaded', close);
        $scope.$on('$destroy', clearListener);

        function errorAdd(response) {
            enableSave();
            BridgeService.errorModalConstructor(response, 'add');
        }

        // Utilities
        function disableSave() {
            vm.requestRunning = true;
        }

        function enableSave() {
            vm.requestRunning = false;
        }

        function resetSelectIndex(viewSelectReference) {
            selectReference[viewSelectReference].activeIndex = 0;
        }

        function setSelectReference(viewSelectReference, $select) {
            selectReference[viewSelectReference] = $select;
        }

        // Return a function that set the content of the defined list (used in comboboxes) when the promise is resolved
        function setList(list) {
            return function (data) {
                vm[list] = data;
            };
        }

        function partial(block) {
            return 'app/components/bridge/partials/bridge-config-' + block + '.html';
        }

        // Convert lan ports object (used in model) to array (used in request)
        // { 1: true, 2: false, 3: true, 4: true } -> [1, 3, 4]
        function portObjectToArray(obj) {
            return Object.keys(obj)
                .filter(function (key) {
                    return obj[key];
                })
                .map(Number);
        }

        // Convert lan ports array (used in request) to object (used in model)
        // [1, 3, 4] -> { 1: true, 2: false, 3: true, 4: true }
        function portArrayToObject(array) {
            var obj = {};
            for (var i = 1; i <= 4; i++) {
                obj[i] = array.indexOf(i) > -1;
            }
            return obj;
        }

        function isOlt8820G() {
            return vm.bridge.olt.model.model != 'Intelbras8820i';
        }

        function isOlt8820i() {
            return vm.bridge.olt.model.model == 'Intelbras8820i';
        }

        function isOnu110() {
            return vm.bridge.onu.model.meProfile == 'intelbras-110';
        }

        function isOnu110G() {
            return vm.bridge.onu.model.meProfile == 'intelbras-110g' || vm.bridge.onu.model.meProfile == 'intelbras-110b' || vm.bridge.onu.model.meProfile == 'intelbras-110gb';
        }

        function isOnu110Gi() {
            return vm.bridge.onu.model.meProfile == 'intelbras-110gi';
        }

        function isOnu120ac() {
            return vm.bridge.onu.model.meProfile == 'intelbras-120ac';
        }

        function isOnu121ac() {
            return vm.bridge.onu.model.meProfile == 'intelbras-121ac';
        }

        function isOnu121w() {
            return vm.bridge.onu.model.meProfile == 'intelbras-121w';
        }

        function isOnu1200r() {
            return vm.bridge.onu.model.meProfile == 'intelbras-1200r';
        }

        function isOnu1420g() {
            return vm.bridge.onu.model.meProfile == 'intelbras-1420g';
        }
        function isOnuax1800() {
            return vm.bridge.onu.model.meProfile == 'intelbras-ax1800';
        }
        function isOnuax1800v() {
            return vm.bridge.onu.model.meProfile == 'intelbras-ax1800v';
        }
        function isOnu142nw() {
            return vm.bridge.onu.model.meProfile == 'intelbras-142nw';
        }

        function isOnuDefault() {
            return vm.bridge.onu.model.meProfile == 'intelbras-default';
        }

        function isOnuR1() {
            return vm.bridge.onu.model.meProfile == 'intelbras-r1';
        }

        function isOnuUnknown() {
            return vm.bridge.onu.model.meProfile == '--';
        }

        function checkRgMode(rgMode) {
            return vm.bridge.rgMode.model.value == rgMode;
        }

        function isWifi() {
            return false;
            //return vm.bridge.wlan.disabled == false;
        }

        function isLanPortDisabled(index) {
            //vm.bridge.rgMode.model.value != '' && vm.bridge.rgMode.model.value != 'RG_BROUTED_ITBS'

            if (!vm.bridge.lanPort.disabled) {
                if ((isOnu110() || isOnu110G() || isOnu110Gi() || isOnuR1()) && index != 1) {
                    return true;
                }
                if ((isOnu121w() || isOnu120ac() || isOnu121ac() || isOnu1200r()) && index != 1 && index != 2) {
                    return true;
                }
            } else {
                return vm.bridge.lanPort.disabled;
            }
        }

        function setTooltip(input) {
            return function (translation) {
                vm.bridge[input].tooltip = translation;
            };
        }

        function setFxsTooltip(input) {
            return function (translation) {
                vm.fxsCredentials[input].tooltip = translation;
            };
        }

        function isStpDisabled() {
            vm.bridge.stp.disabled = false;
            if (vm.bridge.interface.value == 'OLT' && isOlt8820i()) {
                vm.bridge.stp.disabled = true;
                if (vm.bridge.stp.value)
                    vm.bridge.stp.value = false;
            }
            return vm.bridge.stp.disabled;
        }
    }
})();

(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('BridgeService', BridgeService);

    BridgeService.$inject = ['$http', '$q', 'RequestService', 'ModalConstructor', 'AlertModalService'];

    function BridgeService($http, $q, RequestService, ModalConstructor, AlertModalService) {

        return {
            // API Methods
            listBridge: listBridge,
            getBridge: getBridge,
            getTypes: getTypes,
            getPorts: getPorts,
            getMulticastLists: getMulticastLists,
            getRgModesOLT8820G: getRgModesOLT8820G,
            getRgModesIntelbras: getRgModesIntelbras,
            getIpProfiles: getIpProfiles,
            getIpModes: getIpModes,
            getSipProfiles: getSipProfiles,
            getValidationRules: getValidationRules,
            getFxsValidationRules: getFxsValidationRules,
            addBridge: addBridge,
            updateBridge: updateBridge,
            deleteBridge: deleteBridge,
            getCpeVoipProfiles: getCpeVoipProfiles,
            // Modal Methods
            addBridgeSimpleModalConstructor: addBridgeSimpleModalConstructor,
            addBridgeModalConstructor: addBridgeModalConstructor,
            editBridgeModalConstructor: editBridgeModalConstructor,
            successModalConstructor: successModalConstructor,
            warningModalConstructor: warningModalConstructor,
            errorModalConstructor: errorModalConstructor,
            confirmationModalConstructor: confirmationModalConstructor,
            listBridgePages: listBridgePages,

            addBridgeOnuModalConstructor: addBridgeOnuModalConstructor
        };

        function listBridge(filters) {
            var expressionFilter = constructFilter(filters || {});
            return $http.get(apiUrl(), {params: expressionFilter, ignoreLoadingBar: true}).then(responseData);
        }

        function listBridgePages(filters) {
            //var expressionFilter = constructFilter(filters || {});      
            return $http.get(apiUrl('pages'), {params: filters, ignoreLoadingBar: true});//.then(responseData);
        }

        function getBridge(bridgeId) {
            return $http.get(apiUrl(bridgeId)).then(responseData);
        }

        function getPorts(oltModel) {
            var ports = {
                OLT: [],
                ONU: []
            };

            if (oltModel !== undefined) {
                if (oltModel === 'Intelbras8820i') {
                    for (var i = 1; i <= 8; i++) {
                        ports.OLT.push({label: 'Eth ' + i, value: i, type: 'GE1'});
                    }
                } else {
                    for (var i = 2; i <= 9; i++) {
                        ports.OLT.push({label: 'Eth ' + i, value: i, type: 'GE1'});
                    }
                }
            } else {
                for (var i = 1; i <= 9; i++) {
                    ports.OLT.push({label: 'Eth ' + i, value: i, type: 'GE1'});
                }
            }

            for (var i = 1; i <= 10; i++) {
                if (i <= 8) {
                    ports.ONU.push({label: 'Gpon ' + i, value: i, type: 'GPON'});
                } else {
                    ports.OLT.push({label: '10GE ' + (i - 8), value: i - 8, type: 'GE10'});
                }
            }

            return $q.resolve(ports);
        }

        function getTypes(model, rgMode) {
            var types = {
                OLT: [
                    {label: 'Uplink', value: 'UPLINK'},
                    {label: 'Downlink', value: 'DOWNLINK'},
                    {label: 'Intralink', value: 'INTRALINK'},
                    {label: 'TLS', value: 'TLS'}
                ],
                ONU: [
                    {label: 'Downlink', value: 'DOWNLINK'},
                    {label: 'TLS', value: 'TLS'}
                ]
            };

            if (model !== null && model !== 'Intelbras8820i') {
                types.OLT.push({label: 'Rlink', value: 'RLINK'});
            }

            return $q.resolve(types);
        }

        function getMulticastLists(data, hideLoader) {
            return $http
                    .get(mcListUrl(), {params: data, ignoreLoadingBar: !!hideLoader})
                    .then(function (response) {
                        if (response.data.length) {
                            response.data.unshift({id: null, listId: ''});
                        }
                        return response.data;
                    });
        }

        function getRgModesOLT8820G(meProfile) {
            if (meProfile === 'intelbras-110gi') {
                return $q.resolve([
                    {label: 'OMCI', value: ''},
                    //{label: 'Roteamento (RG)', value: 'RG_ROTEAMENTO'},
                    {label: 'PPPoE', value: 'RG_BPPPOE'}
                ]);
            } else if (meProfile === 'intelbras-110' || meProfile === 'intelbras-110g' || meProfile === 'intelbras-110b') {
                return $q.resolve([
                    {label: 'OMCI', value: ''}
                    //{label: 'Bridged', value: 'RG_BRIDGED'}
                    //{label: 'PPPoE', value: 'RG_BPPPOE'}
                ]);
            } else if (meProfile === 'intelbras-1420g' || meProfile === 'intelbras-142ng')  {
                return $q.resolve([
                    {label: 'Roteamento (RG)', value: 'RG_ROTEAMENTO'},
                    {label: 'Bridged', value: 'RG_BRIDGED'},
                    {label: 'Routed', value: 'RG_BROUTED'},
                    {label: 'PPPoE', value: 'RG_BPPPOE'}
                ]);
            } else {
                return $q.resolve([
                    {label: 'OMCI', value: ''},
                    {label: 'Roteamento (RG)', value: 'RG_ROTEAMENTO'}
                ]);
            }
        }

        function getRgModesIntelbras(meProfile) {
            if (meProfile === 'intelbras-110g' || meProfile === 'intelbras-110b') {
                return $q.resolve([
                    {label: 'OMCI', value: ''}
                ]);
            } else if (meProfile === 'intelbras-110gi' || meProfile === 'intelbras-110') {
                return $q.resolve([
                    {label: 'OMCI', value: ''},
                    {label: 'Roteamento (RG)', value: 'RG_ROTEAMENTO'},
                    {label: 'PPPoE', value: 'RG_BPPPOE'}
                ]);
            } else {
                return $q.resolve([
                    {label: 'OMCI', value: ''},
                    {label: 'Roteamento (RG)', value: 'RG_ROTEAMENTO'}
                ]);
            }
        }

        function getIpProfiles(oltId) {
            return $http.get(profileUrl(oltId + '/sip'), {ignoreLoadingBar: true}).then(responseData);
            //return $http.get(profileUrl(oltId + '/ipcom'), { ignoreLoadingBar: true }).then(responseData);
        }

        function getCpeVoipProfiles(oltId, oltModel) {
            return $q.resolve([{index: 1, profileName: "DHCP", gateway: "0.0.0.0"}, {index: 2, profileName: "STATIC", gateway: "0.0.0.0"}]);
        }

        function getCpeVoipProfiles(oltId, oltModel, enderecoIp) {
            return $q.resolve([{index: 1, profileName: "DHCP", gateway: "0.0.0.0"}, {index: 2, profileName: "STATIC", gateway: enderecoIp}]);
        }

        function getIpModes() {
            return $q.resolve([
                {label: 'static', value: 'STATIC'},
                {label: 'dhcp', value: 'DHCP'}
            ]);
        }

        function getSipProfiles(oltId) {
            return $http.get(profileUrl(oltId + '/sip'), {ignoreLoadingBar: true}).then(responseData);
        }

        function getValidationRules() {
            return {
                Zhone8820G: {
                    name: {},
                    vlan: {min: 0, max: 4094},
                    slan: {min: 0, max: 4094},
                    maxMulticastStreams: {min: 1, max: 210}
                },
                Intelbras8820i: {
                    name: {},
                    vlan: {min: 2, max: 4090},
                    slan: {min: 2, max: 4090},
                    maxMulticastStreams: {min: 0, max: 255}
                }
            };
        }

        function getFxsValidationRules() {
            return {
                OLT8820G: {
                    credentials: {pattern: '^[\\S\\s]{1,50}$'}
                },
                Intelbras8820i: {
                    credentials: {pattern: '^\\S{1,50}$'}
                }
            };
        }

        function addBridge(data) {
            return $http.post(apiUrl(), data);
        }

        function updateBridge(data) {
            return $http.put(apiUrl(), data);
        }

        function deleteBridge(bridgeId) {
            return $http.delete(apiUrl(bridgeId)).then(responseData);
        }

        // Modal Methods
        function addBridgeSimpleModalConstructor(onuItem) {
            var addBridge = {
                templateUrl: 'app/components/bridge/bridge-simple-add.html',
                controller: 'BridgeSimpleAddController',
                controllerAs: 'vmBridgeAdd',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    onuItem: function () {
                        return onuItem
                    },
                }
            };
            return ModalConstructor.open(addBridge);
        }

        function addBridgeOnuModalConstructor(scope, onuItem) {
            var modal = bridgeModalConfig();
            modal.scope = scope;
            modal.resolve.bridgeData = {
                interface: {value: 'ONU', disabled: true},
                olt: {model: {id: onuItem.oltId, name: onuItem.oltName, model: onuItem.oltModel}},
                port: {model: {label: onuItem.portInterface, value: onuItem.gponPort, type: 'GPON'}},
                onu: {model: {id: onuItem.id, name: onuItem.name, meProfile: onuItem.meProfile}}
            };
            return ModalConstructor.open(modal);
        }

        function addBridgeModalConstructor(scope, bridgeData) {
            var modal = bridgeModalConfig();
            modal.scope = scope;           
            modal.resolve.bridgeData = bridgeData;
            return ModalConstructor.open(modal);
        }

        function editBridgeModalConstructor(scope, bridgeId) {
            var modal = bridgeModalConfig();
            modal.scope = scope;
            modal.resolve.bridgeId = bridgeId;
            ModalConstructor.open(modal);
        }

        function successModalConstructor(action, isMultiple) {
            return AlertModalService.success(action, isMultiple, 'bridges');
        }

        function warningModalConstructor(list, response, action, dontCloseAll) {
            return AlertModalService.warning(list, response, action, 'bridges', dontCloseAll);
        }

        function errorModalConstructor(response, action) {
            AlertModalService.error(response, action, 'bridges');
        }

        function confirmationModalConstructor(bridgeData, dataAction) {
            var confirm = {
                templateUrl: 'app/components/bridge/bridge-confirm.html',
                controller: 'BridgeConfirmController',
                controllerAs: 'vmBridgeConfirm',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    dataAction: function () {
                        return dataAction;
                    },
                    bridgeData: function () {
                        return bridgeData;
                    }
                },
                avoidCancel: true
            };
            ModalConstructor.open(confirm);
        }

        function bridgeModalConfig() {
            return {
                windowTemplateUrl: 'app/components/bridge/bridge-modal.html',
                templateUrl: 'app/components/bridge/bridge-add.html',
                controller: 'BridgeAddController',
                controllerAs: 'vmBridgeAdd',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
                windowClass: 'modal-bridge',
                resolve: {
                    bridgeId: null,
                    bridgeData: null,
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('bridge');
                            return $translate.refresh();
                        }]
                }
            };
        }

        // Helper Function
        function apiUrl(method) {
            return RequestService.apiUrl('bridges', method);
        }

        function profileUrl(method) {
            return RequestService.apiUrl('profiles', method);
        }

        function mcListUrl(method) {
            return RequestService.apiUrl('mcls', method);
        }

        function constructFilter(filters) {
            angular.forEach(filters, function (value, key, obj) {
                if (!value) {
                    delete obj[key];
                }
            });
            return filters;
        }

        // Return only the data of the response
        function responseData(response) {
            return response.data;
        }

    }
})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('BackupListController', BackupListController);

    BackupListController.$inject = ['$scope', '$filter', '$uibModalInstance', 'SystemConfigService', 'LoginService', 'backupFolderPath'];

    function BackupListController($scope, $filter, $uibModalInstance, SystemConfigService, LoginService, backupFolderPath) {

        var vm = this;

        vm.backupList = {};
        vm.selectedFile = null;

        SystemConfigService.getBackupList(backupFolderPath).then(successList).catch(errorList);

        vm.close = function () {
            $uibModalInstance.dismiss('cancel');
        }

        function successList(data) {
            vm.backupList.path = data.systemBackupPath;
            vm.backupList.files = data.files.map(function (file, index) {
                return {index: index + 1, name: file};
            });
        }

        function errorList(response) {
            SystemConfigService.errorModalConstructor(response, 'getBackupList');
            if (response.status == 409) {
                vm.close();
            }
        }

        vm.restore = function () {

            var dataAction = {
                action: 'restore',
                confirmation: true,
                service: 'UserService',
                methodService: 'getLoggedUsers',
                methodExtra: function (users) {
                    var params = {
                        filename: vm.selectedFile.name,
                        path: vm.backupList.path
                    };
                    var dataActionConfirm = {
                        action: 'confirmRestore',
                        methodService: 'restoreBackup',
                        methodParam: params,
                        methodExtra: function (data, modalInstance) {
                            if (modalInstance) {
                                modalInstance.closed.then(LoginService.logout);
                            }
                        }
                    };

                    var usersList = users.map(function (user) {
                        return user.username;
                    }).join(', ');

                    SystemConfigService.confirmationModalConstructor(dataActionConfirm, usersList);
                }
            };

            var path = vm.backupList.path;
            var slash = path.indexOf('\\') > -1 ? '\\' : '/';
            var backupPath = path;
            if (path.charAt(path.length - 1) != slash) {
                backupPath += slash;
            }
            backupPath += vm.selectedFile.name;

            SystemConfigService.confirmationModalConstructor(dataAction, backupPath);
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('BackupConfirmController', BackupConfirmController);

    BackupConfirmController.$inject = ['$scope', '$injector', '$uibModalInstance', 'ModalConstructor', 'SystemConfigService', 'dataAction', 'confirmData'];

    function BackupConfirmController($scope, $injector, $uibModalInstance, ModalConstructor, SystemConfigService, dataAction, confirmData) {
        var vm = this;
        vm.requestRunning = false;

        if (dataAction) {
            vm.action = dataAction.action;
            vm.data = confirmData;

            if (dataAction.getPath) {
                vm.requestRunning = true;
                SystemConfigService.getSystemConfig().then(function (data) {
                    vm.requestRunning = false;
                    vm.data = data.systemBackupConfig.path;
                    dataAction.methodParam = data.systemBackupConfig.path;
                }).catch(function (response) {
                    vm.close();
                    SystemConfigService.errorModalConstructor(response, 'get');
                });
            }

            vm.close = function () {
                if (!vm.requestRunning) {
                    $uibModalInstance.dismiss('cancel');
                }
            }

            vm.confirmAction = function () {
                vm.requestRunning = true;
                var service = dataAction.service ? $injector.get(dataAction.service) : SystemConfigService;
                service[dataAction.methodService](dataAction.methodParam).then(success).catch(error);
            }
        }

        function success(data) {
            vm.requestRunning = false;
            var modalInstance;
            if (!dataAction.confirmation) {
                modalInstance = SystemConfigService.successModalConstructor(vm.action);
            }
            if (dataAction.methodExtra) {
                dataAction.methodExtra(data, modalInstance);
            }
        }

        function error(response) {
            vm.requestRunning = false;
            var modalInstance = SystemConfigService.errorModalConstructor(response, vm.action);
            if (response.status == 409) {
                modalInstance.closed.then(ModalConstructor.closeAll);
            }
        }

    }
})();

(function () {
  'use strict';
  angular.module('imnApp').factory('AlarmShowService', AlarmShowService);

  AlarmShowService.$inject = ['$http', 'RequestService'];

  function AlarmShowService($http, RequestService) {
    return {
      getAlarmShow: getAlarmShow
    };

    function getAlarmShow(olt) {
      return $http.get(alarmShowApi(olt.id)).then(responseData);
    }

    function responseData(response) {
      return response.data;
    }

    function alarmShowApi(method) {
      return RequestService.apiUrl('alarmshow', method);
    }
  }
})();

(function () {
    'use strict';

    angular.module('imnApp').controller('AlarmShowController', AlarmShowController);

    AlarmShowController.$inject = ['$scope', '$interval', '$uibModalInstance', 'OltData', 'AlarmShowService'];

    function AlarmShowController($scope, $interval, $uibModalInstance, OltData, AlarmShowService) {
        var vm = this;
        var timer = null;
        
        vm.close = close;
        vm.isOlt8820G = isOlt8820G;
        vm.isOlt8820i = isOlt8820i;

        initialize();

        function initialize() {
            $interval.cancel(timer);
            vm.oltSelecionada = OltData.detail;
            obterAlarmShowDaOlt();
        }

        function close() {
            if (!vm.requestRunning) {
                $uibModalInstance.dismiss('cancel');
            }
        }

        function obterAlarmShowDaOlt() {
            if (vm.oltSelecionada)
                AlarmShowService.getAlarmShow(vm.oltSelecionada).then(carregaDadosDaApi);
            else
                close();
        }

        function carregaDadosDaApi(data) {
            vm.alarmShow8820G = data.alarmShow8820G;
            vm.alarmShow8820i = data.alarmShow8820i;
        }

        function isOlt8820G() {
            return OltData.detail.model !== 'Intelbras8820i';
        }

        function isOlt8820i() {
            return OltData.detail.model === 'Intelbras8820i';
        }

    }
})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('AlarmSettingsController', AlarmSettingsController);

    AlarmSettingsController.$inject = ['$scope', '$filter', 'AlarmService', 'OltService', 'OnuService', 'Authenticate', 'RequestService'];

    function AlarmSettingsController($scope, $filter, AlarmService, OltService, OnuService, Authenticate, RequestService) {
        var vm = this;

        // Requests
        vm.getAuthenticate = getAuthenticate;
        vm.getOlts = getOlts;
        vm.getOnus = getOnus;
        vm.getOltAlarmSettings = getOltAlarmSettings;
        vm.getOnuAlarmSettings = getOnuAlarmSettings;
        vm.save = save;

        // Comboboxes content
        vm.oltList = [];
        vm.onuList = [];
        vm.oltZhoneList = [];

        // Comboboxes actions
        vm.setOlt = setOlt;
        vm.setOnu = setOnu;

        // Actions
        vm.close = close;
        vm.clearModelOlt = clearModelOlt;
        vm.clearModelOnu = clearModelOnu;
        vm.disableDropdown = disableDropdown;
        vm.disableButton = disableButton;
        vm.changeLayout = changeLayout;
        vm.listenerSeverityCheck = listenerSeverityCheck;
        vm.setSeverityCheckModelDefault = setSeverityCheckModelDefault;
        vm.updateSeverityCheckModel = updateSeverityCheckModel;
        vm.updateRogueOption = updateRogueOption;
        vm.initialize = initialize;
        vm.toggleFilter = toggleFilter;
        function toggleFilter() {
            vm.open = !vm.open;
        }

        // Variables
        var requestRunning = false;
        vm.postRunning = false;
        var severityCheck = [];
        vm.dataSettings = {fields: {}};
        vm.interface = 'OLT';
        vm.isOptionOlt = true;
        vm.severityTypes = null;
        vm.rogueOptions = null;
        vm.authComponent = {olt: false, onu: false};
        vm.oltSelected = null;
        vm.onuSelected = null;
        vm.settingsModelOlt = {
            oltId: null,
            severity: [],
            maxTemperature: '',
            minTemperature: '',
            onuRogueGpon: {
                port1: '',
                port2: '',
                port3: '',
                port4: '',
                port5: '',
                port6: '',
                port7: '',
                port8: ''
            },
            portLinkDownSeverityGE1: {
                port1: {label: '', value: ''},
                port2: {label: '', value: ''},
                port3: {label: '', value: ''},
                port4: {label: '', value: ''},
                port5: {label: '', value: ''},
                port6: {label: '', value: ''},
                port7: {label: '', value: ''},
                port8: {label: '', value: ''}
            },
            portLinkDownSeverityGE10: {
                port1: {label: '', value: ''},
                port2: {label: '', value: ''}
            }
        };
        vm.settingsModelOnu = {
            oltId: null,
            onuId: null,
            linkDown: {label: '', value: ''},
            maxPower: '',
            minPower: ''
        };
        vm.placeholder = {
            olt: '',
            onu: ''
        };

        // Requests
        function getAuthenticate() {
            vm.authComponent.olt = Authenticate.hasPermission('oltAlarmConfig');
            vm.authComponent.onu = Authenticate.hasPermission('onuAlarmConfig');
            if (!vm.authComponent.olt && vm.authComponent.onu) {
                vm.interface = 'ONU';
                changeLayout(vm.interface);
            } else if (vm.authComponent.olt && !vm.authComponent.onu) {
                vm.interface = 'OLT';
                changeLayout(vm.interface);
            }
        }

        function getOlts() {
            requestRunning = true;
            vm.placeholder.olt = 'global.common.loading';
            OltService.listOlts(null, true).then(getOltSuccess).catch(getOltError);
        }

        function getOnus(oltId) {
            if (vm.authComponent.onu) {
                requestRunning = true;
                vm.placeholder.onu = 'global.common.loading';
                OnuService.getAuthorizedOnuList({oltId: oltId}, true).then(getOnuSuccess).catch(getOnuError);
            }
        }

        function getOltAlarmSettings(oltId) {
            requestRunning = true;
            AlarmService.getOltAlarmSettings(oltId)
                    .then(getOltAlarmSettingsSuccess)
                    .catch(getOltAlarmSettingsError);
        }

        function getOnuAlarmSettings(oltId, onuId) {
            requestRunning = true;
            AlarmService.getOnuAlarmSettings(oltId, onuId)
                    .then(getOnuAlarmSettingsSuccess)
                    .catch(getOnuAlarmSettingsError);
        }

        function save() {

            if (!vm.isOptionOlt) {
                if (parseInt(vm.settingsModelOnu.minPower) > parseInt(vm.settingsModelOnu.maxPower)) {
                    saveAlarmSettingsError({status: '400.1', config: {}});
                    vm.formAlarmSettings.maxPower.$setValidity('maxmin', false);
                    vm.formAlarmSettings.minPower.$setValidity('maxmin', false);
                } else {
                    vm.formAlarmSettings.maxPower.$setValidity('maxmin', true);
                    vm.formAlarmSettings.minPower.$setValidity('maxmin', true);
                }
            }

            if (vm.formAlarmSettings.$valid && !requestRunning && !vm.postRunning) {
                requestRunning = true;
                vm.postRunning = true;
                vm.settingsModelOlt.severity = severityCheck;
                if (vm.isOptionOlt) {
                    vm.settingsModelOlt.maxTemperature = parseInt(vm.settingsModelOlt.maxTemperature);
                    vm.settingsModelOlt.minTemperature = parseInt(vm.settingsModelOlt.minTemperature);
                    vm.settingsOlt = {
                        oltId: vm.oltSelected.id,
                        severity: vm.settingsModelOlt.severity,
                        maxTemperature: vm.settingsModelOlt.maxTemperature,
                        minTemperature: vm.settingsModelOlt.minTemperature,
                        onuRogueGpon: {
                            port1: vm.settingsModelOlt.onuRogueGpon.port1.toUpperCase(),
                            port2: vm.settingsModelOlt.onuRogueGpon.port2.toUpperCase(),
                            port3: vm.settingsModelOlt.onuRogueGpon.port3.toUpperCase(),
                            port4: vm.settingsModelOlt.onuRogueGpon.port4.toUpperCase(),
                            port5: vm.settingsModelOlt.onuRogueGpon.port5.toUpperCase(),
                            port6: vm.settingsModelOlt.onuRogueGpon.port6.toUpperCase(),
                            port7: vm.settingsModelOlt.onuRogueGpon.port7.toUpperCase(),
                            port8: vm.settingsModelOlt.onuRogueGpon.port8.toUpperCase()
                        },
                        portLinkDownSeverityGE1: {
                            port1: vm.settingsModelOlt.portLinkDownSeverityGE1.port1.value,
                            port2: vm.settingsModelOlt.portLinkDownSeverityGE1.port2.value,
                            port3: vm.settingsModelOlt.portLinkDownSeverityGE1.port3.value,
                            port4: vm.settingsModelOlt.portLinkDownSeverityGE1.port4.value,
                            port5: vm.settingsModelOlt.portLinkDownSeverityGE1.port5.value,
                            port6: vm.settingsModelOlt.portLinkDownSeverityGE1.port6.value,
                            port7: vm.settingsModelOlt.portLinkDownSeverityGE1.port7.value,
                            port8: vm.settingsModelOlt.portLinkDownSeverityGE1.port8.value
                        },
                        portLinkDownSeverityGE10: {
                            port1: vm.settingsModelOlt.portLinkDownSeverityGE10.port1.value,
                            port2: vm.settingsModelOlt.portLinkDownSeverityGE10.port2.value
                        }
                    };
                    AlarmService.saveOltAlarmSettings(vm.settingsOlt)
                            .then(saveAlarmSettingsSuccess)
                            .catch(saveAlarmSettingsError);
                } else {
                    vm.settingsOnu = {
                        oltId: vm.oltSelected.id,
                        onuId: vm.onuSelected.id,
                        linkDown: vm.settingsModelOnu.linkDown.value,
                        maxPower: parseInt(vm.settingsModelOnu.maxPower),
                        minPower: parseInt(vm.settingsModelOnu.minPower)
                    };
                    AlarmService.saveOnuAlarmSettings(vm.settingsOnu)
                            .then(saveAlarmSettingsSuccess)
                            .catch(saveAlarmSettingsError);
                }
            }
        }


        // Combo boxes actions
        function setOlt(olt) {
            if (requestRunning) {
                RequestService.cancelRequests('alarms');
                requestRunning = false;
            }

            if (vm.interface == 'OLT') {
                setSeverityCheckModelDefault();
                getOltAlarmSettings(olt.id);
            } else {
                if (vm.onuSelected) {
                    clearModelOnu();
                    vm.onuSelected = null;
                    vm.onuList = [];
                }
                getOnus(olt.id);
            }
        }

        function setOnu(onu) {
            if (requestRunning) {
                RequestService.cancelRequests('alarms');
                requestRunning = false;
            }
            clearModelOnu();
            getOnuAlarmSettings(vm.oltSelected.id, onu.id);
        }

        function setSeverityType() {
            vm.severityTypes = [
                {label: 'Disabled', value: 'NONE'},
                {label: 'Minor', value: 'MINOR'},
                {label: 'Major', value: 'MAJOR'},
                {label: 'Warning', value: 'WARNING'},
                {label: 'Critical', value: 'CRITICAL'}
            ];
        }

        function setRogueOptions() {
            vm.rogueOptions = [
                'none',
                'alarm',
                'shutdown'
            ];
            vm.dataSettings.fields.rogueOptions = vm.rogueOptions;
        }

        function clearModelOlt() {
            vm.settingsModelOlt = {
                oltId: null,
                severity: [],
                maxTemperature: '',
                minTemperature: '',
                onuRogueGpon: {
                    port1: '',
                    port2: '',
                    port3: '',
                    port4: '',
                    port5: '',
                    port6: '',
                    port7: '',
                    port8: ''
                },
                portLinkDownSeverityGE1: {
                    port1: {label: '', value: ''},
                    port2: {label: '', value: ''},
                    port3: {label: '', value: ''},
                    port4: {label: '', value: ''},
                    port5: {label: '', value: ''},
                    port6: {label: '', value: ''},
                    port7: {label: '', value: ''},
                    port8: {label: '', value: ''}
                },
                portLinkDownSeverityGE10: {
                    port1: {label: '', value: ''},
                    port2: {label: '', value: ''}
                }
            };
        }

        function clearModelOnu() {
            vm.settingsModelOnu = {
                oltId: null,
                onuId: null,
                linkDown: {},
                maxPower: '',
                minPower: ''
            };
        }

        function disableDropdown(type) {
            switch (type) {
                case 'OLT':
                    return !vm.oltSelected || !vm.oltSelected.id || requestRunning;
                case 'ONU':
                    return !vm.onuSelected || !vm.onuSelected.id || requestRunning;
            }
        }

        function disableButton(value) {
            return disableDropdown('OLT') || (severityCheck.length == 1 && vm.severityCheckModel[value]);
        }

        function changeLayout(type) {
            switch (type) {
                case 'OLT':

                    if (requestRunning) {
                        RequestService.cancelRequests('onus');
                        RequestService.cancelRequests('alarms');
                        requestRunning = false;
                    }

                    vm.isOptionOlt = true;
                    setSeverityCheckModelDefault();
                    clearModelOlt();

                    if (vm.oltList.length) {
                        vm.placeholder.olt = '';
                        vm.oltSelected = {};
                    } else {
                        vm.placeholder.olt = 'alarm.filter.placeholder.noOltFound';
                        vm.oltSelected = null;
                    }

                    break;

                case 'ONU':

                    if (requestRunning) {
                        RequestService.cancelRequests('alarms');
                        requestRunning = false;
                    }

                    vm.isOptionOlt = false;
                    clearModelOnu();

                    if (vm.oltList.length) {
                        vm.placeholder.olt = '';
                        vm.oltSelected = {};
                    } else {
                        vm.placeholder.olt = 'alarm.filter.placeholder.noOltFound';
                        vm.oltSelected = null;
                    }

                    vm.placeholder.onu = 'alarm.filter.placeholder.selectOlt';
                    vm.onuSelected = null;
                    vm.onuList = [];

                    break;
            }
        }

        function listenerSeverityCheck() {
            setSeverityCheckModelDefault();
            $scope.$watchCollection('vmAlarmSettings.severityCheckModel', function () {
                severityCheck = [];
                angular.forEach(vm.severityCheckModel, function (value, key) {
                    if (value) {
                        severityCheck.push(key.toUpperCase());
                    }
                });
            });
        }

        function setSeverityCheckModelDefault() {
            vm.severityCheckModel = {
                minor: false,
                major: false,
                warning: false,
                critical: false
            };
        }

        function updateSeverityCheckModel(data) {
            if (data.severity) {
                setSeverityCheckModelDefault();
                var severityArray = angular.copy(data.severity);
                angular.forEach(severityArray, function (element) {
                    var itemSeverity = element.trim().toLowerCase();
                    vm.severityCheckModel[itemSeverity] = true;
                });
            }
        }

        function updateRogueOption(data) {
            angular.forEach(vm.settingsModelOlt.onuRogueGpon, function (item, index) {
                vm.settingsModelOlt.onuRogueGpon[index] = $filter('filter')(vm.rogueOptions, data.onuRogueGpon[index])[0];
            });
        }

        function updateEthernetPort(data) {
            angular.forEach(vm.settingsModelOlt.portLinkDownSeverityGE1, function (item, index) {
                vm.settingsModelOlt.portLinkDownSeverityGE1[index] = $filter('filter')(vm.severityTypes, data.portLinkDownSeverityGE1[index])[0];
            });
        }

        function updateGEPort(data) {
            angular.forEach(vm.settingsModelOlt.portLinkDownSeverityGE10, function (item, index) {
                vm.settingsModelOlt.portLinkDownSeverityGE10[index] = $filter('filter')(vm.severityTypes, data.portLinkDownSeverityGE10[index])[0];
            });
        }

        function setTemperatureAndPowerValues() {
            var modelTemperatureAndPower = {
                maxTemperature: [],
                minTemperature: [],
                powerMaxAndMin: []
            };

            for (var i = -40; i <= 65; i++) {
                if (i <= 0) {
                    modelTemperatureAndPower.minTemperature.push(i.toString());
                    if (i >= -35) {
                        modelTemperatureAndPower.powerMaxAndMin.push(i.toString());
                    }
                }
                if (i >= 35 && i <= 65) {
                    modelTemperatureAndPower.maxTemperature.push(i.toString());
                }
            }
            vm.optionsTemperatureAndPowerValues = modelTemperatureAndPower;
        }

        // Request response
        function getOltSuccess(data) {
            requestRunning = false;
            vm.oltList = data;
            vm.oltZhoneList = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].model === 'OLT8820G') {
                    vm.oltZhoneList.push(data[i]);
                }
            }
            vm.placeholder.olt = data.length ? '' : 'alarm.filter.placeholder.noOltFound';
        }

        function getOltError(response) {
            requestRunning = false;
            AlarmService.errorModalConstructor(response, 'getOltList');
        }

        function getOnuSuccess(data) {
            requestRunning = false;
            vm.onuList = data;
            if (data.length) {
                vm.onuSelected = {};
                vm.placeholder.onu = '';
            } else {
                vm.onuSelected = null;
                vm.placeholder.onu = 'alarm.filter.placeholder.noOnuFound';
            }
        }

        function getOnuError(response) {
            requestRunning = false;
            AlarmService.errorModalConstructor(response, 'getOnuList');
        }

        function getOltAlarmSettingsSuccess(data) {
            data.maxTemperature = data.maxTemperature.toString();
            data.minTemperature = data.minTemperature.toString();
            requestRunning = false;
            vm.settingsModelOlt = data;
            updateSeverityCheckModel(data);
            updateRogueOption(data);
            updateEthernetPort(data);
            updateGEPort(data);
        }

        function getOltAlarmSettingsError(response) {
            if (!response.config.canceled) {
                vm.dataSettings.data = null;
                requestRunning = false;
                AlarmService.errorModalConstructor(response, 'getConfigurations');
                vm.oltSelected = {};
            }
        }

        function getOnuAlarmSettingsSuccess(data) {
            requestRunning = false;
            vm.settingsModelOnu.minPower = data.minPower.toString();
            vm.settingsModelOnu.maxPower = data.maxPower.toString();
            vm.settingsModelOnu.linkDown = $filter('filter')(vm.severityTypes, data.linkDown)[0];
        }

        function getOnuAlarmSettingsError(response) {
            if (!response.config.canceled) {
                vm.dataSettings.data = null;
                requestRunning = false;

                vm.oltSelected = {};

                vm.onuSelected = null;
                vm.onuList = [];
                vm.placeholder.onu = 'alarm.filter.placeholder.selectOlt';

                AlarmService.errorModalConstructor(response, 'getConfigurations');
            }
        }

        function saveAlarmSettingsSuccess(response) {
            requestRunning = false;
            vm.postRunning = false;
            AlarmService.successModalConstructor('saveConfigurations');
        }

        function saveAlarmSettingsError(response) {
            requestRunning = false;
            vm.postRunning = false;
            AlarmService.errorModalConstructor(response, 'saveConfigurations');
        }

        function initialize() {
            getAuthenticate();
            clearModelOlt();
            clearModelOnu();
            getOlts();
            listenerSeverityCheck();
            setTemperatureAndPowerValues();
            setSeverityType();
            setRogueOptions();
        }
        initialize();
    }
})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('AlarmListController', AlarmListController);

    AlarmListController.$inject = ['$scope', '$rootScope', '$state', '$filter', 'AlarmService', 'Authenticate'];

    function AlarmListController($scope, $rootScope, $state, $filter, AlarmService, Authenticate) {
        var vm = this;

        // Actions
        vm.clearAlarmHistory = clearAlarmHistory;
        vm.currentPage = 1;
        vm.totalCount = 0;
        vm.itemsPerPage = 50; 
        vm.getData = getData;

        if (!Authenticate.hasPermission('alarmList')) {
            return;
        }

        vm.alarmList = {};

        vm.orderBy = function (column) {
            if (vm.order == column) {
                vm.order = '-' + column;
            } else {
                vm.order = column;
            }
        };


        var cancelHistoryListener = $rootScope.$on('filterDataUpdateHistory', successHistoryList);
        $rootScope.$on('$destroy', cancelHistoryListener);

        function successHistoryList(event, data) {
            console.log(data);
            vm.totalCount = data.totalElements;
            vm.alarmList.history = data.content.map(function (item) {
                var date = new Date(item.dateTime);
                item.dateTime = date;
                item.time = $filter('date')(date, 'HH mm');
                item.severity = item.severity.toLowerCase();
                return item;
            });
        } 
           

        var cancelListener = $rootScope.$on('filterDataUpdate', successList);
        $rootScope.$on('$destroy', cancelListener);

        function successList(event, data) {
            for (var type in data) {
                if (type === 'history') {
                    continue;
                }
                vm.alarmList[type] = data[type].map(function (item) {
                    var date = new Date(item.dateTime);
                    item.dateTime = date;
                    item.time = $filter('date')(date, 'HH mm');
                    item.severity = item.severity.toLowerCase();
                    return item;
                });
            }
        }

        function clearAlarmHistory() {
            AlarmService.clearAlarmHistory().then(clearAlarmHistorySuccess).catch(clearAlarmHistoryError);
        }

        function clearAlarmHistorySuccess(response) {
            AlarmService.successModalConstructor('clearAlarmHistory');
            AlarmService.getAlarmList().then(alarmListSuccess).catch(alarmListError);
        }

        function clearAlarmHistoryError(response) {
            AlarmService.errorModalConstructor(response, 'clearAlarmHistory');
        }

        function alarmListSuccess(data) {
            $rootScope.$emit('filterDataUpdate', data);
        }

        function alarmListError(response) {
            AlarmService.errorModalConstructor(response, 'filter');
        }

        function getData(pageNumber) {
            vm.currentPage = pageNumber;   
            var data = {
                currentPage : (pageNumber - 1)
            }
            AlarmService.getAlarmHistoryList(data).then(localList).catch(alarmListError);  
        }

        function localList(data) {
            vm.totalCount = data.totalElements;
            vm.alarmList.history = data.content.map(function (item) {
                var date = new Date(item.dateTime);
                item.dateTime = date;
                item.time = $filter('date')(date, 'HH mm');
                item.severity = item.severity.toLowerCase();
                return item;
            });
        } 

    }
})();
(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('AlarmFilterController', AlarmFilterController);

    AlarmFilterController.$inject = ['$scope', '$rootScope', '$stateParams', '$state', '$filter', '$locale', '$timeout', 'AlarmService', 'OltService', 'OnuService'];

    function AlarmFilterController($scope, $rootScope, $stateParams, $state, $filter, $locale, $timeout, AlarmService, OltService, OnuService) {

        var vm = this;

        // Comboboxes content
        vm.equipmentTypeList = ['OLT', 'ONU'];
        vm.equipmentList = [];
        vm.interfaceList = [];
        vm.onuList = [];
        vm.datepicker = [];
        vm.time = [];
        vm.typesList = [];

        // Comboboxes actions
        vm.setEquipmentType = setEquipmentType;
        vm.setEquipment = setEquipment;
        vm.setDate = setDate;
        vm.setDatePeriod = setDatePeriod;
        vm.setTime = setTime;

        // Filter actions
        vm.toggleFilter = toggleFilter;
        vm.applyFilter = applyFilter;
        vm.clearFilter = clearFilter;

        // Initialize fields values verifying params
        initialize();
        configDateTimePicker();
        verifyParams();
        clearFilter();
        // Requests
        AlarmService.getInterfaces().then(successInterface);
        AlarmService.getAlarmType().then(successType);

        // Actions functions
        function toggleFilter() {
            vm.open = !vm.open;
        }

        function setEquipmentType(equipmentType) {

            clearFields(['equipment', 'onu']);

            if (equipmentType) {
                vm.filter.equipmentType = equipmentType;
            }

            vm.equipmentList = [];
            vm.filter.equipment = null;
            vm.placeholder.name = 'global.common.loading';

            switch (vm.filter.equipmentType) {
                case 'OLT':
                    vm.filter.onu = null;
                    vm.placeholder.onu = 'alarm.filter.placeholder.selectOlt';
                    return OltService.listOlts(null, true).then(function (data) {
                        vm.equipmentList = data;
                        if (data.length) {
                            vm.filter.equipment = {};
                            vm.placeholder.name = '';
                            vm.equipmentList.unshift({});
                        } else {
                            vm.filter.equipment = null;
                            vm.placeholder.name = 'alarm.filter.placeholder.noOltFound';
                        }
                    });
                case 'ONU':
                    return OnuService.getAuthorizedOnuList(null, true).then(function (data) {
                        vm.equipmentList = data;
                        if (data.length) {
                            vm.filter.equipment = {};
                            vm.placeholder.name = '';
                            vm.equipmentList.unshift({});
                        } else {
                            vm.filter.equipment = null;
                            vm.placeholder.name = 'alarm.filter.placeholder.noOnuFound';
                        }
                    });
            }

        }

        function setEquipment(equipment) {

            clearFields(['onu']);

            if (equipment) {
                vm.filter.equipment = equipment;
            }

            if (vm.filter.equipmentType == 'OLT') {
                vm.onuList = [];
                vm.filter.onu = null;
                vm.placeholder.onu = 'alarm.filter.placeholder.selectOlt';
                if (vm.filter.equipment && vm.filter.equipment.id) {
                    vm.placeholder.onu = 'global.common.loading';
                    OnuService.getAuthorizedOnuList({oltId: vm.filter.equipment.id}, true).then(successOnuList);
                }
            }

        }

        function setDate() {

            var initial = '';
            var final = '';
            var fullDate = '';

            if (vm.datepicker.initial.selected) {
                initial = $filter('date')(vm.datepicker.initial.selected, 'mediumDate');
            }

            if (vm.datepicker.final.selected) {
                final = $filter('date')(vm.datepicker.final.selected, 'mediumDate');
            }

            if (initial && final) {
                if (initial == final) {
                    fullDate = initial;
                } else {
                    fullDate = initial + ' ' + $filter('translate')('alarm.filter.to') + ' ' + final;
                }
            }

            if (initial && !final) {
                fullDate = $filter('translate')('alarm.filter.start') + ': ' + initial;
            }

            if (!initial && final) {
                fullDate = $filter('translate')('alarm.filter.end') + ': ' + final;
            }

            vm.filter.date.initial = vm.datepicker.initial.selected;
            vm.filter.date.final = vm.datepicker.final.selected;
            vm.filter.date.applied = fullDate;
            vm.datepicker.toggle(false, 'applying');

        }

        var cleanListener = $rootScope.$on('$localeChangeSuccess', function () {
            setDate();
            setTime();
        });
        $scope.$on('$destroy', cleanListener);

        function setDatePeriod(period) {
            var today = new Date();
            var yesterday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
            var weekAgo = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 6);
            var monthAgo = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
            var periods = {
                'today': [today, today],
                'yesterday': [yesterday, yesterday],
                'last-week': [weekAgo, today],
                'last-month': [monthAgo, today]
            };
            vm.datepicker.initial.selected = periods[period][0];
            vm.datepicker.final.selected = periods[period][1];
        }

        function setTime() {
            if (vm.time.initial.hour.value && vm.time.initial.minute.value
                    && vm.time.final.hour.value && vm.time.final.minute.value) {
                vm.filter.time = vm.time.initial.hour.value + 'h' + vm.time.initial.minute.value + 'min';
                vm.filter.time += ' ' + $filter('translate')('alarm.filter.to') + ' ';
                vm.filter.time += vm.time.final.hour.value + 'h' + vm.time.final.minute.value + 'min';
                vm.time.toggle(false);
            }
        }

        function clearDate() {
            vm.filter.date.initial = '';
            vm.filter.date.final = '';
            vm.filter.date.applied = '';
            vm.datepicker.initial.selected = '';
            vm.datepicker.initial.previous = '';
            vm.datepicker.final.selected = '';
            vm.datepicker.final.previous = '';
        }

        function clearTime() {
            vm.filter.time = '';
            vm.time.initial.hour = {label: '--h'};
            vm.time.initial.minute = {label: '--min'};
            vm.time.final.hour = {label: '--h'};
            vm.time.final.minute = {label: '--min'};
        }

        function clearFields(fields) {
            fields.forEach(function (field) {
                vm.filter[field] = {};
                vm[field + 'List'] = [];
            });
        }

        function applyFilter() {
            if (vm.time.initial.hour.value && vm.time.initial.minute.value
                    && vm.time.final.hour.value && vm.time.final.minute.value
                    && (!vm.datepicker.initial.selected || !vm.datepicker.final.selected)
                    && !vm.filter.withinTimeOnly) {
                errorList({status: '400.1', config: {}});
            } else if (vm.filter.equipmentType == 'ONU' && !vm.filter.equipment.name) {
                errorList({status: '400.2', config: {}});
            } else {
                getAlarmList(getFilter());
                getData();
            }
        }

        function clearFilter() {
            initialize();
            setEquipmentType('OLT');
            clearDate();
            clearTime();
            getAlarmList();
            getData();
        }

        // Helper functions
        function getFilter() {

            var filter = {};

            if (vm.filter.equipment && vm.filter.equipment.id) {
                switch (vm.filter.equipmentType) {
                    case 'OLT':
                        filter.oltId = vm.filter.equipment.id;
                        break;
                    case 'ONU':
                        filter.onuId = vm.filter.equipment.id;
                        break;
                }
            }

            filter.interface = vm.filter.interface.value;

            if (vm.filter.onu && vm.filter.onu.id) {
                filter.onuId = vm.filter.onu.id;
            }

            if (vm.filter.date.initial) {
                filter.initialDate = $filter('date')(vm.filter.date.initial, 'yyyy-MM-dd');
            }

            if (vm.filter.date.final) {
                filter.endDate = $filter('date')(vm.filter.date.final, 'yyyy-MM-dd');
            }

            if (vm.time.initial.hour.value) {
                filter.initialTime = vm.time.initial.hour.value + ':' + vm.time.initial.minute.value + ':00';
                filter.endTime = vm.time.final.hour.value + ':' + vm.time.final.minute.value + ':59';
            }

            if (vm.time.initial.hour.value && vm.time.final.hour.value) {
                filter.withinTimeOnly = vm.filter.withinTimeOnly;
            }
            filter.alarmType = vm.filter.alarmType.value;
            filter.severity = setSeverity();

            return filter;
        }

        function setSeverity() {
            var severity = [];
            for (var item in vm.filter.severity) {
                if (vm.filter.severity[item]) {
                    severity.push(item.toUpperCase());
                }
            }
            return severity.join();
        }

        function verifyParams() {
            if ($stateParams.id && $stateParams.type) {
                vm.open = true;
                setEquipmentType($stateParams.type).then(function () {
                    angular.forEach(vm.equipmentList, function (item) {
                        if (item.id == $stateParams.id) {
                            setEquipment(item);
                            getAlarmList(getFilter());
                            getData(vm.currentPage);
                        }
                    });
                });
            } else {
                setEquipmentType('OLT');
                getAlarmList(getFilter());
                getData();
            }
        }

        function getData() {
            if (getFilter()) {
                var data = angular.copy(getFilter());         
                data.currentPage = 0;
            } else {
                var data = {
                    currentPage : 0
                }
            }
            AlarmService.getAlarmHistoryList(data).then(successHistoryList).catch(errorList);                        
        }
        // Request Functions
        function getAlarmList(filter) {
            AlarmService.getAlarmList(filter).then(successList).catch(errorList);            
        }

        // Request Callbacks
        function successInterface(data) {
            vm.interfaceList = data.map(stringToObject);
            vm.interfaceList.unshift({});
        }

        function successType(data) {
            vm.typesList = data.map(stringToObject);
            vm.typesList.unshift({});
        }

        function successList(data) {
            $rootScope.$emit('filterDataUpdate', data);
        }

        
        function successHistoryList(data) {
            $rootScope.$emit('filterDataUpdateHistory', data);         
        }
        

        function errorList(response) {
            AlarmService.errorModalConstructor(response, 'filter');
        }

        function successOnuList(data) {
            vm.onuList = data;
            if (data.length) {
                vm.filter.onu = {};
                vm.placeholder.onu = '';
                vm.onuList.unshift({});
            } else {
                vm.filter.onu = null;
                vm.placeholder.onu = 'alarm.filter.placeholder.noOnuFound';
            }
        }

        // Helper Functions
        function listHours() {
            var hours = [];
            var hour = '';
            for (var i = 0; i < 24; i++) {
                hour = (i < 10 ? '0' : '') + i;
                hours.push({value: hour, label: hour + 'h'});
            }
            return hours;
        }

        function listMinutes() {
            var minutes = [];
            var minute = '';
            for (var i = 0; i < 60; i++) {
                minute = (i < 10 ? '0' : '') + i;
                minutes.push({value: minute, label: minute + 'min'});
            }
            return minutes;
        }

        function stringToObject(item) {
            return {value: item};
        }

        function initialize() {
            vm.filter = {
                equipmentType: 'OLT',
                equipment: {},
                interface: {},
                onu: null,
                date: {
                    initial: '',
                    final: '',
                    applied: ''
                },
                time: '',
                withinTimeOnly: false,
                alarmType: {},
                severity: {
                    warning: false,
                    minor: false,
                    major: false,
                    critical: false
                }
            };
            vm.placeholder = {
                name: '',
                onu: ''
            };
        }

        function configDateTimePicker() {
            /* eslint-disable angular/controller-as-vm */
            var today = new Date();
            vm.datepicker = {
                open: false,
                toggle: function (open, applying) {
                    if (!applying && this.open) {
                        if (vm.filter.date.initial) {
                            vm.datepicker.initial.selected = vm.filter.date.initial;
                            vm.datepicker.initial.previous = vm.filter.date.initial;
                        }
                        if (vm.filter.date.final) {
                            vm.datepicker.final.selected = vm.filter.date.final;
                            vm.datepicker.final.previous = vm.filter.date.final;
                        }
                    }
                    this.open = angular.isDefined(open) ? open : !this.open;
                },
                clear: function () {
                    clearDate();
                    this.toggle(false);
                },
                initial: {
                    previous: '',
                    selected: '',
                    change: changeInitialDate,
                    options: {
                        formatDay: 'd',
                        formatMonth: 'MMM',
                        formatYear: 'yy',
                        minDate: new Date(2000, 0, 1),
                        startingDay: 1,
                        showWeeks: false,
                        customClass: customClassInitial
                    }
                },
                final: {
                    previous: '',
                    selected: '',
                    change: changeFinalDate,
                    options: {
                        formatDay: 'd',
                        formatMonth: 'MMM',
                        formatYear: 'yy',
                        minDate: new Date(2000, 0, 1),
                        initDate: new Date(today.getFullYear(), today.getMonth() + 1, 1),
                        startingDay: 1,
                        showWeeks: false,
                        customClass: customClassFinal
                    }
                }
            };

            vm.time = {
                open: false,
                toggle: function (open) {
                    this.open = angular.isDefined(open) ? open : !this.open;
                },
                clear: function () {
                    clearTime();
                    this.toggle(false);
                },
                initial: {
                    hours: listHours(),
                    minutes: listMinutes(),
                    hour: '',
                    minute: ''
                },
                final: {
                    hours: listHours(),
                    minutes: listMinutes(),
                    hour: '',
                    minute: ''
                }
            };

            function customClassInitial(data) {

                var initial = vm.datepicker.initial.selected;
                var final = vm.datepicker.final.selected;
                var date = data.date.setHours(0, 0, 0, 0);

                if (!initial) {
                    return
                }

                initial = initial.setHours(0, 0, 0, 0);
                final = final && final.setHours(0, 0, 0, 0);

                if (final && date > initial && date < final) {
                    return 'selected';
                }

                if (date == initial || date == final) {
                    return 'edge';
                }

            }

            function customClassFinal(data) {

                var initial = vm.datepicker.initial.selected;
                var final = vm.datepicker.final.selected;
                var date = data.date.setHours(0, 0, 0, 0);

                if (!final) {
                    return
                }

                final = final.setHours(0, 0, 0, 0);
                initial = initial && initial.setHours(0, 0, 0, 0);

                if (initial && date > initial && date < final) {
                    return 'selected';
                }

                if (date == final || date == initial) {
                    return 'edge';
                }

            }

            function changeInitialDate() {

                var initial = vm.datepicker.initial.selected;
                var final = vm.datepicker.final.selected;
                var previous = vm.datepicker.initial.previous;

                if (previous && previous.getTime() == initial.getTime()) {
                    vm.datepicker.initial.selected = '';
                    vm.datepicker.initial.previous = '';
                    if (final) {
                        vm.datepicker.final.selected = new Date(final);
                    }
                } else {
                    if (initial > final) {
                        vm.datepicker.final.selected = '';
                    } else {
                        vm.datepicker.final.selected = new Date(final);
                    }
                    vm.datepicker.initial.previous = initial;
                }

            }

            function changeFinalDate() {

                var initial = vm.datepicker.initial.selected;
                var final = vm.datepicker.final.selected;
                var previous = vm.datepicker.final.previous;

                if (previous && previous.getTime() == final.getTime()) {
                    vm.datepicker.final.selected = '';
                    vm.datepicker.final.previous = '';
                    if (initial) {
                        vm.datepicker.initial.selected = new Date(initial);
                    }
                } else {
                    if (final < initial) {
                        vm.datepicker.initial.selected = '';
                    } else if (initial) {
                        vm.datepicker.initial.selected = new Date(initial);
                    }
                    vm.datepicker.final.previous = final;
                    vm.datepicker.initial.options.initDate = new Date(final.getFullYear(), final.getMonth() - 1, 1)
                }

            }
            /* eslint-enable angular/controller-as-vm */
        }
    }

})();

(function () {
    'use strict';

    angular
            .module('imnApp')
            .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
                .state('alarms', {
                    parent: 'app.private',
                    url: '/alarms',
                    data: {
                        pageTitle: 'alarm.title'
                    },
                    params: {
                        id: {
                            value: null,
                            array: true,
                            squash: true
                        },
                        type: {
                            value: null
                        },
                        hiddenParam: 'YES'
                    },
                    views: {
                        'content@app.private': {
                            templateUrl: 'app/components/alarm/alarm.html',
                            controller: 'AlarmController',
                            controllerAs: 'vmAlarm'
                        },
                        'filter@alarms': {
                            templateUrl: 'app/components/alarm/alarm-filter.html',
                            controller: 'AlarmFilterController',
                            controllerAs: 'vmAlarmFilter'
                        },
                        'list@alarms': {
                            templateUrl: 'app/components/alarm/alarm-list.html',
                            controller: 'AlarmListController',
                            controllerAs: 'vmAlarmList'
                        },
                        'settings@alarms': {
                            templateUrl: 'app/components/alarm/alarm-settings.html',
                            controller: 'AlarmSettingsController',
                            controllerAs: 'vmAlarmSettings'
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('global');
                                $translatePartialLoader.addPart('alarm');
                                $translatePartialLoader.addPart('alarm-modal');
                                return $translate.refresh();
                            }]
                    }
                })
    }

})();

(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('AlarmService', AlarmService);

    AlarmService.$inject = ['$http', 'RequestService', 'ModalConstructor', 'AlertModalService'];

    function AlarmService($http, RequestService, ModalConstructor, AlertModalService) {

        var service = {
            // API Methods
            getAlarmList: getAlarmList,            
            getAlarmHistoryList: getAlarmHistoryList,
            getInterfaces: getInterfaces,
            getAlarmType: getAlarmType,
            getOltAlarmSettings: getOltAlarmSettings,
            saveOltAlarmSettings: saveOltAlarmSettings,
            getOnuAlarmSettings: getOnuAlarmSettings,
            saveOnuAlarmSettings: saveOnuAlarmSettings,
            clearAlarmHistory: clearAlarmHistory,
            // Modal Methods
            errorModalConstructor: errorModalConstructor,
            successModalConstructor: successModalConstructor,
            settingsModalConstructor: settingsModalConstructor
            
        };

        return service;

        function getAlarmList(filters) {
            var expressionFilter = {};
            if (filters) {
                expressionFilter = constructFilter(filters);
            }
            return $http.get(apiUrl(), {params: expressionFilter}).then(responseData);

        }

        function getAlarmHistoryList(filters) {
            var expressionFilter = {};
            if (filters) {
                expressionFilter = constructFilter(filters);
            }
            return $http.get(apiUrl('pages'), {params: expressionFilter}).then(responseData);

        }
       
        function getInterfaces() {
            return $http.get(apiUrl('filters/interfaces')).then(responseData);
        }

        function getAlarmType() {
            return $http.get(apiUrl('filters/types')).then(responseData);
        }

        function getOltAlarmSettings(oltId) {
            return $http.get(apiUrl(oltId)).then(responseData);
        }

        function saveOltAlarmSettings(data) {
            return $http.put(apiUrl('updateoltalarmconfig'), data).then(responseData);
        }

        function getOnuAlarmSettings(oltId, onuId) {
            return $http.get(apiUrl(oltId + '/' + onuId)).then(responseData);
        }

        function saveOnuAlarmSettings(data) {
            return $http.put(apiUrl('updateonualarmconfig'), data).then(responseData);
        }

        function clearAlarmHistory() {
            return $http.put(apiUrl('clearalarmhistory')).then(responseData);
        }

        // Helper functions
        function apiUrl(method) {
            return RequestService.apiUrl('alarms', method);
        }

        function constructFilter(filters) {
            angular.forEach(filters, function (value, key, obj) {
                if (!value) {
                    delete obj[key];
                }
            });
            return filters;
        }

        // Return only the data of the response
        function responseData(response) {
            return response.data;
        }

        function errorModalConstructor(response, action) {
            AlertModalService.error(response, action, 'alarm');
        }

        function successModalConstructor(action, isMultiple) {
            AlertModalService.success(action, isMultiple, 'alarm');
        }

        function settingsModalConstructor() {
            var settings = {
                templateUrl: 'app/components/alarm/alarm-settings-modal.html',
                controller: 'AlarmSettingsController',
                controllerAs: 'vmAlarmSettings',
                size: 'sm',
                backdrop: true,
                appendTo: angular.element('.main'),
                windowClass: 'left'
            };
            ModalConstructor.open(settings);
        }

    }
})();
(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('AlarmController', AlarmController);

    AlarmController.$inject = ['$scope', '$state', '$stateParams', 'AlarmService'];

    function AlarmController($scope, $state, $stateParams, AlarmService) {
        var vm = this;
        vm.historyHeader = false;
        vm.tableTitle = 'list';

        vm.openSettings = openSettings;
        vm.configScrollbar = {
            theme: 'dark',
            scrollbarPosition: 'inside',
            scrollButtons: {
                enable: false
            }
        };

        function openSettings() {
            AlarmService.settingsModalConstructor();
        }
    }
})();
(function () {
    'use strict';

    angular
            .module('imnApp')
            .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {

        $stateProvider
                .state('app', {
                    abstract: true,
                    resolve: {
                        translatePartialLoader: ['$translatePartialLoader', function ($translatePartialLoader) {
                                $translatePartialLoader.addPart('global');
                                $translatePartialLoader.addPart('tooltip');
                                $translatePartialLoader.addPart('favorites');
                            }]
                    }
                })
                .state('app.private', {
                    abstract: true,
                    views: {
                        'main@': {
                            templateUrl: 'app/shared/layout/main/main.html'
                        },
                        'navbar@app.private': {
                            templateUrl: 'app/shared/layout/navbar/navbar.html',
                            controller: 'NavbarController',
                            controllerAs: 'vmNavbar'
                        }
                    }
                })
                .state('app.public', {
                    abstract: true
                })
    }
})();
(function(){angular.module('imnApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/components/alarm/alarm-config.html','<div class="panel panel-default">\n    <div class="panel-heading" ng-click="vmAlarmSettings.toggleController()">\n        <span class="panel-title"><span>Configura\xE7\xF5es de alarmes</span>:</span>\n        <span>Personalize a forma como voc\xEA quer visualizar os alarmes</span>\n        <div class="btn-open-filter">\n            <span class="icon icon-open-filter"></span>\n        </div>\n    </div>\n    <div class="panel-body" uib-collapse="vmAlarmSettings.open">\n        <form id="formAlarmSettings" class="form-horizontal form-modal" name="vmAlarmSettings.formAlarmSettings" ng-submit="vmAlarmSettings.save()" novalidate>\n            <section class="setting-section form-horizontal">\n                <div class="form-group">\n                    <label class="col-xs-12 setting-label setting-filter" for="field-filter" data-translate="alarmModal.filter">Filtrar</label>\n                    <div class="combo pull-rigth">\n                        <div class="col-xs-6 col-radio radio-options text-right">\n                            <span class="status-item-value">\n                                <label class="radio" ng-class="{checked: vmAlarmSettings.interface == \'OLT\', disabled: !vmAlarmSettings.authComponent.olt}">\n                                    <input type="radio" id="olt" ng-model="vmAlarmSettings.interface" ng-value="\'OLT\'"\n                                           ng-change="vmAlarmSettings.changeLayout(vmAlarmSettings.interface)"\n                                           ng-disabled="!vmAlarmSettings.authComponent.olt">\n                                </label>\n                            </span>\n                            <label for="olt" class="status-item-label" ng-class="{\'text-disabled\': !vmAlarmSettings.authComponent.olt}" data-translate="global.menu.olt">OLT</label>\n                        </div>\n                        <div class="col-xs-6 col-radio radio-options text-right">\n                            <span class="status-item-value">\n                                <label class="radio" ng-class="{checked: vmAlarmSettings.interface == \'ONU\', disabled: !vmAlarmSettings.authComponent.onu}">\n                                    <input type="radio" id="onu" ng-model="vmAlarmSettings.interface" ng-value="\'ONU\'"\n                                           ng-change="vmAlarmSettings.changeLayout(vmAlarmSettings.interface)"\n                                           ng-disabled="!vmAlarmSettings.authComponent.onu">\n                                </label>\n                            </span>\n                            <label for="onu" class="status-item-label" ng-class="{\'text-disabled\': !vmAlarmSettings.authComponent.onu}" data-translate="global.menu.onu">ONU</label>\n                        </div>\n\n                        <div class="col-xs-6 col-radio radio-options text-right">\n                            <span class="status-item-value">\n                                <label class="radio" ng-class="{checked: vmAlarmSettings.interface == \'ONU\', disabled: !vmAlarmSettings.authComponent.onu}">\n                                    <input type="radio" id="onu" ng-model="vmAlarmSettings.interface" ng-value="\'ONU\'"\n                                           ng-change="vmAlarmSettings.changeLayout(vmAlarmSettings.interface)"\n                                           ng-disabled="!vmAlarmSettings.authComponent.onu">\n                                </label>\n                            </span>\n                            <label for="onu" class="status-item-label" ng-class="{\'text-disabled\': !vmAlarmSettings.authComponent.onu}">ONUX</label>\n                        </div>\n\n                    </div>\n                </div>\n                <div class="form-group">\n                    <label class="col-xs-6 setting-label"><span data-translate="global.menu.olt">OLT</span>:</label>\n                    <div class="col-xs-18">\n                        <ui-select ng-model="vmAlarmSettings.oltSelected" on-select="vmAlarmSettings.setOlt($item)" search-enabled="false"\n                                   ng-disabled="!vmAlarmSettings.oltList.length">\n                            <ui-select-match placeholder="{{vmAlarmSettings.placeholder.olt| translate}}">{{vmAlarmSettings.oltSelected.name}}</ui-select-match>\n                            <ui-select-choices repeat="item in vmAlarmSettings.oltList">{{item.name}}</ui-select-choices>\n                        </ui-select>\n                    </div>\n                </div>\n                <div class="form-group" ng-if="!vmAlarmSettings.isOptionOlt && vmAlarmSettings.authComponent.onu">\n                    <label class="col-xs-6 setting-label"><span data-translate="global.menu.onu">ONU</span>:</label>\n                    <div class="col-xs-18">\n                        <ui-select ng-model="vmAlarmSettings.onuSelected" on-select="vmAlarmSettings.setOnu($item)" search-enabled="false"\n                                   ng-disabled="!vmAlarmSettings.onuList.length">\n                            <ui-select-match placeholder="{{vmAlarmSettings.placeholder.onu| translate}}">{{vmAlarmSettings.onuSelected.name}}</ui-select-match>\n                            <ui-select-choices repeat="item in vmAlarmSettings.onuList">{{item.name}}</ui-select-choices>\n                        </ui-select>\n                    </div>\n                </div>\n            </section>\n            <div class="container-settings-olt" ng-if="vmAlarmSettings.isOptionOlt && vmAlarmSettings.authComponent.olt">\n                <section class="setting-section">\n                    <h5 data-translate="alarmModal.severity.message">Quais criticidades devem aparecer na interface</h5>\n                    <div class="row">\n                        <button type="button" class="btn btn-minor col-xs-10 col-xs-offset-1" ng-class="vmAlarmSettings.severityCheckModel.minor ? \'btn-criticity enable minor\' : \'btn-criticity disable\'"\n                                ng-model="vmAlarmSettings.severityCheckModel.minor" uib-btn-checkbox ng-disabled="vmAlarmSettings.disableButton(\'minor\')">Minor\n                        </button>\n                        <button type="button" class="btn btn-major col-xs-10 col-xs-offset-2" ng-class="vmAlarmSettings.severityCheckModel.major ? \'btn-criticity enable major\' : \'btn-criticity disable\'"\n                                ng-model="vmAlarmSettings.severityCheckModel.major" uib-btn-checkbox ng-disabled="vmAlarmSettings.disableButton(\'major\')">Major\n                        </button>\n                    </div>\n                    <div class="row">\n                        <button type="button" class="btn btn-critical col-xs-10 col-xs-offset-1" ng-class="vmAlarmSettings.severityCheckModel.critical ? \'btn-criticity enable critical\' : \'btn-criticity disable\'"\n                                ng-model="vmAlarmSettings.severityCheckModel.critical" uib-btn-checkbox ng-disabled="vmAlarmSettings.disableButton(\'critical\')">Critical\n                        </button>\n                        <button type="button" class="btn  col-xs-10 col-xs-offset-2" ng-class="vmAlarmSettings.severityCheckModel.warning ? \'btn-criticity enable warning\' : \'btn-criticity disable\'"\n                                ng-model="vmAlarmSettings.severityCheckModel.warning" uib-btn-checkbox ng-disabled="vmAlarmSettings.disableButton(\'warning\')">Warning\n                        </button>\n                    </div>\n                </section>\n                <section class="setting-section">\n                    <h5 data-translate="alarmModal.temperature.message">Configura\xE7\xE3o de limite de temperatura</h5>\n                    <div class="form-group margin-less">\n                        <label class="setting-label" data-translate="alarmModal.temperature.max">Temperatura maxima</label>\n                        <ui-select ng-model="vmAlarmSettings.settingsModelOlt.maxTemperature" search-enabled="false"\n                                   ng-disabled="vmAlarmSettings.disableDropdown(\'OLT\')">\n                            <ui-select-match>{{vmAlarmSettings.settingsModelOlt.maxTemperature}}</ui-select-match>\n                            <ui-select-choices repeat="item in vmAlarmSettings.optionsTemperatureAndPowerValues.maxTemperature">{{item}}</ui-select-choices>\n                        </ui-select>\n                    </div>\n                    <div class="form-group margin-bottom">\n                        <label class="setting-label"data-translate="alarmModal.temperature.min">Temperatura minima</label>\n                        <ui-select ng-model="vmAlarmSettings.settingsModelOlt.minTemperature" search-enabled="false"\n                                   ng-disabled="vmAlarmSettings.disableDropdown(\'OLT\')">\n                            <ui-select-match>{{vmAlarmSettings.settingsModelOlt.minTemperature}}</ui-select-match>\n                            <ui-select-choices repeat="item in vmAlarmSettings.optionsTemperatureAndPowerValues.minTemperature">{{item}}</ui-select-choices>\n                        </ui-select>\n                    </div>\n                </section>\n                <section class="setting-section section-linkdown">\n                    <h5 data-translate="alarmModal.rogue.message">Detec\xE7\xE3o de ONU rogue</h5>\n                    <fieldset class="margin-top">\n                        <div class="form-group margin-bottom" ng-repeat="(index, item) in vmAlarmSettings.settingsModelOlt.onuRogueGpon">\n                            <label class="col-xs-6 setting-label" for="field-filter"><span data-translate="alarmModal.linkdown.port">Port</span> {{$index + 1}}</label>\n                            <div class="col-xs-18">\n                                <ui-select ng-model="vmAlarmSettings.settingsModelOlt.onuRogueGpon[index]" search-enabled="false"\n                                           ng-disabled="vmAlarmSettings.disableDropdown(\'OLT\')">\n                                    <ui-select-match>{{\'alarmModal.rogue.\' + vmAlarmSettings.settingsModelOlt.onuRogueGpon[index]| translate}}</ui-select-match>\n                                    <ui-select-choices repeat="item in vmAlarmSettings.dataSettings.fields.rogueOptions">\n                                        {{\'alarmModal.rogue.\' + item| translate}}\n                                    </ui-select-choices>\n                                </ui-select>\n                            </div>\n                        </div>\n                    </fieldset>\n                </section>\n                <section class="section-linkdown form-horizontal">\n                    <h5 data-translate="alarmModal.linkdown.message">Configura\xE7\xE3o de linkdown</h5>\n                    <fieldset class="margin-top">\n                        <legend class="fieldset-legend"><span>ETHERNET</span></legend>\n                        <div class="form-group" ng-repeat="(index, item) in vmAlarmSettings.settingsModelOlt.portLinkDownSeverityGE1">\n                            <label class="col-xs-6 setting-label" for="field-filter"><span data-translate="alarmModal.linkdown.port">Port</span> {{$index + 1}}</label>\n                            <div class="col-xs-18">\n                                <ui-select ng-model="vmAlarmSettings.settingsModelOlt.portLinkDownSeverityGE1[index]" search-enabled="false"\n                                           ng-disabled="vmAlarmSettings.disableDropdown(\'OLT\')">\n                                    <ui-select-match>{{vmAlarmSettings.settingsModelOlt.portLinkDownSeverityGE1[index].label}}</ui-select-match>\n                                    <ui-select-choices repeat="item in vmAlarmSettings.severityTypes">{{item.label}}</ui-select-choices>\n                                </ui-select>\n                            </div>\n                        </div>\n                    </fieldset>\n                    <fieldset>\n                        <legend class="fieldset-legend"><span>10GE</span></legend>\n                        <div class="form-group" ng-repeat="(index, item) in vmAlarmSettings.settingsModelOlt.portLinkDownSeverityGE10">\n                            <label class="col-xs-6 setting-label" for="field-filter"><span data-translate="alarmModal.linkdown.port">Port</span> {{$index + 1}}</label>\n                            <div class="col-xs-18">\n                                <ui-select ng-model="vmAlarmSettings.settingsModelOlt.portLinkDownSeverityGE10[index]" search-enabled="false"\n                                           ng-disabled="vmAlarmSettings.disableDropdown(\'OLT\')">\n                                    <ui-select-match> {{vmAlarmSettings.settingsModelOlt.portLinkDownSeverityGE10[index].label}}</ui-select-match>\n                                    <ui-select-choices repeat="item in vmAlarmSettings.severityTypes" position="up">{{item.label}}</ui-select-choices>\n                                </ui-select>\n                            </div>\n                        </div>\n                    </fieldset>\n                </section>\n\n            </div>\n            <div class="container-settings-onu" ng-if="!vmAlarmSettings.isOptionOlt && vmAlarmSettings.authComponent.onu">\n                <section class="setting-section">\n                    <h5 data-translate="alarmModal.linkdown.message">Configura\xE7\xE3o de linkdown</h5>\n                    <div class="form-group">\n                        <ui-select ng-model="vmAlarmSettings.settingsModelOnu.linkDown" on-select="vmAlarmSettings.setSettingsLinkdown($item)" search-enabled="false"\n                                   ng-disabled="vmAlarmSettings.disableDropdown(\'ONU\')">\n                            <ui-select-match>{{vmAlarmSettings.settingsModelOnu.linkDown.label}}</ui-select-match>\n                            <ui-select-choices repeat="item in vmAlarmSettings.severityTypes | filter: {value : \'!WARNING\'}">{{item.label}}</ui-select-choices>\n                        </ui-select>\n                    </div>\n                </section>\n                <section class="setting-section">\n                    <h5 data-translate="alarmModal.power.message">Configura\xE7\xE3o de limite da pot\xEAncia da ONU</h5>\n                    <div class="form-group margin-less">\n                        <label class="setting-label" for="field-filter" data-translate="alarmModal.power.max">Pot\xEAncia maxima</label>\n                        <ui-select ng-model="vmAlarmSettings.settingsModelOnu.maxPower" search-enabled="false"\n                                   ng-disabled="vmAlarmSettings.disableDropdown(\'ONU\')" name="maxPower">\n                            <ui-select-match>{{vmAlarmSettings.settingsModelOnu.maxPower}}</ui-select-match>\n                            <ui-select-choices class="select-final" repeat="item in vmAlarmSettings.optionsTemperatureAndPowerValues.powerMaxAndMin">{{item}}</ui-select-choices>\n                        </ui-select>\n                    </div>\n                    <div class="form-group margin-bottom">\n                        <label class="setting-label" for="field-filter" data-translate="alarmModal.power.min">Pot\xEAncia minima</label>\n                        <ui-select ng-model="vmAlarmSettings.settingsModelOnu.minPower" search-enabled="false"\n                                   ng-disabled="vmAlarmSettings.disableDropdown(\'ONU\')" name="minPower">\n                            <ui-select-match>{{vmAlarmSettings.settingsModelOnu.minPower}}</ui-select-match>\n                            <ui-select-choices class="select-final" repeat="item in vmAlarmSettings.optionsTemperatureAndPowerValues.powerMaxAndMin">{{item}}</ui-select-choices>\n                        </ui-select>\n                    </div>\n                </section>\n            </div>\n        </form>\n    </div>\n    <button type="submit" class="btn btn-primary btn-add" ng-disabled="vmAlarmSettings.disableDropdown(vmAlarmSettings.interface)" form="formAlarmSettings" data-translate="global.button.apply">Aplicar</button>\n</div>\n');
$templateCache.put('app/components/alarm/alarm-filter.html','<div class="panel panel-default" ng-class="{open: vmAlarmFilter.open}" data-ng-init="vmAlarmFilter.clearFilter()">\r\n    <div class="panel-heading" ng-click="vmAlarmFilter.toggleFilter()">\r\n        <span class="panel-title"><span>Filtro de Alarmes</span>:</span>\r\n        <span data-translate="alarm.textHistory">Selecione os filtros desejados para buscar os alarmes</span>\r\n        <div class="btn-open-filter">\r\n            <span class="icon icon-open-filter"></span>\r\n        </div>\r\n    </div>\r\n    <div class="panel-body" uib-collapse="!vmAlarmFilter.open">\r\n        <form>\r\n            <div class="row">\r\n                <div class="form-group col-xs-6" hidden="true">\r\n                    <label><span data-translate="alarm.filter.equipment">Equipamento</span>:</label>\r\n                    <ui-select ng-model="vmAlarmFilter.filter.equipmentType" on-select="vmAlarmFilter.setEquipmentType()" search-enabled="false">\r\n                        <ui-select-match>{{vmAlarmFilter.filter.equipmentType}}</ui-select-match>\r\n                        <ui-select-choices repeat="equipment in vmAlarmFilter.equipmentTypeList">{{equipment}}</ui-select-choices>\r\n                    </ui-select>\r\n                </div>\r\n\r\n                <div class="form-group col-xs-6">\r\n                    <label><span data-translate="alarm.filter.name">Nome</span>:</label>\r\n                    <ui-select ng-model="vmAlarmFilter.filter.equipment" on-select="vmAlarmFilter.setEquipment()" search-enabled="false"\r\n                               ng-disabled="!vmAlarmFilter.equipmentList.length">\r\n                        <ui-select-match placeholder="{{vmAlarmFilter.placeholder.name| translate}}">{{vmAlarmFilter.filter.equipment.name}}</ui-select-match>\r\n                        <ui-select-choices repeat="item in vmAlarmFilter.equipmentList">{{item.name}}</ui-select-choices>\r\n                    </ui-select>\r\n                </div>\r\n\r\n                <div class="form-group col-xs-6">\r\n                    <label><span data-translate="alarm.filter.date">Data</span>:</label>\r\n                    <div class="dropdown-select dropdown-select-filter dropdown-block" ng-class="{open: vmAlarmFilter.datepicker.open}"\r\n                         event-clickout event-action="vmAlarmFilter.datepicker.toggle(false)">\r\n                        <button type="button" class="dropdown-toggle" ng-click="vmAlarmFilter.datepicker.toggle()">\r\n                            {{vmAlarmFilter.filter.date.applied}}\r\n                            <span class="icon icon-arrow-select"></span>\r\n                        </button>\r\n                        <div class="dropdown-datetime dropdown-date" uib-collapse="!vmAlarmFilter.datepicker.open" stop-propagation>\r\n                            <div class="row">\r\n                                <div class="col-xs-8 datepicker date-start">\r\n                                    <div class="date-selected">\r\n                                        <div class="datetime-period"><span data-translate="alarm.filter.start">Inicio</span>:</div>\r\n                                        <div class="preview-date">{{vmAlarmFilter.datepicker.initial.selected| date:\'longDate\'}}</div>\r\n                                    </div>\r\n                                    <div uib-datepicker datepicker-options="vmAlarmFilter.datepicker.initial.options"\r\n                                         ng-model="vmAlarmFilter.datepicker.initial.selected"\r\n                                         ng-change="vmAlarmFilter.datepicker.initial.change()">\r\n                                    </div>\r\n                                </div>\r\n                                <div class="col-xs-8 datepicker date-end">\r\n                                    <div class="date-selected">\r\n                                        <div class="datetime-period"><span data-translate="alarm.filter.end">T\xE9rmino</span>:</div>\r\n                                        <div class="preview-date">{{vmAlarmFilter.datepicker.final.selected| date:\'longDate\'}}</div>\r\n                                    </div>\r\n                                    <div uib-datepicker datepicker-options="vmAlarmFilter.datepicker.final.options"\r\n                                         ng-model="vmAlarmFilter.datepicker.final.selected"\r\n                                         ng-change="vmAlarmFilter.datepicker.final.change()">\r\n                                    </div>\r\n                                </div>\r\n                                <div class="col-xs-8">\r\n                                    <div class="datetime-periods">\r\n                                        <ul>\r\n                                            <li>\r\n                                                <button type="button" data-translate="alarm.filter.today"\r\n                                                        ng-model="vmAlarmFilter.filter.datePeriod" uib-btn-radio="\'today\'"\r\n                                                        ng-click="vmAlarmFilter.setDatePeriod(\'today\')">Hoje</button>\r\n                                            </li>\r\n                                            <li>\r\n                                                <button type="button" data-translate="alarm.filter.yesterday"\r\n                                                        ng-model="vmAlarmFilter.filter.datePeriod" uib-btn-radio="\'yesterday\'"\r\n                                                        ng-click="vmAlarmFilter.setDatePeriod(\'yesterday\')">Ontem</button>\r\n                                            </li>\r\n                                            <li>\r\n                                                <button type="button" data-translate="alarm.filter.week"\r\n                                                        ng-model="vmAlarmFilter.filter.datePeriod" uib-btn-radio="\'last-week\'"\r\n                                                        ng-click="vmAlarmFilter.setDatePeriod(\'last-week\')">\xDAltimos Sete Dias</button>\r\n                                            </li>\r\n                                            <li>\r\n                                                <button type="button" data-translate="alarm.filter.month"\r\n                                                        ng-model="vmAlarmFilter.filter.datePeriod" uib-btn-radio="\'last-month\'"\r\n                                                        ng-click="vmAlarmFilter.setDatePeriod(\'last-month\')">\xDAltimo m\xEAs</button>\r\n                                            </li>\r\n                                        </ul>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                            <div class="text-right">\r\n                                <button type="button" class="btn btn-default btn-cancel" data-translate="alarm.button.clear" ng-click="vmAlarmFilter.datepicker.clear()">Limpar</button>\r\n                                <button type="button" class="btn btn-primary btn-apply" data-translate="alarm.button.apply" ng-click="vmAlarmFilter.setDate()">Aplicar</button>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class="form-group col-xs-4">\r\n                    <label><span data-translate="alarm.filter.time">Hora</span>:</label>\r\n                    <div class="dropdown-select dropdown-select-filter dropdown-block" ng-class="{open: vmAlarmFilter.time.open}"\r\n                         event-clickout event-action="vmAlarmFilter.time.toggle(false)">\r\n                        <button type="button" class="dropdown-toggle" ng-click="vmAlarmFilter.time.toggle()">\r\n                            {{vmAlarmFilter.filter.time}}\r\n                            <span class="icon icon-arrow-select"></span>\r\n                        </button>\r\n                        <div class="dropdown-datetime dropdown-time" uib-collapse="!vmAlarmFilter.time.open">\r\n                            <div class="row">\r\n                                <div class="col-xs-8">\r\n                                    <div class="datetime-period"><span data-translate="alarm.filter.start">In\xEDcio</span>:</div>\r\n                                    <div class="time-dropdowns">\r\n                                        <ui-select class="ui-time ui-time-hour" ng-model="vmAlarmFilter.time.initial.hour" search-enabled="false">\r\n                                            <ui-select-match placeholder="--h">{{vmAlarmFilter.time.initial.hour.label}}</ui-select-match>\r\n                                            <ui-select-choices repeat="hour in vmAlarmFilter.time.initial.hours">{{hour.label}}</ui-select-choices>\r\n                                        </ui-select>\r\n                                        <ui-select class="ui-time ui-time-minute" ng-model="vmAlarmFilter.time.initial.minute" search-enabled="false">\r\n                                            <ui-select-match placeholder="--min">{{vmAlarmFilter.time.initial.minute.label}}</ui-select-match>\r\n                                            <ui-select-choices repeat="minute in vmAlarmFilter.time.initial.minutes">{{minute.label}}</ui-select-choices>\r\n                                        </ui-select>\r\n                                    </div>\r\n                                </div>\r\n                                <div class="col-xs-8">\r\n                                    <div class="datetime-period"><span data-translate="alarm.filter.end">T\xE9rmino</span>:</div>\r\n                                    <div class="time-dropdowns">\r\n                                        <ui-select class="ui-time ui-time-hour" ng-model="vmAlarmFilter.time.final.hour" search-enabled="false">\r\n                                            <ui-select-match placeholder="--h">{{vmAlarmFilter.time.final.hour.label}}</ui-select-match>\r\n                                            <ui-select-choices repeat="hour in vmAlarmFilter.time.final.hours">{{hour.label}}</ui-select-choices>\r\n                                        </ui-select>\r\n                                        <ui-select class="ui-time ui-time-minute" ng-model="vmAlarmFilter.time.final.minute" search-enabled="false">\r\n                                            <ui-select-match placeholder="--min">{{vmAlarmFilter.time.final.minute.label}}</ui-select-match>\r\n                                            <ui-select-choices repeat="minute in vmAlarmFilter.time.final.minutes">{{minute.label}}</ui-select-choices>\r\n                                        </ui-select>\r\n                                    </div>\r\n                                </div>\r\n                                <div class="col-xs-8">\r\n                                    <div class="datetime-periods">\r\n                                        <ul>\r\n                                            <li>\r\n                                                <button type="button"\r\n                                                        ng-model="vmAlarmFilter.filter.withinTimeOnly" uib-btn-radio="false"\r\n                                                        data-translate="alarm.filter.byPeriod">\r\n                                                    Por per\xEDodo\r\n                                                </button>\r\n                                            </li>\r\n                                            <li>\r\n                                                <button type="button"\r\n                                                        ng-model="vmAlarmFilter.filter.withinTimeOnly" uib-btn-radio="true"\r\n                                                        data-translate="alarm.filter.byTime">\r\n                                                    Por hor\xE1rio\r\n                                                </button>\r\n                                            </li>\r\n                                        </ul>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                            <div class="text-right">\r\n                                <button type="button" class="btn btn-default btn-cancel" data-translate="alarm.button.clear" ng-click="vmAlarmFilter.time.clear()">Cancelar</button>\r\n                                <button type="button" class="btn btn-primary btn-apply" data-translate="alarm.button.apply" ng-click="vmAlarmFilter.setTime()">Aplicar</button>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class="form-group col-xs-8">\r\n                    <label><span data-translate="alarm.filter.severity">Criticidade</span>:</label>\r\n                    <div class="btn-severity">\r\n                        <button type="button" class="btn"\r\n                                ng-class="{\'btn-default\': !vmAlarmFilter.filter.severity.minor, \'btn-primary\': vmAlarmFilter.filter.severity.minor}"\r\n                                ng-model="vmAlarmFilter.filter.severity.minor" uib-btn-checkbox>Minor</button>\r\n                        <button type="button" class="btn"\r\n                                ng-class="{\'btn-default\': !vmAlarmFilter.filter.severity.major, \'btn-primary\': vmAlarmFilter.filter.severity.major}"\r\n                                ng-model="vmAlarmFilter.filter.severity.major" uib-btn-checkbox>Major</button>\r\n                        <button type="button" class="btn"\r\n                                ng-class="{\'btn-default\': !vmAlarmFilter.filter.severity.critical, \'btn-primary\': vmAlarmFilter.filter.severity.critical}"\r\n                                ng-model="vmAlarmFilter.filter.severity.critical" uib-btn-checkbox>Critical</button>\r\n                        <button type="button" class="btn"\r\n                                ng-class="{\'btn-default\': !vmAlarmFilter.filter.severity.warning, \'btn-primary\': vmAlarmFilter.filter.severity.warning}"\r\n                                ng-model="vmAlarmFilter.filter.severity.warning" uib-btn-checkbox>Warning</button>\r\n                    </div>\r\n                </div>\r\n\r\n            </div>\r\n\r\n            <div class="btns-filter">\r\n                <button type="button" class="btn btn-default btn-clear" data-translate="alarm.button.clear" ng-click="vmAlarmFilter.clearFilter()">Limpar</button>\r\n                <button type="submit" class="btn btn-primary btn-apply" data-translate="alarm.button.apply" ng-click="vmAlarmFilter.applyFilter()">Aplicar</button>\r\n            </div>\r\n\r\n\r\n        </form>\r\n    </div>\r\n</div>\r\n');
$templateCache.put('app/components/alarm/alarm-list.html','<div class="panel panel-default panel-alarm-list" has-authority="alarmList" has-behavior="hide">\r\n    <div class="panel-heading" ng-class="{\'heading-triggered\': !vmAlarm.historyHeader, \'heading-history\': vmAlarm.historyHeader}">\r\n        <span class="panel-title" data-translate="alarm.{{vmAlarm.tableTitle}}">Lista de Alarmes Disparados</span>\r\n    </div>\r\n    <div class="table-heading">\r\n        <table class="table">\r\n            <thead ng-class="{\'alarm-active\': !vmAlarm.historyHeader}">\r\n                <tr>\r\n                    <th class="col-alarm">\r\n                        <div class="order-table">\r\n                        </div>\r\n                    </th>\r\n                    <th class="col-equipment">\r\n                        <div class="order-table" ng-click="vmAlarmList.orderBy(\'equipment\')" ng-class="{\'order-desc\': vmAlarmList.order == \'-equipment\'}">\r\n                            <span data-translate="alarm.equipment"></span>\r\n                            <span class="caret"></span>\r\n                        </div>\r\n                    </th>\r\n                    <th class="col-interface">\r\n                        <div class="order-table" ng-click="vmAlarmList.orderBy(\'interface\')" ng-class="{\'order-desc\': vmAlarmList.order == \'-interface\'}">\r\n                            <span data-translate="alarm.interface"></span>\r\n                            <span class="caret"></span>\r\n                        </div>\r\n                    </th>\r\n                    <th class="col-type">\r\n                        <div class="order-table" ng-click="vmAlarmList.orderBy(\'alarmType\')" ng-class="{\'order-desc\': vmAlarmList.order == \'-alarmType\'}">\r\n                            <span data-translate="alarm.type"></span>\r\n                            <span class="caret"></span>\r\n                        </div>\r\n                    </th>\r\n                    <th class="col-severity">\r\n                        <div class="order-table" ng-click="vmAlarmList.orderBy(\'severity\')" ng-class="{\'order-desc\': vmAlarmList.order == \'-severity\'}">\r\n                            <span data-translate="alarm.severity"></span>\r\n                            <span class="caret"></span>\r\n                        </div>\r\n\r\n                    </th>\r\n                    <th class="col-date">\r\n                        <div class="order-table" ng-click="vmAlarmList.orderBy(\'dateTime\')" ng-class="{\'order-desc\': vmAlarmList.order == \'-dateTime\'}">\r\n                            <span data-translate="alarm.date"></span>\r\n                            <span class="caret"></span>\r\n                        </div>\r\n                    </th>\r\n                    <th class="col-time">\r\n                        <div class="order-table" ng-click="vmAlarmList.orderBy(\'time\')" ng-class="{\'order-desc\': vmAlarmList.order == \'-time\'}">\r\n                            <span data-translate="alarm.time"></span>\r\n                            <span class="caret"></span>\r\n                        </div>\r\n                    </th>\r\n                </tr>\r\n            </thead>\r\n        </table>\r\n    </div>\r\n    <div class="alarm-list-body">\r\n        <div class="container-scroll" ng-scrollbars ng-scrollbars-config="vmAlarm.configScrollbar">\r\n            <table class="table">\r\n                <tbody class="alarm-active">\r\n                    <tr class="list-alarm alarm" ng-if="!vmAlarmList.alarmList.active.length">\r\n                        <td colspan="7"></td>\r\n                    </tr>\r\n                    <tr class="list-alarm alarm" ng-repeat="alarmItem in vmAlarmList.alarmList.active| orderBy:vmAlarmList.order"\r\n                        ng-class="[\'alarm-\' + alarmItem.severity]">\r\n                        <td class="icon-align col-alarm">\r\n                            <div class="icon icon-alarm"></div>\r\n                        </td>\r\n                        <td class="col-equipment">{{alarmItem.equipment}}</td>\r\n                        <td class="col-interface">{{alarmItem.interface}}</td>\r\n                        <td class="text-capitalize col-type">{{alarmItem.alarmType}}</td>\r\n                        <td class="text-capitalize col-severity">{{alarmItem.severity}}</td>\r\n                        <td class="col-date">{{alarmItem.dateTime| date:"longDate"}}</td>\r\n                        <td class="col-time">{{alarmItem.dateTime| date:"HH\'h\' mm\'min\'"}}</td>\r\n                    </tr>\r\n                </tbody>\r\n            </table>\r\n           \r\n        </div>\r\n    </div>\r\n</div>\r\n');
$templateCache.put('app/components/alarm/alarm-settings-bar.html','<div class="container-setting-bar">\r\n    <div class="btn-setting-alarm" ng-click="vmAlarm.openSettings()" has-authority="oltAlarmConfig||onuAlarmConfig" has-behavior="disable-button-float">\r\n        <span class="btn-text" data-translate="alarmModal.btnOpenModal.message">Configura\xE7\xF5es</span>\r\n        <span class="icon-config-alarm"></span>\r\n    </div>\r\n</div>');
$templateCache.put('app/components/alarm/alarm-settings-modal.html','<div class="container-settings-modal container-scroll">\r\n    <div class="modal-header">\r\n        <button type="button" class="close" ng-click="vmAlarmSettings.close()" aria-label="Close"><span aria-hidden="true">&times;</span></button>\r\n        <h4 class="modal-title" id="myModalLabel2" data-translate="alarmModal.title">Configura\xE7\xE3o de alarmes</h4>\r\n    </div>\r\n    <div class="modal-body container-scroll" ng-scrollbars>\r\n        <form id="formAlarmSettings" class="form-horizontal form-modal" name="vmAlarmSettings.formAlarmSettings" ng-submit="vmAlarmSettings.save()" novalidate>\r\n            <section class="setting-section form-horizontal">\r\n                <div class="form-group">\r\n                    <label class="col-xs-12 setting-label setting-filter" for="field-filter" data-translate="alarmModal.filter">Filtrar</label>\r\n                    <div class="combo pull-rigth">\r\n                        <div class="col-xs-6 col-radio radio-options text-right">\r\n                            <span class="status-item-value">\r\n                                <label class="radio" ng-class="{checked: vmAlarmSettings.interface == \'OLT\', disabled: !vmAlarmSettings.authComponent.olt}">\r\n                                    <input type="radio" id="olt" ng-model="vmAlarmSettings.interface" ng-value="\'OLT\'"\r\n                                           ng-change="vmAlarmSettings.changeLayout(vmAlarmSettings.interface)"\r\n                                           ng-disabled="!vmAlarmSettings.authComponent.olt">\r\n                                </label>\r\n                            </span>\r\n                            <label for="olt" class="status-item-label" ng-class="{\'text-disabled\': !vmAlarmSettings.authComponent.olt}" data-translate="global.menu.olt">OLT</label>\r\n                        </div>\r\n                        <div class="col-xs-6 col-radio radio-options text-right">\r\n                            <span class="status-item-value">\r\n                                <label class="radio" ng-class="{checked: vmAlarmSettings.interface == \'ONU\', disabled: !vmAlarmSettings.authComponent.onu}">\r\n                                    <input type="radio" id="onu" ng-model="vmAlarmSettings.interface" ng-value="\'ONU\'"\r\n                                           ng-change="vmAlarmSettings.changeLayout(vmAlarmSettings.interface)"\r\n                                           ng-disabled="!vmAlarmSettings.authComponent.onu">\r\n                                </label>\r\n                            </span>\r\n                            <label for="onu" class="status-item-label" ng-class="{\'text-disabled\': !vmAlarmSettings.authComponent.onu}" data-translate="global.menu.onu">ONU</label>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class="form-group">\r\n                    <label class="col-xs-6 setting-label"><span data-translate="global.menu.olt">OLT</span>:</label>\r\n                    <div class="col-xs-18">\r\n                        <ui-select ng-model="vmAlarmSettings.oltSelected" on-select="vmAlarmSettings.setOlt($item)" search-enabled="false"\r\n                                   ng-disabled="!vmAlarmSettings.oltList.length">\r\n                            <ui-select-match placeholder="{{vmAlarmSettings.placeholder.olt| translate}}">{{vmAlarmSettings.oltSelected.name}}</ui-select-match>\r\n                            <ui-select-choices repeat="item in vmAlarmSettings.oltList">{{item.name}}</ui-select-choices>\r\n                        </ui-select>\r\n                    </div>\r\n                </div>\r\n                <div class="form-group" ng-if="!vmAlarmSettings.isOptionOlt && vmAlarmSettings.authComponent.onu">\r\n                    <label class="col-xs-6 setting-label"><span data-translate="global.menu.onu">ONU</span>:</label>\r\n                    <div class="col-xs-18">\r\n                        <ui-select ng-model="vmAlarmSettings.onuSelected" on-select="vmAlarmSettings.setOnu($item)" search-enabled="false"\r\n                                   ng-disabled="!vmAlarmSettings.onuList.length">\r\n                            <ui-select-match placeholder="{{vmAlarmSettings.placeholder.onu| translate}}">{{vmAlarmSettings.onuSelected.name}}</ui-select-match>\r\n                            <ui-select-choices repeat="item in vmAlarmSettings.onuList">{{item.name}}</ui-select-choices>\r\n                        </ui-select>\r\n                    </div>\r\n                </div>\r\n            </section>\r\n            <div class="container-settings-olt" ng-if="vmAlarmSettings.isOptionOlt && vmAlarmSettings.authComponent.olt">\r\n                <section class="setting-section">\r\n                    <h5 data-translate="alarmModal.severity.message">Quais criticidades devem aparecer na interface</h5>\r\n                    <div class="row">\r\n                        <button type="button" class="btn btn-minor col-xs-10 col-xs-offset-1" ng-class="vmAlarmSettings.severityCheckModel.minor ? \'btn-criticity enable minor\' : \'btn-criticity disable\'"\r\n                                ng-model="vmAlarmSettings.severityCheckModel.minor" uib-btn-checkbox ng-disabled="vmAlarmSettings.disableButton(\'minor\')">Minor\r\n                        </button>\r\n                        <button type="button" class="btn btn-major col-xs-10 col-xs-offset-2" ng-class="vmAlarmSettings.severityCheckModel.major ? \'btn-criticity enable major\' : \'btn-criticity disable\'"\r\n                                ng-model="vmAlarmSettings.severityCheckModel.major" uib-btn-checkbox ng-disabled="vmAlarmSettings.disableButton(\'major\')">Major\r\n                        </button>\r\n                    </div>\r\n                    <div class="row">\r\n                        <button type="button" class="btn btn-critical col-xs-10 col-xs-offset-1" ng-class="vmAlarmSettings.severityCheckModel.critical ? \'btn-criticity enable critical\' : \'btn-criticity disable\'"\r\n                                ng-model="vmAlarmSettings.severityCheckModel.critical" uib-btn-checkbox ng-disabled="vmAlarmSettings.disableButton(\'critical\')">Critical\r\n                        </button>\r\n                        <button type="button" class="btn  col-xs-10 col-xs-offset-2" ng-class="vmAlarmSettings.severityCheckModel.warning ? \'btn-criticity enable warning\' : \'btn-criticity disable\'"\r\n                                ng-model="vmAlarmSettings.severityCheckModel.warning" uib-btn-checkbox ng-disabled="vmAlarmSettings.disableButton(\'warning\')">Warning\r\n                        </button>\r\n                    </div>\r\n                </section>\r\n                <section class="setting-section">\r\n                    <h5 data-translate="alarmModal.temperature.message">Configura\xE7\xE3o de limite de temperatura</h5>\r\n                    <div class="form-group margin-less">\r\n                        <label class="setting-label" data-translate="alarmModal.temperature.max">Temperatura maxima</label>\r\n                        <ui-select ng-model="vmAlarmSettings.settingsModelOlt.maxTemperature" search-enabled="false"\r\n                                   ng-disabled="vmAlarmSettings.disableDropdown(\'OLT\')">\r\n                            <ui-select-match>{{vmAlarmSettings.settingsModelOlt.maxTemperature}}</ui-select-match>\r\n                            <ui-select-choices repeat="item in vmAlarmSettings.optionsTemperatureAndPowerValues.maxTemperature">{{item}}</ui-select-choices>\r\n                        </ui-select>\r\n                    </div>\r\n                    <div class="form-group margin-bottom">\r\n                        <label class="setting-label"data-translate="alarmModal.temperature.min">Temperatura minima</label>\r\n                        <ui-select ng-model="vmAlarmSettings.settingsModelOlt.minTemperature" search-enabled="false"\r\n                                   ng-disabled="vmAlarmSettings.disableDropdown(\'OLT\')">\r\n                            <ui-select-match>{{vmAlarmSettings.settingsModelOlt.minTemperature}}</ui-select-match>\r\n                            <ui-select-choices repeat="item in vmAlarmSettings.optionsTemperatureAndPowerValues.minTemperature">{{item}}</ui-select-choices>\r\n                        </ui-select>\r\n                    </div>\r\n                </section>\r\n                <section class="setting-section section-linkdown">\r\n                    <h5 data-translate="alarmModal.rogue.message">Detec\xE7\xE3o de ONU rogue</h5>\r\n                    <fieldset class="margin-top">\r\n                        <div class="form-group margin-bottom" ng-repeat="(index, item) in vmAlarmSettings.settingsModelOlt.onuRogueGpon">\r\n                            <label class="col-xs-6 setting-label" for="field-filter"><span data-translate="alarmModal.linkdown.port">Port</span> {{$index + 1}}</label>\r\n                            <div class="col-xs-18">\r\n                                <ui-select ng-model="vmAlarmSettings.settingsModelOlt.onuRogueGpon[index]" search-enabled="false"\r\n                                           ng-disabled="vmAlarmSettings.disableDropdown(\'OLT\')">\r\n                                    <ui-select-match>{{\'alarmModal.rogue.\' + vmAlarmSettings.settingsModelOlt.onuRogueGpon[index]| translate}}</ui-select-match>\r\n                                    <ui-select-choices repeat="item in vmAlarmSettings.dataSettings.fields.rogueOptions">\r\n                                        {{\'alarmModal.rogue.\' + item| translate}}\r\n                                    </ui-select-choices>\r\n                                </ui-select>\r\n                            </div>\r\n                        </div>\r\n                    </fieldset>\r\n                </section>\r\n                <section class="section-linkdown form-horizontal">\r\n                    <h5 data-translate="alarmModal.linkdown.message">Configura\xE7\xE3o de linkdown</h5>\r\n                    <fieldset class="margin-top">\r\n                        <legend class="fieldset-legend"><span>ETHERNET</span></legend>\r\n                        <div class="form-group" ng-repeat="(index, item) in vmAlarmSettings.settingsModelOlt.portLinkDownSeverityGE1">\r\n                            <label class="col-xs-6 setting-label" for="field-filter"><span data-translate="alarmModal.linkdown.port">Port</span> {{$index + 1}}</label>\r\n                            <div class="col-xs-18">\r\n                                <ui-select ng-model="vmAlarmSettings.settingsModelOlt.portLinkDownSeverityGE1[index]" search-enabled="false"\r\n                                           ng-disabled="vmAlarmSettings.disableDropdown(\'OLT\')">\r\n                                    <ui-select-match>{{vmAlarmSettings.settingsModelOlt.portLinkDownSeverityGE1[index].label}}</ui-select-match>\r\n                                    <ui-select-choices repeat="item in vmAlarmSettings.severityTypes">{{item.label}}</ui-select-choices>\r\n                                </ui-select>\r\n                            </div>\r\n                        </div>\r\n                    </fieldset>\r\n                    <fieldset>\r\n                        <legend class="fieldset-legend"><span>10GE</span></legend>\r\n                        <div class="form-group" ng-repeat="(index, item) in vmAlarmSettings.settingsModelOlt.portLinkDownSeverityGE10">\r\n                            <label class="col-xs-6 setting-label" for="field-filter"><span data-translate="alarmModal.linkdown.port">Port</span> {{$index + 1}}</label>\r\n                            <div class="col-xs-18">\r\n                                <ui-select ng-model="vmAlarmSettings.settingsModelOlt.portLinkDownSeverityGE10[index]" search-enabled="false"\r\n                                           ng-disabled="vmAlarmSettings.disableDropdown(\'OLT\')">\r\n                                    <ui-select-match> {{vmAlarmSettings.settingsModelOlt.portLinkDownSeverityGE10[index].label}}</ui-select-match>\r\n                                    <ui-select-choices repeat="item in vmAlarmSettings.severityTypes" position="up">{{item.label}}</ui-select-choices>\r\n                                </ui-select>\r\n                            </div>\r\n                        </div>\r\n                    </fieldset>\r\n                </section>\r\n\r\n            </div>\r\n            <div class="container-settings-onu" ng-if="!vmAlarmSettings.isOptionOlt && vmAlarmSettings.authComponent.onu">\r\n                <section class="setting-section">\r\n                    <h5 data-translate="alarmModal.linkdown.message">Configura\xE7\xE3o de linkdown</h5>\r\n                    <div class="form-group">\r\n                        <ui-select ng-model="vmAlarmSettings.settingsModelOnu.linkDown" on-select="vmAlarmSettings.setSettingsLinkdown($item)" search-enabled="false"\r\n                                   ng-disabled="vmAlarmSettings.disableDropdown(\'ONU\')">\r\n                            <ui-select-match>{{vmAlarmSettings.settingsModelOnu.linkDown.label}}</ui-select-match>\r\n                            <ui-select-choices repeat="item in vmAlarmSettings.severityTypes | filter: {value : \'!WARNING\'}">{{item.label}}</ui-select-choices>\r\n                        </ui-select>\r\n                    </div>\r\n                </section>\r\n                <section class="setting-section">\r\n                    <h5 data-translate="alarmModal.power.message">Configura\xE7\xE3o de limite da pot\xEAncia da ONU</h5>\r\n                    <div class="form-group margin-less">\r\n                        <label class="setting-label" for="field-filter" data-translate="alarmModal.power.max">Pot\xEAncia maxima</label>\r\n                        <ui-select ng-model="vmAlarmSettings.settingsModelOnu.maxPower" search-enabled="false"\r\n                                   ng-disabled="vmAlarmSettings.disableDropdown(\'ONU\')" name="maxPower">\r\n                            <ui-select-match>{{vmAlarmSettings.settingsModelOnu.maxPower}}</ui-select-match>\r\n                            <ui-select-choices class="select-final" repeat="item in vmAlarmSettings.optionsTemperatureAndPowerValues.powerMaxAndMin">{{item}}</ui-select-choices>\r\n                        </ui-select>\r\n                    </div>\r\n                    <div class="form-group margin-bottom">\r\n                        <label class="setting-label" for="field-filter" data-translate="alarmModal.power.min">Pot\xEAncia minima</label>\r\n                        <ui-select ng-model="vmAlarmSettings.settingsModelOnu.minPower" search-enabled="false"\r\n                                   ng-disabled="vmAlarmSettings.disableDropdown(\'ONU\')" name="minPower">\r\n                            <ui-select-match>{{vmAlarmSettings.settingsModelOnu.minPower}}</ui-select-match>\r\n                            <ui-select-choices class="select-final" repeat="item in vmAlarmSettings.optionsTemperatureAndPowerValues.powerMaxAndMin">{{item}}</ui-select-choices>\r\n                        </ui-select>\r\n                    </div>\r\n                </section>\r\n            </div>\r\n        </form>\r\n    </div>\r\n    <footer class="modal-footer">\r\n        <button type="button" class="btn btn-default btn-cancel" ng-click="vmAlarmSettings.close()" ng-disabled="vmAlarmSettings.postRunning" data-translate="global.button.cancel">Cancelar</button>\r\n        <button type="submit" class="btn btn-primary btn-add" ng-disabled="vmAlarmSettings.disableDropdown(vmAlarmSettings.interface)" form="formAlarmSettings" data-translate="global.button.apply">Aplicar</button>\r\n    </footer>\r\n</div>\r\n\r\n\r\n');
$templateCache.put('app/components/alarm/alarm-settings.html','<div class="panel panel-default" ng-class="{open: vmAlarmSettings.open}">\n    <div class="panel-heading" ng-click="vmAlarmSettings.toggleFilter()">\n        <span class="panel-title"><span data-translate="alarm.configuration">Configura\xE7\xF5es</span>:</span>\n        <span data-translate="alarm.textConfiguration">Personalize os alarmes do sistema para determinado equipamento ONU/OLT</span>\n        <div class="btn-open-filter">\n            <span class="icon icon-open-filter"></span>\n        </div>\n    </div>\n    <div uib-collapse="!vmAlarmSettings.open" class="panel-body">\n        <form id="formAlarmSettings" name="vmAlarmSettings.formAlarmSettings" ng-submit="vmAlarmSettings.save()" novalidate>\n            <section >\n                <div class="form-group">\n                    <div class="combo row">\n                        <div class="col-xs-6 col-radio radio-options text-right">\n                            <span class="status-item-value">\n                                <label class="radio" ng-class="{checked: vmAlarmSettings.interface == \'OLT\', disabled: !vmAlarmSettings.authComponent.olt}">\n                                    <input type="radio" id="olt" ng-model="vmAlarmSettings.interface" ng-value="\'OLT\'"\n                                           ng-change="vmAlarmSettings.changeLayout(vmAlarmSettings.interface)"\n                                           ng-disabled="!vmAlarmSettings.authComponent.olt">\n                                </label>\n                            </span>\n                            <label for="olt" class="status-item-label" ng-class="{\'text-disabled\': !vmAlarmSettings.authComponent.olt}" data-translate="global.menu.olt">OLT</label>\n                        </div>\n                        <div class="col-xs-6 col-radio radio-options text-right">\n                            <span class="status-item-value">\n                                <label class="radio" ng-class="{checked: vmAlarmSettings.interface == \'ONU\', disabled: !vmAlarmSettings.authComponent.onu}">\n                                    <input type="radio" id="onu" ng-model="vmAlarmSettings.interface" ng-value="\'ONU\'"\n                                           ng-change="vmAlarmSettings.changeLayout(vmAlarmSettings.interface)"\n                                           ng-disabled="!vmAlarmSettings.authComponent.onu">\n                                </label>\n                            </span>\n                            <label for="onu" class="status-item-label" ng-class="{\'text-disabled\': !vmAlarmSettings.authComponent.onu}" data-translate="global.menu.onu">ONU</label>\n                        </div>\n                    </div>\n                </div>\n                <div class="form-group">\n                    <div class="row">\n                        <label><span>OLT</span>:</label>\n                        <ui-select ng-model="vmAlarmSettings.oltSelected" on-select="vmAlarmSettings.setOlt($item)" search-enabled="false"\n                                   ng-disabled="!vmAlarmSettings.oltList.length">\n                            <ui-select-match placeholder="{{vmAlarmSettings.placeholder.olt| translate}}">{{vmAlarmSettings.oltSelected.name}}</ui-select-match>\n                            <ui-select-choices repeat="item in vmAlarmSettings.oltZhoneList">{{item.name}}</ui-select-choices>\n                        </ui-select>\n                    </div>\n                </div>\n                <div ng-if="!vmAlarmSettings.isOptionOlt && vmAlarmSettings.authComponent.onu">\n                    <label><span>ONU</span>:</label>\n                    <div>\n                        <ui-select ng-model="vmAlarmSettings.onuSelected" on-select="vmAlarmSettings.setOnu($item)" search-enabled="false"\n                                   ng-disabled="!vmAlarmSettings.onuList.length">\n                            <ui-select-match placeholder="{{vmAlarmSettings.placeholder.onu| translate}}">{{vmAlarmSettings.onuSelected.name}}</ui-select-match>\n                            <ui-select-choices repeat="item in vmAlarmSettings.onuList">{{item.name}}</ui-select-choices>\n                        </ui-select>\n                    </div>\n                </div>\n            </section>\n            <div class="container-settings-olt" ng-if="vmAlarmSettings.isOptionOlt && vmAlarmSettings.authComponent.olt">\n                <section class="setting-section">\n                    <h5 data-translate="alarmModal.severity.message">Quais criticidades devem aparecer na interface</h5>\n                    <div class="row">\n                        <button type="button" class="btn btn-minor col-xs-10 col-xs-offset-1" ng-class="vmAlarmSettings.severityCheckModel.minor ? \'btn-criticity enable minor\' : \'btn-criticity disable\'"\n                                ng-model="vmAlarmSettings.severityCheckModel.minor" uib-btn-checkbox ng-disabled="vmAlarmSettings.disableButton(\'minor\')">Minor\n                        </button>\n                        <button type="button" class="btn btn-major col-xs-10 col-xs-offset-2" ng-class="vmAlarmSettings.severityCheckModel.major ? \'btn-criticity enable major\' : \'btn-criticity disable\'"\n                                ng-model="vmAlarmSettings.severityCheckModel.major" uib-btn-checkbox ng-disabled="vmAlarmSettings.disableButton(\'major\')">Major\n                        </button>\n                    </div>\n                    <div class="row">\n                        <button type="button" class="btn btn-critical col-xs-10 col-xs-offset-1" ng-class="vmAlarmSettings.severityCheckModel.critical ? \'btn-criticity enable critical\' : \'btn-criticity disable\'"\n                                ng-model="vmAlarmSettings.severityCheckModel.critical" uib-btn-checkbox ng-disabled="vmAlarmSettings.disableButton(\'critical\')">Critical\n                        </button>\n                        <button type="button" class="btn  col-xs-10 col-xs-offset-2" ng-class="vmAlarmSettings.severityCheckModel.warning ? \'btn-criticity enable warning\' : \'btn-criticity disable\'"\n                                ng-model="vmAlarmSettings.severityCheckModel.warning" uib-btn-checkbox ng-disabled="vmAlarmSettings.disableButton(\'warning\')">Warning\n                        </button>\n                    </div>\n                </section>\n                <section class="setting-section">\n                    <h5 data-translate="alarmModal.temperature.message">Configura\xE7\xE3o de limite de temperatura</h5>\n                    <div class="form-group margin-less row">\n                        <div class="row">\n                            <label class="setting-label" data-translate="alarmModal.temperature.max">Temperatura maxima</label>\n                        </div>\n                        <div class="col-md-4">\n                            <ui-select ng-model="vmAlarmSettings.settingsModelOlt.maxTemperature" search-enabled="false"\n                                       ng-disabled="vmAlarmSettings.disableDropdown(\'OLT\')">\n                                <ui-select-match>{{vmAlarmSettings.settingsModelOlt.maxTemperature}}</ui-select-match>\n                                <ui-select-choices repeat="item in vmAlarmSettings.optionsTemperatureAndPowerValues.maxTemperature">{{item}}</ui-select-choices>\n                            </ui-select>\n                        </div>\n                    </div>\n                    <div class="form-group margin-bottom">\n                        <div class="row">\n                            <label class="setting-label"data-translate="alarmModal.temperature.min">Temperatura minima</label>\n                        </div>\n                        <div class="col-md-4">\n                            <ui-select ng-model="vmAlarmSettings.settingsModelOlt.minTemperature" search-enabled="false"\n                                       ng-disabled="vmAlarmSettings.disableDropdown(\'OLT\')">\n                                <ui-select-match>{{vmAlarmSettings.settingsModelOlt.minTemperature}}</ui-select-match>\n                                <ui-select-choices repeat="item in vmAlarmSettings.optionsTemperatureAndPowerValues.minTemperature">{{item}}</ui-select-choices>\n                            </ui-select>\n                        </div>\n                    </div>\n                </section>\n                <section class="setting-section section-linkdown">\n                    <div class="row">\n                    </div>\n                    <fieldset class="margin-top">\n                        <h5 data-translate="alarmModal.rogue.message">Detec\xE7\xE3o de ONU rogue</h5>\n                        <div class="form-group margin-bottom" ng-repeat="(index, item) in vmAlarmSettings.settingsModelOlt.onuRogueGpon">\n                            <div class="row">\n                                <label class="col-xs-2 setting-label" for="field-filter"><span data-translate="alarmModal.linkdown.port">Port</span> {{$index + 1}}</label>\n                                <div class="col-xs-8">\n                                    <ui-select ng-model="vmAlarmSettings.settingsModelOlt.onuRogueGpon[index]" search-enabled="false"\n                                               ng-disabled="vmAlarmSettings.disableDropdown(\'OLT\')">\n                                        <ui-select-match>{{\'alarmModal.rogue.\' + vmAlarmSettings.settingsModelOlt.onuRogueGpon[index]| translate}}</ui-select-match>\n                                        <ui-select-choices repeat="item in vmAlarmSettings.dataSettings.fields.rogueOptions">\n                                            {{\'alarmModal.rogue.\' + item| translate}}\n                                        </ui-select-choices>\n                                    </ui-select>\n                                </div>\n                            </div>\n                        </div>\n                    </fieldset>\n                </section>\n                <section class="section-linkdown form-horizontal">\n                    <h5 data-translate="alarmModal.linkdown.message">Configura\xE7\xE3o de linkdown</h5>\n                    <fieldset class="margin-top">\n                        <legend class="fieldset-legend"><span>ETHERNET</span></legend>\n                        <div class="form-group" ng-repeat="(index, item) in vmAlarmSettings.settingsModelOlt.portLinkDownSeverityGE1">\n                            <label class="col-xs-2 setting-label" for="field-filter"><span data-translate="alarmModal.linkdown.port">Port</span> {{$index + 1}}</label>\n                            <div class="col-xs-8">\n                                <ui-select ng-model="vmAlarmSettings.settingsModelOlt.portLinkDownSeverityGE1[index]" search-enabled="false"\n                                           ng-disabled="vmAlarmSettings.disableDropdown(\'OLT\')">\n                                    <ui-select-match>{{vmAlarmSettings.settingsModelOlt.portLinkDownSeverityGE1[index].label}}</ui-select-match>\n                                    <ui-select-choices repeat="item in vmAlarmSettings.severityTypes">{{item.label}}</ui-select-choices>\n                                </ui-select>\n                            </div>\n                        </div>\n                    </fieldset>\n                    <fieldset>\n                        <legend class="fieldset-legend"><span>10GE</span></legend>\n                        <div class="form-group" ng-repeat="(index, item) in vmAlarmSettings.settingsModelOlt.portLinkDownSeverityGE10">\n                            <label class="col-xs-2 setting-label" for="field-filter"><span data-translate="alarmModal.linkdown.port">Port</span> {{$index + 1}}</label>\n                            <div class="col-xs-8">\n                                <ui-select ng-model="vmAlarmSettings.settingsModelOlt.portLinkDownSeverityGE10[index]" search-enabled="false"\n                                           ng-disabled="vmAlarmSettings.disableDropdown(\'OLT\')">\n                                    <ui-select-match> {{vmAlarmSettings.settingsModelOlt.portLinkDownSeverityGE10[index].label}}</ui-select-match>\n                                    <ui-select-choices repeat="item in vmAlarmSettings.severityTypes" position="up">{{item.label}}</ui-select-choices>\n                                </ui-select>\n                            </div>\n                        </div>\n                    </fieldset>\n                </section>\n\n            </div>\n            <div class="container-settings-onu" ng-if="!vmAlarmSettings.isOptionOlt && vmAlarmSettings.authComponent.onu">\n                <section class="setting-section">\n                    <h5 data-translate="alarmModal.linkdown.message">Configura\xE7\xE3o de linkdown</h5>\n                    <div class="form-group">\n                        <ui-select ng-model="vmAlarmSettings.settingsModelOnu.linkDown" on-select="vmAlarmSettings.setSettingsLinkdown($item)" search-enabled="false"\n                                   ng-disabled="vmAlarmSettings.disableDropdown(\'ONU\')">\n                            <ui-select-match>{{vmAlarmSettings.settingsModelOnu.linkDown.label}}</ui-select-match>\n                            <ui-select-choices repeat="item in vmAlarmSettings.severityTypes | filter: {value : \'!WARNING\'}">{{item.label}}</ui-select-choices>\n                        </ui-select>\n                    </div>\n                </section>\n                <section class="setting-section">\n                    <h5 data-translate="alarmModal.power.message">Configura\xE7\xE3o de limite da pot\xEAncia da ONU</h5>\n                    <div class="form-group margin-less">\n                        <label class="setting-label" for="field-filter" data-translate="alarmModal.power.max">Pot\xEAncia maxima</label>\n                        <ui-select ng-model="vmAlarmSettings.settingsModelOnu.maxPower" search-enabled="false"\n                                   ng-disabled="vmAlarmSettings.disableDropdown(\'ONU\')" name="maxPower">\n                            <ui-select-match>{{vmAlarmSettings.settingsModelOnu.maxPower}}</ui-select-match>\n                            <ui-select-choices class="select-final" repeat="item in vmAlarmSettings.optionsTemperatureAndPowerValues.powerMaxAndMin">{{item}}</ui-select-choices>\n                        </ui-select>\n                    </div>\n                    <div class="form-group margin-bottom">\n                        <label class="setting-label" for="field-filter" data-translate="alarmModal.power.min">Pot\xEAncia minima</label>\n                        <ui-select ng-model="vmAlarmSettings.settingsModelOnu.minPower" search-enabled="false"\n                                   ng-disabled="vmAlarmSettings.disableDropdown(\'ONU\')" name="minPower">\n                            <ui-select-match>{{vmAlarmSettings.settingsModelOnu.minPower}}</ui-select-match>\n                            <ui-select-choices class="select-final" repeat="item in vmAlarmSettings.optionsTemperatureAndPowerValues.powerMaxAndMin">{{item}}</ui-select-choices>\n                        </ui-select>\n                    </div>\n                </section>\n            </div>\n            <button type="submit" class="btn btn-primary btn-add" ng-disabled="vmAlarmSettings.disableDropdown(vmAlarmSettings.interface)" form="formAlarmSettings" data-translate="global.button.apply">Aplicar</button>\n        </form>\n    </div>\n</div>\n\n\n');
$templateCache.put('app/components/alarm/alarm-show.html','<div class="modal-header">\n    <button type="button" class="close" ng-click="alarmShowVm.close()"><span aria-hidden="true">&times;</span></button>\n    <h4 class="modal-title" id="update-olt-label" >Alarme</h4>\n</div>\n\n<div ng-if="alarmShowVm.isOlt8820G()">\n\n    <table style="border:hidden;">\n        <tr style="border:hidden;">\n            <th colspan="2">************    Central Alarm Manager    ************</th>\n        </tr>\n        <tr style="border:hidden;">\n            <td>ActiveAlarmCurrentCount\t\t:</td>\n            <td>{{ alarmShowVm.alarmShow8820G.activeAlarmCurrentCount }}</td>\n        </tr>\n        <tr style="border:hidden;">\n            <td>AlarmTotalCount\t\t\t:</td>\n            <td>{{ alarmShowVm.alarmShow8820G.alarmTotalCount }}</td>\n        </tr>\n        <tr style="border:hidden;">\n            <td>ClearAlarmTotalCount\t\t:</td>\n            <td>{{ alarmShowVm.alarmShow8820G.clearAlarmTotalCount }}</td>\n        </tr>\n        <tr style="border:hidden;">\n            <td>OverflowAlarmTableCount\t\t:</td>\n            <td>{{ alarmShowVm.alarmShow8820G.overflowAlarmTableCount }}</td>\n        </tr>\n    </table>\n\n    <table style="border:hidden;">\n        <tr>\n            <th style="border:hidden;">ResourceId</th>\n            <th style="border:hidden;"></th>\n            <th style="border:hidden;">AlarmType</th>\n            <th style="border:hidden;"></th>\n            <th style="border:hidden;"></th>\n            <th style="border:hidden;">AlarmSeverity</th>\n        </tr>\n        <tr style="border:hidden;">\n            <td style="border:hidden;">----------</td>\n            <td style="border:hidden;"></td>\n            <td style="border:hidden;">---------</td>\n            <td style="border:hidden;"></td>\n            <td style="border:hidden;"></td>\n            <td style="border:hidden;">-------------</td>\n        </tr>\n        <tr ng-repeat="alarm in alarmShowVm.alarmShow8820G.listAlarms" style="border:hidden;">\n            <td style="border:hidden;">{{ alarm.resourceId }}</td>\n            <td style="border:hidden;"></td>\n            <td style="border:hidden;">{{ alarm.alarmType }}</td>\n            <td style="border:hidden;"></td>\n            <td style="border:hidden;"></td>\n            <td style="border:hidden;">{{ alarm.alarmSeverity }}</td>\n        </tr>   \n    </table>\n\n</div>\n\n<div ng-if="alarmShowVm.isOlt8820i()">\n\n    <table style="border:hidden;">\n        <tr style="border:hidden;">\n            <th colspan="2">************   Central Alarm Manager   ************</th>\n        </tr>\n        <tr style="border:hidden;">\n            <td style="border:hidden;">Alarm Count     :</td>\n            <td style="border:hidden;">{{ alarmShowVm.alarmShow8820i.alarmCount }}</td>\n        </tr>\n        <tr style="border:hidden;">\n            <td style="border:hidden;">History Count   :</td>\n            <td style="border:hidden;">{{ alarmShowVm.alarmShow8820i.historyCount }}</td>\n        </tr>\n    </table>\n\n    <table style="border:hidden;">\n        <tr style="border:hidden;">\n            <th colspan="6" style="border:hidden;">********************************************** Alarms **************************************************</th>\n        </tr>\n        <tr style="border:hidden;">\n            <th style="border:hidden;">Num</th>\n            <th style="border:hidden;">AlarmType</th>\n            <th style="border:hidden;">ResourceId</th>\n            <th style="border:hidden;">Info</th>\n            <th style="border:hidden;">AlarmSeverity</th>\n            <th style="border:hidden;">Date</th>\n        </tr>\n        <tr style="border:hidden;">\n            <td style="border:hidden;">------</td>\n            <td style="border:hidden;">----------------</td>\n            <td style="border:hidden;">-----------------------</td>\n            <td style="border:hidden;">-----------------</td>\n            <td style="border:hidden;">-------------</td>\n            <td style="border:hidden;">-------------------</td>\n        </tr>\n        <tr ng-repeat="alarm in alarmShowVm.alarmShow8820i.listAlarms" style="border:hidden;">\n            <td style="border:hidden;">{{ alarm.alarmsNum }}</td>\n            <td style="border:hidden;">{{ alarm.alarmsAlarmType }}</td>\n            <td style="border:hidden;">{{ alarm.alarmsResourceId }}</td>\n            <td style="border:hidden;">{{ alarm.alarmsInfo }}</td>\n            <td style="border:hidden;">{{ alarm.alarmsAlarmSeverity }}</td>\n            <td style="border:hidden;">{{ alarm.alarmsDate }}</td>\n        </tr>\n    </table>\n\n    <table style="border:hidden;">\n        <tr style="border:hidden;">\n            <th colspan="6">********************************************* History **************************************************</th>\n        </tr>\n        <tr style="border:hidden;">\n            <th style="border:hidden;">Num</th>\n            <th style="border:hidden;">AlarmType</th>\n            <th style="border:hidden;">ResourceId</th>\n            <th style="border:hidden;">Info</th>\n            <th style="border:hidden;">AlarmSeverity</th>\n            <th style="border:hidden;">Date</th>\n        </tr>\n        <tr style="border:hidden;">\n            <td style="border:hidden;">------</td>\n            <td style="border:hidden;">----------------</td>\n            <td style="border:hidden;">-----------------------</td>\n            <td style="border:hidden;">-----------------</td>\n            <td style="border:hidden;">-------------</td>\n            <td style="border:hidden;">-------------------</td>\n        </tr>\n        <tr ng-repeat="history in alarmShowVm.alarmShow8820i.listHistory" style="border:hidden;">\n            <td style="border:hidden;">{{ history.historyNum }}</td>\n            <td style="border:hidden;">{{ history.historyAlarmType }}</td>\n            <td style="border:hidden;">{{ history.historyResourceId }}</td>\n            <td style="border:hidden;">{{ history.historyInfo }}</td>\n            <td style="border:hidden;">{{ history.historyAlarmSeverity }}</td>\n            <td style="border:hidden;">{{ history.historyDate }}</td>\n        </tr>\n    </table>\n\n</div>');
$templateCache.put('app/components/alarm/alarm.html','<div class="container-alarm" ng-scrollbars ng-scrollbars-config="vmAlarm.configScrollbar">\n    <div class="alarm-filter">\n        <div ui-view="filter" class="panel-filter"></div>\n    </div>\n    \n    <div ui-view="list" class="alarm-list"></div>\n</div>');
$templateCache.put('app/components/backup-db/backup-confirm.html','<div class="modal-header">\n    <button type="button" class="close close-delete" ng-click="vmBackupConfirm.close()"><span aria-hidden="true">&times;</span></button>\n    <h4 class="modal-title" id="del-one-bridge-label" data-translate="backupConfirm.{{vmBackupConfirm.action}}.title">Confirma\xE7\xE3o Bridge</h4>\n</div>\n<div class="modal-body modal-content-confirm">\n    <p data-translate="backupConfirm.{{vmBackupConfirm.action}}.message.question" data-translate-values="{data: vmBackupConfirm.data}">\n        Voc\xEA deseja realmente realizar a a\xE7\xE3o {{data}}?\n    </p>\n</div>\n<div class="modal-footer modal-footer-confirm">\n    <button type="button" class="btn btn-default btn-cancel" ng-click="vmBackupConfirm.close()" ng-disabled="vmBackupConfirm.requestRunning"\n            data-translate="global.button.cancel">Cancelar</button>\n    <button type="submit" class="btn btn-primary btn-del" ng-click="vmBackupConfirm.confirmAction()" ng-disabled="vmBackupConfirm.requestRunning"\n            data-translate="backupConfirm.{{vmBackupConfirm.action}}.btnConfirm">Action</button>\n</div>');
$templateCache.put('app/components/backup-db/backup-list.html','<div class="container-restore">\n    <div class="modal-header">\n        <button type="button" class="close close-delete" ng-click="vmBackupList.close()"><span aria-hidden="true">&times;</span></button>\n        <h4 class="modal-title" id="del-one-olt-label" data-translate="backupList.title">Restaurar Backup do Sistema</h4>\n    </div>\n    <form ng-submit="vmBackupList.restore()" novalidate>\n        <div class="modal-body modal-body-table">\n            <div class="container-scroll" ng-scrollbars>\n                <div class="panel panel-default">\n                    <table class="table table-hover">\n                        <thead>\n                            <tr>\n                                <th colspan="2">\n                                    <span data-translate="backupList.files">Arquivos da pasta</span> {{vmBackupList.backupList.path}}\n                                </th>\n                            </tr>\n                        </thead>\n                        <tbody>\n                            <tr ng-if="!vmBackupList.backupList.files.length">\n                                <td colspan="4" class="list-empty" data-translate="backupList.emptyList">N\xE3o foram encontrados resultados.</td>\n                            </tr>\n                            <tr ng-repeat="file in vmBackupList.backupList.files" ng-class="{active: vmBackupList.selectedFile.index == file.index}"\n                                ng-click="vmBackupList.selectedFile = file">\n                                <td class="col-select">\n                                    <label class="radio" ng-class="{checked: vmBackupList.selectedFile.index == file.index}">\n                                        <input type="radio" name="restore" ng-model="vmBackupList.selectedFile" ng-value="file">\n                                    </label>\n                                </td>\n                                <td>{{file.name}}</td>\n                            </tr>\n                        </tbody>\n                    </table>\n                </div>\n            </div>\n        </div>\n\n        <div class="modal-footer">\n            <button type="button" class="btn btn-default" ng-click="vmBackupList.close()" data-translate="global.button.cancel">Cancelar</button>\n            <button type="submit" class="btn btn-primary btn-main-action" ng-disabled="!vmBackupList.selectedFile" data-translate="backupList.restore">Restaurar</button>\n        </div>\n    </form>\n</div>');
$templateCache.put('app/components/backup-db/backup.html','<div class="panel panel-default">\n  <div class="panel-heading">\n    <div class="container-title">\n      <span\n        class="modal-title"\n        data-translate="systemConfig.backupConfig.title"\n        title="{{ \'systemConfig.backupConfig.titleAlt\' | translate}}"\n        >Configura\xE7\xE3o do Sistema</span\n      >\n    </div>\n  </div>\n  <div class="panel-body">\n    <div class="form-horizontal">\n      <div class="form-group">\n        <label class="col-xs-24 control-label" for="backup-path">\n          <span data-translate="systemConfig.backupConfig.backupPath">Caminho do Backup</span>:\n        </label>\n        <div class="col-xs-24">\n          <input\n            type="text"\n            class="form-control backup-path-field"\n            id="backup-path"\n            name="backupPath"\n            ng-required="vmSystemConfig.config.backup.periodic"\n            placeholder="{{\'systemConfig.backupConfig.placeholder.backupPath\'| translate}}"\n            ng-model="vmSystemConfig.config.backup.path"\n            ng-change="vmSystemConfig.setTooltip()"\n            uib-tooltip="{{\'tooltip.backupPath\'| translate}}"\n            tooltip-trigger="focus"\n            tooltip-placement="left"\n          />\n        </div>\n      </div>\n    </div>\n\n    <div class="form-horizontal">\n      <div class="form-group">\n        <label class="col-xs-12 control-label"\n          ><span data-translate="systemConfig.backupConfig.periodic">Backup peri\xF3dico</span>:</label\n        >\n        <div class="col-xs-12">\n          <switch name="bridge-stp" ng-model="vmSystemConfig.config.backup.periodic"></switch>\n        </div>\n      </div>\n    </div>\n\n    <div class="form-group">\n      <label class="control-label"\n        ><span data-translate="systemConfig.backupConfig.periodicity">Periodicidade</span>:</label\n      >\n\n      <div>\n        <label for="backup-period" class="label-backup" data-translate="systemConfig.backupConfig.each">A cada</label>\n\n        <ui-select\n          class="backup-time-field backup-day-field"\n          name="backupHour"\n          search-enabled="false"\n          on-select="vmSystemConfig.setPeriodDay($select)"\n          ng-model="vmSystemConfig.config.backup.day"\n          ng-disabled="!vmSystemConfig.config.backup.periodic"\n        >\n          <ui-select-match placeholder="-- {{\'systemConfig.backupConfig.days\'| translate}}">\n            {{vmSystemConfig.config.backup.day.label}}\n          </ui-select-match>\n          <ui-select-choices repeat="day in vmSystemConfig.dateTime.days">{{day.label}}</ui-select-choices>\n        </ui-select>\n\n        <label class="label-backup" ng-if="vmSystemConfig.config.backup.day">\n          <span data-translate="systemConfig.backupConfig.at">\xE0s</span>\n        </label>\n\n        <ui-select\n          class="backup-time-field backup-hour-field"\n          name="backupHour"\n          search-enabled="false"\n          on-select="vmSystemConfig.setPeriodHour($select)"\n          ng-model="vmSystemConfig.config.backup.hour"\n          ng-required="vmSystemConfig.config.backup.periodic"\n          ng-disabled="!vmSystemConfig.config.backup.periodic"\n        >\n          <ui-select-match placeholder="--h">{{vmSystemConfig.config.backup.hour.label}}</ui-select-match>\n          <ui-select-choices repeat="hour in vmSystemConfig.dateTime.hours">{{hour.label}}</ui-select-choices>\n        </ui-select>\n\n        <ui-select\n          class="backup-time-field backup-minute-field"\n          name="backupMinutes"\n          search-enabled="false"\n          on-select="vmSystemConfig.setPeriodMinute($select)"\n          ng-model="vmSystemConfig.config.backup.minute"\n          ng-required="vmSystemConfig.config.backup.periodic"\n          ng-disabled="!vmSystemConfig.config.backup.day || !vmSystemConfig.config.backup.periodic"\n        >\n          <ui-select-match placeholder="--min">{{vmSystemConfig.config.backup.minute.label}}</ui-select-match>\n          <ui-select-choices repeat="min in vmSystemConfig.dateTime.minutes">{{min.label}}</ui-select-choices>\n        </ui-select>\n      </div>\n    </div>\n\n    <div class="box-btns">\n      <button\n        type="button"\n        class="btn btn-primary btn-ok cal-50"\n        data-translate="systemConfig.backupConfig.backupNow"\n        ng-class="{ disabled: !vmSystemConfig.allowBackup() }"\n        ng-click="vmSystemConfig.doBackup()"\n        uib-tooltip="{{\'tooltip.\' + vmSystemConfig.tooltip| translate}}"\n        tooltip-placement="bottom"\n        tooltip-enable="!vmSystemConfig.allowBackup()"\n        has-authority="systemBackup"\n        has-behavior="disable-button"\n      >\n        Fazer backup agora\n      </button>\n      <button\n        type="button"\n        class="btn btn-primary btn-ok cal-50"\n        data-translate="systemConfig.backupConfig.restoreBackup"\n        ng-class="{ disabled: !vmSystemConfig.allowBackup() }"\n        ng-click="vmSystemConfig.restoreBackup()"\n        uib-tooltip="{{\'tooltip.\' + vmSystemConfig.tooltip| translate}}"\n        tooltip-placement="bottom"\n        tooltip-enable="!vmSystemConfig.allowBackup()"\n        has-authority="systemBackupRestore"\n        has-behavior="disable-button"\n      >\n        Restaurar backup\n      </button>\n      <button\n        type="button"\n        class="btn btn-primary btn-ok cal-100"\n        data-translate="systemConfig.backupConfig.restoreAppIni"\n        ng-click="vmSystemConfig.restoreAppConfigInitial()"\n        tooltip-placement="bottom"\n        tooltip-enable="!vmSystemConfig.allowBackup()"\n        has-authority="systemBackupRestore"\n        has-behavior="disable-button"\n      >\n        Restaurar Configura\xE7\xE3o Inicial\n      </button>\n    </div>\n  </div>\n</div>\n');
$templateCache.put('app/components/bridge/bridge-add.html','<div class="modal-header">\n    <button type="button" class="close" ng-click="vmBridgeAdd.close()"><span aria-hidden="true">&times;</span></button>\n    <h4 class="modal-title" data-translate="bridgeModal.{{vmBridgeAdd.modalTitle}}Bridge">Adicionar Bridge</h4>\n</div>\n\n<form class="form-horizontal form-modal" name="vmBridgeAdd.formAddBridge" novalidate>\n    <div class="modal-body">\n        <div class="row">\n            <div class="modal-col col-xs-{{{\'OLT\': \'12\', \'ONU\': \'8\'}[vmBridgeAdd.bridge.interface.value]}}">\n                <div ng-include="vmBridgeAdd.partial(\'name\')"></div>\n                <div ng-include="vmBridgeAdd.partial(\'interface\')" ng-if="vmBridgeAdd.isAdvanced && !vmBridgeAdd.isEdit && !vmBridgeAdd.fromSimple"></div>\n                <div ng-include="vmBridgeAdd.partial(\'simple-interface\')" ng-if="vmBridgeAdd.isEdit || vmBridgeAdd.fromSimple"></div> \n                <div ng-include="vmBridgeAdd.partial(\'interface-olt\')"></div>\n            </div>\n\n            <div class="modal-col col-xs-{{{\'OLT\': \'12\', \'ONU\': \'8\'}[vmBridgeAdd.bridge.interface.value]}}">\n                <div ng-include="vmBridgeAdd.partial(\'service\')"></div>\n                <div ng-include="vmBridgeAdd.partial(\'video\')"></div>\n                <div ng-include="vmBridgeAdd.partial(\'rules\')"></div>\n                <div ng-include="vmBridgeAdd.partial(\'additional\')"></div>\n                <div ng-include="vmBridgeAdd.partial(\'stp\')" ng-if="vmBridgeAdd.bridge.interface.value == \'OLT\'"></div>\n            </div>\n            <div class="modal-col col-xs-8" ng-include="vmBridgeAdd.partial(\'interface-onu\')" ng-if="!vmBridgeAdd.bridge.onuInterface.hidden"></div>\n            <div class="modal-col col-xs-8" ng-include="vmBridgeAdd.partial(\'sip\')" ng-if="vmBridgeAdd.bridge.service == \'voice\'"></div>\n        </div>\n\n        <div align="center" ng-if="vmBridgeAdd.showAlertVisible">\n            <h2 style="color:#FF0000">Alertas</h2>\n            <div class="alert alert-info">\n                <strong style="color:#FF0000">Info!</strong><label style="color:#FF0000">{{vmBridgeAdd.showAlertMessage}}</label>\n            </div>\n        </div>\n\n    </div>\n\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default btn-cancel btn-modal-lg" ng-click="vmBridgeAdd.close()" ng-disabled="vmBridgeAdd.requestRunning"\n                data-translate="global.button.cancel">Cancelar</button>\n        <button type="submit" class="btn btn-primary btn-add btn-modal-lg" ng-click="vmBridgeAdd.save()" ng-disabled="vmBridgeAdd.requestRunning"\n                data-translate="global.button.{{vmBridgeAdd.buttonLabel}}">Adicionar</button>\n        <button type="submit" class="btn btn-primary btn-add btn-modal-lg" ng-click="vmBridgeAdd.save(vmBridgeAdd.isWifi())" ng-disabled="vmBridgeAdd.requestRunning"\n                ng-if="vmBridgeAdd.isWifi()" data-translate="bridgeModal.{{vmBridgeAdd.buttonLabel}}AndConfigWifi" hidden>Adicionar e Configurar ONU</button>\n    </div>\n</form>\n\n');
$templateCache.put('app/components/bridge/bridge-confirm.html','<div class="modal-header">\n    <button type="button" class="close close-delete" ng-click="vmBridgeConfirm.close()"><span aria-hidden="true">&times;</span></button>\n    <h4 class="modal-title" id="del-one-bridge-label" data-translate="bridgesConfirm.{{vmBridgeConfirm.action}}.title">Confirma\xE7\xE3o Bridge</h4>\n</div>\n<div class="modal-body modal-content-confirm">\n    <p data-translate="bridgesConfirm.{{vmBridgeConfirm.action}}.message.question" data-translate-values="{name: vmBridgeConfirm.name}">Voc\xEA deseja realmente {{action}} a Bridge xxxx ?</p>\n</div>\n<div class="modal-footer modal-footer-confirm">\n    <button type="button" class="btn btn-default btn-cancel" ng-click="vmBridgeConfirm.close()" ng-disabled="vmBridgeConfirm.requestRunning" data-translate="global.button.cancel">Cancelar</button>\n    <button type="submit" class="btn btn-primary btn-del" ng-click="vmBridgeConfirm.confirmAction()" ng-disabled="vmBridgeConfirm.requestRunning" data-translate="bridgesConfirm.{{vmBridgeConfirm.action}}.btnConfirm">Action</button>\n</div>');
$templateCache.put('app/components/bridge/bridge-list.html','<div class="panel panel-default panel-list panel-bridge" style="margin-bottom: 50px"\n     has-authority="bridgeList" has-behavior="hide">\n\n    <div class="panel-heading onu-header">\n        <div class="container-title">\n            <span class="panel-title" data-translate="bridge.bridgesConfigured">BRIDGES\n                CONFIGURADAS</span>\n            <div class="pull-right">\n                <div class="btn-circle btn-circle-plus" id="btn-add-bridge"\n                     uib-tooltip-html="vmBridgeList.view.tooltip"\n                     tooltip-placement="bottom" tooltip-append-to-body="true"\n                     ng-click="vmBridgeList.addBridge()" has-authority="bridgeAdd"\n                     has-behavior="disable-button">+</div>\n            </div>\n        </div>\n\n\n        <div class="paginator">\n\n            <div dir-pagination-controls\n                    max-size="6"\n                    direction-links="true"\n                    boundary-links="true"\n                    on-page-change="vmBridgeList.getData(newPageNumber)">\n            </div dir-pagination-controls>\n\n        </div>  \n\n\n        <form class="container-search form-search" style="margin:0"\n              ng-hide="vmBridgeList.isVlanVisible()" novalidate>\n            <div class="row">\n                <div class="col-xs-6">\n                    \n\n                    <div class="input-group col-search-bridge">\n                            <ui-select name="filter-onu" ng-model="vmBridgeList.tipo" search-enabled="false">\n                                    <ui-select-match placeholder="TIPO">{{vmBridgeList.tipo.value}}</ui-select-match>\n                                    <ui-select-choices repeat="item in vmBridgeList.listTipo">{{item.value}}</ui-select-choices>\n                                </ui-select>\n                            </div>\n\n                </div>\n\n                <div class="col-xs-8">\n                        <div class="input-group col-search-bridge">\n                                <input type="text" \n                                       class="form-control disable-error-background"\n                                       placeholder="NOME" \n                                       ng-model="vmBridgeList.nome">\n                            </div>\n\n                </div>\n\n                <div class="col-xs-10">\n                        <div class="input-group col-search-bridge">\n                                <input type="number" min="0" max="4096"\n                                       class="form-control disable-error-background"\n                                       placeholder="{{\'bridge.vlan\'| translate}}" pattern="\\d+"\n                                       ng-model="vmBridgeList.searchVlan"\n                                       ng-model-options="{\n                                                   allowInvalid: false, updateOn: \'blur\'}"\n                                       uib-tooltip="{{\'tooltip.searchByVlan\'| translate}}"\n                                       tooltip-class="tooltip-vlan" tooltip-trigger="focus"\n                                       tooltip-placement="right"> <span class="input-group-btn">\n                                    <button type="submit" class="btn-search-bridge" ng-click="vmBridgeList.getBridgeList()">\n                                        <span class="icon icon-search-bridge"></span>\n                                    </button>\n                                </span>\n                            </div>\n\n                </div>\n            </div>\n        </form>\n    </div>\n\n    <div class="panel-body" loader-section="vmBridgeList.requestRunning">\n        <div class="container-scroll margin-top-list" ng-scrollbars>\n            <ul class="list list-provisioning list-bridge">\n\n                <li class="list-item"\n                    dir-paginate="bridgeItem in vmBridgeList.bridgeList  | itemsPerPage:vmBridgeList.itemsPerPage" total-items="vmBridgeList.totalCount" \n                    ng-class="{opened: !bridgeItem.collapsed}" >\n\n                    <div class="list-item-collapse-bridge" ng-click="vmBridgeList.toggle(bridgeItem.id)">\n                        <div class="list-item-info-bridge">\n                            <div ng-if="bridgeItem.onuId != null" >\n                                <div class="list-item-name-bridge field-bridge-name">{{bridgeItem.name}}</div> \n                                <div class="list-item-name-bridge-down field-bridge-name">ONT/ONU</div>\n                                <span ng-if="bridgeItem.serviceType == \'ROUTER\' && bridgeItem.rgMode == \'RG_ROTEAMENTO\'" class="icon icon-routed"></span>\n                                <span ng-if="bridgeItem.serviceType == \'DATA\' && bridgeItem.rgMode == \'RG_ROTEAMENTO\'" class="icon icon-routed"></span>\n                                <span ng-if="bridgeItem.serviceType == \'VOICE\' && bridgeItem.rgMode == \'RG_ROTEAMENTO\'" class="icon icon-voice"></span>\n                                <span ng-if="bridgeItem.serviceType == \'VOICE\' && bridgeItem.rgMode == null" class="icon icon-voice"></span>\n                                <span ng-if="bridgeItem.serviceType == \'DATA\' && bridgeItem.rgMode == null" class="icon icon-lan-dados"></span>\n                                <span ng-if="bridgeItem.serviceType == \'DATA\' && bridgeItem.rgMode == \'RG_BROUTED\'" class="icon icon-routed"></span>\n                                <span ng-if="bridgeItem.serviceType == \'DATA\' && bridgeItem.rgMode == \'RG_BRIDGED\'" class="icon icon-lan-dados"></span>\n                                <span ng-if="bridgeItem.serviceType == \'DATA\' && bridgeItem.rgMode == \'RG_BPPPOE\'" class="icon icon-pppoe"></span>\n                                <span ng-if="bridgeItem.serviceType == \'VOICE\' && bridgeItem.rgMode == \'RG_BRIDGED\'" class="icon icon-voice"></span>\n                            </div>\n                            <div ng-if="bridgeItem.onuId == null">\n                                <div class="list-item-name-bridge field-bridge-name">{{bridgeItem.name}}</div>\n                                <div class="list-item-name-bridge-down field-bridge-name">OLT</div>\n                                <span ng-if="bridgeItem.serviceType == \'DATA\'" class="icon icon-olt"></span>\n                            </div>\n                            <span class="list-item-action icon icon-arrow-select-list"></span>\n                            <div class="list-item-menu" stop-propagation>\n                                <div class="dropdown-default" uib-dropdown>\n                                    <button class="list-item-menu-btn-bridge" uib-dropdown-toggle>\n                                        <span class="icon icon-menu-more"></span>\n                                    </button>\n                                    <ul class="dropdown-menu dropdown-menu-right" uib-dropdown-menu>\n                                        <li><a\n                                                ng-click="vmBridgeList.configBridge(bridgeItem.id)"\n                                                data-translate="bridge.menu.advancedSettings"\n                                                has-authority="bridgeEdit" has-behavior="disable-link">Configura\xE7\xF5es\n                                                Avan\xE7adas</a></li>\n                                        <li><a ng-click="vmBridgeList.deleteBridge(bridgeItem)"\n                                               data-translate="bridge.menu.delete"\n                                               has-authority="bridgeDelete" has-behavior="disable-link">Deletar</a></li>\n                                    </ul>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class="list-item-detail" uib-collapse="!bridgeItem.opened"\n                         collapsed="bridgeItem.collapsed=true"\n                         expanding="bridgeItem.collapsed=false"\n                         expanded="bridgeItem.collapsed=false">\n                        <div class="list-item-detail-content">\n                            <div class="container-info item-subtitle row">\n                                <div class="col-xs-12">\n                                    <span data-translate="bridge.interface">Interface</span>:\n                                </div>\n                                <div class="col-xs-12 item-value">\n                                    <span ng-if="bridgeItem.onuName && bridgeItem.gponSlot">ONU</span>\n                                    <span ng-if="!bridgeItem.onuName && !bridgeItem.gponSlot">OLT</span>\n                                </div>\n                            </div>\n\n                            <div class="container-info row">\n                                <div class="col-xs-12 item-label">\n                                    <span data-translate="bridge.olt">OLT</span>:\n                                </div>\n                                <span class="col-xs-12 collapse-data item-value">{{bridgeItem.oltName}}</span>\n                            </div>\n\n                            <div class="container-info row">\n                                <div class="col-xs-16 item-label">\n                                    <span data-translate="bridge.port">Porta</span>:\n                                </div>\n                                <span class="col-xs-4 collapse-data item-value">{{vmBridgeList.portType[bridgeItem.portType]}}</span>\n                                <span class="col-xs-4 collapse-data item-value">{{bridgeItem.portNumber}}</span>\n                            </div>\n\n                            <div class="container-info row" ng-if="bridgeItem.onuName">\n                                <div class="col-xs-12 item-label">\n                                    <span data-translate="bridge.onu">ONU</span>:\n                                </div>\n                                <span class="col-xs-12 collapse-data item-value">\n                                    {{bridgeItem.onuName}}</span>\n                            </div>\n\n                            <div class="container-info row" ng-if="bridgeItem.gponSlot">\n                                <div class="col-xs-12 item-label">\n                                    <span data-translate="bridge.gponSlot">Slot GPon</span>:\n                                </div>\n                                <span class="col-xs-12 collapse-data item-value">{{bridgeItem.gponSlot}}</span>\n                            </div>\n\n                            <div class="container-info item-subtitle">\n                                <span data-translate="bridge.oltInterface">Interface OLT</span>:\n                            </div>\n\n                            <div class="container-info row">\n                                <div class="col-xs-12 item-label">\n                                    <span data-translate="bridge.type">Tipo</span>:\n                                </div>\n                                <span class="col-xs-12 collapse-data item-value text-capitalize">\n                                    {{bridgeItem.type}}</span>\n                            </div>\n\n                            <div class="container-info row">\n                                <div class="col-xs-12 item-label">\n                                    <span data-translate="bridge.mode">Modo</span>:\n                                </div>\n                                <span class="col-xs-12 collapse-data item-value text-capitalize">\n                                    {{bridgeItem.vlanMode}}</span>\n                            </div>\n\n                            <div class="container-info row">\n                                <div class="col-xs-12 item-label">\n                                    <span data-translate="bridge.vlan">VLAN</span>/<span\n                                        data-translate="bridge.slan">SLAN</span>:\n                                </div>\n                                <span class="col-xs-12 collapse-data item-value">{{bridgeItem.vlan}}\n                                    / {{bridgeItem.slan}}</span>\n                            </div>\n\n                            <div class="container-info row" ng-if="!bridgeItem.onuId">\n                                <div class="col-xs-12 item-label">\n                                    <span data-translate="bridge.stp">STP</span>:\n                                </div>\n                                <div\n                                    class="col-xs-12 collapse-data item-value checkbox-options text-right">\n                                    <span class="status-item-value"> <span\n                                            class="checkbox-select-item checkbox-status"\n                                            ng-class="{\n                                                    disabled: !bridgeItem.stp, checked: bridgeItem.stp}"></span>\n                                    </span>\n                                </div>\n                            </div>\n\n                            <div class="container-info item-subtitle">\n                                <span data-translate="bridge.bridge">Bridge</span>:\n                            </div>\n\n                            <div class="container-info row">\n                                <div class="col-xs-12 item-label">\n                                    <span data-translate="bridge.status">Status</span>:\n                                </div>\n                                <span class="col-xs-12 collapse-data item-value text-capitalize">\n                                    {{bridgeItem.status}}</span>\n                            </div>\n\n                            <div ng-if="bridgeItem.serviceType === \'VOICE\'">\n                                <div class="container-info item-subtitle">\n                                    <span data-translate="bridgeModal.profileUsed">Profiles utilizados</span>:\n                                </div>\n\n                                <div class="container-info row">\n                                    <div class="col-xs-12 item-label">\n                                        <span data-translate="bridgeModal.mediaProfile">M\xEDdia</span>:\n                                    </div>\n                                    <span\n                                        class="col-xs-12 collapse-data item-value text-capitalize">\n                                        {{bridgeItem.mediaProfile.profileName}}</span>\n                                </div>\n\n                                <div class="container-info row">\n                                    <div class="col-xs-12 item-label">\n                                        <span data-translate="bridgeModal.serve">Server</span>:\n                                    </div>\n                                    <span\n                                        class="col-xs-12 collapse-data item-value text-capitalize">\n                                        {{bridgeItem.serverProfile.profileName}}</span>\n                                </div>\n\n                                <div class="container-info row">\n                                    <div class="col-xs-12 item-label">\n                                        <span data-translate="bridgeModal.ipAddress">IP</span>:\n                                    </div>\n                                    <span\n                                        class="col-xs-12 collapse-data item-value text-capitalize">\n                                        {{bridgeItem.cpeVoipProfile.gateway}}</span>\n                                </div>\n\n\n\n                                <div class="container-info row">\n                                    <div class="col-xs-12 item-label">\n                                        <span data-translate="bridgeModal.ipMode">Modo IP</span>:\n                                    </div>\n                                    <span\n                                        class="col-xs-12 collapse-data item-value text-capitalize">\n                                        {{bridgeItem.featuresProfile.modo}}</span>\n                                </div>\n\n\n                                <div class="container-info item-subtitle">\n                                    <span data-translate="bridgeModal.voiceBridgeSettingsFXS-1">Configura\xE7\xF5es\n                                        de Bridge Voz</span>:\n                                </div>\n\n                                <div class="container-info row">\n                                    <div class="col-xs-12 item-label">\n                                        <span data-translate="bridge.port">Porta</span>:\n                                    </div>\n                                    <span\n                                        class="col-xs-12 collapse-data item-value text-capitalize">\n                                        {{bridgeItem.fxs[0].adminState}}</span>\n                                </div>\n\n                                <div class="container-info row">\n                                    <div class="col-xs-12 item-label">\n                                        <span data-translate="bridgeModal.phoneNumber">N\xFAmero\n                                            do telefone</span>:\n                                    </div>\n                                    <span\n                                        class="col-xs-12 collapse-data item-value text-capitalize">\n                                        {{bridgeItem.fxs[0].dialNumber}}</span>\n                                </div>\n\n                                <div class="container-info row">\n                                    <div class="col-xs-12 item-label">\n                                        <span data-translate="bridgeModal.user">Usu\xE1rio</span>:\n                                    </div>\n                                    <span\n                                        class="col-xs-12 collapse-data item-value text-capitalize">\n                                        {{bridgeItem.fxs[0].username}}</span>\n                                </div>\n\n                                <div class="container-info item-subtitle">\n                                    <span data-translate="bridgeModal.voiceBridgeSettingsFXS-2">Configura\xE7\xF5es\n                                        de Bridge Voz 2</span>:\n                                </div>\n\n                                <div class="container-info row">\n                                    <div class="col-xs-12 item-label">\n                                        <span data-translate="bridge.port">Porta</span>:\n                                    </div>\n                                    <span\n                                        class="col-xs-12 collapse-data item-value text-capitalize">\n                                        {{bridgeItem.fxs[1].adminState}}</span>\n                                </div>\n\n                                <div class="container-info row">\n                                    <div class="col-xs-12 item-label">\n                                        <span data-translate="bridgeModal.phoneNumber">N\xFAmero\n                                            do telefone</span>:\n                                    </div>\n                                    <span\n                                        class="col-xs-12 collapse-data item-value text-capitalize">\n                                        {{bridgeItem.fxs[1].dialNumber}}</span>\n                                </div>\n\n                                <div class="container-info row">\n                                    <div class="col-xs-12 item-label">\n                                        <span data-translate="bridgeModal.user">Usu\xE1rio</span>:\n                                    </div>\n                                    <span\n                                        class="col-xs-12 collapse-data item-value text-capitalize">\n                                        {{bridgeItem.fxs[1].username}}</span>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </li>\n            </ul>\n            <div class="list-empty" data-translate="bridge.emptyList"\n                 ng-if="vmBridgeList.isBridgeListEmpty()">Nenhuma Bridge\n                encontrada.</div>\n            <div class="list-loading" data-translate="bridge.loadingList"\n                 ng-if="vmBridgeList.requestRunning">Aguarde, carregando\n                Bridges ...</div>\n            <div class="list-empty" data-translate="bridge.loadingListError"\n                 ng-if="vmBridgeList.hasErrorList()">Ocorreu um erro ao buscar\n                pelas Bridges. Por favor, atualize a lista.</div>\n        </div>\n    </div>\n\n</div>\n');
$templateCache.put('app/components/bridge/bridge-modal.html','<div modal-render="{{$isRendered}}" tabindex="-1" role="dialog" class="modal"\n     uib-modal-animation-class="fade"\n     modal-in-class="in"\n     ng-style="{\'z-index\': 1050 + index * 10, display: \'block\'}">\n    <div class="modal-dialog {{$parent.vmBridgeAdd.modalSize ? $parent.vmBridgeAdd.modalSize : (size ? \'modal-\' + size : \'\')}}">\n        <div class="modal-content" uib-modal-transclude></div>\n    </div>\n</div>\n');
$templateCache.put('app/components/bridge/bridge-simple-add.html','<div class="modal-header">\n    <button type="button" class="close" ng-click="vmBridgeAdd.close()"><span aria-hidden="true">&times;</span></button>\n    <h4 class="modal-title" data-translate="bridgeModal.addBridge">Adicionar Bridge</h4>\n</div>\n<form class="form-horizontal form-modal" name="vmBridgeAdd.formAddBridge" ng-submit="vmBridgeAdd.save()" novalidate>\n    <div class="modal-body">\n        <div class="row">\n            <div class="modal-col col-xs-12">\n                <div ng-include="vmBridgeAdd.partial(\'name\')"></div>\n                <div ng-include="vmBridgeAdd.partial(\'simple-interface\')"></div>\n                <div ng-include="vmBridgeAdd.partial(\'interface-olt\')"></div>\n            </div>\n\n            <div class="modal-col col-xs-12">\n                <div ng-include="vmBridgeAdd.partial(\'service\')"></div>\n                <div ng-include="vmBridgeAdd.partial(\'video\')"></div>\n                <div ng-include="vmBridgeAdd.partial(\'additional\')"></div>\n                <div ng-include="vmBridgeAdd.partial(\'interface-onu\')"></div>\n            </div>\n        </div>\n    </div>\n    <div class="modal-footer modal-footer-bridge">\n        <button type="button" class="btn btn-default btn-cancel btn-modal-lg" ng-click="vmBridgeAdd.close()" ng-disabled="vmBridgeAdd.requestRunning" data-translate="global.button.cancel">Cancelar</button>\n        <button type="button" class="btn btn-default btn-modal-lg" ng-click="vmBridgeAdd.advancedSettings()" ng-disabled="vmBridgeAdd.requestRunning" data-translate="bridgeModal.advancedSettings">Configura\xE7\xF5es avan\xE7adas</button>\n        <button type="submit" class="btn btn-primary btn-add btn-modal-lg" ng-disabled="vmBridgeAdd.requestRunning" data-translate="global.button.add">Adicionar</button>\n    </div>\n</form>');
$templateCache.put('app/components/config/config-access-control.html','<div class="panel panel-default">\n    <div class="panel-heading">\n        <div class="container-title">\n            <span class="modal-title" data-translate="systemConfig.accessControl.title">Servidor TFTP</span>\n        </div>\n    </div>\n    <div class="panel-body form-horizontal">\n\n        <div class="form-group">\n            <label class="col-xs-12 control-label" for="field-config-ip"><span data-translate="systemConfig.accessControl.ipServer">IP do Servidor</span>: </label>\n            <div class="col-xs-12">\n                <input type="text" class="form-control" id="field-config-ip" name="ipServer" ng-model="vmSystemConfig.config.ipTftp"\n                       maxlength="15" pattern="^((25[0-4]|2[0-4][0-9]|[01]?[0-9][0-9]?){1}(\\.)){3}(25[0-4]|2[0-4][0-9]|[01]?[0-9][0-9]?){1}$"\n                       placeholder="XXX.XXX.XXX.XXX"\n                       uib-tooltip="{{\'tooltip.ip.invalid\'| translate}}"\n                       tooltip-trigger="focus"\n                       tooltip-enable="vmSystemConfig.config.ipTftp.$invalid"\n                       tooltip-is-open="vmSystemConfig.config.ipTftp.$invalid && !vmSystemConfig.config.ipTftp.$error.required"\n                       tooltip-placement="right"\n                       ng-required="!vmSystemConfig.config.fromSIG">\n            </div>\n        </div>\n        \n        <div class="form-group">\n            <label class="col-xs-12 control-label" for="field-config-fromSIG"><span data-translate="systemConfig.accessControl.fromSIG">Usar do SIG</span>: </label>\n            <div class="col-xs-12">\n                <switch id="field-config-fromSIG" name="fromSIG" ng-model="vmSystemConfig.config.fromSIG" class="green"></switch>\n            </div>\n        </div>\n\n    </div>\n\n    <div class="panel-heading">\n        <div class="container-title">\n            <span class="modal-title" data-translate="systemConfig.accessControl.alarmSetting">Configura\xE7\xE3o dos Alarmes</span>\n        </div>\n    </div>\n    <div class="panel-body form-horizontal">\n\n        <div class="form-group">\n            <label class="col-xs-12 control-label" for="field-config-sincronizar"><span data-translate="systemConfig.accessControl.syncAlarms">Sincronizar Alarmes</span>: </label>\n            <div class="col-xs-12">\n                <switch id="field-config-sincronizar" name="sincronizar" ng-model="vmSystemConfig.config.sincronizarAlarme" class="green"></switch>\n            </div>\n        </div>\n\n    </div>\n\n</div>\n');
$templateCache.put('app/components/config/config-smtp.html','<div class="panel panel-default" ng-controller="TermosAceiteController as termosVm">\n  <div ng-include="\'app/components/termos-aceite/termos-aceite.html\'"></div>\n  <div class="panel-heading">\n    <div class="container-title">\n      <span class="modal-title">Termos de Aceite</span>\n    </div>\n  </div>\n  <div class="panel-body form-horizontal">\n    <button type="button" class="btn btn-primary btn-ok" ng-click="termosVm.abreModal()">Visualizar Contrato</button>\n  </div>\n  <div class="panel-heading">\n    <div class="container-title">\n      <span class="modal-title" data-translate="systemConfig.smtpConfig.title">SMTP</span>\n    </div>\n  </div>\n  <div class="panel-body form-horizontal">\n    <div class="form-group">\n      <label class="col-xs-12 control-label" for="field-config-smtp"\n        ><span data-translate="systemConfig.smtpConfig.smtp">SMTP</span>: *</label\n      >\n      <div class="col-xs-12">\n        <input\n          type="text"\n          class="form-control"\n          id="field-config-smtp"\n          name="mailServerSmtp"\n          placeholder="smtp.example.com"\n          required\n          ng-model="vmSystemConfig.config.smtp.server"\n          uib-tooltip="{{\'tooltip.mailServerSmtp\'| translate}}"\n          tooltip-trigger="focus"\n          tooltip-placement="right"\n          tooltip-enable="vmSystemConfig.formConfig.mailServerSmtp.$invalid"\n        />\n      </div>\n    </div>\n\n    <div class="form-group">\n      <label class="col-xs-12 control-label" for="field-config-port"\n        ><span data-translate="systemConfig.smtpConfig.port">Porta</span>: *</label\n      >\n      <div class="col-xs-12">\n        <input\n          type="number"\n          class="form-control"\n          id="field-config-port"\n          name="mailServerPort"\n          step="1"\n          min="1"\n          max="99999"\n          placeholder="XXXXX"\n          pattern="\\d+"\n          required\n          ng-model="vmSystemConfig.config.smtp.port"\n          uib-tooltip="{{\'tooltip.mailServerPort\'| translate}}"\n          tooltip-trigger="focus"\n          tooltip-placement="right"\n          tooltip-enable="vmSystemConfig.formConfig.mailServerPort.$invalid"\n        />\n      </div>\n    </div>\n\n    <div class="form-group">\n      <label class="col-xs-12 control-label" for="field-config-tls"\n        ><span data-translate="systemConfig.smtpConfig.tls">TLS</span>: *</label\n      >\n      <div class="col-xs-12">\n        <switch id="enabled" name="enabled" ng-model="vmSystemConfig.config.smtp.tls" class="green"></switch>\n      </div>\n    </div>\n\n    <div class="form-group">\n      <label class="col-xs-12 control-label" for="field-config-email"\n        ><span data-translate="systemConfig.smtpConfig.email">E-mail</span>: *</label\n      >\n      <div class="col-xs-12">\n        <input\n          type="text"\n          class="form-control"\n          id="field-config-email"\n          name="mailServerEmail"\n          placeholder="e-mail"\n          required\n          pattern="^[\\w-]+([\\w\\.\\-]+)?@[\\w-]+(\\.\\w+){1,}$"\n          ng-model="vmSystemConfig.config.smtp.email"\n          uib-tooltip="{{\'tooltip.mailServerEmail\'| translate}}"\n          tooltip-trigger="focus"\n          tooltip-placement="right"\n          tooltip-enable="vmSystemConfig.formConfig.mailServerEmail.$invalid"\n        />\n      </div>\n    </div>\n\n    <div class="form-group">\n      <label class="col-xs-12 control-label" for="field-config-password"\n        ><span data-translate="systemConfig.smtpConfig.password">Senha</span>: *</label\n      >\n      <div class="col-xs-12">\n        <input\n          type="password"\n          class="form-control"\n          id="field-config-password"\n          name="mailServerPassword"\n          placeholder="password"\n          required\n          autocomplete="new-password"\n          ng-model="vmSystemConfig.config.smtp.password"\n          uib-tooltip="{{\'tooltip.mailServerPassword\'| translate}}"\n          tooltip-trigger="focus"\n          tooltip-placement="right"\n          tooltip-enable="vmSystemConfig.formConfig.mailServerPassword.$invalid"\n        />\n      </div>\n    </div>\n  </div>\n</div>\n');
$templateCache.put('app/components/config/config.html','<div class="config-content" has-authority="systemConfiguration">\n  <form class="form-modal" name="vmSystemConfig.formConfig" ng-submit="vmSystemConfig.save()" novalidate>\n    <div class="col-container container-config">\n      <div class="col-list">\n        <div ui-view="smtp" class="container-list"></div>\n      </div>\n      <div class="col-list">\n        <div ui-view="access-control" class="container-list"></div>\n      </div>\n      <div class="col-list">\n        <div ui-view="backup" class="container-list"></div>\n      </div>\n    </div>\n    <div class="button-container modal-footer col-list">\n      <button\n        type="button"\n        class="btn btn-default btn-cancel"\n        ng-disabled="vmSystemConfig.requestRunning"\n        ng-click="vmSystemConfig.cancel()"\n        data-translate="global.button.cancel"\n      >\n        Cancelar\n      </button>\n      <button\n        type="submit"\n        class="btn btn-primary btn-ok"\n        ng-disabled="vmSystemConfig.requestRunning"\n        data-translate="global.button.save"\n      >\n        Salvar\n      </button>\n    </div>\n  </form>\n</div>\n<div has-authority="userList">\n  <div ui-view="user-list" class="user-list-container"></div>\n</div>\n<div has-authority="!userList" class="container-change-password">\n  <div ui-view="user-password" class="panel"></div>\n</div>\n');
$templateCache.put('app/components/favorites/favorites-delete.html','<div class="modal-header">\n    <button type="button" class="close close-delete" ng-click="vmFavoriteDelete.close()">&times;</button>\n    <h4 class="modal-title" data-translate="favorites.delete">Deletar Favorito</h4>\n</div>\n<div class="modal-body content-delete">\n    <p data-translate="favorites.questionDelete" data-translate-values="vmFavoriteDelete.favorite">Deseja realmente excluir o favorito xxxx?</p>\n</div>\n<div class="modal-footer modal-footer-delete">\n    <button type="button" class="btn btn-default btn-cancel"\n            ng-click="vmFavoriteDelete.close()"\n            ng-disabled="vmFavoriteDelete.requestRunning"\n            data-translate="global.button.cancel">\n        Cancelar\n    </button>\n    <button type="submit" class="btn btn-primary btn-del"\n            ng-click="vmFavoriteDelete.delete()"\n            ng-disabled="vmFavoriteDelete.requestRunning"\n            data-translate="global.button.delete">\n        Deletar\n    </button>\n</div>');
$templateCache.put('app/components/favorites/favorites-list.html','<div class="modal-header">\n    <button type="button" class="close" ng-click="vmFavoritesList.close()"><span aria-hidden="true">&times;</span></button>\n    <h4 class="modal-title" data-translate="favorites.favoritesList">Lista de Favoritos</h4>\n</div>\n<form ng-submit="vmFavoritesList.save()" novalidate>\n    <div class="modal-body favorite-body">\n        <div class="container-scroll" ng-scrollbars>\n            <div class="panel panel-default">\n                <table class="table table-hover">\n                    <tbody>\n                        <tr ng-repeat="item in vmFavoritesList.favoriteList" ng-class="{active: item.userFavorite}" ng-click="item.userFavorite = !item.userFavorite">\n                            <td>\n                                <label class="checkbox-select-item checkbox-select-favorites" ng-class="{checked: item.userFavorite}">\n                                    <input type="checkbox" name="favorite" ng-model="item.userFavorite">\n                                </label>\n                            </td>\n                            <td data-translate="favorites.{{item.action}}">Favorite name</td>\n                        </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n    <div class="modal-footer favorite-footer">\n        <button type="button" class="btn btn-default"\n                ng-disabled="vmFavoritesList.requestRunning"\n                ng-click="vmFavoritesList.close()"\n                data-translate="global.button.cancel">\n            Cancelar\n        </button>\n        <button type="submit" class="btn btn-primary btn-main-action"\n                ng-disabled="vmFavoritesList.requestRunning"\n                data-translate="global.button.update">\n            Atualizar\n        </button>\n    </div>\n</form>');
$templateCache.put('app/components/favorites/favorites.html','<div class="panel panel-default container-favorite">\n    <div class="panel-heading">\n        <span class="panel-title" data-translate="favorites.title">Favoritos</span>\n        <div class="pull-right">\n            <div class="btn-circle btn-circle-plus"\n                 uib-tooltip-html="vmFavorites.view.tooltip"\n                 tooltip-placement="bottom"\n                 tooltip-append-to-body="true"\n                 ng-click="vmFavorites.addFavorite()">\n                +\n            </div>\n        </div>\n    </div>\n    <div class="panel-body" loader-section="vmFavorites.requestRunning">\n        <div class="container-scroll scroll-inside" ng-scrollbars>\n            <ul class="list-group">\n                <li class="list-group-item" ng-repeat="favoriteItem in vmFavorites.favoriteUserList">\n                    <a class="link-action" ng-click="vmFavorites.openFavorite(favoriteItem.action)" data-translate="favorites.{{favoriteItem.action}}">Nome do Item Favorito</a>\n                    <div class="pull-right">\n                        <a class="btn-remove" ng-click="vmFavorites.removeFavoriteItem(favoriteItem)"></a>\n                    </div>\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/components/console-web/console-web.html','<div class="modal-header">\n    <span class="modal-title">{{vmConsoleWeb.data.detail.name}}</span>\n    <span class="btn btn-default btn-cancel" ng-click="vmConsoleWeb.disconnect()" data-translate="global.button.cancel">Cancelar</span>\n</div>\n<div class="modal-body" loader-section="vmConsoleWeb.requestRunning" loader-theme="dark">\n    <pre auto-scroll="vmConsoleWeb.autoScroll" ng-mouseup="vmConsoleWeb.verifyMouseEvent($event)">{{vmConsoleWeb.content}}</pre>\n    <div class="container-console">\n        <label class="control-label">{{vmConsoleWeb.prompt|| \'>\'}}</label>\n        <input type="text" class="input-console"\n               ng-keyup="vmConsoleWeb.sendCommand($event)"\n               ng-model="vmConsoleWeb.input"\n               ng-disabled="vmConsoleWeb.requestRunning"\n               auto-focus="vmConsoleWeb.autoFocus">\n    </div>\n</div>');
$templateCache.put('app/components/gtp/gtp-add.html','<div class="modal-header">\n    <button type="button" class="close" ng-click="vmGtpAdd.close()"><span aria-hidden="true">&times;</span></button>\n    <h4 class="modal-title" id="add-gtp-label" data-translate="gtp.modal.{{vmGtpAdd.modalTitle}}">Criar Gpon Traffic Profile</h4>\n</div>\n<form class="form-horizontal form-modal modal-gtp" name="vmGtpAdd.formGtpAdd" ng-submit="vmGtpAdd.save()" novalidate valid-multiple>\n    <div class="modal-body">\n        <div class="form-group">\n            <div class="col-xs-24">\n                <input type="text" class="form-control field-name" id="gtp-name" name="gtpName" ng-model="vmGtpAdd.gtpModel.name"\n                       maxlength="20" placeholder="{{\'gtp.modal.placeholder.name\'| translate}}" required\n                       uib-tooltip="{{\'tooltip.gtpName\'| translate}}"\n                       tooltip-trigger="focus" tooltip-placement="right" tooltip-enable="vmGtpAdd.formGtpAdd.gtpName.$invalid"\n                       tooltip-is-open="vmGtpAdd.formGtpAdd.gtpName.$invalid && !vmGtpAdd.formGtpAdd.gtpName.$error.required">\n            </div>\n        </div>\n\n        <div class="form-group">\n            <label class="col-xs-7 control-label" for="field-olt"><span data-translate="gtp.olt">OLT</span>: *</label>\n            <div class="col-xs-17">\n                <ui-select name="bridge-onu" ng-model="vmGtpAdd.gtpModel.olt" on-select="vmGtpAdd.changeOlt($item)" search-enabled="false"\n                           ng-if="!vmGtpAdd.isEdit" required>\n                    <ui-select-match>{{vmGtpAdd.gtpModel.olt.name}}</ui-select-match>\n                    <ui-select-choices repeat="olt in vmGtpAdd.arrayOlts">{{olt.name}}</ui-select-choices>\n                </ui-select>\n                <input type="text" class="form-control" ng-model="vmGtpAdd.gtpModel.olt.name" ng-if="vmGtpAdd.isEdit" readonly>\n            </div>\n        </div>\n\n        <div class="form-group">\n            <label class="col-xs-14 control-label" for="gtp-id"><span data-translate="gtp.gtpId">ID do GTP</span>: *</label>\n            <div class="col-xs-10">\n                <input type="number" class="form-control" id="gtp-id" name="gtpId" min="1" ng-max="vmGtpAdd.gtpModel.gtpId.max"\n                       ng-model="vmGtpAdd.gtpModel.gtpId.value" required pattern="\\d+"\n                       ng-disabled="!vmGtpAdd.gtpModel.olt || vmGtpAdd.isEdit"\n                       placeholder="{{\'gtp.modal.placeholder.gtpId\'| translate}}"\n                       uib-tooltip="{{vmGtpAdd.gtpModel.gtpId.tooltip}}"\n                       tooltip-trigger="focus" tooltip-placement="right" tooltip-enable="vmGtpAdd.formGtpAdd.gtpId.$invalid"\n                       tooltip-is-open="vmGtpAdd.formGtpAdd.gtpId.$invalid && !vmGtpAdd.formGtpAdd.gtpId.$error.required">\n            </div>\n        </div>\n\n        <div class="form-group">\n            <label class="col-xs-14 control-label" for="guaranteedUpstreamBw"><span data-translate="gtp.guaranteedUpstream">Banda garantida</span>: *</label>\n            <div class="col-xs-10">\n                <input type="number" class="form-control" id="guaranteedUpstreamBw" name="guaranteedUpstreamBw"\n                       min="0" max="{{vmGtpAdd.gtpModel.guaranteedUpstreamBw.max}}" step="{{vmGtpAdd.gtpModel.guaranteedUpstreamBw.multiple}}"\n                       pattern="\\d+" ng-model="vmGtpAdd.gtpModel.guaranteedUpstreamBw.value"\n                       ng-disabled="!vmGtpAdd.gtpModel.olt || vmGtpAdd.oltModelIsIntelbras"\n                       ng-required="!vmGtpAdd.oltModelIsIntelbras"\n                       ng-focus="vmGtpAdd.gtpModel.guaranteedUpstreamBw.focus = true"\n                       ng-blur="vmGtpAdd.gtpModel.guaranteedUpstreamBw.focus = false"\n                       invalid-if="!vmGtpAdd.oltModelIsIntelbras && !vmGtpAdd.validateRange(\'guaranteedUpstreamBw\')"\n                       placeholder="{{\'gtp.modal.placeholder.dbaInput\'| translate}}"\n                       uib-tooltip="{{vmGtpAdd.gtpModel.guaranteedUpstreamBw.tooltip}}"\n                       tooltip-trigger="focus" tooltip-placement="right"\n                       tooltip-is-open="vmGtpAdd.gtpModel.guaranteedUpstreamBw.focus\n                       && vmGtpAdd.formGtpAdd.guaranteedUpstreamBw.$invalid\n                       && !vmGtpAdd.formGtpAdd.guaranteedUpstreamBw.$error.required">\n            </div>\n        </div>\n\n        <div class="form-group">\n            <label class="col-xs-14 control-label" for="field-traffic-class"><span data-translate="gtp.trafficClass">Traffic class</span>: *</label>\n            <div class="col-xs-10">\n                <ui-select name="bridge-onu" ng-model="vmGtpAdd.gtpModel.trafficClass" search-enabled="false"\n                           ng-disabled="!vmGtpAdd.gtpModel.olt || vmGtpAdd.oltModelIsIntelbras">\n                    <ui-select-match>{{vmGtpAdd.gtpModel.trafficClass}}</ui-select-match>\n                    <ui-select-choices repeat="trafficClass in [\'UBR\', \'CBR\']">{{trafficClass}}</ui-select-choices>\n                </ui-select>\n            </div>\n        </div>\n\n        <div class="form-group" ng-repeat="inputName in vmGtpAdd.arrayInputsSwitch">\n            <label class="col-xs-12 control-label" for="field-{{inputName}}">\n                <span data-translate="gtp.{{inputName}}" ng-click="!vmGtpAdd.oltModelIsIntelbras && vmGtpAdd.toggleSwitch(inputName)">Nome do campo</span>: *\n            </label>\n            <div class="col-xs-12 control-switch">\n                <switch id="field-{{inputName}}" name="inputName" ng-model="vmGtpAdd.gtpModel[inputName]" ng-change="vmGtpAdd.changeSwitch(inputName)"\n                        disabled="!vmGtpAdd.gtpModel.olt || vmGtpAdd.oltModelIsIntelbras"></switch>\n            </div>\n        </div>\n\n        <div class="form-group" ng-repeat="inputName in vmGtpAdd.arrayInputs">\n            <label class="col-xs-14 control-label" for="inputName"><span data-translate="gtp.{{inputName}}">Nome do campo</span>: *</label>\n            <div class="col-xs-10">\n                <input type="number" class="form-control" id="inputName" name="inputName" required\n                       min="0" max="{{vmGtpAdd.gtpModel[inputName].max}}" step="{{vmGtpAdd.gtpModel[inputName].multiple}}"\n                       pattern="\\d+" ng-model="vmGtpAdd.gtpModel[inputName].value"\n                       ng-disabled="!vmGtpAdd.gtpModel.olt"\n                       invalid-if="!vmGtpAdd.validateRange(inputName)"\n                       placeholder="{{\'gtp.modal.placeholder.dbaInput\'| translate}}"\n                       uib-tooltip="{{vmGtpAdd.gtpModel[inputName].tooltip}}" tooltip-trigger="focus" tooltip-placement="right">\n            </div>\n        </div>\n\n        <div class="form-group container-info">\n            <label class="col-xs-24 control-label" for="dbaExtraUsBwType"><span data-translate="gtp.dbaExtraUsBwType">Tipo de banda extra</span>:</label>\n            <div class="col-xs-24 radio-options text-left">\n                <span class="status-item">\n                    <span class="status-item-value">\n                        <label class="radio" ng-class="{disabled: !vmGtpAdd.gtpModel.olt.model, checked: vmGtpAdd.gtpModel.dbaExtraUsBwType == \'BESTEFFORT\'}">\n                            <input id="dbaExtraUsBwType-1" type="radio" ng-model="vmGtpAdd.gtpModel.dbaExtraUsBwType" ng-value="\'BESTEFFORT\'"\n                                   ng-disabled="!vmGtpAdd.gtpModel.olt.model">\n                        </label>\n                    </span>\n                    <label class="status-item-label item-label" data-translate="gtp.bestEffort" for="dbaExtraUsBwType-1"\n                           ng-class="{\'text-disabled\': !vmGtpAdd.gtpModel.olt.model}">assegurado</label>\n                </span>\n\n                <span class="status-item">\n                    <span class="status-item-value">\n                        <label class="radio" ng-class="{disabled: !vmGtpAdd.gtpModel.olt.model , checked: vmGtpAdd.gtpModel.dbaExtraUsBwType == \'NONASSURED\'}">\n                            <input id="dbaExtraUsBwType-2" type="radio" ng-model="vmGtpAdd.gtpModel.dbaExtraUsBwType" ng-value="\'NONASSURED\'"\n                                   ng-disabled="!vmGtpAdd.gtpModel.olt.model">\n                        </label>\n                    </span>\n                    <label class="status-item-label item-label" data-translate="gtp.nonAssured" for="dbaExtraUsBwType-2"\n                           ng-class="{\'text-disabled\': !vmGtpAdd.gtpModel.olt.model}">n\xE3o assegurado</label>\n                </span>\n            </div>\n        </div>\n\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default btn-cancel" ng-click="vmGtpAdd.close()" ng-disabled="vmGtpAdd.requestRunning" data-translate="global.button.cancel">Cancelar</button>\n        <button type="submit" class="btn btn-primary btn-add" ng-disabled="vmGtpAdd.requestRunning" data-translate="global.button.{{vmGtpAdd.labelButton}}">Salvar</button>\n    </div>\n</form>');
$templateCache.put('app/components/gtp/gtp-confirm.html','<div class="modal-header">\n    <button type="button" class="close close-delete" ng-click="vmGtpConfirm.close()"><span aria-hidden="true">&times;</span></button>\n    <h4 class="modal-title" id="del-one-olt-label" data-translate="gtpConfirm.{{vmGtpConfirm.action}}.title">Confirma\xE7\xE3o GTP</h4>\n</div>\n<div class="modal-body modal-content-confirm">\n    <p ng-if="vmGtpConfirm.itemOne" data-translate="gtpConfirm.{{vmGtpConfirm.action}}.message.question.questionOne" data-translate-values="vmGtpConfirm.gtpData">Voc\xEA deseja realmente {{action}} o GTP xxxx ?</p>\n</div>\n<div class="modal-footer modal-footer-confirm">\n    <button type="button" class="btn btn-default btn-cancel" ng-click="vmGtpConfirm.close()" ng-disabled="vmGtpConfirm.requestRunning" data-translate="global.button.cancel">Cancelar</button>\n    <button type="submit" class="btn btn-primary btn-del" ng-click="vmGtpConfirm.confirmAction()" ng-disabled="vmGtpConfirm.requestRunning" data-translate="gtpConfirm.{{vmGtpConfirm.action}}.btnConfirm">Action</button>\n</div>\n');
$templateCache.put('app/components/gtp/gtp-list.html','<div class="panel panel-default panel-list" has-authority="gtpList" has-behavior="hide">\n\n    <div class="panel-heading">\n        <div class="container-title">\n            <span class="panel-title" data-translate="gtp.title">GPON TRAFFIC PROFILE</span>\n            <div class="pull-right">\n                <div class="btn-circle btn-circle-plus" has-authority="gtpAdd" has-behavior="disable-button"\n                     uib-tooltip-html="vmGtp.view.tooltip"\n                     tooltip-placement="bottom"\n                     tooltip-append-to-body="true"\n                     ng-click="vmGtp.addGtp()">\n                    +\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class="panel-body" loader-section="vmGtp.requestRunning">\n        <div class="container-scroll" ng-scrollbars>\n            <ul class="list list-provisioning list-gtp">\n                <li class="list-item" ng-repeat="gtpItem in vmGtp.gtpList| orderBy:\'id\'" ng-class="{opened: !gtpItem.collapsed}">\n                    <div class="list-item-collapse" ng-click="vmGtp.toggle(gtpItem.id)">\n                      <span class="list-item-action icon icon-arrow-select-list"></span>\n                        <div class="list-item-info">\n                            <div class="list-item-name">{{gtpItem.name}}</div>\n                            <div class="list-item-menu" stop-propagation>\n                                <div class="dropdown-default" uib-dropdown>\n                                    <button class="list-item-menu-btn" uib-dropdown-toggle>\n                                        <span class="icon icon-menu-more"></span>\n                                    </button>\n                                    <ul class="dropdown-menu dropdown-menu-right" uib-dropdown-menu>\n                                        <li><a ng-click="vmGtp.editGtp(gtpItem)" data-translate="gtp.menu.edit" has-authority="gtpEdit" has-behavior="disable-link">Editar</a></li>\n                                        <li><a ng-click="vmGtp.deleteGtp(gtpItem)" data-translate="gtp.menu.delete" has-authority="gtpDelete" has-behavior="disable-link">Deletar</a></li>\n                                    </ul>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class="list-item-detail" uib-collapse="!gtpItem.opened" collapsed="gtpItem.collapsed=true"\n                         expanding="gtpItem.collapsed=false" expanded="gtpItem.collapsed=false">\n                        <div class="list-item-detail-content">\n                            <div class="container-info row">\n                                <div class="col-xs-12 item-label"><span data-translate="gtp.gtpId">GTP ID</span>:</div>\n                                <span class="col-xs-12 item-value">{{gtpItem.gtpId}}</span>\n                            </div>\n\n                            <div class="container-info row">\n                                <div class="col-xs-12 item-label"><span data-translate="gtp.olt">OLT</span>:</div>\n                                <span class="col-xs-12 item-value">{{gtpItem.oltName}}</span>\n                            </div>\n\n                            <div class="container-info row" ng-if="gtpItem.guaranteedUpstreamBw !== null">\n                                <div class="col-xs-14 item-label"><span data-translate="gtp.guaranteedUpstream">Banda garantida</span>:</div>\n                                <span class="col-xs-10 item-value">{{gtpItem.guaranteedUpstreamBw}}</span>\n                            </div>\n\n                            <div class="container-info row" ng-if="gtpItem.trafficClass !== null">\n                                <div class="col-xs-12 item-label"><span data-translate="gtp.trafficClass">Traffic Class</span>:</div>\n                                <span class="col-xs-12 item-value">{{gtpItem.trafficClass}}</span>\n                            </div>\n\n                            <div class="container-info row" ng-if="gtpItem.compensated !== null">\n                                <div class="col-xs-4"><span data-translate="gtp.compensated" class="item-label">Compensated</span>:</div>\n                                <div class="col-xs-20 checkbox-options text-right">\n                                    <span class="status-item-value">\n                                        <span class="checkbox-select-item checkbox-status" ng-class="{disabled: !gtpItem.compensated, checked: gtpItem.compensated}"></span>\n                                    </span>\n                                </div>\n                            </div>\n\n                            <div class="container-info row" ng-if="gtpItem.shared !== null">\n                                <div class="col-xs-4"><span data-translate="gtp.shared" class="item-label">Compartilhado</span>:</div>\n                                <div class="col-xs-20 text-right">\n                                    <span class="status-item-value">\n                                        <span class="checkbox-select-item checkbox-status" ng-class="{disabled: !gtpItem.shared, checked: gtpItem.shared}"></span>\n                                    </span>\n                                </div>\n                            </div>\n\n                            <div class="container-info row" ng-if="gtpItem.dbaEnabled !== null">\n                                <div class="col-xs-8"><span data-translate="gtp.dbaEnabled" class="item-label">DBA ativado</span>:</div>\n                                <div class="col-xs-16 checkbox-options text-right">\n                                    <span class="status-item-value">\n                                        <span class="checkbox-select-item checkbox-status" ng-class="{disabled: !gtpItem.dbaEnabled, checked: gtpItem.dbaEnabled}"></span>\n                                    </span>\n                                </div>\n                            </div>\n\n                            <div class="container-info row">\n                                <div class="col-xs-12 item-label"><span data-translate="gtp.dbaFixedUsUbrBw">Banda fixa UBR</span>:</div>\n                                <span class="col-xs-12 item-value">{{gtpItem.dbaFixedUsUbrBw}}</span>\n                            </div>\n\n                            <div class="container-info row">\n                                <div class="col-xs-12 item-label"><span data-translate="gtp.dbaFixedUsCbrBw">Banda fixa CBR</span>:</div>\n                                <span class="col-xs-12 item-value">{{gtpItem.dbaFixedUsCbrBw}}</span>\n                            </div>\n\n                            <div class="container-info row">\n                                <div class="col-xs-12 item-label"><span data-translate="gtp.dbaAssuredUsBw">Banda assegurada</span>:</div>\n                                <span class="col-xs-12 item-value">{{gtpItem.dbaAssuredUsBw}}</span>\n                            </div>\n\n                            <div class="container-info row">\n                                <div class="col-xs-12 item-label"><span data-translate="gtp.dbaMaxUsBw">Banda m\xE1xima</span>:</div>\n                                <span class="col-xs-12 item-value">{{gtpItem.dbaMaxUsBw}}</span>\n                            </div>\n\n                            <div class="container-info item-subtitle">\n                                <span data-translate="gtp.dbaExtraUsBwType">Tipo de banda extra</span>:\n                            </div>\n\n                            <div class="container-info">\n                                <span class="status-item-value">\n                                    <span class="checkbox-select-item checkbox-status" ng-class="{disabled: gtpItem.dbaExtraUsBwType != \'BESTEFFORT\', checked: gtpItem.dbaExtraUsBwType == \'BESTEFFORT\'}"></span>\n                                </span>\n                                <span class="status-item-label item-label" data-translate="gtp.bestEffort">assegurado</span>\n\n                                <span class="status-item-value">\n                                    <span class="checkbox-select-item checkbox-status" ng-class="{disabled: gtpItem.dbaExtraUsBwType != \'NONASSURED\', checked: gtpItem.dbaExtraUsBwType == \'NONASSURED\'}"></span>\n                                </span>\n                                <span class="status-item-label item-label" data-translate="gtp.nonAssured">n\xE3o assegurado</span>\n                            </div>\n\n                        </div>\n                    </div>\n                </li>\n            </ul>\n            <div class="list-empty" data-translate="gtp.emptyList" ng-if="vmGtp.isListEmpty()">Nenhum GTP encontrado.</div>\n            <div class="list-loading" data-translate="gtp.loadingList" ng-if="vmGtp.requestRunning">Aguarde, carregando GTPs...</div>\n            <div class="list-empty" data-translate="gtp.loadingListError" ng-if="vmGtp.hasErrorList()">Ocorreu um erro ao buscar pelos GTPs. Por favor, atualize a lista.</div>\n        </div>\n    </div>\n\n</div>');
$templateCache.put('app/components/login/login-alert-notification.html','<div class="modal-header title-warning-message">\n    <button type="button" class="close" ng-click="vmAlertNotification.close()"><span aria-hidden="true">&times;</span></button>\n    <h4 class="modal-title title-warning-message" id="title-warning-message" data-translate="global.common.warning">ATEN\xC7\xC3O</h4>\n</div>\n<div class="modal-body content-warning-message">\n    <p>\n        <span data-translate="{{vmAlertNotification.modalMessage}}"></span>\n    </p>\n</div>\n<div class="modal-footer modal-footer-confirm">\n    <button type="submit" class="btn btn-primary btn-del" ng-click="vmAlertNotification.close()" data-translate="global.button.ok">OK</button>\n</div>');
$templateCache.put('app/components/login/login-recover-password.html','<div class="modal-recover">\n    <div class="modal-header">\n        <button type="button" class="close" ng-click="vmRecover.close()"><span aria-hidden="true">&times;</span></button>\n        <h4 class="modal-title" id="recover-password-label" data-translate="login.recoverPassword">Recuperar Senha</h4>\n    </div>\n    <form class="form-validation" ng-submit="vmRecover.recover()" name="vmRecover.recoverPassword" novalidate>\n        <div class="modal-body recover-content">\n            <div class="form-group">\n                <input type="text" class="form-control user-email" name="userEmail" ng-model="vmRecover.email" maxlength="50"\n                       pattern="^[\\w-]+([\\w\\.\\-]+)?@[\\w-]+(\\.\\w+){1,}$"\n                       placeholder="{{\'login.placeholder.email\'| translate}}" required\n                       uib-tooltip="{{\'tooltip.email\'| translate}}"\n                       tooltip-trigger="focus"\n                       tooltip-enable="vmRecover.recoverPassword.userEmail.$invalid"\n                       tooltip-is-open="vmRecover.recoverPassword.userEmail.$invalid && !vmRecover.recoverPassword.userEmail.$error.required"\n                       tooltip-placement="right">\n            </div>\n        </div>\n        <div class="modal-footer">\n            <button type="submit" class="btn btn-primary btn-send" ng-disabled="vmRecover.requestRunning" data-translate="login.button.send">Enviar</button>\n        </div>\n    </form>\n</div>');
$templateCache.put('app/components/login/login-support.html','<div class="modal-header">\n    <button type="button" class="close" ng-click="vmSupportController.close()"><span aria-hidden="true">&times;</span></button>\n    <h4 class="modal-title" id="support-label"  data-translate="login.support">Suporte</h4>\n</div>\n<div class="modal-body form-modal">\n    <div class="text-support">\n        <p data-translate="login.supportHeader">Os clientes Intelbras contam com uma equipe especializada, que est\xE1 \xE0 disposi\xE7\xE3o para prestar um suporte t\xE9cnico de qualidade.<br>O suporte t\xE9cnico da Intelbras \xE9 multicanais, atendendo atrav\xE9s de:</p>\n    </div>\n    <div class="row support-fields">\n        <label class="col-xs-9 control-label" data-translate="login.phone">Telefone</label>\n        <div class="col-xs-15 control-label">\n            <p class="field-phone-support">(48) 2106-0006</p>\n        </div>\n    </div>\n    <div class="row support-fields">\n        <label class="col-xs-9 control-label" data-translate="login.chat">Chat</label>\n        <div class="col-xs-15 control-label">\n            <a href="http://www.intelbras.com.br/chat" target="_blank">crmchat.intelbras.com.br</a>\n        </div>\n    </div>\n    <div class="row support-fields">\n        <label class="col-xs-9 control-label" data-translate="login.email">E-mail</label>\n        <div class="col-xs-15 control-label">\n            <a href="mailto:suporte@intelbras.com.br">suporte@intelbras.com.br</a>\n        </div>\n    </div>\n    <div class="row support-fields">\n        <label class="col-xs-9 control-label" data-translate="login.forum">F\xF3rum</label>\n        <div class="col-xs-15 control-label">\n            <a href="http://forum.intelbras.com.br/" target="_blank">forum.intelbras.com.br</a>\n        </div>\n    </div>\n    <div class="row support-fields">\n        <label class="col-xs-9 control-label" data-translate="login.youTube">YouTube</label>\n        <div class="col-xs-15 control-label">\n            <a href="https://www.youtube.com/user/IntelbrasBR" target="_blank">www.youtube.com/Intelbras</a>\n        </div>\n    </div>\n    <div class="row support-fields">\n        <label class="col-xs-9 control-label" data-translate="login.facebook">Facebook</label>\n        <div class="col-xs-15 control-label">\n            <a href="https://www.facebook.com/Intelbras/" target="_blank">www.facebook.com/Intelbras</a>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/components/login/login.html','<div class="container-login">\n  <ul class="nav navbar-nav navbar-right nav-lang">\n    <li><span data-translate="global.labelVersion"></span> <span data-translate="global.version"></span></li>\n    <li>|</li>\n    <li><span data-translate="global.menu.language">Linguagem</span></li>\n    <li ng-cloak uib-dropdown class="dropdown-default pointer" ng-controller="LanguageController as languageVm">\n      <a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1">\n        <span data-translate="global.menu.lang">PT</span>\n        <strong class="caret"></strong>\n      </a>\n      <ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1">\n        <li active-menu="{{language}}" ng-repeat="language in languageVm.languages">\n          <a href="" ng-click="languageVm.changeLanguage(language);">{{language| findLanguageFromKey}}</a>\n        </li>\n      </ul>\n    </li>\n  </ul>\n\n  <div class="form-login">\n    <form ng-submit="vmLogin.login()" name="vmLogin.formLogin" novalidate>\n      <img class="header-logo" src="assets/images/logo-login.png" alt="Intelbras GPon" />\n      <div class="content-login">\n        <div class="form-group">\n          <div class="input-group">\n            <div class="input-group-addon"><span class="icon icon-user"></span></div>\n            <input\n              type="text"\n              class="form-control user"\n              name="username"\n              maxlength="50"\n              required\n              ng-model="vmLogin.credentials.username"\n              placeholder="{{\'login.placeholder.user\'| translate}}"\n            />\n          </div>\n        </div>\n        <div class="form-group">\n          <div class="input-group">\n            <div class="input-group-addon"><span class="icon icon-password"></span></div>\n            <input\n              type="password"\n              class="form-control user-password"\n              name="password"\n              required\n              ng-model="vmLogin.credentials.password"\n              placeholder="{{\'login.placeholder.password\'| translate}}"\n            />\n          </div>\n        </div>\n\n        <div ng-if="vmLogin.desabilitaButtonLogin">\n          <label class="carregando">Aguarde enquanto o banco de dados inicializa</label>\n        </div>\n\n        <button\n          type="submit"\n          class="btn btn-primary btn-login"\n          ng-disabled="vmLogin.desabilitaButtonLogin"\n          data-translate="login.button.login"\n        >\n          Entrar\n        </button>\n        <div class="options">\n          <a class="options-login pull-left" ng-click="vmLogin.supportLogin()" data-translate="login.support"\n            >Suporte</a\n          >\n          <a\n            class="options-login pull-right"\n            ng-click="vmLogin.recoverPassword()"\n            data-translate="login.recoverPassword"\n            >Recuperar Senha</a\n          >\n        </div>\n      </div>\n    </form>\n  </div>\n</div>\n');
$templateCache.put('app/components/olt/olt-add.html','<div class="modal-header">\n  <button type="button" class="close" ng-click="vmOltAdd.close()"><span aria-hidden="true">&times;</span></button>\n  <h4 class="modal-title" id="add-olt-label" data-translate="olt.{{vmOltAdd.modalTitle}}">Adicionar OLT</h4>\n</div>\n\n<form class="form-horizontal form-modal" name="vmOltAdd.formAddOlt" ng-submit="vmOltAdd.save()" novalidate>\n  <div class="modal-body">\n    <div>\n      <p class="alert-mensagem" data-translate="mensageAlert"></p>\n    </div>\n    <div class="form-group">\n      <div class="col-xs-24">\n        <input\n          type="text"\n          class="form-control field-name"\n          id="field-name"\n          name="oltName"\n          ng-model="vmOltAdd.olt.name"\n          maxlength="20"\n          placeholder="{{\'oltAdd.placeholder.oltName\'| translate}} *"\n          required\n          uib-tooltip="{{\'tooltip.oltName\'| translate}}"\n          tooltip-trigger="focus"\n          tooltip-enable="vmOltAdd.formAddOlt.oltName.$invalid"\n          tooltip-is-open="vmOltAdd.formAddOlt.oltName.$invalid && !vmOltAdd.formAddOlt.oltName.$error.required"\n          tooltip-placement="right"\n        />\n      </div>\n    </div>\n    <div class="form-group">\n      <label class="col-xs-12 control-label" for="field-access-ip"\n        ><span data-translate="oltAdd.accessIp">IP de acesso</span>: *</label\n      >\n      <div class="col-xs-12">\n        <input\n          type="text"\n          class="form-control"\n          id="field-access-ip"\n          name="accessIp"\n          ng-model="vmOltAdd.olt.ip"\n          maxlength="15"\n          pattern="^((25[0-5]|2[0-5][0-9]|[01]?[0-9][0-9]?){1}(\\.)){3}(25[0-5]|2[0-5][0-9]|[01]?[0-9][0-9]?){1}$"\n          placeholder="XXX.XXX.XXX.XXX"\n          required\n          uib-tooltip="{{\'tooltip.ip.invalid\'| translate}}"\n          tooltip-trigger="focus"\n          tooltip-enable="vmOltAdd.formAddOlt.accessIp.$invalid"\n          tooltip-is-open="vmOltAdd.formAddOlt.accessIp.$invalid && !vmOltAdd.formAddOlt.accessIp.$error.required"\n          tooltip-placement="right"\n        />\n      </div>\n    </div>\n    <div class="form-group">\n      <label class="col-xs-10 control-label" for="field-mac" data-translate="oltAdd.macAddress">Endere\xE7o MAC :</label>\n      <div class="col-xs-14">\n        <input\n          type="text"\n          class="form-control"\n          id="field-mac"\n          name="macAddress"\n          ng-model="vmOltAdd.olt.mac"\n          maxlength="17"\n          pattern="(^([0-9A-Fa-f]{2}[:]){5}([0-9A-Fa-f]{2})$)|(^([0-9A-Fa-f]{2}[-]){5}([0-9A-Fa-f]{2})$)"\n          placeholder="XX-XX-XX-XX-XX-XX"\n          uib-tooltip="{{\'tooltip.optionalMac\'| translate}}"\n          tooltip-trigger="focus"\n          tooltip-enable="vmOltAdd.formAddOlt.macAddress.$invalid"\n          tooltip-is-open="vmOltAdd.formAddOlt.macAddress.$invalid"\n          tooltip-placement="right"\n        />\n      </div>\n    </div>\n    <div class="form-group">\n      <label class="col-xs-12 control-label" for="field-access-type"\n        ><span data-translate="oltAdd.accessTypeLabel">Tipo de acesso</span>: *</label\n      >\n      <div class="col-xs-12">\n        <ui-select\n          name="field-access-type"\n          ng-model="vmOltAdd.olt.accessType"\n          search-enabled="false"\n          ng-change="vmOltAdd.setPort()"\n          required\n        >\n          <ui-select-match>{{vmOltAdd.olt.accessType.label}}</ui-select-match>\n          <ui-select-choices repeat="type in vmOltAdd.accessTypeList">{{type.label}}</ui-select-choices>\n        </ui-select>\n      </div>\n    </div>\n    <div class="form-group">\n      <label class="col-xs-12 control-label" for="field-olt-port"\n        ><span data-translate="oltAdd.oltPort">Porta</span>: *</label\n      >\n      <div class="col-xs-12">\n        <input\n          type="number"\n          class="form-control"\n          id="field-olt-port"\n          name="oltPort"\n          ng-model="vmOltAdd.olt.port"\n          step="1"\n          min="1"\n          max="65535"\n          placeholder="XXXXX"\n          pattern="\\d+"\n          required\n          value="{{vmOltAdd.olt.accessType.portSugestion}}"\n          uib-tooltip="{{\'tooltip.port\'| translate}}"\n          tooltip-trigger="focus"\n          tooltip-enable="vmOltAdd.formAddOlt.oltPort.$invalid"\n          tooltip-is-open="vmOltAdd.formAddOlt.oltPort.$invalid && !vmOltAdd.formAddOlt.oltPort.$error.required"\n          tooltip-placement="right"\n        />\n      </div>\n    </div>\n    <div class="form-group">\n      <label class="col-xs-12 control-label" for="field-acess-user"\n        ><span data-translate="oltAdd.accessUser">Usu\xE1rio de acesso</span>: *</label\n      >\n      <div class="col-xs-12">\n        <input\n          type="text"\n          class="form-control"\n          id="field-access-user"\n          name="accessUser"\n          ng-model="vmOltAdd.olt.accessUser"\n          maxlength="20"\n          placeholder="{{\'oltAdd.placeholder.user\'| translate}}"\n          required\n          uib-tooltip="{{\'tooltip.accessUser\'| translate}}"\n          tooltip-trigger="focus"\n          tooltip-enable="vmOltAdd.formAddOlt.accessUser.$invalid"\n          tooltip-is-open="vmOltAdd.formAddOlt.accessUser.$invalid && !vmOltAdd.formAddOlt.accessUser.$error.required"\n          tooltip-placement="right"\n        />\n      </div>\n    </div>\n    <div class="form-group">\n      <label class="col-xs-12 control-label" for="field-access-password"\n        ><span data-translate="oltAdd.accessPassword">Senha de acesso</span>: *</label\n      >\n      <div class="col-xs-12">\n        <input\n          type="password"\n          class="form-control"\n          id="field-access-password"\n          name="accessPassword"\n          ng-model="vmOltAdd.olt.accessPassword"\n          maxlength="20"\n          placeholder="{{\'oltAdd.placeholder.password\'| translate}}"\n          required\n          autocomplete="new-password"\n          uib-tooltip="{{\'tooltip.accessPassword\'| translate}}"\n          tooltip-trigger="focus"\n          tooltip-enable="vmOltAdd.formAddOlt.accessPassword.$invalid"\n          tooltip-is-open="vmOltAdd.formAddOlt.accessPassword.$invalid && !vmOltAdd.formAddOlt.accessPassword.$error.required"\n          tooltip-placement="right"\n        />\n      </div>\n    </div>\n  </div>\n  <div class="modal-footer">\n    <button\n      type="button"\n      id="btn-cancel-add-olt"\n      class="btn btn-default btn-cancel"\n      ng-click="vmOltAdd.close()"\n      ng-disabled="vmOltAdd.requestRunning"\n      data-translate="global.button.cancel"\n    >\n      Cancelar\n    </button>\n    <button\n      type="submit"\n      id="btn-save-add-olt"\n      class="btn btn-primary btn-add"\n      ng-disabled="vmOltAdd.requestRunning"\n      data-translate="global.button.{{vmOltAdd.labelButton}}"\n    >\n      Salvar\n    </button>\n  </div>\n</form>\n');
$templateCache.put('app/components/olt/olt-confirm.html','<div class="modal-header">\n    <button type="button" class="close close-delete" ng-click="vmOltConfirm.close()"><span aria-hidden="true">&times;</span></button>\n    <h4 class="modal-title" id="del-one-olt-label" data-translate="oltConfirm.{{vmOltConfirm.action}}.title">Confirma\xE7\xE3o OLT</h4>\n</div>\n<div class="modal-body modal-content-confirm" ng-scrollbars>\n    <div ng-if="vmOltConfirm.itemOne" data-translate="oltConfirm.{{vmOltConfirm.action}}.message.question.questionOneOlt" data-translate-values="vmOltConfirm.oltData">\n        Voc\xEA deseja realmente {{action}} a OLT xxxx ?\n    </div>\n    <div ng-if="!vmOltConfirm.itemOne" data-translate="oltConfirm.{{vmOltConfirm.action}}.message.question.questionManyOlts" data-translate-values="vmOltConfirm.oltData">\n        Foram selecionadas <span>XX</span> olts <span>string, string, string, string, string, string</span>, deseja <span>deletar</span>?\n    </div>\n</div>\n<div class="modal-footer modal-footer-confirm">\n    <button type="button" class="btn btn-default btn-cancel" ng-click="vmOltConfirm.close()" ng-disabled="vmOltConfirm.requestRunning" data-translate="global.button.cancel">Cancelar</button>\n    <button id="btn-delete-olt-confirm" type="submit" class="btn btn-primary btn-del" ng-click="vmOltConfirm.confirmAction()" ng-disabled="vmOltConfirm.requestRunning" data-translate="oltConfirm.{{vmOltConfirm.action}}.btnConfirm">Action</button>\n</div>');
$templateCache.put('app/components/olt/olt-detail.html','<div class="panel panel-default olt-detail" ng-class="[{alarm: vmOltDetail.data.detail.mostCriticalAlarm}, vmOltDetail.data.detail.mostCriticalAlarm]">\n\n    <div class="panel-heading" >\n        <span class="panel-title">{{vmOltDetail.data.detail.name}}</span>\n        <div class="pull-right">\n            <button class="btn btn-primary btn-console" ng-click="vmOltDetail.accessCode()" ng-disabled="vmOltDetail.statusDisabled"\n                    has-authority="consoleWeb" has-behavior="disable-button">\n                <span class="icon icon-code"></span>\n                <span data-translate="olt.detail.accessCode">Acessar c\xF3digo</span>\n            </button>\n            <div class="dropdown-default menu-olt" uib-dropdown >\n                <button id="btn-more-olt-detail" class="btn-menu-olt" uib-dropdown-toggle>\n                    <span class="icon icon-menu-more"></span>\n                </button>\n                <ul class="dropdown-menu dropdown-menu-right" uib-dropdown-menu>\n                    <li><a ng-click="vmOltDetail.restartOlt()" id="restart_olt" data-translate="olt.detail.menu.restart" has-authority="oltRestart" has-behavior="disable-link">Reiniciar</a></li>\n                    <li class="container-input-file" ng-if="vmOltDetail.fromSIG">\n                        <input id="detailFile" type="file" name="file" class="btn-olt-inputfile" file-change="vmOltDetail.uploadFilesToOlt()" ng-model="vmOltDetail.files" multiple has-authority="oltLoadFiles" has-behavior="disable-link">\n                        <a data-translate="olt.detail.menu.loadFile" has-authority="oltLoadFiles" has-behavior="disable-link">Carregar arquivos</a>\n                    </li>\n                    <li class="container-input-file" ng-if="!vmOltDetail.fromSIG">\n                        <a ng-click="vmOltDetail.uploadFilesTftp()" data-translate="olt.detail.menu.loadFile" has-authority="oltLoadFiles" has-behavior="disable-link">Carregar arquivos</a>\n                    </li> \n                    <li><a id="btn-restore_olt" ng-click="vmOltDetail.restore()" data-translate="olt.detail.menu.restore">Restaurar</a></li>\n                    <li><a id="btn-update_olt_firmware" ng-click="vmOltDetail.updateFirmware()" data-translate="olt.detail.menu.updateFirmware" has-authority="oltFirmwareUpdate" has-behavior="disable-link">Atualizar Firmware</a></li>\n                    <li><a id="btn-backup_olt" ng-click="vmOltDetail.backup()" data-translate="olt.detail.menu.backup" has-authority="oltBackup" has-behavior="disable-link">Backup</a></li>\n                    <li><a id="btn-delete-olt-detail" ng-click="vmOltDetail.deleteOlt()" data-translate="olt.detail.menu.delete" has-authority="oltDelete" has-behavior="disable-link">Deletar</a></li>\n                    <li><a id="btn-edit_olt" ng-click="vmOltDetail.editOlt()" data-translate="olt.detail.menu.edit" has-authority="oltEdit" has-behavior="disable-link">Editar</a></li>\n                    <li><a id="gtp_profile" ng-click="vmOltDetail.setGtpCpeMgrOlt()" data-translate="olt.detail.menu.gtpCpeMgr" has-authority="oltEdit" has-behavior="disable-link">Set Gtp</a></li>\n                    <li><a id="sincronizacao_forcada" ng-click="relatorioVm.sincronizar(vmOltDetail.data.detail)" >Sincroniza\xE7\xE3o For\xE7ada</a></li>\n                    <li><a id="relatorio_sincronizacao " ng-click="relatorioVm.abreModal(vmOltDetail.data.detail)">Relat\xF3rio da \xDAltima Sincroniza\xE7\xE3o For\xE7ada</a></li>\n                    <li><a id="alarm_show" ng-click="vmOltDetail.abreModalAlarmShow()" >Alarme</a></li>\n                </ul>\n            </div>\n        </div>\n    </div>\n\n    <div class="panel-body" loader-section="vmOltDetail.requestRunning.status">\n\n        <div class="container-scroll" ng-scrollbars>\n\n            <div class="detail-section section-ports">\n\n                <h3 class="section-title" data-translate="olt.detail.oltPorts">Portas da OLT</h3>\n\n                <div class="olt-ports-gpon">\n                    <div class="olt-port port-{{port.status}}" ng-repeat="port in vmOltDetail.ports.gpon">\n                        <div class="port-number">{{port.portNumber}}</div>\n                        <div class="port-onus" id="status_onu" ng-if="port.status == \'up\'" ui-state="vmOltDetail.statusDisabled ? \'.\' : \'onu\'"\n                             ui-state-params="{name: vmOltDetail.data.detail.name, ip: vmOltDetail.statusOlt.ip, port: port.portNumber}">\n                            {{port.totalAuthorizedOnus}} <br> onu(s)\n                        </div>\n                        <span class="port-alarms {{port.mostCriticalAlarm}}" ng-if="port.totalActiveAlarms && port.status == \'up\'">{{port.totalActiveAlarms}}</span>\n                    </div>\n                </div>\n\n                <div class="olt-ports-ge">\n                    <div class="olt-ports-ge10">\n                        <div class="ports-title" data-translate="olt.detail.port10Ge">10GE</div>\n                        <div class="olt-port port-{{port.status}}" ng-repeat="port in vmOltDetail.ports.ge10">\n                            <div class="port-number">{{port.portNumber}}</div>\n                        </div>    \n                    </div>\n\n                    <div class="olt-ports-ge1">\n                        <div class="ports-title" data-translate="olt.detail.portEthernet">ETHERNET</div>\n\n                        <div class="ports-content">\n                            <div class="olt-port port-{{port.status}}" ng-repeat="port in vmOltDetail.ports.ge1">\n                                <div class="port-number">{{port.portNumber}}</div>\n                            </div>    \n                        </div>\n                        <br>\n                        <div class="ports-caption">\n                            <div class="port-caption">\n                                <div class="olt-port port-up1g"></div>\n                                <span>Giga</span>\n                            </div>\n\n                            <div class="port-caption">\n                                <div class="olt-port port-up100m"></div>\n                                <span>Fast</span>\n                            </div>\n\n                            <div class="port-caption">\n                                <div class="olt-port port-down"></div>\n                                <span>Off</span>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n            </div>\n\n            <div class="panel-body form-horizontal detail-section">\n\n                <div class="form-group">\n                    <label class="col-sm-14 control-label" for="field-automatedProvisioning"><span data-translate="olt.detail.automatedProvisioning">Provisionamento automatizado</span>: </label>\n                    <div class="col-sm-8">\n                        <switch id="field-automatedProvisioning" name="automatedProvisioning" ng-model="vmOltDetail.automatedProvisioning" class="green"></switch>\n                    </div>\n                </div>\n\n                <div class="form-group" ng-if="vmOltDetail.isOlt8820i()">\n                    <label class="col-sm-14 control-label" for="field-autoService"><span data-translate="olt.detail.autoService">Auto-servi\xE7o</span>: </label>\n                    <div class="col-sm-8">\n                        <switch id="field-autoService" name="autoService" ng-model="vmOltDetail.autoService" class="green"></switch>\n                    </div>\n                </div>\n\n                <div class="form-group">\n                    <button type="submit" class="btn btn-primary btn-update"\n                            data-translate="olt.detail.update"\n                            ng-click="vmOltDetail.setAutoConfig()">\n                        Atualizar\n                    </button>\n                </div>\n\n            </div>\n\n            <div class="detail-section section-status">\n                <h3 class="section-title" data-translate="olt.detail.status">Status</h3>\n                <div class="detail-subsection">\n                    <span class="status-item-label"><span data-translate="olt.detail.timeOfUse">Tempo de uso</span>:</span>\n                    <span class="status-item-value">{{vmOltDetail.statusOlt.uptime}}</span>\n                </div>\n                <div class="detail-subsection">\n                    <span class="status-item-label"><span data-translate="olt.detail.temperature">Temperatura</span>:</span>\n                    <span class="status-item-value">{{vmOltDetail.statusOlt.temperature}}</span>\n                </div>\n            </div>\n\n            <div class="detail-section section-ip">\n                <div class="detail-subsection">\n                    <span class="status-item-label"><span data-translate="olt.detail.ip">IP</span>:</span>\n                    <span class="status-item-value">{{vmOltDetail.statusOlt.ip}}</span>\n                </div>\n            </div>\n\n            <div class="detail-section section-datetime">\n                <div class="detail-subsection">\n                    <h3 class="section-title" data-translate="olt.detail.date">Data</h3>\n                    <div class="dropdown-select dropdown-field-date datepicker status-item">\n                        <div class="dropdown-toggle" ng-class="{opened: vmOltDetail.datepicker.opened}"\n                             ng-disabled="vmOltDetail.statusDisabled"\n                             ng-click="vmOltDetail.datepicker.toggle()"\n                             uib-datepicker-popup="{{vmOltDetail.datepicker.format}}"\n                             ng-model="vmOltDetail.datepicker.selected"\n                             is-open="vmOltDetail.datepicker.opened"\n                             datepicker-options="vmOltDetail.datepicker.options"\n                             show-button-bar="false"\n                             has-authority="oltSetDateTime" has-behavior="disable-default">\n                            {{vmOltDetail.datepicker.selected| date:\'longDate\'}}\n                            <span class="icon icon-arrow-select"></span>\n                        </div>\n                    </div>\n                </div>\n                <div class="detail-subsection detail-right">\n                    <h3 class="section-title" data-translate="olt.detail.time">Hora</h3>\n                    <div class="status-item">\n                        <ui-select class="ui-time ui-time-hour" ng-model="vmOltDetail.time.hour" search-enabled="false" ng-disabled="vmOltDetail.statusDisabled"\n                                   has-authority="oltSetDateTime" has-behavior="disable-default">\n                            <ui-select-match>{{vmOltDetail.time.hour}}h</ui-select-match>\n                            <ui-select-choices repeat="hour in vmOltDetail.time.hours">{{hour}}h</ui-select-choices>\n                        </ui-select>\n                        <ui-select class="ui-time ui-time-minute" ng-model="vmOltDetail.time.minute" search-enabled="false" ng-disabled="vmOltDetail.statusDisabled"\n                                   has-authority="oltSetDateTime" has-behavior="disable-default">\n                            <ui-select-match>{{vmOltDetail.time.minute}}min</ui-select-match>\n                            <ui-select-choices repeat="minute in vmOltDetail.time.minutes">{{minute}}min</ui-select-choices>\n                        </ui-select>\n                    </div>\n                </div>\n                <button type="submit" class="btn btn-primary btn-update"\n                        data-translate="olt.detail.updateTime"\n                        ng-click="vmOltDetail.setDateOlt()"\n                        ng-disabled="vmOltDetail.statusDisabled"\n                        has-authority="oltSetDateTime" has-behavior="disable-button">\n                    Atualizar\n                </button>\n            </div>\n\n            <div class="detail-section section-chart" ui-view="history"></div>\n\n            <div class="detail-section section-hardware">\n                <div class="detail-subsection">\n                    <span class="status-item-label"><span data-translate="olt.detail.cooler">Cooler</span> A:</span>\n                    <span class="status-item-value">\n                        <span class="checkbox-select-item checkbox-status" ng-class="{disabled: !vmOltDetail.statusOlt.coolerStatusA, checked: vmOltDetail.statusOlt.coolerStatusA}"></span>\n                    </span>\n                    <span class="status-item-label">B:</span>\n                    <span class="status-item-value">\n                        <span class="checkbox-select-item checkbox-status" ng-class="{disabled: !vmOltDetail.statusOlt.coolerStatusB, checked: vmOltDetail.statusOlt.coolerStatusB}"></span>\n                    </span>\n                    <span class="status-item-label">C:</span>\n                    <span class="status-item-value">\n                        <span class="checkbox-select-item checkbox-status" ng-class="{disabled: !vmOltDetail.statusOlt.coolerStatusC, checked: vmOltDetail.statusOlt.coolerStatusC}"></span>\n                    </span>\n                </div>\n                <div class="detail-subsection">\n                    <span class="status-item-label"><span data-translate="olt.detail.cardMemory">Card Memory</span>:</span>\n                    <span class="status-item-value">\n                        <span class="checkbox-select-item checkbox-status" ng-class="{disabled: !vmOltDetail.statusOlt.cardMemoryStatus, checked: vmOltDetail.statusOlt.cardMemoryStatus}"></span>\n                    </span>\n                </div>\n            </div>\n\n            <div class="detail-section section-version">\n                <span class="status-item-label"><span data-translate="olt.detail.softwareVersion">Vers\xE3o do software</span>:</span>\n                <span class="status-item-value">{{vmOltDetail.statusOlt.softwareVersion}}</span>\n            </div>\n\n        </div>\n    </div>\n\n    <div class="panel-footer">\n        <!-- <button class="btn btn-block btn-olt-alarms" ng-class="[vmOltDetail.data.detail.mostCriticalAlarm]" ui-sref="alarms({id:{{vmOltDetail.data.detail.id}}, type: \'OLT\'})">\n            <span class="icon icon-alarm-small"></span>\n            <span data-translate="olt.detail.alarms">Alarmes</span>\n        </button> -->\n    </div>\n\n</div>\n');
$templateCache.put('app/components/olt/olt-gtp-cpe-mgr.html','<div class="modal-header">\n    <button type="button" class="close" ng-click="vmOltGtpCpeMgr.close()"><span aria-hidden="true">&times;</span></button>\n    <h4 class="modal-title" data-translate="oltGtpCpeMgr.title">Set GtpCpeMgr</h4>\n</div>\n<form class="form-horizontal form-modal" name="vmOltGtpCpeMgr.formAddGtp" ng-submit="vmOltGtpCpeMgr.save()" novalidate>\n    <div class="modal-body">\n        <div ng-if="vmOltGtpCpeMgr.showMessage" data-translate="oltGtpCpeMgr.message" class="modal-gtpcpe-body">\n            \xC9 necess\xE1rio que seja configurado o GTP para prosseguir.\n        </div>\n        <div class="form-group">\n            <label class="col-xs-6 control-label"><span data-translate="oltGtpCpeMgr.gtp">GTP</span>:</label>\n            <div class="col-xs-16">\n                <ui-select ng-model="vmOltGtpCpeMgr.gtp" on-select="vmOltGtpCpeMgr.setGtp($item)" search-enabled="false"\n                           ng-required="vmOltGtpCpeMgr.showMessage">\n                    <ui-select-match>{{vmOltGtpCpeMgr.gtp.name}}</ui-select-match>\n                    <ui-select-choices repeat="item in vmOltGtpCpeMgr.listGtps">{{item.name}}</ui-select-choices>\n                </ui-select>\n            </div>\n        </div>\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default btn-cancel" ng-click="vmOltGtpCpeMgr.close()" ng-disabled="vmOltGtpCpeMgr.requestRunning" data-translate="global.button.cancel">Cancelar</button>\n        <button type="submit" class="btn btn-primary btn-add" ng-disabled="vmOltGtpCpeMgr.requestRunning" data-translate="global.button.save">Salvar</button>\n    </div>\n</form>');
$templateCache.put('app/components/olt/olt-history.html','<h3 class="section-title">\n    <button class="btn-change-chart" ng-click="vmOltHistory.changeChart()">\n        <span class="icon icon-arrow-left"></span>\n    </button>\n    <span data-translate="olt.detail.{{vmOltHistory.selectedChart}}" ng-cloak>Mem\xF3ria</span>\n    <button class="btn-change-chart" ng-click="vmOltHistory.changeChart()">\n        <span class="icon icon-arrow-right"></span>\n    </button>\n</h3>\n<nvd3 options="vmOltHistory.chart.options" data="vmOltHistory.chart.data" api="vmOltHistory.chart.api" cancel-event="mousewheel"></nvd3>');
$templateCache.put('app/components/olt/olt-list.html','<div class="panel panel-default panel-list">\n\n    <div class="panel-heading">\n\n        <span class="panel-title" data-translate="olt.oltList">LISTA DE OLTS</span>\n        <div class="pull-right" ng-hide="vmOltList.isSearchEmpty()">\n            <div class="dropdown-default dropdown-order-list" uib-dropdown>\n                <div class="dropdown-toggle" uib-dropdown-toggle>\n                    <span data-translate="olt.orderTypeSelection.{{vmOltList.view.labelOrderSelected}}">Ordem alfab\xE9tica</span>\n                    <span class="caret"></span>\n                </div>\n                <ul class="dropdown-menu dropdown-menu-right" ng-model="vmOltList.orderSelected" uib-dropdown-menu>\n                    <li value="{{item.paramObjectOrder}}" ng-repeat="item in vmOltList.list.typeOrder" ng-class="{active: item.paramObjectOrder == vmOltList.orderSelected}">\n                        <a ng-click="vmOltList.setTypeOrder(item.paramObjectOrder)" data-translate="olt.orderTypeSelection.{{item.translateKey}}">{{item.name}}</a>\n                    </li>\n                </ul>\n            </div>\n        </div>\n\n        <div class="container-select" ng-hide="vmOltList.isSearchEmpty()">\n            <div class="dropdown-default dropdown-select-list pull-left" uib-dropdown>\n                <div class="dropdown-toggle" uib-dropdown-toggle>\n                    <label class="checkbox-select-item checkbox-select-olt" ng-class="{checked: vmOltList.list.checkBoxEnable}">\n                        <input type="checkbox" name="checkbox-select-olt" id="" ng-model="vmOltList.list.checkBoxEnable" ng-change="vmOltList.unselectAll()">\n                    </label>\n                    <span class="caret"></span>\n                </div>\n                <ul class="dropdown-menu dropdown-menu-right" ng-model="vmOltList.list.itemSelected" uib-dropdown-menu>\n                    <li value="selectAll" ng-class="{active:vmOltList.view.isActiveOptionAll}">\n                        <a href="" data-translate="olt.selectAll.{{vmOltList.view.menuSelectAll}}" ng-click="vmOltList.typeSelection(\'selectAll\')">\n                            Selecionar todas\n                        </a>\n                    </li>\n                    <li value="selectIndividual" ng-class="{active:vmOltList.view.isActiveOptionIndividual}">\n                        <a href="" data-translate="olt.selectIndividual.{{vmOltList.view.menuSelectIndividual}}" ng-click="vmOltList.typeSelection(\'selectIndividual\')">\n                            Sele\xE7\xE3o individual\n                        </a>\n                    </li>\n                </ul>\n            </div>\n            <span data-translate="olt.selectOlts">Selecionar OLTS</span>\n        </div>\n\n    </div>\n\n    <div class="container-loader" loader-section="vmOlt.data.requestRunning">\n\n        <div class="container-scroll" ng-scrollbars>\n\n            <div class="panel-body">\n\n                <ul class="list list-olt">\n                    <li class="list-item" id="olt-{{$index}}" ng-repeat="oltItem in vmOlt.data.arrayOlts| orderBy: vmOltList.orderSelected"\n                        ng-class="[{active: oltItem.active, alarm: oltItem.mostCriticalAlarm}, oltItem.mostCriticalAlarm]"\n                        ng-click="vmOltList.clickOltItem(oltItem)">\n                        <label class="checkbox-select-item" ng-show="vmOltList.list.checkBoxEnable" ng-class="{checked: oltItem.selected}" stop-propagation>\n                            <input type="checkbox" name="checkbox-select-olt" id="" ng-model="oltItem.selected" ng-change="vmOltList.addAndRemoveItem(oltItem)">\n                        </label>\n                        <div class="icon icon-alarm" ng-show="oltItem.mostCriticalAlarm"></div>\n                        <div class="list-item-info">\n                            <span class="list-item-name">{{oltItem.name}}</span>\n                        </div>\n                        <div class="list-item-links">\n                            <a ui-state="vmOltList.view.menuSelection ? \'.\' : \'onu\'" ui-state-params="{name: oltItem.name, ip: oltItem.ip}" data-translate="global.menu.onu" stop-propagation disable-propagation="{{vmOltList.view.menuSelection}}">ONU</a>\n                            <a ui-state="vmOltList.view.menuSelection ? \'.\' : \'provisioning\'" ui-state-params="{id:oltItem.id, name:oltItem.name, type:\'OLT\'}" data-translate="global.menu.service" class="pull-right" stop-propagation disable-propagation="{{vmOltList.view.menuSelection}}">Servi\xE7o</a>\n                        </div>\n                    </li>\n                </ul>\n\n                <div class="list-loading" data-translate="olt.loadingList" ng-if="vmOlt.data.requestRunning">Aguarde, carregando OLTs ...</div>\n                <div class="list-empty" data-translate="olt.emptyList" ng-if="vmOltList.isSearchEmpty()">N\xE3o foram encontrados resultados.</div>\n\n            </div>\n\n        </div>\n\n    </div>\n\n</div>');
$templateCache.put('app/components/olt/olt-management.html','<div class="panel panel-default width-full">\n    <div class="modal-header management-heading">\n        <h4 class="modal-title"  data-translate="olt.oltList">LISTA DE OLTS</h4>\n    </div>\n\n    <div class="modal-body management-body">\n        <form class="form-horizontal form-modal" name="vmOltAdd.formAddOlt"  novalidate>\n            <p ng-if="vmOltManagement.itemOne" data-translate="olt.management.questionOneOlt" data-translate-values="vmOltManagement.oltData">Voc\xEA deseja realmente {{action}} a OLT xxxx ?</p>\n            <p ng-if="!vmOltManagement.itemOne" data-translate="olt.management.questionManyOlts" data-translate-values="vmOltManagement.oltData">Foram selecionadas <span>XX</span> olts <span>string, string, string, string, string, string</span>, deseja <span>deletar</span>?\n        </form>\n    </div>\n\n    <div class="modal-footer management-footer">\n        <button type="button" class="btn btn-default" ui-sref="alarms({oltId:{{vmOltManagement.arrayIds}}})"  data-translate="olt.management.button.alarms">Alarms</button>\n        <button type="button" class="btn btn-default disable-not-hover" ng-click="vmOltManagement.backup()"  data-translate="olt.management.button.backup" has-authority="oltBackup" has-behavior="disable-default">Backup</button>\n        <button type="button" class="btn btn-default disable-not-hover" ng-click="vmOltManagement.restart()" data-translate="olt.management.button.restart"has-authority="oltRestart"has-behavior="disable-default">Reiniciar</button>\n        <button type="button" class="btn btn-default disable-not-hover" ng-click="vmOltManagement.delete()"  data-translate="olt.management.button.delete" has-authority="oltDelete" has-behavior="disable-default">Deletar</button>\n    </div>\n</div>\n');
$templateCache.put('app/components/olt/olt-option-restore.html','<div class="container-option-restore">\n    <div class="modal-header">\n        <button type="button" class="close close-delete" ng-click="vmOltOptionRestore.close()"><span aria-hidden="true">&times;</span></button>\n        <h4 class="modal-title" id="del-one-olt-label" data-translate="oltOptionRestore.title">Restaurar</h4>\n    </div>\n    <div class="modal-body modal-content-confirm">\n        <p data-translate="oltOptionRestore.message">Choose option to restore olt:</p>\n    </div>\n    <div class="modal-footer">\n        <a  class="btn btn-primary" ng-click="vmOltOptionRestore.configDefault()" data-translate="oltOptionRestore.btn.configDefault" has-authority="oltFactoryReset" has-behavior="disable-button">Config F\xE1brica</a>\n        <a  class="btn btn-primary" ng-click="vmOltOptionRestore.restoreConfig()" data-translate="oltOptionRestore.btn.restoreBackup" has-authority="oltBackupRestore" has-behavior="disable-button">Restaurar Backup</a>\n        <a  class="btn btn-default btn-cancel" ng-click="vmOltOptionRestore.close()" data-translate="oltOptionRestore.btn.cancel"><span>Cancelar</span></a>\n    </div>\n</div>');
$templateCache.put('app/components/olt/olt-restore-backup.html','<div class="modal-header">\n    <button type="button" class="close" ng-click="vmOltRestoreBackup.close()"><span aria-hidden="true">&times;</span></button>\n    <h4 class="modal-title" id="update-olt-label" >Carregar Arquivo para Backup</h4>\n</div>\n<form class="form-update-firmware" name="vmOltRestoreBackup.formRestoreBackup" ng-submit="vmOltRestoreBackup.uploadFileName()" novalidate>\n    <div class="modal-body modal-update-firmware" loader-section="vmOltRestoreBackup.requestRunning">\n        <div class="label-description">\n            <span>Procurar o arquivo para upload</span>:\n            <span class="label-content">{{vmOltRestoreBackup.modelUpload.oltName}}</span>\n        </div>\n        <div class="row">\n            <div class="modal-col col-xs-24">\n                 \n                <div class="form-group" ng-if="vmOltRestoreBackup.fromSIG">\n                    <input type="file" multiple fileread="vmOltRestoreBackup.modelUpload.file" />\n                    {{vmOltRestoreBackup.modelUpload.file.name}}  \n                </div>\n                \n                <div class="form-group" ng-if="!vmOltRestoreBackup.fromSIG">                \n                    <label for="search-name" class="search-label control-label"><span data-translate="oltUploadTftp.name">Nome</span>:</label>\n                    <input class="search-input form-control" type="text" id="search-name"\n                           maxlength="40" placeholder="{{\'oltUploadTftp.placeholder.fileName\'| translate}}"\n                           ng-model="vmOltRestoreBackup.modelUpload.fileName">\n                </div>\n\n            </div>\n        </div>\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default btn-modal-lg" ng-disabled="vmOltRestoreBackup.requestRunning" ng-click="vmOltRestoreBackup.close()" data-translate="global.button.cancel">Cancelar</button>\n        <button type="submit" class="btn btn-primary btn-modal-lg btn-main-action" ng-disabled="!vmOltRestoreBackup.modelUpload.file && !vmOltRestoreBackup.modelUpload.fileName" data-translate="global.button.submit">Enviar</button>\n    </div>    \n</form>');
$templateCache.put('app/components/olt/olt-restore.html','<div class="container-restore">\n    <div class="modal-header">\n        <button type="button" class="close close-delete" ng-click="vmOltRestore.close()"><span aria-hidden="true">&times;</span></button>\n        <h4 class="modal-title" id="del-one-olt-label" data-translate="oltRestore.title">RESTAURAR</h4>\n    </div>\n    <form ng-submit="vmOltRestore.restore()" novalidate>\n        <div class="modal-body modal-body-table">\n            <div class="container-scroll" ng-scrollbars>\n                <div class="panel panel-default">\n                    <table class="table table-hover">\n                        <thead>\n                            <tr>\n                                <th></th>\n                                <th>OLT</th>\n                                <th data-translate="oltRestore.table.header.dateTime">Data/Hora</th>\n                                <th data-translate="oltRestore.table.header.user">Usu\xE1rio</th>\n                            </tr>\n                        </thead>\n                        <tbody>\n                            <tr>\n                                <td colspan="4" class="list-empty" data-translate="olt.emptyBackupList" ng-if="vmOltRestore.isSearchEmpty()">N\xE3o foram encontrados resultados.</td>\n                            </tr>\n                            <tr ng-repeat="item in vmOltRestore.backupList" ng-class="{active: vmOltRestore.selectedBackup == item.id}"\n                                ng-click="vmOltRestore.selectedBackup = item.id">\n                                <td>\n                                    <label class="radio" ng-class="{checked: vmOltRestore.selectedBackup == item.id}">\n                                        <input type="radio" name="restore" ng-model="vmOltRestore.selectedBackup" ng-value="item.id">\n                                    </label>\n                                </td>\n                                <td>{{item.oltName}}</td>\n                                <td>{{item.creationDate| patternDate}} {{\'oltRestore.table.date.at\'| translate}} {{item.creationDate| date:\'HH:mm\'}}</td>\n                                <td>{{item.userEmail}}</td>\n                            </tr>\n\n                        </tbody>\n                    </table>\n                </div>\n            </div>\n        </div>\n\n        <div class="modal-footer">\n            <button type="button" class="btn btn-default" ng-click="vmOltRestore.close()" data-translate="oltRestore.btn.cancel">Cancelar</button>\n            <button type="submit" class="btn btn-primary btn-main-action" ng-disabled="!vmOltRestore.selectedBackup" data-translate="oltRestore.btn.restore">Restaurar</button>\n        </div>\n    </form>\n</div>');
$templateCache.put('app/components/olt/olt-search.html','<div class="panel panel-default">\n    <div class="panel-heading">\n        <span class="panel-title" data-translate="global.search.searchFilter">FILTRO DE BUSCA</span>\n    </div>\n    <div class="panel-body">\n        <form class="form-inline form-search" name="vmOltSearch.formSearch" ng-submit="vmOltSearch.searchOlts()" novalidate>\n            <div class="form-group">\n                <label for="search-name" class="search-label control-label"><span data-translate="global.search.name">Nome</span>:</label>\n                <input class="search-input form-control" type="text" id="search-name"\n                       maxlength="20" placeholder="{{\'global.search.placeholder.oltName\'| translate}}"\n                       ng-model="vmOltSearch.searchData.name"\n                       uib-tooltip="{{\'tooltip.searchByName\'| translate}}"\n                       tooltip-trigger="focus"\n                       tooltip-placement="right">\n            </div>\n            <div class="form-group">\n                <label for="search-ip" class="search-label control-label"><span data-translate="global.search.ip">IP</span>:</label>\n                <input class="search-input form-control" type="text" id="search-ip" name="searchIp" maxlength="15"\n                       pattern="^((25[0-4]|2[0-4][0-9]|[01]?[0-9][0-9]?){1}(\\.)){0,3}(25[0-4]|2[0-4][0-9]|[01]?[0-9][0-9]?){0,1}$"\n                       placeholder="XXX.XXX.XXX.XXX" ng-model="vmOltSearch.searchData.ip"\n                       uib-tooltip="{{vmOltSearch.ipTooltip| translate}}"\n                       tooltip-trigger="focus"\n                       tooltip-placement="right"\n                       ng-change="vmOltSearch.changeTooltip()">\n            </div>\n            <div class="panel-button">\n                <button type="button" class="btn btn-default btn-clean" data-translate="global.search.cleanText" ng-click="vmOltSearch.cleanFilter()">Limpar</button>\n                <button class="btn btn-primary btn-search">\n                    <span class="icon icon-search"></span>\n                    <span data-translate="global.search.searchText">Pesquisar</span>\n                </button>\n            </div>\n        </form>\n    </div>\n</div>');
$templateCache.put('app/components/olt/olt-update-firmware.html','<div class="modal-header">\n    <button type="button" class="close" ng-click="vmOltUpdateFirmware.close()"><span aria-hidden="true">&times;</span></button>\n    <h4 class="modal-title" id="update-olt-label" data-translate="oltUpdateFirmware.updateFirmware">Atualiza\xE7\xE3o de Firmware</h4>\n</div>\n<form class="form-update-firmware" name="vmOltUpdateFirmware.formUpdateOlt" ng-submit="vmOltUpdateFirmware.updateFirmware()" novalidate>\n    <div class="modal-body modal-update-firmware">\n        <div class="label-description">\n            <span data-translate="oltUpdateFirmware.selectLabel.{{vmOltUpdateFirmware.description}}">Selecione o arquivo para a atualiza\xE7\xE3o da olt-update-firmware</span>:\n            <span class="label-content">{{vmOltUpdateFirmware.modelFirmware.oltName}}</span>\n        </div>\n        <div class="row">\n            <div class="modal-col col-xs-24">\n                <div class="label-table">\n                    <span data-translate="oltUpdateFirmware.files">Arquivos</span>:\n                </div>\n                <div class="container-scroll" ng-scrollbars>\n                    <table class="table table-hover">\n                        <tbody>\n                            <tr ng-repeat="item in vmOltUpdateFirmware.modelFirmware.files" ng-class="{active: item.checked}"\n                                ng-click="item.checked = !item.checked">\n                                <td>\n                                    <label class="checkbox-select-item checkbox-select-equipment"\n                                           ng-class="{checked: item.checked,\n                                                      invalid: vmOltUpdateFirmware.formUpdateOlt.$submitted && !vmOltUpdateFirmware.selectedFiles.length}">\n                                        <input type="checkbox" name="file" ng-model="item.checked">\n                                    </label>\n                                </td>\n                                <td>{{item.name}}</td>\n                            </tr>\n                        </tbody>\n                    </table>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default btn-modal-lg" ng-disabled="oltUpdateFirmware.requestRunning" ng-click="vmOltUpdateFirmware.close()" data-translate="global.button.cancel">Cancelar</button>\n        <button type="submit" class="btn btn-primary btn-modal-lg btn-main-action" ng-disabled="oltUpdateFirmware.requestRunning" data-translate="global.button.update">Atualizar</button>\n    </div>\n</form>');
$templateCache.put('app/components/olt/olt-upload-tftp.html','<div class="modal-header">\n    <button type="button" class="close" ng-click="vmOltUploadTftp.close()"><span aria-hidden="true">&times;</span></button>\n    <h4 class="modal-title" id="update-olt-label" data-translate="oltUploadTftp.uploadTftpFile">Carregar Arquivo TFTP</h4>\n</div>\n<form class="form-update-firmware" name="vmOltUploadTftp.formUploadTftp" ng-submit="vmOltUploadTftp.uploadFileName()" novalidate>\n    <div class="modal-body modal-update-firmware">\n        <div class="label-description">\n            <span data-translate="oltUploadTftp.selectLabel.{{vmOltUploadTftp.description}}">Informe o nome do arquivo para upload</span>:\n            <span class="label-content">{{vmOltUploadTftp.modelUpload.oltName}}</span>\n        </div>\n        <div class="row">\n            <div class="modal-col col-xs-24">\n                <div class="form-group">\n                    <label for="search-name" class="search-label control-label"><span data-translate="oltUploadTftp.name">Nome</span>:</label>\n                    <input class="search-input form-control" type="text" id="search-name"\n                           maxlength="20" placeholder="{{\'oltUploadTftp.placeholder.fileName\'| translate}}"\n                           ng-model="vmOltUploadTftp.modelUpload.fileName">\n                 </div>\n            </div>\n        </div>\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default btn-modal-lg" ng-disabled="oltUploadTftp.requestRunning" ng-click="vmOltUploadTftp.close()" data-translate="global.button.cancel">Cancelar</button>\n        <button type="submit" class="btn btn-primary btn-modal-lg btn-main-action" ng-disabled="oltUploadTftp.requestRunning" data-translate="global.button.submit">Enviar</button>\n    </div>\n</form>');
$templateCache.put('app/components/olt/olts.html','<div\n    class="col-container container-olt"\n    ng-if="vmOlt.hasOltOrSearch()"\n    ng-class="{\'panel-open\': panelIsVisible}"\n    ng-controller="RelatorioSchedulerController as relatorioVm"\n    >\n    <div ng-include="\'app/components/relatorio/relatorio.html\'"></div>\n    <div class="col-search">\n        <button\n            id="btn-add-olt"\n            class="btn btn-primary btn-block btn-add-olt"\n            ng-click="vmOlt.addOlt()"\n            has-authority="oltAdd"\n            has-behavior="disable-button"\n            >\n            <span class="icon icon-plus"></span>\n            <span data-translate="olt.add">Adicionar OLT</span>\n        </button>\n        <div ui-view="search" class="panel-search"></div>\n        <div ui-view="favorites"></div>\n    </div>\n    <div class="col-list" has-authority="oltList">\n        <div ui-view="list" class="container-list"></div>\n    </div>\n    <div class="col-detail" ng-if="panelIsVisible">\n        <div ui-view="detail" class="panel-detail" ng-if="vmOlt.data.detail"></div>\n        <div ui-view="management" class="panel-management" ng-if="!vmOlt.data.detail"></div>\n    </div>\n</div>\n<div ng-if="vmOlt.hasNoOlt()" class="col-add">\n    <button\n        id="btn-primary"\n        ng-click="vmOlt.addOlt()"\n        class="btn btn-primary btn-block btn-add-olt"\n        has-authority="oltAdd"\n        has-behavior="disable-button"\n        >\n        <span class="icon icon-plus"></span>\n        <span data-translate="olt.add">Adicionar OLT</span>\n    </button>\n</div>\n');
$templateCache.put('app/components/packet-rule/packet-rule-add.html','<div class="modal-header">\n    <button type="button" class="close" ng-click="vmPacketRuleAdd.close()"><span aria-hidden="true">&times;</span></button>\n    <h4 class="modal-title" id="add-packet-rule-label" data-translate="packetRule.modal.{{vmPacketRuleAdd.modalTitle}}">Criar Regra de Pacote</h4>\n</div>\n<form class="form-horizontal form-modal form-packet-rules" name="vmPacketRuleAdd.formPacketRuleAdd" ng-submit="vmPacketRuleAdd.save()" novalidate >\n    <div class="modal-body">\n\n        <div class="form-group">\n            <label class="col-xs-8 control-label" for="rule-name"><span data-translate="packetRule.modal.rule">Regra</span>:*</label>\n            <div class="col-xs-16">\n                <input type="text" class="form-control field-rule-name" id="rule-name" name="ruleName" ng-model="vmPacketRuleAdd.packetRuleModel.name"\n                       placeholder="{{\'packetRule.modal.placeholder.ruleName\'| translate}}" required\n                       uib-tooltip="{{\'tooltip.packetRuleName\'| translate}}"\n                       tooltip-trigger="focus" tooltip-placement="right" tooltip-enable="vmPacketRuleAdd.formPacketRuleAdd.ruleName.$invalid"\n                       tooltip-is-open="vmPacketRuleAdd.formPacketRuleAdd.ruleName.$invalid && !vmPacketRuleAdd.formPacketRuleAdd.ruleName.$error.required">\n            </div>\n        </div>\n\n        <div class="form-group">\n            <label class="col-xs-8 control-label" for="olt"><span data-translate="packetRule.modal.olt">OLT</span>:*</label>\n            <div class="col-xs-16">\n                <ui-select name="oltName" ng-model="vmPacketRuleAdd.packetRuleModel.olt" on-select="vmPacketRuleAdd.changeOlt($item)" search-enabled="false"\n                           ng-if="!vmPacketRuleAdd.isEdit" required>\n                    <ui-select-match placeholder="{{\'global.common.select\'| translate}}">{{vmPacketRuleAdd.packetRuleModel.olt.name}}</ui-select-match>\n                    <ui-select-choices repeat="olt in vmPacketRuleAdd.arrayOlts">{{olt.name}}</ui-select-choices>\n                </ui-select>\n                <input type="text" class="form-control" ng-model="vmPacketRuleAdd.packetRuleModel.olt.name" ng-if="vmPacketRuleAdd.isEdit" readonly>\n            </div>\n        </div>\n\n        <div class="form-group">\n            <label class="col-xs-8 control-label" for="group"><span data-translate="packetRule.modal.group">Grupo</span>:*</label>\n            <div ng-if="!vmPacketRuleAdd.isEdit">\n                <div class="col-xs-8">\n                    <ui-select name="group" ng-model="vmPacketRuleAdd.packetRuleModel.group" on-select="vmPacketRuleAdd.changeGroup()"\n                               search-enabled="false" required ng-disabled="!vmPacketRuleAdd.packetRuleModel.olt">\n                        <ui-select-match placeholder="{{\'global.common.select\'| translate}}">{{vmPacketRuleAdd.packetRuleModel.group.groupIdEquipment}}</ui-select-match>\n                        <ui-select-choices repeat="group in vmPacketRuleAdd.arrayGroups">{{group.groupIdEquipment}}</ui-select-choices>\n                    </ui-select>\n                </div>\n                <div class="col-xs-8">\n                    <input name="newGroup" type="number" step="1" min="0" max="{{vmPacketRuleAdd.packetRuleModel.newGroup.max}}" class="form-control input-group" placeholder="{{\'packetRule.modal.placeholder.number\'| translate}}"\n                           pattern="\\d+" ng-required="!vmPacketRuleAdd.groupDisabled" ng-model="vmPacketRuleAdd.packetRuleModel.newGroup.value"\n                           ng-hide="vmPacketRuleAdd.groupDisabled" uib-tooltip="{{vmPacketRuleAdd.packetRuleModel.newGroup.tooltip}}"\n                           tooltip-enable="vmPacketRuleAdd.formPacketRuleAdd.newGroup.$invalid" tooltip-trigger="focus" tooltip-placement="right"\n                           tooltip-is-open="vmPacketRuleAdd.formPacketRuleAdd.newGroup.$invalid && !vmPacketRuleAdd.formPacketRuleAdd.newGroup.$error.required">\n                </div>\n            </div>\n            <div class="col-xs-16">\n                <input type="number" class="form-control" ng-model="vmPacketRuleAdd.packetRuleModel.groupIdEquipment" ng-if="vmPacketRuleAdd.isEdit" readonly>\n            </div>\n        </div>\n\n        <div class="form-group">\n            <label class="col-xs-8 control-label" for="member"><span data-translate="packetRule.modal.member">Membro</span>:*</label>\n            <div class="col-xs-16">\n                <input type="number" step="1" min="0" max="{{vmPacketRuleAdd.packetRuleModel.member.max}}" class="form-control" placeholder="{{\'packetRule.modal.placeholder.number\'| translate}}"\n                       pattern="\\d+" ng-disabled="!vmPacketRuleAdd.packetRuleModel.olt || vmPacketRuleAdd.isEdit" pattern="\\d+"\n                       id="member" name="member" ng-model="vmPacketRuleAdd.packetRuleModel.member.value" uib-tooltip="{{vmPacketRuleAdd.packetRuleModel.member.tooltip}}"\n                       tooltip-enable="vmPacketRuleAdd.formPacketRuleAdd.member.$invalid" tooltip-trigger="focus" tooltip-placement="right"\n                       tooltip-is-open="vmPacketRuleAdd.formPacketRuleAdd.member.$invalid && !vmPacketRuleAdd.formPacketRuleAdd.member.$error.required" required>\n            </div>\n        </div>\n\n        <div class="form-group">\n            <label class="col-xs-8 control-label" for="type"><span data-translate="packetRule.modal.type">Tipo</span>:*</label>\n            <div class="col-xs-16">\n                <ui-select name="type" ng-model="vmPacketRuleAdd.packetRuleModel.type" on-select="vmPacketRuleAdd.changeType($item)" search-enabled="false"\n                           required ng-disabled="!vmPacketRuleAdd.packetRuleModel.olt">\n                    <ui-select-match placeholder="{{\'global.common.select\'| translate}}">{{vmPacketRuleAdd.packetRuleModel.type.label}}</ui-select-match>\n                    <ui-select-choices repeat="ruleType in vmPacketRuleAdd.arrayTypes">{{ruleType.label}}</ui-select-choices>\n                </ui-select>\n            </div>\n        </div>\n\n        <div ng-if="vmPacketRuleAdd.packetRuleModel.type">\n            <div class="form-group" ng-repeat="index in vmPacketRuleAdd.values">\n                <label class="col-xs-14 control-label" for="value">{{index}}:</label>\n                <div class="col-xs-10">\n                    <input type="text" class="form-control" id="value" name="value" placeholder="{{\'packetRule.modal.placeholder.value\'| translate}}"\n                           ng-model="vmPacketRuleAdd.packetRuleModel.values[index]"\n                           ng-disabled="!vmPacketRuleAdd.packetRuleModel.type">\n                </div>\n            </div>\n        </div>\n\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default btn-cancel" ng-click="vmPacketRuleAdd.close()" ng-disabled="vmPacketRuleAdd.requestRunning" data-translate="global.button.cancel"></button>\n        <button type="submit" class="btn btn-primary btn-add" ng-disabled="vmPacketRuleAdd.requestRunning" data-translate="global.button.{{vmPacketRuleAdd.labelButton}}">Salvar</button>\n    </div>\n\n</form>\n');
$templateCache.put('app/components/packet-rule/packet-rule-confirm.html','<div class="modal-header">\n    <button type="button" class="close" ng-click="vmPacketRulesConfirm.close()"><span aria-hidden="true">&times;</span></button>\n    <h4 class="modal-title" id="label-confirm" data-translate="packetRulesConfirm.{{vmPacketRulesConfirm.action}}.title">{{action}} Regra de Pacote</h4>\n</div>\n<div class="modal-body modal-content-confirm">\n    <p data-translate="packetRulesConfirm.{{vmPacketRulesConfirm.action}}.message.question.questionOne" data-translate-values="vmPacketRulesConfirm.packetRuleData">Voc\xEA deseja realmente {{action}} a regra de pacote xxxx ?</p>\n</div>\n<div class="modal-footer modal-footer-confirm">\n    <button type="button" class="btn btn-default btn-cancel" ng-click="vmPacketRulesConfirm.close()" ng-disabled="vmPacketRulesConfirm.requestRunning" data-translate="global.button.cancel">Cancelar</button>\n    <button type="submit" class="btn btn-primary btn-del" ng-click="vmPacketRulesConfirm.confirmAction()" ng-disabled="vmPacketRulesConfirm.requestRunning" data-translate="packetRulesConfirm.{{vmPacketRulesConfirm.action}}.btnConfirm">Action</button>\n</div>\n');
$templateCache.put('app/components/packet-rule/packet-rule-list.html','<div class="panel panel-default panel-list" has-authority="packetRuleList" has-behavior="hide">\n\n    <div class="panel-heading">\n        <div class="container-title">\n            <span class="panel-title" data-translate="packetRule.title">REGRAS DE PACOTE</span>\n            <div class="pull-right">\n                <div class="btn-circle btn-circle-plus"\n                     uib-tooltip-html="vmPacketRuleList.view.tooltip"\n                     tooltip-placement="bottom"\n                     tooltip-append-to-body="true"\n                     ng-click="vmPacketRuleList.addPacketRule()"\n                     has-authority="packetRuleAdd" has-behavior="disable-button">\n                    +\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class="panel-body" loader-section="vmPacketRuleList.requestRunning">\n        <div class="container-scroll" ng-scrollbars>\n            <ul class="list list-provisioning list-packet-rule">\n                <li class="list-item" ng-repeat="packetRuleItem in vmPacketRuleList.packetRuleList" ng-class="{opened: !packetRuleItem.collapsed}">\n                    <div class="list-item-collapse" ng-click="vmPacketRuleList.toggle(packetRuleItem.id)">\n                      <span class="list-item-action icon icon-arrow-select-list"></span>\n                        <div class="list-item-info">\n                            <div class="list-item-name">{{packetRuleItem.name}}</div>\n                            <div class="list-item-menu" stop-propagation>\n                                <div class="dropdown-default" uib-dropdown>\n                                    <button class="list-item-menu-btn" uib-dropdown-toggle>\n                                        <span class="icon icon-menu-more"></span>\n                                    </button>\n                                    <ul class="dropdown-menu dropdown-menu-right" uib-dropdown-menu>\n                                        <li>\n                                            <a ng-click="vmPacketRuleList.editPacketRule(packetRuleItem)" data-translate="packetRule.menu.edit"\n                                               has-authority="packetRuleEdit" has-behavior="disable-link">Editar</a>\n                                        </li>\n                                        <li>\n                                            <a ng-click="vmPacketRuleList.deletePacketRule(packetRuleItem)" data-translate="packetRule.menu.delete"\n                                               has-authority="packetRuleDelete" has-behavior="disable-link">Deletar</a>\n                                        </li>\n                                    </ul>\n                                </div>\n                            </div>\n                        </div>\n                        <div class="list-item-content">\n                            <span data-translate="packetRule.ruleType">Tipo de Regra</span>: {{packetRuleItem.type.label}}\n                        </div>\n                    </div>\n\n                    <div class="list-item-detail" uib-collapse="!packetRuleItem.opened" collapsed="packetRuleItem.collapsed=true"\n                         expanding="packetRuleItem.collapsed=false" expanded="packetRuleItem.collapsed=false">\n                        <div class="list-item-detail-content">\n                            <div class="container-info row">\n                                <div class="col-xs-12 item-label"><span data-translate="packetRule.group">Grupo</span>/<span data-translate="packetRule.member">Membro</span>:</div>\n                                <span class="col-xs-12 item-value">{{packetRuleItem.groupIdEquipment}} / {{packetRuleItem.member}} </span>\n                            </div>\n                            <div class="container-info row">\n                                <div class="col-xs-12 item-label"><span data-translate="packetRule.ruleType">Tipo de Regra</span>:</div>\n                                <span class="col-xs-12 item-value">{{packetRuleItem.type.label}}</span>\n                            </div>\n                            <div class="container-info row" ng-repeat="value in packetRuleItem.values">\n                                <div class="col-xs-13 item-label">{{value.name}}:</div>\n                                <span class="col-xs-11 item-value">{{value.value}}</span>\n                            </div>\n                        </div>\n                    </div>\n                </li>\n            </ul>\n            <div class="list-empty" data-translate="packetRule.emptyList" ng-if="vmPacketRuleList.isListEmpty()">Nenhuma Regra de Pacote encontrada.</div>\n            <div class="list-loading" data-translate="packetRule.loadingList" ng-if="vmPacketRuleList.requestRunning">Aguarde, carregando Regras de Pacotes ...</div>\n            <div class="list-empty" data-translate="packetRule.loadingListError" ng-if="vmPacketRuleList.hasErrorList()">Ocorreu um erro ao buscar pelas Regras de Pacote. Por favor, atualize a lista.</div>\n        </div>\n    </div>\n\n</div>');
$templateCache.put('app/components/provisioning/provisioning-filter.html','<section class="filter-section form-horizontal">\n    <form>\n        <div class="row">\n            <div class="form-group col-xs-12">\n                <label class="filter-label">OLT:</label>\n                <div class="container-input">\n                    <div class="bg-select-primary">\n                        <ui-select name="filter-olt" ng-model="vmProvisioningFilter.selected.olt" \n                                   search-enabled="false" ng-disabled="!vmProvisioningFilter.listOlts.length">\n                            <ui-select-match placeholder="{{vmProvisioningFilter.placeholder.olt| translate}}" allow-clear="true">{{vmProvisioningFilter.selected.olt.name}}</ui-select-match>\n                            <ui-select-choices repeat="item in vmProvisioningFilter.listOlts">{{item.name}}</ui-select-choices>\n                        </ui-select>\n                    </div>\n                </div>    \n\n                <label class="filter-label">Porta:</label>\n                <div class="container-input">\n                    <div class="bg-select-primary">\n                        <ui-select name="filter-onu" ng-model="vmProvisioningFilter.porta" search-enabled="false" ng-disabled="!vmProvisioningFilter.listGponPortas.length">\n                            <ui-select-match>{{vmProvisioningFilter.porta.value}}</ui-select-match>\n                            <ui-select-choices repeat="item in vmProvisioningFilter.listGponPortas">{{item.value}}</ui-select-choices>\n                        </ui-select>\n                    </div>\n                </div>\n\n                <label class="filter-label">ONU:</label>\n                <div class="container-input">\n                    <div class="bg-select-primary">\n                        <input class="search-input form-control" type="text" id="search-name" name="searchName"\n                            maxlength="20" placeholder="{{\'global.search.placeholder.onuName\'| translate}}"\n                            ng-model="vmProvisioningFilter.onuName"\n                            uib-tooltip="Preenchimento pode ser total ou parcial, somente ONU\'s autorizadas tem nome."\n                            tooltip-trigger="focus" tooltip-placement="right">\n                    </div>\n                </div>\n\n                <div class="col-xs-6 btns-filter">\n                    <button type="button" class="btn btn-default btn-filter-sm" data-translate="global.button.clear" ng-click="vmProvisioningFilter.clear()">Limpar</button>\n                    <button type="submit" class="btn btn-primary btn-apply btn-filter-sm" data-translate="global.button.apply" ng-click="vmProvisioningFilter.filter()">Aplicar</button>\n                </div>\n            </div>\n        </div>\n    </form>\n</section>');
$templateCache.put('app/components/provisioning/provisioning.html','<div class="container-primary col-xs-24">\n    <div ui-view="filter" class=""></div>\n</div>\n<div class="col-container container-secondary container-provisioning">\n    <div class="col-list">\n        <div ui-view="bridge" class="container-list"></div>\n    </div>\n    <div class="col-list">\n        <div ui-view="gtp" class="container-list"></div>\n    </div>\n    <div class="col-list">\n        <div ui-view="packetRule" class="container-list"></div>\n    </div>\n</div>');
$templateCache.put('app/components/onu/onu-authorize.html','<div class="modal-header">\n    <button type="button" class="close" ng-click="vmAuthorizeOnu.close()">\n        <span aria-hidden="true">&times;</span>\n    </button>\n    <h4 class="modal-title" id="authorize-onu-label"\n        data-translate="onuEdit.authorizeOnu">Autorizar ONU</h4>\n</div>\n<form class="form-horizontal form-modal"\n      name="vmAuthorizeOnu.formAuthorizeOnu" novalidate>\n    <div class="modal-body">\n        <div class="form-group">\n            <label class="col-xs-12 control-label" for="field-onu-name"><span\n                    data-translate="onuEdit.onuName">Nome da ONU</span>: *</label>\n            <div class="col-xs-12">\n                <input type="text" class="form-control field-onu-name"\n                       id="field-onu-name" name="onuName"\n                       ng-model="vmAuthorizeOnu.dataOnu.name" maxlength="35"\n                       placeholder="{{\'onuEdit.placeholder.onuName\'|translate}}" required\n                       uib-tooltip="{{\'tooltip.onuName\'| translate}}"\n                       tooltip-trigger="focus"\n                       tooltip-enable="vmAuthorizeOnu.formAuthorizeOnu.onuName.$invalid"\n                       tooltip-is-open="vmAuthorizeOnu.formAuthorizeOnu.onuName.$invalid && !vmAuthorizeOnu.formAuthorizeOnu.onuName.$error.required"\n                       tooltip-placement="right">\n            </div>\n        </div>\n\n        <div class="form-group" ng-if="vmAuthorizeOnu.dataOnu.model !== \'\'">\n            <label class="col-xs-12 control-label" for="field-me-profile"><span\n                    data-translate="onuEdit.model">Modelo</span>:</label>\n            <div class="col-xs-12">\n                <input type="text" class="form-control" id="field-me-profile"\n                       ng-model="vmAuthorizeOnu.dataOnu.model" readonly>\n            </div>\n        </div>\n\n        <div class="form-group" ng-if="vmAuthorizeOnu.dataOnu.model === \'\'">\n            <label class="col-xs-12 control-label" for="field-me-profile"><span\n                    data-translate="onuEdit.model">Modelo</span>: *</label>\n            <div class="col-xs-12">\n                <ui-select name="field-me-profile"\n                           ng-model="vmAuthorizeOnu.dataOnu.model" search-enabled="false"\n                           ng-disabled="!vmAuthorizeOnu.modelList.length"> <ui-select-match\n                        placeholder="{{\'global.common.loading\'| translate}}...">{{vmAuthorizeOnu.dataOnu.model}}</ui-select-match>\n                    <ui-select-choices repeat="item in vmAuthorizeOnu.modelList">{{item}}</ui-select-choices>\n                </ui-select>\n            </div>\n        </div>\n\n        <div class="form-group onu-authorize">\n            <label class="col-xs-12 control-label" for="field-slot-gpon"><span\n                    data-translate="onuEdit.slotGpon">Slot Gpon</span>: *</label>\n            <div class="col-xs-12">\n                <ui-select name="bridge-multicastlist"\n                           ng-model="vmAuthorizeOnu.dataOnu.gponSlot" search-enabled="false"\n                           ng-disabled="!vmAuthorizeOnu.gponSlotList.length"> <ui-select-match\n                        placeholder="{{\'global.common.loading\'| translate}}...">{{vmAuthorizeOnu.dataOnu.gponSlot}}</ui-select-match>\n                    <ui-select-choices repeat="item in vmAuthorizeOnu.gponSlotList">{{item}}</ui-select-choices>\n                </ui-select>\n            </div>\n        </div>\n\n        <div class="form-group">\n            <label class="col-xs-12 control-label"><span\n                    data-translate="onuEdit.connectedOLT">OLT Conectada</span>:</label>\n        </div>\n\n        <div class="form-group">\n            <label class="col-xs-12 control-label" for="field-olt-name"><span\n                    data-translate="onuEdit.oltName">Nome</span>:</label>\n            <div class="col-xs-12">\n                <input type="text" class="form-control" id="field-olt-name"\n                       ng-model="vmAuthorizeOnu.dataOnu.oltName" readonly>\n            </div>\n        </div>\n\n        <div class="form-group">\n            <label class="col-xs-12 control-label" for="field-olt-ip"><span\n                    data-translate="onuEdit.ip">IP</span>:</label>\n            <div class="col-xs-12">\n                <input type="text" class="form-control" id="field-olt-ip"\n                       ng-model="vmAuthorizeOnu.dataOnu.oltIp" readonly>\n            </div>\n        </div>\n\n        <div class="form-group">\n            <label class="col-xs-12 control-label" for="field-olt-mac"><span\n                    data-translate="onuEdit.mac">MAC</span>:</label>\n            <div class="col-xs-12">\n                <input type="text" class="form-control" id="field-olt-mac"\n                       ng-model="vmAuthorizeOnu.dataOnu.oltMacAddress" readonly>\n            </div>\n        </div>\n\n        <div class="form-group">\n            <label class="col-xs-12 control-label" for="field-olt-port"><span\n                    data-translate="onuEdit.port">Porta</span>:</label>\n            <div class="col-xs-12">\n                <input type="text" class="form-control" id="field-olt-port"\n                       ng-model="vmAuthorizeOnu.dataOnu.gponPort" readonly>\n            </div>\n        </div>\n    </div>\n\n    <div class="modal-footer modal-footer-authorize">\n        <button type="button" class="btn btn-default"\n                ng-click="vmAuthorizeOnu.close()"\n                ng-disabled="vmAuthorizeOnu.postRunning"\n                data-translate="onuEdit.btn.cancel">Cancelar</button>\n        <button type="submit" class="btn btn-primary btn-main-action"\n                ng-click="vmAuthorizeOnu.authorize(vm.configure)"\n                ng-disabled="vmAuthorizeOnu.requestRunning || vmAuthorizeOnu.postRunning || vmAuthorizeOnu.dataOnu.gponSlot === \'--\'"\n                data-translate="onuEdit.btn.authorize">Autorizar</button>\n    </div>\n</form>');
$templateCache.put('app/components/onu/onu-config-access.html','<div class="modal-header">\n    <button type="button" class="close" ng-click="vmConfigAccessOnu.close()"><span aria-hidden="true">&times;</span></button>\n    <h4 class="modal-title" id="authorize-onu-label" data-translate="onuEdit.configAccessOnu">Configurar Acesso ONU</h4>\n</div>\n<form class="form-horizontal form-modal" name="vmConfigAccessOnu.formConfigAccessOnu" ng-submit="vmConfigAccessOnu.save()" novalidate>\n    <div class="modal-body">\n        <div class="form-group">\n            <label class="col-xs-12 control-label"><span data-translate="onuEdit.onuName">Nome da ONU</span>:</label>\n            <div class="col-xs-12">\n                <input type="text" class="form-control" ng-value="::vmConfigAccessOnu.dataOnu.name" readonly>\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-xs-12 control-label"><span data-translate="onuEdit.model">Modelo</span>:</label>\n            <div class="col-xs-12">\n                <input type="text" class="form-control" ng-value="::vmConfigAccessOnu.dataOnu.meProfile" readonly>\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-xs-12 control-label"><span data-translate="onuEdit.slotGpon">Slot Gpon</span>:</label>\n            <div class="col-xs-12">\n                <input type="text" class="form-control" ng-value="::vmConfigAccessOnu.dataOnu.gponSlot" readonly>\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-xs-24 control-label"><span data-translate="onuEdit.connectedOLT">OLT Conectada</span>:</label>\n        </div>\n        <div class="form-group">\n            <label class="col-xs-12 control-label"><span data-translate="onuEdit.oltName">Nome</span>:</label>\n            <div class="col-xs-12">\n                <input type="text" class="form-control" ng-value="::vmConfigAccessOnu.dataOnu.oltName" readonly>\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-xs-12 control-label"><span data-translate="onuEdit.port">Porta</span>:</label>\n            <div class="col-xs-12">\n                <input type="text" class="form-control" ng-value="::vmConfigAccessOnu.dataOnu.gponPort" readonly>\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-xs-12 control-label" for="field-onu-access-user"><span data-translate="onuEdit.accessUser">Usu\xE1rio de acesso</span>: *</label>\n            <div class="col-xs-12">\n                <input type="text" class="form-control" id="field-onu-access-user" name="onuAccessUser" ng-model="vmConfigAccessOnu.dataOnu.accessUser"\n                       maxlength="20" placeholder="{{\'onuEdit.placeholder.user\'| translate}}" required\n                       uib-tooltip="{{\'tooltip.accessUser\'| translate}}"\n                       tooltip-trigger="focus"\n                       tooltip-enable="vmConfigAccessOnu.formConfigAccessOnu.onuAccessUser.$invalid"\n                       tooltip-is-open="vmConfigAccessOnu.formConfigAccessOnu.onuAccessUser.$invalid && !vmConfigAccessOnu.formConfigAccessOnu.onuAccessUser.$error.required"\n                       tooltip-placement="right">\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-xs-12 control-label" for="field-onu-access-password"><span data-translate="onuEdit.accessPassword">Senha de acesso</span>: *</label>\n            <div class="col-xs-12">\n                <input type="password" class="form-control" id="field-onu-access-password" name="onuAccessPassword" ng-model="vmConfigAccessOnu.dataOnu.accessPassword"\n                       maxlength="20" placeholder="{{\'onuEdit.placeholder.password\'| translate}}" required autocomplete="new-password"\n                       uib-tooltip="{{\'tooltip.accessPassword\'| translate}}"\n                       tooltip-trigger="focus"\n                       tooltip-enable="vmConfigAccessOnu.formConfigAccessOnu.onuAccessPassword.$invalid"\n                       tooltip-is-open="vmConfigAccessOnu.formConfigAccessOnu.onuAccessPassword.$invalid && !vmConfigAccessOnu.formConfigAccessOnu.onuAccessPassword.$error.required"\n                       tooltip-placement="right">\n            </div>\n        </div>\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default" ng-click="vmConfigAccessOnu.close()" ng-disabled="vmConfigAccessOnu.requestRunning"\n                data-translate="global.button.cancel">\n            Cancelar\n        </button>\n        <button type="submit" class="btn btn-primary btn-main-action" ng-disabled="vmConfigAccessOnu.requestRunning" data-translate="global.button.update">\n            Atualizar\n        </button>\n    </div>\n</form>\n');
$templateCache.put('app/components/onu/onu-config.html','<div class="modal-header">\n    <button type="button" class="close" ng-click="vmConfigOnu.close()"><span aria-hidden="true">&times;</span></button>\n    <h4 class="modal-title" id="config-onu-label" data-translate="onuConfig.configOnu">Configurar ONU</h4>\n</div>\n<div class="modal-config-onu">\n    <form class="form-horizontal form-modal" name="vmConfigOnu.formSettingsWifi" ng-submit="vmConfigOnu.saveSettingsWifi()" novalidate>\n        <div class="modal-body">\n            <div class="row">\n                <div class="modal-col col-xs-12">\n                    <div class="content-block content-initial">\n                        <div class="form-group">\n                            <label class="col-xs-12 control-label"><span data-translate="onuConfig.bandwidth">Largura de Banda</span>:</label>\n                            <div class="col-xs-12">\n                                <ui-select name="band-width" ng-model="vmConfigOnu.data.bandwidth" search-enabled="false" ng-disabled="vmConfigOnu.requestRunning">\n                                    <ui-select-match>{{vmConfigOnu.data.bandwidth}} MHz</ui-select-match>\n                                    <ui-select-choices repeat="bandwidth in vmConfigOnu.bandwidthList">{{bandwidth}} MHz</ui-select-choices>\n                                </ui-select>\n                            </div>\n                        </div>\n                        <div class="form-group">\n                            <label class="col-xs-12 control-label"><span data-translate="onuConfig.channel">Canal</span>:</label>\n                            <div class="col-xs-12">\n                                <ui-select name="channel" ng-model="vmConfigOnu.data.channel" search-enabled="false" ng-disabled="vmConfigOnu.requestRunning">\n                                    <ui-select-match>{{vmConfigOnu.data.channel}}</ui-select-match>\n                                    <ui-select-choices repeat="channel in vmConfigOnu.channelList">{{channel}}</ui-select-choices>\n                                </ui-select>\n                            </div>\n                        </div>\n                        <div class="form-group">\n                            <label class="col-xs-12 control-label"><span data-translate="onuConfig.sideband">Canal de Extens\xE3o</span>:</label>\n                            <div class="col-xs-12">\n                                <ui-select name="extension-channel" ng-model="vmConfigOnu.data.sideband" search-enabled="false" ng-disabled="vmConfigOnu.requestRunning">\n                                    <ui-select-match>{{\'onuConfig.\' + vmConfigOnu.data.sideband.label| translate }}</ui-select-match>\n                                    <ui-select-choices repeat="sideband in vmConfigOnu.sidebandList">{{\'onuConfig.\' + sideband.label| translate}}</ui-select-choices>\n                                </ui-select>\n                            </div>\n                        </div>\n                        <div class="form-group">\n                            <label class="col-xs-12 control-label label-slider"><span data-translate="onuConfig.power">Pot\xEAncia</span>:</label>\n                            <div class="col-xs-12">\n                                <rzslider rz-slider-model="vmConfigOnu.data.power" rz-slider-options="vmConfigOnu.slider.options"></rzslider>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n                <div class="modal-col col-xs-12">\n                    <div class="form-group combo-title">\n                        <label class="col-xs-8 control-label onu-config-label">\n                            <span data-translate="onuConfig.ssid">SSID</span>:\n                        </label>\n                        <div class="text-right">\n                            <div class="col-xs-4 col-radio radio-options" ng-repeat="ssid in vmConfigOnu.data.ssids">\n                                <span class="status-item-value">\n                                    <label class="radio" ng-class="{checked: vmConfigOnu.data.ssidActive == $index, disabled: vmConfigOnu.requestRunning }">\n                                        <input type="radio" id="ssid{{ssid.ssid}}" name="ssid" ng-model="vmConfigOnu.data.ssidActive" ng-value="$index"\n                                               ng-change="vmConfigOnu.setSsid($index)" ng-disabled="vmConfigOnu.requestRunning">\n                                    </label>\n                                </span>\n                                <label for="ssid{{ssid.ssid}}" class="status-item-label"\n                                       ng-class="{active: vmConfigOnu.data.ssids[$index].enable, invalid: vmConfigOnu.checkSsidInvalid($index)}">\n                                    {{ssid.ssid}}\n                                </label>\n                            </div>\n                        </div>\n                    </div>\n                    <div class="content-block">\n                        <div class="form-group">\n                            <label class="col-xs-12 control-label"><span data-translate="onuConfig.enable">Habilitar</span>:</label>\n                            <div class="col-xs-12 col-switch">\n                                <switch id="enabled-ap" name="enabled-ap" ng-model="vmConfigOnu.data.ssids[vmConfigOnu.data.ssidActive].enable" disabled="vmConfigOnu.requestRunning"></switch>\n                            </div>\n                        </div>\n                        <div class="form-group">\n                            <label class="col-xs-8 control-label"><span data-translate="onuConfig.name">Nome</span>:</label>\n                            <div class="col-xs-16">\n                                <input type="text" class="form-control" name="name" ng-model="vmConfigOnu.data.ssids[vmConfigOnu.data.ssidActive].name" ng-disabled="vmConfigOnu.requestRunning"\n                                       placeholder="{{\'onuConfig.placeholder.ssid\'| translate}}" required maxlength="32">\n                            </div>\n                        </div>\n                        <div class="form-group">\n                            <label class="col-xs-12 control-label"><span data-translate="onuConfig.securityMode">Modo de Seguran\xE7a</span>:</label>\n                            <div class="col-xs-12">\n                                <ui-select name="security" ng-model="vmConfigOnu.data.ssids[vmConfigOnu.data.ssidActive].securityAuth" search-enabled="false"\n                                           on-select="vmConfigOnu.setSecurityAuth($item)" ng-disabled="vmConfigOnu.requestRunning" required>\n                                    <ui-select-match>{{\'onuConfig.\' + vmConfigOnu.data.ssids[vmConfigOnu.data.ssidActive].securityAuth.label| translate}}</ui-select-match>\n                                    <ui-select-choices repeat="securityAuth in vmConfigOnu.securityAuthList">{{\'onuConfig.\' + securityAuth.label| translate}}</ui-select-choices>\n                                </ui-select>\n                            </div>\n                        </div>\n                        <div class="form-group">\n                            <label class="col-xs-12 control-label"><span data-translate="onuConfig.securityEncrypt">Modo de Criptografia</span>:</label>\n                            <div class="col-xs-12">\n                                <ui-select name="encryption" ng-model="vmConfigOnu.data.ssids[vmConfigOnu.data.ssidActive].securityEncrypt" search-enabled="false"\n                                           ng-disabled="!vmConfigOnu.data.ssids[vmConfigOnu.data.ssidActive].securityAuth || vmConfigOnu.requestRunning"\n                                           ng-required="vmConfigOnu.data.ssids[vmConfigOnu.data.ssidActive].securityAuth.value != \'OPEN\'">\n                                    <ui-select-match>{{vmConfigOnu.data.ssids[vmConfigOnu.data.ssidActive].securityEncrypt.label}}</ui-select-match>\n                                    <ui-select-choices repeat="securityEncrypt in vmConfigOnu.getSecurityEncryptList()">\n                                        {{securityEncrypt.label}}\n                                    </ui-select-choices>\n                                </ui-select>\n                            </div>\n                        </div>\n                        <div class="form-group">\n                            <label class="col-xs-12 control-label"><span data-translate="onuConfig.password">Senha Wifi</span>:</label>\n                            <div class="col-xs-12">\n                                <input type="password" class="form-control" name="password-wifi" ng-model="vmConfigOnu.data.ssids[vmConfigOnu.data.ssidActive].password"\n                                       placeholder="{{\'onuConfig.placeholder.password\'| translate}}" autocomplete="off" required ng-disabled="vmConfigOnu.requestRunning">\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class="modal-footer">\n            <button type="button" class="btn btn-default btn-cancel btn-modal-lg" ng-click="vmConfigOnu.close()" ng-disabled="vmConfigOnu.requestRunning"\n                    data-translate="global.button.cancel">Cancelar</button>\n            <button type="submit" class="btn btn-primary btn-modal-lg btn-main-action" ng-disabled="vmConfigOnu.requestRunning" data-translate="global.button.save">Salvar</button>\n        </div>\n    </form>\n</div>\n');
$templateCache.put('app/components/onu/onu-confirm.html','<div class="modal-header">\n    <button type="button" class="close close-delete" ng-click="vmOnuConfirm.close()"><span aria-hidden="true">&times;</span></button>\n    <h4 class="modal-title" id="del-one-olt-label" data-translate="onuConfirm.{{vmOnuConfirm.action}}.title">Confirma\xE7\xE3o OLT</h4>\n</div>\n<div class="modal-body modal-content-confirm" ng-scrollbars>\n    <div ng-if="vmOnuConfirm.itemOne" data-translate="onuConfirm.{{vmOnuConfirm.action}}.message.question.questionOneOnu" data-translate-values="vmOnuConfirm.onuData">\n        Voc\xEA deseja realmente {{action}} a ONU xxxx ?\n    </div>\n    <div ng-if="!vmOnuConfirm.itemOne" data-translate="onuConfirm.{{vmOnuConfirm.action}}.message.question.questionManyOnus" data-translate-values="vmOnuConfirm.onuData">\n        Foram selecionadas <span>XX</span> ONUs <span>string, string, string, string, string, string</span>, deseja <span>deletar</span>?\n    </div>\n</div>\n<div class="modal-footer modal-footer-confirm">\n    <button type="button" class="btn btn-default btn-cancel" ng-click="vmOnuConfirm.close()" ng-disabled="vmOnuConfirm.requestRunning" data-translate="global.button.cancel">Cancelar</button>\n    <button type="submit" class="btn btn-primary btn-del" ng-click="vmOnuConfirm.confirmAction()" ng-disabled="vmOnuConfirm.requestRunning" data-translate="onuConfirm.{{vmOnuConfirm.action}}.btnConfirm">Action</button>\n</div>');
$templateCache.put('app/components/onu/onu-edit-authorized.html','<div class="modal-header">\n    <button type="button" class="close"\n            ng-click="vmEditAuthorizedOnu.close()">\n        <span aria-hidden="true">&times;</span>\n    </button>\n    <h4 class="modal-title" id="authorize-onu-label"\n        data-translate="onuEdit.editAuthorizedOnu">Autorizar ONU</h4>\n</div>\n<form class="form-horizontal form-modal"\n      name="vmEditAuthorizedOnu.formEditAuthorizedOnu"\n      ng-submit="vmEditAuthorizedOnu.update()" novalidate>\n    <div class="modal-body">\n        <div class="form-group">\n            <label class="col-xs-12 control-label" for="field-me-profile"><span\n                    data-translate="onuEdit.descrition">Descri\xE7\xE3o</span>:</label>\n            <div class="col-xs-26">\n                <input type="text" class="form-control field-onu-name"\n                       id="field-onu-description"\n                       ng-model="vmEditAuthorizedOnu.dataOnu.description" maxlength="80">\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-xs-12 control-label" for="field-onu-name"><span\n                    data-translate="onuEdit.onuName">Nome da ONU</span>: *</label>\n            <div class="col-xs-12">\n                <input type="text" class="form-control field-onu-name"\n                       id="field-onu-name" name="onuName"\n                       ng-model="vmEditAuthorizedOnu.dataOnu.name" maxlength="35"\n                       placeholder="{{\'onuEdit.placeholder.onuName\'|translate}}" required\n                       uib-tooltip="{{\'tooltip.onuName\'| translate}}"\n                       tooltip-trigger="focus"\n                       tooltip-enable="vmEditAuthorizedOnu.formEditAuthorizedOnu.onuName.$invalid"\n                       tooltip-is-open="vmEditAuthorizedOnu.formEditAuthorizedOnu.onuName.$invalid && !vmEditAuthorizedOnu.formEditAuthorizedOnu.onuName.$error.required"\n                       tooltip-placement="right">\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-xs-12 control-label" for="field-me-profile"><span\n                    data-translate="onuEdit.model">Modelo</span>:</label>\n            <div class="col-xs-12">\n                <span class="form-control" readonly>{{vmEditAuthorizedOnu.dataOnu.meProfile}}</span>\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-xs-12 control-label" for="field-slot-gpon"><span\n                    data-translate="onuEdit.slotGpon">Slot Gpon</span>: *</label>\n            <div class="col-xs-12">\n                <span class="form-control" readonly>{{vmEditAuthorizedOnu.dataOnu.gponSlot}}</span>\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-xs-12 control-label"><span\n                    data-translate="onuEdit.connectedOLT">OLT Conectada</span>:</label>\n        </div>\n        <div class="form-group">\n            <label class="col-xs-12 control-label" for="field-olt-name"><span\n                    data-translate="onuEdit.oltName">Nome</span>:</label>\n            <div class="col-xs-12" id="edit-input-nome">\n                <span class="form-control" readonly>{{vmEditAuthorizedOnu.dataOnu.oltName}}</span>\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-xs-12 control-label" for="field-olt-port"><span\n                    data-translate="onuEdit.port">Porta</span>:</label>\n            <div class="col-xs-12">\n                <span class="form-control" readonly>{{vmEditAuthorizedOnu.dataOnu.gponPort}}</span>\n            </div>\n        </div>\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default"\n                ng-click="vmEditAuthorizedOnu.close()"\n                ng-disabled="vmEditAuthorizedOnu.requestRunning"\n                data-translate="global.button.cancel">Cancelar</button>\n        <button type="submit" class="btn btn-primary btn-main-action"\n                ng-disabled="vmEditAuthorizedOnu.requestRunning"\n                data-translate="global.button.update">Atualizar</button>\n    </div>\n</form>\n');
$templateCache.put('app/components/onu/onu-info.html','<div class="modal-header">\n    <button type="button" class="close close-delete" ng-click="vmOnuInfo.close()"><span aria-hidden="true">&times;</span></button>\n    <h4 class="modal-title title-wait-message" id="info-onu-label" data-translate="onuInfo.{{vmOnuInfo.action}}.title">Informa\xE7\xE3o ONU</h4>\n</div>\n<div class="modal-body content-wait-message" ng-scrollbars>\n    <div data-translate="onuInfo.{{vmOnuInfo.action}}.message">\n        Importante!\n    </div>\n</div>');
$templateCache.put('app/components/onu/onu-list-authorized.html','<div class="panel panel-default panel-list panel-list-authorized" ng-class="{\'panel-expand\': vmListAuthorized.view.panelButton}" has-authority="onuList" has-behavior="hide">\r\n    <div class="panel-heading">\r\n        <div class="container-title onu-header">\r\n            <span class="panel-title" data-translate="onu.authorizedOnu">ONUS AUTORIZADAS</span>{{vmListAuthorized.panelButton}}\r\n\r\n            <div class="pull-right">\r\n                <div class="btn-circle btn-circle-plus"\r\n                     uib-tooltip-html="vmListAuthorized.view.tooltip"\r\n                     tooltip-placement="bottom"\r\n                     tooltip-append-to-body="true"\r\n                     ng-click="vmListAuthorized.reload()">\r\n                    <span class="icon icon-update"></span>\r\n                </div>\r\n            </div>\r\n\r\n            <div class="paginator">\r\n\r\n                <div dir-pagination-controls\r\n                        max-size="12"\r\n                        direction-links="true"\r\n                        boundary-links="true"\r\n                        on-page-change="vmListAuthorized.getData(newPageNumber)">\r\n                </div dir-pagination-controls>\r\n\r\n            </div>   \r\n\r\n        </div>\r\n        <div class="container-order" ng-hide="vmListAuthorized.hasSearch() || vmListAuthorized.requestRunning || vmListAuthorized.hasNoSearch() || vmListAuthorized.hasErrorList()">\r\n            <div class="container-select pull-left">\r\n                <div class="dropdown-default dropdown-select-list pull-left" uib-dropdown>\r\n                    <div class="dropdown-toggle" uib-dropdown-toggle>\r\n                        <label class="checkbox-select-item checkbox-select" ng-class="{checked: vmListAuthorized.list.checkBoxEnable}">\r\n                            <input type="checkbox" name="checkbox-select" id="" ng-model="vmListAuthorized.list.checkBoxEnable" ng-change="vmListAuthorized.unselectAll()">\r\n                        </label>\r\n                        <span class="caret"></span>\r\n                    </div>\r\n                    <ul class="dropdown-menu dropdown-menu-right" ng-model="vmListAuthorized.list.itemSelected" uib-dropdown-menu>\r\n                        <li value="selectAll" ng-class="{active:vmListAuthorized.view.isActiveOptionAll}">\r\n                            <a href="" data-translate="onu.selectAll.{{vmListAuthorized.view.menuSelectAll}}" ng-click="vmListAuthorized.typeSelection(\'selectAll\')">\r\n                                Selecionar todas\r\n                            </a>\r\n                        </li>\r\n                        <li value="selectIndividual" ng-class="{active:vmListAuthorized.view.isActiveOptionIndividual}">\r\n                            <a href="" data-translate="onu.selectIndividual.{{vmListAuthorized.view.menuSelectIndividual}}" ng-click="vmListAuthorized.typeSelection(\'selectIndividual\')">\r\n                                Sele\xE7\xE3o individual\r\n                            </a>\r\n                        </li>\r\n                    </ul>\r\n                </div>\r\n\r\n                <span data-translate="onu.selectOnus">Selecionar ONUS</span>\r\n\r\n            </div>\r\n            <div class="container-select pull-right">\r\n                <div>\r\n                    <div class="dropdown-default dropdown-order-list" uib-dropdown>\r\n                        <div class="dropdown-toggle" uib-dropdown-toggle>\r\n                            <span data-translate="onu.orderTypeSelection.{{vmListAuthorized.view.labelOrderSelected}}">Ordem alfab\xE9tica</span>\r\n                            <span class="caret"></span>\r\n                        </div>\r\n                        <ul class="dropdown-menu dropdown-menu-right" ng-model="vmListAuthorized.orderSelected" uib-dropdown-menu> \r\n                            <li value="{{item.paramObjectOrder}}" ng-repeat="item in vmListAuthorized.list.typeOrder"\r\n                                ng-class="{active: item.paramObjectOrder == vmListAuthorized.orderSelected}">\r\n                                <a ng-click="vmListAuthorized.setTypeOrder(item.paramObjectOrder)" data-translate="onu.orderTypeSelection.{{item.translateKey}}">{{item.name}}</a>\r\n                            </li>\r\n                        </ul>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class="row" ng-if="vmListAuthorized.view.panelButton">\r\n            <div class="container-buttons">\r\n                <button class="btn btn-primary" data-translate="onu.authorize.header.actions.restart" ng-click="vmListAuthorized.restartOnu()" has-authority="onuRestart" has-behavior="disable-button">Reiniciar</button>\r\n                <button class="btn btn-primary" data-translate="onu.authorize.header.actions.delete" ng-click="vmListAuthorized.deleteOnu()" has-authority="onuDelete" has-behavior="disable-button">Deletar</button>\r\n                <button class="btn btn-primary" data-translate="onu.authorize.header.actions.update" ng-click="vmListAuthorized.updateOnu()" has-authority="onuFirmwareUpdate" has-behavior="disable-button">Atualizar</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n\r\n\r\n\r\n    <div class="panel-body" loader-section="vmListAuthorized.requestRunning">\r\n        <div class="container-scroll margin-top-list" ng-scrollbars>\r\n            <ul class="list list-onu">\r\n\r\n                <li class="list-item list-item-authorized" dir-paginate="onuItem in vmListAuthorized.arrayOnus | itemsPerPage:vmListAuthorized.itemsPerPage | orderBy: vmListAuthorized.orderSelected" total-items="vmListAuthorized.totalCount" \r\n                    ng-class="[{active: onuItem.active, alarm: onuItem.mostCriticalAlarm, opened: !onuItem.collapsed}, onuItem.mostCriticalAlarm]"\r\n                    ng-click="vmListAuthorized.toggleCollapse(onuItem.id)">\r\n\r\n\r\n                    <div class="list-item-collapse">\r\n                        <label class="checkbox-select-item" ng-show="vmListAuthorized.list.checkBoxEnable" ng-class="{checked: onuItem.selected}" stop-propagation>\r\n                            <input type="checkbox" name="checkbox-select-onu" id="" ng-model="onuItem.selected" ng-change="vmListAuthorized.addAndRemoveItem(onuItem)">\r\n                        </label>\r\n                        <div class="icon icon-alarm" ng-show="onuItem.mostCriticalAlarm"></div>\r\n                        <span class="list-item-action icon icon-arrow-select-list"></span> \r\n                        <div class="list-item-info">\r\n                            <div class="list-item-name">{{onuItem.name}}</div>\r\n                            <div class="list-item-menu" stop-propagation>\r\n                                <div class="dropdown-default" uib-dropdown on-toggle="vmListAuthorized.disableSelection()">\r\n                                    <button  id="onu_drop_dow{{$index}}" class="list-item-menu-btn" uib-dropdown-toggle>\r\n                                        <span class="icon icon-menu-more"></span>\r\n                                    </button>\r\n                                    <ul class="dropdown-menu dropdown-menu-right" uib-dropdown-menu>\r\n                                        <li><a id="onu_restart" ng-click="vmListAuthorized.restartOnu(onuItem)" data-translate="onu.authorize.collapse.menu.restart" has-authority="onuRestart" has-behavior="disable-link" data-ng-show="onuItem.online">Reiniciar</a></li>\r\n                                        <li><a id="onu_delete" ng-click="vmListAuthorized.deleteOnu(onuItem)" data-translate="onu.authorize.collapse.menu.delete" has-authority="onuDelete" has-behavior="disable-link">Deletar</a></li>\r\n                                        <li><a id="onu_edit" ng-click="vmListAuthorized.editOnu(onuItem)" data-translate="onu.authorize.collapse.menu.edit" has-authority="onuEdit" has-behavior="disable-link">Editar</a></li>\r\n                                        <li><a id="onu_update" ng-click="vmListAuthorized.updateOnu(onuItem)" data-translate="onu.authorize.collapse.menu.update" has-authority="onuFirmwareUpdate" has-behavior="disable-link">Atualizar</a></li>\r\n                                        <li><a id="onu_reset" ng-click="vmListAuthorized.resetOnu(onuItem)" data-translate="onu.authorize.collapse.menu.reset" has-authority="onuFactoryReset" has-behavior="disable-link" data-ng-show="!vmListAuthorized.isOltIntelbras(onuItem)">Restaurar</a></li>\r\n                                        <li><a id="onu_config_access" ng-click="vmListAuthorized.configAccess(onuItem)" data-translate="onu.authorize.collapse.menu.configAccess" has-authority="onuEdit" has-behavior="disable-link" data-ng-show="vmListAuthorized.isONTAndONU110Gi(onuItem.meProfile)">Configurar Acesso</a></li>\r\n                                        <li><a id="onu_alarms" ui-sref="alarms({id:onuItem.id, type:\'ONU\'})" data-translate="onu.authorize.collapse.menu.alarm">Alarms</a></li>\r\n                                    </ul>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                        <div class="list-item-content">\r\n                            <div>\r\n                                <div class="content-left">\r\n                                    <span class="item-right">Serial: <span class="item-value">{{onuItem.serialNumber}}</span></span>\r\n                                </div>\r\n                                <div class="content-right">\r\n                                    <span class="">Interface: <span class="item-value">{{onuItem.portInterface}}</span></span>\r\n                                </div>\r\n                            </div>\r\n                        </div>    \r\n                        <div class="list-item-content">\r\n                            <div>\r\n                                <div class="content-left">\r\n\r\n                                    <span class="item-right">Rx ONU:<span class="item-value">{{onuItem.rxPower}} dBm</span></span>\r\n                                </div>\r\n                                <div  class="content-right">\r\n                                    <span>Rx OLT:<span class="item-value">{{onuItem.txPower}} dBm</span></span>\r\n\r\n                                </div>    \r\n                            </div>\r\n                        </div>    \r\n                        <div class="list-item-content">\r\n                            <div>\r\n                                <div class="content-left">\r\n                                    <span>Status OLT:<span class="item-value">{{onuItem.oltOnline ? \'UP\' : \'DOWN\'}}</span></span>\r\n                                </div>\r\n                                <div  class="content-right">\r\n                                    <span class="">Dist\xE2ncia: <span class="item-value">{{onuItem.distance| patternMeter}}</span></span>\r\n                                </div>\r\n                            </div>    \r\n                        </div>\r\n                    </div>\r\n                    <div class="list-item-detail" uib-collapse="!onuItem.opened" collapsed="onuItem.collapsed=true"\r\n                         expanding="onuItem.collapsed=false" expanded="onuItem.collapsed=false" stop-propagation>\r\n                        <div class="list-item-detail-content">\r\n                            <div class="row">\r\n                                <span class="col-xs-10 item-label" data-translate="onu.authorize.collapse.profile">Me Profile:</span>\r\n                                <span class="col-xs-14 item-value">{{onuItem.meProfile}}</span >\r\n                            </div>\r\n                            <div class="row">\r\n                                <span class="col-xs-10 item-label" data-translate="onu.authorize.collapse.softwareVersion">Vers\xE3o do Software:</span>\r\n                                <span class="col-xs-14 item-value">{{onuItem.softwareVersion}}</span >\r\n                            </div>\r\n                            <div class="row">\r\n                                <span class="col-xs-12 item-label" data-translate="onu.authorize.collapse.statusGpon">Status da portaGpon:</span>\r\n                                <span class="col-xs-12 item-value text-capitalize">{{onuItem.statusGpon}}</span >\r\n                            </div>\r\n                            <div class="row">\r\n                                <span class="col-xs-10 item-label" data-translate="onu.authorize.collapse.connectedOlt">OLT conectada:</span>\r\n                                <span class="col-xs-14 item-value"><span data-translate="onu.authorize.collapse.name">Nome:</span> {{onuItem.oltName}}</span >\r\n                            </div>\r\n                            <div class="row">\r\n                                <span class="col-xs-7 item-label" data-translate="onu.authorize.collapse.powerSignal">Pot\xEAncia do sinal:</span>\r\n                                <div class="col-xs-17 item-value">\r\n\r\n                                    <span class="col-xs-12">Rx ONU: {{onuItem.rxPower}} dBm</span>\r\n                                    <span class="col-xs-12">Rx OLT: {{onuItem.txPower}} dBm</span>\r\n\r\n                                </div>\r\n                            </div>\r\n                            <div class="row">\r\n                                <span class="col-xs-10 item-label" data-translate="onu.authorize.collapse.distance">Dist\xE2ncia:</span>\r\n                                <span class="col-xs-14 item-value">{{onuItem.distance| patternMeter}}</span>\r\n                            </div>\r\n                            <div class="row">\r\n                                <span class="col-xs-10 item-label" data-translate="onu.authorize.collapse.portGpon">Porta Gpon:</span>\r\n                                <span class="col-xs-14 item-value">{{onuItem.gponPort}}</span>\r\n                            </div>\r\n                            <div class="row">\r\n                                <span class="col-xs-10 item-label" data-translate="onu.authorize.collapse.slotGpon">Slot Gpon:</span>\r\n                                <span class="col-xs-14 item-value">{{onuItem.gponSlot}}</span>\r\n                            </div>\r\n                        </div>\r\n                        <div class="list-item-detail-footer">\r\n                        \t<div>\r\n\t                            <button id= "status_voip" class="btn btn-primary" data-translate="onu.authorize.collapse.btnStatusVoip" ng-click="vmListAuthorized.getStatusVoip(onuItem.id)"\r\n\t                                    data-ng-show="vmListAuthorized.isONT(onuItem.meProfile)" has-authority="onuStatusVoip" has-behavior="disable-button"></button>\r\n                        \t</div>\r\n\t\t\t\t\t\t\t<div>\r\n                            <button class="btn btn-primary" data-translate="onu.authorize.collapse.btnRemoteManagement" ng-click="vmListAuthorized.getOnuCpeMgr(onuItem.id)"\r\n                                    data-ng-show="vmListAuthorized.isNotONU110G(onuItem.meProfile)" has-authority="onuEdit" has-behavior="disable-button"></button>\r\n\t\t\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t\t\t<div class="btn-circle btn-circle-plus nomargin"\r\n\t\t\t\t\t\t\t\ttooltip-placement="bottom" tooltip-append-to-body="true"\r\n\t\t\t\t\t\t\t\tng-click="vmListAuthorized.addBridge(onuItem)"\r\n\t\t\t\t\t\t\t\thas-authority="bridgeAdd" has-behavior="disable-button">+</div>\r\n\r\n\r\n\t\t\t\t\t\t\t<!-- <button class="btn btn-primary" data-translate="onu.authorize.collapse.btn" ng-click="vmListAuthorized.configOnu(onuItem)"\r\n                            ng-hide="!vmListAuthorized.hasWiFi(onuItem)" has-authority="onuConfig" has-behavior="disable-button">\r\n                            Configurar ONU\r\n                        </button> -->\r\n                        </div>\r\n\r\n                    </div>\r\n                </li>\r\n            </ul>\r\n\r\n            <div class="list-empty" data-translate="onu.emptyList" ng-if="vmListAuthorized.hasSearch()">Nenhuma ONU encontrada para os par\xE2metros buscados.</div>\r\n            <div class="list-loading" data-translate="onu.loadingList" ng-if="vmListAuthorized.requestRunning">Aguarde, carregando ONUs ...</div>\r\n            <div class="list-empty" data-translate="onu.emptyListNoParameters" ng-if="vmListAuthorized.hasNoSearch()">Nenhuma ONU encontrada.</div>\r\n            <div class="list-empty" data-translate="onu.loadingListError" ng-if="vmListAuthorized.hasErrorList()">Ocorreu um erro ao buscar pelas ONUs. Por favor, atualize a lista.</div>\r\n\r\n        </div>\r\n\r\n    </div>\r\n\r\n</div>');
$templateCache.put('app/components/onu/onu-list-unauthorized.html','<div class="panel panel-default panel-list" has-authority="onuList" has-behavior="hide">\n\n    <div class="panel-heading">\n        <div class="container-title">\n            <span class="panel-title" data-translate="onu.unauthorizedOnu">ONUS N\xC3O AUTORIZADAS</span>\n            <div class="pull-right">\n                <div class="btn-circle btn-circle-plus"\n                     uib-tooltip-html="vmOnuUnauthorized.view.tooltip"\n                     tooltip-placement="bottom"\n                     tooltip-append-to-body="true"\n                     ng-click="vmOnuUnauthorized.reload()">\n                    <span class="icon icon-update"></span>\n                </div>\n            </div>\n        </div>\n        <div class="container-order" ng-hide="vmOnuUnauthorized.hasSearch() || vmOnuUnauthorized.requestRunning || vmOnuUnauthorized.hasNoSearch() || vmOnuUnauthorized.hasErrorList()">\n            <div class="container-select pull-right" ng-hide="vmOnuUnauthorized.searchIsActive">\n                <div class="dropdown-default dropdown-order-list" uib-dropdown>\n                    <div class="dropdown-toggle" uib-dropdown-toggle>\n                        <span data-translate="onu.orderTypeSelection.{{vmOnuUnauthorized.view.labelOrderSelected}}">Ordem alfab\xE9tica</span>\n                        <span class="caret"></span>\n                    </div>\n                    <ul class="dropdown-menu dropdown-menu-right" ng-model="vmOnuUnauthorized.orderSelected" uib-dropdown-menu>\n                        <li value="{{item.paramObjectOrder}}" ng-repeat="item in vmOnuUnauthorized.list.typeOrder"\n                            ng-class="{active: item.paramObjectOrder == vmOnuUnauthorized.orderSelected}">\n                            <a ng-click="vmOnuUnauthorized.setTypeOrder(item.paramObjectOrder)"\n                               data-translate="onu.orderTypeSelection.{{item.translateKey}}">\n                                {{item.name}}\n                            </a>\n                        </li>\n                    </ul>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class="panel-body" loader-section="vmOnuUnauthorized.requestRunning">\n        <div class="container-scroll" ng-scrollbars>\n            <ul class="list list-onu">\n                <li class="list-item" ng-repeat="onuItem in vmOnuUnauthorized.onuList| orderBy: vmOnuUnauthorized.orderSelected"\n                    ng-class="{opened: !onuItem.collapsed}">\n                    <div class="list-item-collapse" ng-click="vmOnuUnauthorized.toggle(onuItem.id)">\n                     <span class="list-item-action icon icon-arrow-select-list"></span>\n                        <div class="list-item-info">\n                            <span class="list-item-name">{{onuItem.serialNumber}}</span>\n                        </div>\n                        <div class="list-item-content">\n                        </div>\n                        <div class="list-item-content">\n                        </div>\n                        <div class="list-item-content">\n                            <span><span data-translate="onu.unauthorize.olt">OLT</span>:</span>\n                            <span>{{onuItem.oltName}}</span>\n                            <div class="pull-right">\n                                <span><span data-translate="onu.unauthorize.port">Porta</span>:</span>\n                                <span>{{onuItem.gponPort}}</span>   \n                            </div>\n                        </div>\n                    </div>\n                    <div class="list-item-detail" uib-collapse="!onuItem.opened" collapsed="onuItem.collapsed=true"\n                         expanding="onuItem.collapsed=false" expanded="onuItem.collapsed=false" stop-propagation>\n                        <div class="list-item-detail-content">\n                            <div class="row">\n                                <span class="col-xs-12 item-label"><span data-translate="onu.unauthorize.connectedOltName">Nome da OLT Conectada</span>:</span>\n                                <span class="col-xs-12 item-value">{{onuItem.oltName}}</span>\n                            </div>\n                            <div class="row">\n                                <span class="col-xs-12 item-label"><span data-translate="onu.unauthorize.ip">IP</span>:</span>\n                                <span class="col-xs-12 item-value">{{onuItem.oltIp}}</span>\n                            </div>\n                            <div class="row">\n                                <span class="col-xs-12 item-label"><span data-translate="onu.unauthorize.mac">Mac</span>:</span>\n                                <span class="col-xs-12 item-value">{{onuItem.oltMacAddress}}</span>\n                            </div>\n                            <div class="row">\n                                <span class="col-xs-12 item-label"><span data-translate="onu.unauthorize.port">Porta</span>:</span>\n                                <span class="col-xs-12 item-value">{{onuItem.gponPort}}</span>\n                            </div>\n                        </div>\n                        <div class="list-item-detail-footer">\n                            <button class="btn btn-primary" ng-click="vmOnuUnauthorized.authorize(onuItem)"\n                                    data-translate="onu.unauthorize.btn.authorizeONU" has-authority="onuEdit" has-behavior="disable-default">\n                                Autorizar ONU\n                            </button>\n                        </div>\n                    </div>\n                </li>\n            </ul>\n            <div class="list-empty" data-translate="onu.emptyList" ng-if="vmOnuUnauthorized.hasSearch()">Nenhuma ONU encontrada para os par\xE2metros buscados.</div>\n            <div class="list-loading" data-translate="onu.loadingList" ng-if="vmOnuUnauthorized.requestRunning">Aguarde, carregando ONUs ...</div>\n            <div class="list-empty" data-translate="onu.emptyListNoParameters" ng-if="vmOnuUnauthorized.hasNoSearch()">Nenhuma ONU encontrada.</div>\n            <div class="list-empty" data-translate="onu.loadingListError" ng-if="vmOnuUnauthorized.hasErrorList()">Ocorreu um erro ao buscar pelas ONUs. Por favor, atualize a lista.</div>\n        </div>\n    </div>\n\n</div>');
$templateCache.put('app/components/onu/onu-remote-mgmt.html','<div class="modal-header">\n    <button type="button" class="close" ng-click="vmOnuRemoteMgmt.close()"><span aria-hidden="true">&times;</span></button>\n    <h4 class="modal-title" data-translate="onu.authorize.collapse.btnRemoteManagement"></h4>\n</div>\n<div class="modal-body" ng-init="vmOnuRemoteMgmt.init()">\n    <div class="modal-body">\n        <div class="row" style="text-align: center">\n            <p data-translate="{{vmOnuRemoteMgmt.modalMessage}}"></p>\n        </div>\n        <div class="row" style="text-align: center">\n            <a ng-href="{{vmOnuRemoteMgmt.modalLink}}" target="_blank">{{vmOnuRemoteMgmt.modalLink}}</a>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/components/onu/onu-search.html','<div class="panel panel-default">\n    <div class="panel-heading">\n        <span class="panel-title" data-translate="global.search.searchFilter">FILTRO DE BUSCA</span>\n    </div>\n    <div class="panel-body">\n        <form class="form-inline form-search onu-search" name="vmOnuSearch.formSearch" ng-submit="vmOnuSearch.searchOnus()" novalidate autocomplete="off">\n            <section class="agrupamento-input" id="agrupamento">\n                <label for="search-name" class=""><span data-translate="global.search.name">Nome</span>:</label>\n                <input class="search-input form-control input-border" type="text" id="search-name" name="searchName"\n                       maxlength="20" placeholder="{{\'global.search.placeholder.onuName\'| translate}}"\n                       ng-model="vmOnuSearch.searchData.name"\n                       uib-tooltip="{{\'tooltip.searchByOnuName\'| translate}}"\n                       tooltip-trigger="focus" tooltip-placement="right">\n            </section>\n            <section class="agrupamento-input" id="agrupamento">\n                <label for="search-serial" class="search-label control-label"><span data-translate="global.search.serialNumber">Serial Number</span>:</label>\n                <input class="search-input form-control input-border" type="text" id="search-serial" name="searchSerial"\n                       maxlength="20" placeholder="{{\'global.search.serialNumber\'| translate}}"\n                       ng-model="vmOnuSearch.searchData.serialNumber"\n                       uib-tooltip="{{\'tooltip.searchBySerialNumber\'| translate}}"\n                       tooltip-trigger="focus" tooltip-placement="right">\n            </section>\n            <section class="agrupamento-input" id="agrupamento">\n                <label for="search-meprofile" class="search-label control-label"><span data-translate="global.search.meProfile">Me Profile</span>:</label>\n                <input class="search-input form-control input-border" type="text" id="search-meprofile" name="searchMeProfile"\n                       maxlength="20" placeholder="{{\'global.search.meProfile\'| translate}}"\n                       ng-model="vmOnuSearch.searchData.meProfile"\n                       uib-tooltip="{{\'tooltip.searchByMeProfile\'| translate}}"\n                       tooltip-trigger="focus" tooltip-placement="right">\n            </section>\n            <section class="agrupamento-input" id="agrupamento">\n                    <span class="section-title" data-translate="global.search.olt">OLT</span>:\n                <ui-select name="filter-olt" ng-model="vmOnuSearch.selected.olt" class="input-border" style="width: 100%"\n                           search-enabled="false" ng-disabled="!vmOnuSearch.listOlts.length">\n                    <ui-select-match placeholder="{{vmOnuSearch.placeholder.olt| translate}}" allow-clear="true">{{vmOnuSearch.selected.olt.name}}</ui-select-match>\n                    <ui-select-choices repeat="item in vmOnuSearch.listOlts">{{item.name}}</ui-select-choices>\n                </ui-select>\n            </section>\n\n            <div class="form-group">\n                <label for="search-port" class="search-label control-label"><span data-translate="global.search.gponPort">Porta</span>:</label>\n                <ui-select ng-model="vmOnuSearch.searchData.gponPort" search-enabled="false" class="input-border">\n                    <ui-select-match>{{vmOnuSearch.searchData.gponPort.value}}</ui-select-match>\n                    <ui-select-choices repeat="port in vmOnuSearch.gponPortList">{{port.value}}</ui-select-choices>\n                </ui-select>\n            </div>\n\n\n\n           \n            \n            <div class="panel-button">\n                <button type="button" class="btn btn-default btn-clean" data-translate="global.search.cleanText" ng-click="vmOnuSearch.cleanFilter()">Limpar</button>\n                <button type="submit" class="btn btn-primary btn-search" >\n                    <span class="icon icon-search"></span>\n                    <span data-translate="global.search.searchText">Pesquisar</span>\n                </button>\n            </div>\n        </form>\n    </div>\n</div>');
$templateCache.put('app/components/onu/onu-status-voip.html','<div class="modal-header">\n    <div class="pull-right">\n        <div class="btn-circle btn-circle-plus" uib-tooltip-html="vmListAuthorized.view.tooltip" tooltip-placement="bottom" tooltip-append-to-body="true" \n             ng-click="vmOnuStatusVoip.reload()">\n            <span class="icon icon-update"></span>\n        </div>\n    </div>\n    <button type="button" class="close" ng-click="vmOnuStatusVoip.close()"><span aria-hidden="true">&times;</span></button>\n    <h4 class="modal-title" id="config-onu-label" data-translate="onu.authorize.collapse.btnStatusVoip"></h4>\n</div>\n\n<div class="modal-config-onu" ng-init="vmOnuStatusVoip.init()">\n    <div class="modal-body">\n        <div class="row">\n            <div class="" style="text-align: center">\n                <div class="">\n                    <button class="btn btn-default onu-status-voip-fxs" ng-model="vmOnuStatusVoip.selectedFxs"\n                            ng-class="{\'btn-success\': vmOnuStatusVoip.statusVoipList[0].administrationState === \'Enabled\'}"\n                            uib-btn-radio="1" disabled>\n                        Fxs 1\n                    </button>\n                    <button class="btn btn-default" ng-model="vmOnuStatusVoip.selectedFxs"\n                            ng-class="{\'btn-success\': vmOnuStatusVoip.statusVoipList[1].administrationState === \'Enabled\'}"\n                            uib-btn-radio="2" disabled>\n                        Fxs 2\n                    </button>\n                </div>\n            </div>\n            <div class="modal-col col-xs-25">\n                <div class="content-block content-initial">\n                    <div class="form-group">\n                        <label class="col-xs-12 control-label"><span data-translate="onuStatusVoip.phoneNumber"></span></label>\n                        <div class="col-xs-12">\n                            <label class="col-xs-12">{{ vmOnuStatusVoip.statusVoipList[0].phoneNumber}}</label>\n                            <label class="col-xs-12">{{ vmOnuStatusVoip.statusVoipList[1].phoneNumber}}</label>\n                        </div>\n                    </div>\n                    <div class="form-group">\n                        <label class="col-xs-12 control-label"><span data-translate="onuStatusVoip.registrationStatus"></span></label>\n                        <div class="col-xs-12">\n                            <label class="col-xs-12">{{ vmOnuStatusVoip.statusVoipList[0].registrationStatus}}</label>\n                            <label class="col-xs-12">{{ vmOnuStatusVoip.statusVoipList[1].registrationStatus}}</label>\n                        </div>\n                    </div>\n                    <div class="form-group">\n                        <label class="col-xs-12 control-label"><span data-translate="onuStatusVoip.callStatus"></span></label>\n                        <div class="col-xs-12">\n                            <label class="col-xs-12">{{ vmOnuStatusVoip.statusVoipList[0].callStatus}}</label>\n                            <label class="col-xs-12">{{ vmOnuStatusVoip.statusVoipList[1].callStatus}}</label>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/components/onu/onu-update-firmware.html','<div class="modal-header">\n    <button type="button" class="close" ng-click="vmOnuUpdateFirmware.close()"><span aria-hidden="true">&times;</span></button>\n    <h4 class="modal-title" id="update-onu-label" data-translate="onuUpdateFirmware.updateFirmware">Atualiza\xE7\xE3o de Firmware</h4>\n</div>\n<form class="form-update-firmware" name="vmOnuUpdateFirmware.formUpdateOnuFirmware" ng-submit="vmOnuUpdateFirmware.updateFirmware()" novalidate>\n    <div class="modal-body modal-update-firmware">\n        <div class="label-description">\n            <span data-translate="onuUpdateFirmware.selectFile">Selecione o arquivo para a atualiza\xE7\xE3o do firmware dos equipamentos</span>:\n        </div>\n        <div class="row">\n            <div class="modal-col col-xs-12">\n                <div class="label-table">\n                    <span data-translate="onuUpdateFirmware.files">Arquivos</span>:\n                    <span class="label-table-content pull-right">{{vmOnuUpdateFirmware.modelFirmware.oltName}}</span>\n                </div>\n                <div class="container-scroll" ng-scrollbars>\n                    <table class="table table-hover">\n                        <tbody>\n                            <tr ng-repeat="item in vmOnuUpdateFirmware.modelFirmware.files" ng-class="{active: vmOnuUpdateFirmware.selectedFile == item}">\n                                <td>\n                                    <label class="radio radio-select-files" ng-class="{checked: vmOnuUpdateFirmware.selectedFile == item,\n                                        invalid: vmOnuUpdateFirmware.formUpdateOnuFirmware.$submitted && !vmOnuUpdateFirmware.selectedFile}">\n                                        <input type="radio" id="oltFile{{$index}}" name="file" ng-model="vmOnuUpdateFirmware.selectedFile" ng-value="item" required>\n                                    </label>\n                                </td>\n                                <td class="label-radio" ng-click="vmOnuUpdateFirmware.selectedFile = item">{{item}}</td>\n                            </tr>\n                        </tbody>\n                    </table>\n                </div>\n            </div>\n            <div class="modal-col col-xs-12">\n                <div class="label-table">\n                    <span data-translate="onuUpdateFirmware.equipment">Equipamento</span>\n                </div>\n                <div class="container-scroll" ng-scrollbars>\n                    <table class="table table-hover">\n                        <tbody>\n                            <tr ng-repeat="item in vmOnuUpdateFirmware.modelFirmware.onus" ng-class="{active: item.checked}" ng-click="item.checked = !item.checked">\n                                <td>\n                                    <label class="checkbox-select-item checkbox-select-equipment"\n                                           ng-class="{checked: item.checked,\n                                                    invalid: vmOnuUpdateFirmware.formUpdateOnuFirmware.$submitted && !vmOnuUpdateFirmware.selectedOnus.length}">\n                                        <input type="checkbox" name="onu"\n                                               ng-model="item.checked">\n                                    </label>\n                                </td>\n                                <td class="label-checkbox">{{item.onuName}} ({{item.onuMeProfile}})</td>\n                            </tr>\n                        </tbody>\n                    </table>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div ng-if="vmOnuUpdateFirmware.totalItems > 1" class="text-center">\n        <ul uib-pager total-items="vmOnuUpdateFirmware.totalItems" items-per-page="1" template-url="app/components/onu/templates/pager.html"\n            ng-model="vmOnuUpdateFirmware.currentPage" ng-change="vmOnuUpdateFirmware.changePage()" ng-disabled="vmOnuUpdateFirmware.requestRunning"></ul>\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default btn-modal-lg" ng-disabled="vmOnuUpdateFirmware.requestRunning" ng-click="vmOnuUpdateFirmware.close()" data-translate="global.button.cancel">Cancelar</button>\n        <button type="submit" class="btn btn-primary btn-modal-lg" ng-disabled="vmOnuUpdateFirmware.requestRunning" data-translate="global.button.update">Atualizar</button>\n    </div>\n</form>');
$templateCache.put('app/components/onu/onu.html','<div class="col-container container-onu">\n    <div class="col-search">\n        <div ui-view="search" class="panel-search"></div>\n        <div ui-view="favorites"></div>\n    </div>\n    <div class="col-list">\n        <div ui-view="unauthorized" class="container-list"></div>\n    </div>\n    <div class="col-list">\n        <div ui-view="authorized" class="container-list"></div>\n    </div>\n</div>\n');
$templateCache.put('app/components/relatorio/relatorio.html','<div\n    class="relatorio-scheduler"\n    ng-class="relatorioVm.modalAberta ? \'\': \'invisivel\'"\n    > \n    <button class="btn btn-primary btn-console" ng-click="relatorioVm.fecharModal()">x</button>\n\n    <h1>Relat\xF3rio de Sincroniza\xE7\xE3o For\xE7ada</h1>\n\n    <!--  <div class="conteudo-scheduler">\n     <div ng-if="relatorioVm.aindaNaoComecouSincronizacaoForcada">\n       <p>\n            O sistema ainda n\xE3o come\xE7ou a sincroniza\xE7\xE3o pedida pelo usu\xE1rio para a OLT {{relatorioVm.oltSelecionada.nome}}.\n          </p>\n          <p>\n            A sincroniza\xE7\xE3o for\xE7ada remove do SIG as ONUs autorizadas e tamb\xE9m as Bridges (Servi\xE7os) que foram deletadas da OLT\n            fora do sistema (Utilizando a linha de comando por exemplo, ou seja, diretamente pela OLT)\n          </p>\n          <p>\n            Essa tela ser\xE1 atualizada a medida que o sistema for sincronizado.\n          </p>\n        </div>\n        <div ng-if="relatorioVm.oSchedulerJaComecou">\n          <p>\n            O Scheduler j\xE1 comecou a verificar se alguma Bridge ou ONU foi removido do sistema.\n          </p>\n        </div>\n       <div ng-if="relatorioVm.oSchedulerJaComecou">\n          <div ng-if="relatorioVm.oSchedulerJaComecou">\n            <p>\n              Total de brigdes removidas na \xFAltima sincroniza\xE7\xE3o: {{relatorioVm.servicosRemovidos.length}}\n            </p>\n            <ul>\n             <table class="table" ng-if="relatorioVm.servicosRemovidos.length">\n                <thead>\n                  <th>Nome</th>\n                </thead>\n                <tbody>\n                  <tr ng-repeat="bridge in relatorioVm.servicosRemovidos">\n                    <td >{{bridge.nome}}</td>\n                    <td>{{brigde.dataSolicitacao}}</td>\n                    <td>{{brige.dataInicioProcessamento}}</td>\n    \n                    <td></td>\n                  </tr> \n                </tbody>\n              </table> \n          </ul> \n            <hr>\n            <p>\n              Total de ONUs Removidas na Ultima Sincronizacao: {{relatorioVm.onusRemovidas.length}}\n            </p>\n            <ul>\n              <table class="table" ng-if="relatorioVm.onusRemovidas.length">\n                <thead>\n                  <th>Nome</th>\n                  <th>N\xFAmero de S\xE9rie</th>\n                <thead>\n                <tbody>\n                  <tr ng-repeat="onu in relatorioVm.onusRemovidas">\n                  <td >{{onu.nome}}</td>\n                    <td >{{onu.numeroDeSerie}}</td>\n                  </tr>\n                </tbody>\n              </table>\n            </ul>\n          </div>\n        </div>\n        <hr>\n        <div ng-if="relatorioVm.oSchedulerJaTerminou">\n          <p>\n            O processo de sincronia acabou, caso deseja novamente, favor solicitar no menu de sincronizacao forcada\n          </p>\n        </div>\n        <div ng-if="!relatorioVm.oSchedulerJaTerminou">\n          <p>\n            O processo de sincronia ainda n\xE3o acabou, pode ser que a lista de ONUs e Bridges acima seja atualizada com novas informa\xE7\xF5es.\n          </p>\n        </div>\n      </div> -->\n\n    <hr>\n    <!-- ESTRUTURA VISUAL MOCK TABLE -->\n\n    <h3>ONU\'s</h3>\n\n    <table style="width:100%;">\n        <thead>\n        <th>Nome</th>\n        <th>Data de solicita\xE7\xE3o</th> \n        <th>Serial number</th>\n        <th>Port interface</th>\n        <th>Data in\xEDcio processamento</th>\n        <th>Data fim processamento</th>\n        </thead>\n        <tbody>\n            <tr ng-repeat="onu in relatorioVm.onusRemovidas">\n                <td>{{onu.onuName}}</td>\n                <td>{{onu.dateTimeSolicitacao}}</td>\n                <td>{{onu.serialNumber}}</td>\n                <td>{{onu.portInterface}}</td>\n                <td>{{onu.dateTimeInicioProcessamento}}</td>\n                <td>{{onu.dateTimeFimProcessamento}}</td>\n            </tr>\n        </tbody>\n    </table> \n\n    <hr>\n\n    <h3>Brigdes</h3>\n\n    <table style="width:100%;">\n        <thead>\n        <th>Nome</th>\n        <th>Data de solicita\xE7\xE3o</th> \n        <th>Bridge interface</th>\n        <th>Data in\xEDcio processamento</th>\n        <th>Data fim processamento</th>\n        </thead>\n        <tbody>\n            <tr ng-repeat="bridge in relatorioVm.servicosRemovidos">\n                <td>{{bridge.name}}</td>\n                <td>{{bridge.dateTimeSolicitacao}}</td>\n                <td>{{bridge.bridgeInterface}}</td>\n                <td>{{bridge.dateTimeInicioProcessamento}}</td>\n                <td>{{bridge.dateTimeFimProcessamento}}</td>\n            </tr>\n        </tbody>\n    </table>   \n\n</div> ');
$templateCache.put('app/components/termos-aceite/termos-aceite.html','<div\n  class="relatorio-scheduler"\n  ng-class="termosVm.modalAberta ? \'\': \'invisivel\'"\n  ng-click="termosVm.fecharModal()"\n  ng-controller="SystemConfigController as vmSystemConfig"\n>\n  <p>\n    Para utilizar o Software de Gerenciamento de Redes GPON, \xE9 indispens\xE1vel a aceita\xE7\xE3o dos termos descritos a seguir.\n  </p>\n  <p>\n    Este Contrato de Licen\xE7a de Uso de Software (CONTRATO) \xE9 um acordo legal entre o licenciado (pessoa f\xEDsica ou\n    jur\xEDdica) denominado LICENCIADO e INTELBRAS S/A - IND\xDASTRIA DE TELECOMUNICA\xC7\xC3O ELETR\xD4NICA BRASILEIRA, pessoa\n    jur\xEDdica de direito privado, inscrita no CNPJ sob n.\xBA 82.901.000/0001-27, estabelecida a Rodovia BR 101, KM 210,\n    \xC1rea Industrial, S\xE3o Jos\xE9 - SC., doravante denominada LICENCIANTE, para uso do programa de computador denominado\n    Software de Gerenciamento de Redes GPON (SOFTWARE), podendo incluir os meios f\xEDsicos associados, bem como quaisquer\n    materiais impressos e qualquer documenta\xE7\xE3o online ou eletr\xF4nica. Ao utilizar o SOFTWARE, mesmo que parcialmente ou\n    a t\xEDtulo de teste, o LICENCIADO estar\xE1 vinculado aos termos deste CONTRATO, concordando com suas disposi\xE7\xF5es,\n    principalmente com rela\xE7\xE3o ao CONSENTIMENTO PARA o ACESSO, COLETA, USO, ARMAZENAMENTO, TRATAMENTO E T\xC9CNICAS DE\n    PROTE\xC7\xC3O \xC0S INFORMA\xC7\xD5ES do LICENCIADO pela LICENCIANTE, necess\xE1rias para a integral execu\xE7\xE3o das funcionalidades\n    ofertadas pelo SOFTWARE. Em caso de discord\xE2ncia com os termos aqui apresentados, a utiliza\xE7\xE3o do SOFTWARE deve ser\n    imediatamente interrompida pelo LICENCIADO. mediante as cl\xE1usulas a seguir estabelecidas.\n  </p>\n  <p>\n    1. Aceita\xE7\xE3o do contrato - Ao instalar o programa de computador, doravante denominado SOFTWARE, o LICENCIADO\n    manifesta sua concord\xE2ncia em se vincular e se submeter a todos os termos deste contrato.\n  </p>\n  <p>\n    2. Objeto do contrato - O LICENCIADO recebe, neste ato, uma licen\xE7a revog\xE1vel, n\xE3o exclusiva e intransfer\xEDvel do\n    instalador, para baixar, instalar, executar e utilizar este servi\xE7o em seus dispositivos. O LICENCIADO reconhece e\n    concorda que a LICENCIANTE concede ao usu\xE1rio uma permiss\xE3o exclusiva e gratuita para uso e desta forma n\xE3o lhe\n    transfere os direitos sobre o produto. A venda, transfer\xEAncia, modifica\xE7\xE3o, engenharia reversa ou distribui\xE7\xE3o bem\n    como a c\xF3pia de textos, imagens ou quaisquer partes nele contido \xE9 expressamente proibida.\n  </p>\n  <p>\n    3. Direitos Autorais - O LICENCIADO n\xE3o adquire, pelo presente instrumento ou pela utiliza\xE7\xE3o do SOFTWARE, nenhum\n    direito de propriedade intelectual ou outros direitos exclusivos, incluindo patentes, desenhos, marcas, direitos\n    autorais ou quaisquer direitos sobre informa\xE7\xF5es confidenciais ou segredos de neg\xF3cio, bem como todo o conte\xFAdo\n    disponibilizado no Site, incluindo, mas n\xE3o se limitando a textos, gr\xE1ficos, imagens, logotipos, \xEDcones,\n    fotografias, conte\xFAdo editorial, notifica\xE7\xF5es, softwares e qualquer outro material, sobre ou relacionados ao\n    SOFTWARE ou nenhuma parte dele. O LICENCIADO tamb\xE9m n\xE3o adquire nenhum direito sobre ou relacionado ao SOFTWARE ou\n    qualquer componente dele, al\xE9m dos direitos expressamente licenciados ao LICENCIADO sob o presente EULA ou em\n    qualquer outro contrato mutuamente acordado por escrito entre o LICENCIADO e a LICENCIANTE. Quaisquer direitos n\xE3o\n    expressamente concedidos sob o presente instrumento s\xE3o reservados. Tamb\xE9m ser\xE1 de propriedade exclusiva da\n    LICENCIANTE ou est\xE1 devidamente licenciado, todo o conte\xFAdo disponibilizado no Site, incluindo, mas n\xE3o se limitando\n    a, textos, gr\xE1ficos, imagens, logos, \xEDcones, fotografias, conte\xFAdo editorial, notifica\xE7\xF5es, softwares e qualquer\n    outro material.\n  </p>\n  <p>\n    4. Altera\xE7\xF5es, modifica\xE7\xF5es e rescis\xE3o - A LICENCIANTE reserva-se no direito de, a qualquer tempo, modificar estes\n    termos, seja incluindo, removendo ou alterando quaisquer de suas cl\xE1usulas. Tais modifica\xE7\xF5es ter\xE3o efeito imediato.\n    Ap\xF3s publicadas tais altera\xE7\xF5es, ao continuar com o uso do SOFTWARE, o LICENCIADO ter\xE1 aceitado e concordado em\n    cumprir os termos modificados. A LICENCIANTE pode, de tempos em tempos, modificar ou descontinuar (tempor\xE1ria ou\n    permanentemente) a distribui\xE7\xE3o ou a atualiza\xE7\xE3o deste SOFTWARE. A LICENCIANTE n\xE3o \xE9 obrigada a fornecer nenhum\n    servi\xE7o de suporte para este servi\xE7o.\n  </p>\n  <p>\n    5. Isen\xE7\xE3o De Garantias E Limita\xE7\xF5es De Responsabilidade - Este software estar\xE1 em cont\xEDnuo desenvolvimento e pode\n    conter erros e, por isso, o uso \xE9 fornecido "no estado em que se encontra" e sob risco do usu\xE1rio final. Na extens\xE3o\n    m\xE1xima permitida pela legisla\xE7\xE3o aplic\xE1vel, a Intelbras e seus fornecedores isentam-se de quaisquer garantias e\n    condi\xE7\xF5es expressas ou impl\xEDcitas incluindo, sem limita\xE7\xE3o, garantias de comercializa\xE7\xE3o, adequa\xE7\xE3o a um prop\xF3sito\n    espec\xEDfico, titularidade e n\xE3o viola\xE7\xE3o no que diz respeito ao software e qualquer um de seus componentes ou ainda \xE0\n    presta\xE7\xE3o ou n\xE3o de servi\xE7os de suporte. A LICENCIANTE n\xE3o garante que a opera\xE7\xE3o deste servi\xE7o seja cont\xEDnua e sem\n    defeitos.\n  </p>\n  <p>\n    6. Validade T\xE9cnica: Fica estipulado que a INTELBRAS, seus fornecedores ou distribuidores n\xE3o oferecem um per\xEDodo de\n    validade t\xE9cnica do software. N\xE3o se pode considerar que o programa esteja isento de erros, que seu funcionamento\n    seja ininterrupto ou que suas fun\xE7\xF5es satisfa\xE7am os requisitos dos usu\xE1rios, raz\xE3o pela qual fica expressamente\n    estipulado que o LICENCIADO o utiliza por sua conta e risco. Devido \xE0s diferen\xE7as e a complexidade entre software e\n    hardware, a INTELBRAS n\xE3o garante que o Software ser\xE1 compat\xEDvel com todos os sistemas de software e hardware, e vai\n    operar corretamente sob essas condi\xE7\xF5es ou atender \xE0s suas expectativas.\n  </p>\n  <p>\n    7. Indeniza\xE7\xE3o - Em nenhum caso a LICENCIANTE ser\xE1 respons\xE1vel por danos pessoais ou qualquer preju\xEDzo incidental,\n    especial, indireto ou consequente, incluindo, sem limita\xE7\xE3o, preju\xEDzos por perda de lucro, corrup\xE7\xE3o ou perda de\n    dados, falha de transmiss\xE3o ou recep\xE7\xE3o de dados, n\xE3o continuidade do neg\xF3cio ou qualquer outro preju\xEDzo ou perda\n    comercial, decorrentes ou relacionados ao seu uso ou sua inabilidade em usar o SOFTWARE, por qualquer outro motivo.\n    Sob nenhuma circunst\xE2ncia a responsabilidade integral da LICENCIANTE com rela\xE7\xE3o ao LICENCIADO por todos os danos\n    exceder\xE1 a quantia correspondente ao \xFAltimo plano de licenciamento pago pelo LICENCIADO \xE0 LICENCIANTE pela obten\xE7\xE3o\n    da presente licen\xE7a de SOFTWARE.\n  </p>\n  <p>\n    8. Consentimento para coleta e uso de dados - O LICENCIADO concorda que a LICENCIANTE pode coletar e usar dados\n    t\xE9cnicos de seu dispositivo tais como especifica\xE7\xF5es, configura\xE7\xF5es, vers\xF5es de sistema operacional, tipo de conex\xE3o\n    \xE0 internet e afins.\n  </p>\n  <p>\n    9. Rescis\xE3o - Este contrato poder\xE1 ser rescindido por interesse das partes a qualquer instante ou por quebra de\n    qualquer cl\xE1usula.\n  </p>\n  <p>\n    10. Condi\xE7\xF5es gerais - A inviabilidade de condi\xE7\xF5es isoladas deste contrato n\xE3o constitui invalidade de todo o\n    contrato, sendo que as modifica\xE7\xF5es dever\xE3o se processar de forma escrita, n\xE3o vigorando e gerando qualquer efeito\n    os acordos verbais.\n  </p>\n  <p>\n    11. As partes elegem o foro da Comarca de S\xE3o Jos\xE9 - SC, para dirimirem eventuais d\xFAvidas ou lit\xEDgios provenientes\n    do presente contrato, com exclus\xE3o de qualquer outro por mais privilegiado que seja.\n  </p>\n  <p>Este produto n\xE3o trata qualquer informa\xE7\xE3o de dados pessoais.</p>\n  <p>Data de Aceite: {{vmSystemConfig.aceiteDoContrato}}</p>\n</div>\n');
$templateCache.put('app/components/user/user-add.html','<div class="modal-header">\n    <button type="button" class="close" ng-click="vmUserAdd.close()"><span aria-hidden="true">&times;</span></button>\n    <h4 class="modal-title" data-translate="user.{{vmUserAdd.modalTitle}}">Adicionar Usu\xE1rio</h4>\n</div>\n<form class="form-horizontal form-modal" name="vmUserAdd.formUserAdd" ng-submit="vmUserAdd.save()" novalidate>\n    <div class="modal-body">\n        <div class="form-group">\n            <label class="col-xs-12 control-label" for="field-username"><span data-translate="user.add.username">Usu\xE1rio</span>: *</label>\n            <div class="col-xs-12">\n                <input type="text" class="form-control" id="field-username" name="userName"\n                       placeholder="{{\'user.add.placeholder.username\'| translate}}" required\n                       ng-model="vmUserAdd.dataUser.username"\n                       uib-tooltip="{{\'tooltip.username\'| translate}}" tooltip-trigger="focus" tooltip-placement="right"\n                       tooltip-enable="vmUserAdd.formUserAdd.userName.$invalid"\n                       tooltip-is-open="vmUserAdd.formUserAdd.userName.$invalid && !vmUserAdd.formUserAdd.userName.$error.required"\n                       ng-disabled="vmUserAdd.isEdit">\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-xs-12 control-label" for="field-email"><span data-translate="user.add.email">E-mail</span>: *</label>\n            <div class="col-xs-12">\n                <input type="text" class="form-control" id="field-email" name="userEmail"\n                       placeholder="e-mail" required ng-model="vmUserAdd.dataUser.email"\n                       pattern="^[\\w-]+([\\w\\.\\-]+)?@[\\w-]+(\\.\\w+){1,}$"\n                       uib-tooltip="{{\'tooltip.email\'| translate}}" tooltip-trigger="focus" tooltip-placement="right"\n                       tooltip-enable="vmUserAdd.formUserAdd.userEmail.$invalid"\n                       tooltip-is-open="vmUserAdd.formUserAdd.userEmail.$invalid && !vmUserAdd.formUserAdd.userEmail.$error.required">\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-xs-12 control-label" for="field-user-profile"><span data-translate="user.add.profile">Perfil do Usu\xE1rio</span>: *</label>\n            <div class="col-xs-12">\n                <ui-select id="config-input-perfil-user" name="field-user-profile" ng-model="vmUserAdd.dataUser.group" search-enabled="false" required>\n                    <ui-select-match>{{vmUserAdd.dataUser.group.name}}</ui-select-match>\n                    <ui-select-choices repeat="group in vmUserAdd.groups">{{group.name}}</ui-select-choices>\n                </ui-select>\n            </div>\n        </div>\n        <div ng-if="!vmUserAdd.isEdit">\n            <div class="form-group">\n                <label class="col-xs-12 control-label" for="field-access-password"><span data-translate="user.add.password">Senha</span>: *</label>\n                <div class="col-xs-12">\n                    <input type="password" class="form-control" id="field-access-password" name="password" minlength="6" maxlength="20"\n                           placeholder="password"\n                           ng-model="vmUserAdd.dataUser.password"\n                           required autocomplete="off"\n                           uib-tooltip="{{\'tooltip.password\'| translate}}"\n                           tooltip-trigger="focus"\n                           tooltip-enable="vmUserAdd.formUserAdd.password.$invalid"\n                           tooltip-is-open="vmUserAdd.formUserAdd.password.$invalid && !vmUserAdd.formUserAdd.password.$error.required"\n                           tooltip-placement="right">\n                </div>\n            </div>\n            <div class="form-group">\n                <label class="col-xs-12 control-label" for="field-access-confirm"><span data-translate="user.add.confirm">Confirmar Senha</span>: *</label>\n                <div class="col-xs-12">\n                    <input type="password" class="form-control" id="field-access-confirm" minlength="6" maxlength="20"\n                           placeholder="password" required\n                           ng-model="vmUserAdd.dataUser.confirmPassword"\n                           required autocomplete="off"\n                           invalid-if="!vmUserAdd.checkPassword()">\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default btn-cancel" ng-click="vmUserAdd.close()" ng-disabled="vmUserAdd.requestRunning" data-translate="global.button.cancel">Cancelar</button>\n        <button type="submit" class="btn btn-primary btn-add" ng-disabled="vmUserAdd.requestRunning" data-translate="global.button.{{vmUserAdd.labelButton}}">Salvar</button>\n    </div>\n</form>\n');
$templateCache.put('app/components/user/user-change-password.html','<div class="modal-header">\n    <button type="button" class="close" ng-click="vmUserChangePassword.close()" ng-if="vmUserChangePassword.groupName == \'ADMIN\'">\n        <span aria-hidden="true">&times;</span>\n    </button>\n    <h4 class="modal-title" data-translate="user.changePassword.title">TROCAR SENHA</h4>\n</div>\n<form class="form-horizontal form-modal" name="vmUserChangePassword.formChangePassword" ng-submit="vmUserChangePassword.save()" novalidate autocomplete="off">\n    <div class="modal-body">\n        <div class="form-group">\n            <label class="col-xs-13 control-label" for="field-current-password"><span data-translate="user.changePassword.currentPassword">Senha Atual</span>: *</label>\n            <div class="col-xs-11">\n                <input type="password" class="form-control" id="field-current-password" name="password"\n                       ng-model="vmUserChangePassword.changePassword.password"\n                       placeholder="{{\'user.changePassword.placeholder.currentPassword\'| translate}}" required>\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-xs-14 control-label" for="field-password-new"><span data-translate="user.changePassword.newPassword">Nova Senha</span>: *</label>\n            <div class="col-xs-10">\n                <input type="password" class="form-control" id="field-password-new" name="newPassword" maxlength="20" minlength="6"\n                       ng-model="vmUserChangePassword.changePassword.newPassword" required\n                       placeholder="{{\'user.changePassword.placeholder.newPassword\'| translate}}"\n                       uib-tooltip="{{\'tooltip.password\'| translate}}" tooltip-trigger="focus" tooltip-placement="right"\n                       tooltip-enable="vmUserChangePassword.formChangePassword.newPassword.$invalid"\n                       tooltip-is-open="vmUserChangePassword.formChangePassword.newPassword.$invalid && !vmUserChangePassword.formChangePassword.newPassword.$error.required">\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-xs-14 control-label" for="field-password-repeat"><span data-translate="user.changePassword.repeatNewPassword">Repetir Nova Senha</span>: *</label>\n            <div class="col-xs-10">\n                <input type="password" class="form-control" id="field-password-repeat" name="confirmNewPassword" maxlength="20" minlength="6"\n                       ng-model="vmUserChangePassword.changePassword.confirmNewPassword" required\n                       placeholder="{{\'user.changePassword.placeholder.repeatNewPassword\'| translate}}"\n                       invalid-if="vmUserChangePassword.changePassword.newPassword != vmUserChangePassword.changePassword.confirmNewPassword"\n                       uib-tooltip="{{\'tooltip.newPassword\'| translate}}" tooltip-trigger="focus" tooltip-placement="right"\n                       tooltip-enable="vmUserChangePassword.formChangePassword.confirmNewPassword.$invalid && !vmUserChangePassword.formChangePassword.newPassword.$invalid"\n                       tooltip-is-open="vmUserChangePassword.formChangePassword.confirmNewPassword.$invalid">\n            </div>\n        </div>\n    </div>\n    <div class="modal-footer">\n        <button type="submit" class="btn btn-primary btn-confirm" ng-disabled="vmUserChangePassword.requestRunning" data-translate="global.button.ok">OK</button>\n    </div>\n</form>');
$templateCache.put('app/components/user/user-delete.html','<div class="modal-header">\n    <button type="button" class="close close-delete" ng-click="vmUserDelete.close()">&times;</button>\n    <h4 class="modal-title" id="del-one-olt-label" data-translate="userConfirm.delete.title">Deletar Usu\xE1rio</h4>\n</div>\n<div class="modal-body content-delete">\n    <div data-translate="userConfirm.delete.question" data-translate-values="vmUserDelete.userData">Deseja realmente excluir o usu\xE1rio xxxx?</div>\n</div>\n<div class="modal-footer modal-footer-delete">\n    <button type="button" class="btn btn-default btn-cancel" ng-click="vmUserDelete.close()" ng-disabled="vmUserDelete.requestRunning" data-translate="global.button.cancel">Cancelar</button>\n    <button type="submit" class="btn btn-primary btn-del" ng-click="vmUserDelete.delete()" ng-disabled="vmUserDelete.requestRunning" data-translate="userConfirm.delete.btnConfirm">Deletar</button>\n</div>');
$templateCache.put('app/components/user/user-list.html','<div class="panel user-list-panel">\n    <div class="panel-heading">\n        <div class="container-title pull-left">\n            <span class="modal-title" data-translate="user.list">Lista de Usu\xE1rios</span>\n        </div>\n        <div class="pull-right">\n            <button id="config-add-user" class="btn btn-primary btn-add-user" ng-click="vmUserList.addUser()" has-authority="userAdd" has-behavior="disable-button">\n                <span class="icon icon-plus"></span>\n                <span data-translate="user.addUser">Adicionar Usu\xE1rios</span>\n            </button>\n            <button class="btn btn-primary btn-change-password" data-translate="user.changePassword.title" ng-click="vmUserList.changePassword()">Trocar Senha</button>\n        </div>\n    </div>\n    <div class="panel-body">\n        <table class="table table-striped">\n            <thead>\n                <tr>\n                    <th data-translate="user.add.username">Usu\xE1rio</th>\n                    <th data-translate="user.add.email">E-mail</th>\n                    <th data-translate="user.add.profile">Perfil do Usu\xE1rio</th>\n                    <th></th>\n                    <th></th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr ng-repeat="user in vmUserList.userList">\n                    <td>{{user.username}}</td>\n                    <td>{{user.email}}</td>\n                    <td>{{user.groupName}}</td>\n                    <td>\n                        <button class="btn btn-link" ng-click="vmUserList.editUser(user.id)" uib-tooltip-html="vmUserList.view.tooltip.editUser" tooltip-placement="bottom"\n                                tooltip-append-to-body="true" has-authority="userEdit" has-behavior="disable-default">\n                            <span class="icon icon-edit"></span>\n                        </button>\n                    </td>\n                    <td>\n                        <button class="btn btn-link" ng-click="vmUserList.deleteUser(user)" uib-tooltip-html="vmUserList.view.tooltip.deleteUser" tooltip-placement="bottom"\n                                tooltip-append-to-body="true" has-authority="userDelete" has-behavior="disable-default">\n                            <span class="icon icon-delete"></span>\n                        </button>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n</div>');
$templateCache.put('app/components/user/user.html','<div ui-view="list" class="user-list" has-authority="userList"></div>\n<div ui-view="password" class="container-change-password" has-authority="!userList"></div>\n');
$templateCache.put('app/shared/alert/alert-error-modal.html','<div modal-render="{{$isRendered}}" tabindex="-1" role="dialog" class="modal"\n     uib-modal-animation-class="fade"\n     modal-in-class="in"\n     ng-style="{\'z-index\': 1050 + index * 10, display: \'block\'}">\n    <div class="modal-dialog {{$parent.vmAlertError.modalSize ? $parent.vmAlertError.modalSize : (size ? \'modal-\' + size : \'\')}}">\n        <div class="modal-content" uib-modal-transclude></div>\n    </div>\n</div>\n');
$templateCache.put('app/shared/alert/alert-error.html','<div class="modal-header title-error-message">\n    <button type="button" class="close" ng-click="vmAlertError.close()"><span aria-hidden="true">&times;</span></button>\n    <h4 class="modal-title title-error-message" id="title-error-message" data-translate="global.common.error">ERRO</h4>\n</div>\n<div class="modal-body content-error-message">\n    <p data-translate="{{vmAlertError.modalMessage}}" data-translate-values="{equipmentName: vmAlertError.equipmentName}"></p>\n    <div class="text-left" ng-if="vmAlertError.errorDetail">\n        <p>\n            <button class="btn btn-link btn-error-detail" ng-click="vmAlertError.toggleDetail()">\n                <i class="icon icon-caret-right"></i>\n                <span data-translate="global.button.detail">Detalhes</span>\n            </button>\n        </p>\n        <pre class="error-detail" uib-collapse="vmAlertError.detailCollapsed"><b>{{vmAlertError.errorDetail.command}}</b>{{vmAlertError.errorDetail.printout}}</pre>\n    </div>\n</div>\n');
$templateCache.put('app/shared/alert/alert-success.html','<div class="modal-header header-alert-success">\n    <button id="btn-close-alert-success" type="button" class="close" ng-click="vmAlertSuccess.close()"><span aria-hidden="true">&times;</span></button>\n    <h4 class="modal-title" data-translate="global.common.success">SUCESSO</h4>\n</div>\n<div class="modal-body content-success-message">\n    <div class="content-icon-alert-success">\n        <span class="icon icon-ok"></span>\n    </div>\n    <p data-translate="{{vmAlertSuccess.modalMessage}}">Opera\xE7\xE3o realizada com sucesso.</p>\n</div>');
$templateCache.put('app/shared/alert/alert-wait.html','<div class="modal-header">\n    <h4 class="modal-title title-wait-message" data-translate="globalWait.title">WAIT</h4>\n</div>\n<div class="modal-body content-wait-message">\n    <p data-translate="{{vmAlertWait.modalMessage}}"> Aguarde opera\xE7\xE3o ser finalizada.</p>\n</div>');
$templateCache.put('app/shared/alert/alert-warning.html','<div class="modal-header title-warning-message">\n    <button type="button" class="close" ng-click="vmAlertWarning.close()"><span aria-hidden="true">&times;</span></button>\n    <h4 class="modal-title title-warning-message" id="title-warning-message" data-translate="global.common.warning">ATEN\xC7\xC3O</h4>\n</div>\n<div class="modal-body content-warning-message">\n    <p>\n        <span data-translate="{{vmAlertWarning.modalMessage}}"></span>\n        <b>{{vmAlertWarning.list}}.</b>\n    </p>\n</div>\n');
$templateCache.put('app/shared/datepicker/datepicker.html','<div ng-switch="datepickerMode">\n    <div uib-daypicker ng-switch-when="day" tabindex="0" class="uib-daypicker" template-url="app/shared/datepicker/daypicker.html"></div>\n    <div uib-monthpicker ng-switch-when="month" tabindex="0" class="uib-monthpicker"></div>\n    <div uib-yearpicker ng-switch-when="year" tabindex="0" class="uib-yearpicker"></div>\n</div>');
$templateCache.put('app/shared/datepicker/daypicker.html','<table role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}">\n    <thead>\n        <tr>\n            <th><button type="button" class="btn btn-default btn-sm pull-left uib-left" ng-click="move(-1)" tabindex="-1"><i aria-hidden="true" class="glyphicon glyphicon-chevron-left"></i><span class="sr-only">previous</span></button></th>\n            <th colspan="{{::5 + showWeeks}}"><button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="btn btn-default btn-sm uib-title" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1"><strong>{{title}}</strong></button></th>\n            <th><button type="button" class="btn btn-default btn-sm pull-right uib-right" ng-click="move(1)" tabindex="-1"><i aria-hidden="true" class="glyphicon glyphicon-chevron-right"></i><span class="sr-only">next</span></button></th>\n        </tr>\n        <tr>\n            <th ng-if="showWeeks" class="text-center"></th>\n            <th ng-repeat="label in labels track by $index" class="text-center"><small aria-label="{{label.full}}">{{label.abbr}}</small></th>\n        </tr>\n    </thead>\n    <tbody>\n        <tr class="uib-weeks" ng-repeat="row in rows track by $index" role="row">\n            <td ng-if="showWeeks" class="text-center h6"><em>{{ weekNumbers[$index]}}</em></td>\n            <td ng-repeat="dt in row" class="uib-day text-center" role="gridcell"\n                id="{{::dt.uid}}"\n                ng-class="::dt.customClass">\n                <button type="button" class="btn btn-default btn-sm"\n                        uib-is-class="\n                        \'btn-info\' for selectedDt,\n                        \'active\' for activeDt\n                        on dt"\n                        ng-click="select(dt.date)"\n                        ng-disabled="::dt.disabled"\n                        tabindex="-1"><span ng-class="::{\'text-muted\': dt.secondary, \'text-info\': dt.current}">{{::dt.label}}</span></button>\n            </td>\n        </tr>\n    </tbody>\n</table>');
$templateCache.put('app/components/bridge/partials/bridge-config-additional.html','<div class="combo-title">\n    <span data-translate="bridgeModal.additionalConfig">Configura\xE7\xF5es adicionais</span>\n</div>\n\n<div class="content-block">\n    <div class="form-group">\n        <label class="col-xs-16 control-label" data-translate="bridgeModal.macLimit">Limite de MAC aprendido</label>\n        <div class="col-xs-8">\n            <input type="number" class="form-control" name="bridge-maclimit" ng-model="vmBridgeAdd.bridge.macLimit" min="0" max="2147483647" maxlength="10"\n                   placeholder="{{\'bridgeModal.placeholder.number\'| translate}}" pattern="\\d+"\n                   uib-tooltip="{{\'tooltip.macLimit\'| translate}}" tooltip-placement="right" tooltip-trigger="focus"\n                   ng-disabled="vmBridgeAdd.bridge.olt.model.model == \'Intelbras8820i\' || vmBridgeAdd.bridge.rgMode.model.value == \'RG_ROTEAMENTO\'"> \n        </div>\n    </div>\n\n    <div ng-if="vmBridgeAdd.isAdvanced">\n        <div class="form-group" ng-if="vmBridgeAdd.bridge.interface.value == \'ONU\'">\n            <label class="col-xs-9 control-label multiline" data-translate="bridgeModal.gtp">Gpon Traffic Profile</label>\n            <div class="col-xs-9 col-radio">\n                <label class="checkbox-select-item" ng-class="{checked: vmBridgeAdd.bridge.gtp.automatic}">\n                    <input type="checkbox" name="bridge-enable-gtp" id="enable-gtp" ng-model="vmBridgeAdd.bridge.gtp.automatic" ng-change="vmBridgeAdd.setGtp()">\n                </label>\n                <label for="enable-gtp" data-translate="bridgeModal.automatic">Autom\xE1tico</label>\n            </div>\n            <div class="col-xs-6">\n                <ui-select name="bridge-gtp" ng-model="vmBridgeAdd.bridge.gtp.model" search-enabled="false"\n                           ng-disabled="vmBridgeAdd.bridge.gtp.disabled" ng-required="!vmBridgeAdd.bridge.gtp.disabled">\n                    <ui-select-match>{{vmBridgeAdd.bridge.gtp.model.gtpId}}</ui-select-match>\n                    <ui-select-choices repeat="gtp in vmBridgeAdd.gtpList">{{gtp.gtpId}}</ui-select-choices>\n                </ui-select>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/components/bridge/partials/bridge-config-gemport.html','<div class="form-group" ng-if="vmBridgeAdd.bridge.interface.value == \'ONU\'">\n    <label class="col-xs-8 control-label" data-translate="bridgeModal.gemPort">GEM Port</label>\n    <div class="col-xs-9 col-radio">\n        <label class="checkbox-select-item" ng-class="{checked: vmBridgeAdd.bridge.gemPort.automatic, \'checked-disabled\': vmBridgeAdd.bridge.gemPort.automaticDisabled}">\n            <input type="checkbox" name="bridge-enable-gemport" id="enable-gemport" ng-model="vmBridgeAdd.bridge.gemPort.automatic"\n                   ng-disabled="vmBridgeAdd.bridge.gemPort.automaticDisabled">\n        </label>\n        <label for="enable-gemport" data-translate="bridgeModal.automatic" ng-class="{\'text-disabled\': vmBridgeAdd.bridge.gemPort.automaticDisabled}">Autom\xE1tico</label>\n    </div>\n    <div class="col-xs-7">\n        <input type="number" class="form-control" name="bridge-gemport" min="257" max="3828" maxlength="4" pattern="\\d+"\n               ng-model="vmBridgeAdd.bridge.gemPort.value" placeholder="{{\'bridgeModal.placeholder.number\'| translate}}"\n               ng-disabled="vmBridgeAdd.bridge.gemPort.automatic" ng-required="!vmBridgeAdd.bridge.gemPort.automatic"\n               uib-tooltip="{{\'tooltip.gemPort\'| translate}}" tooltip-placement="right" tooltip-trigger="focus">\n    </div>\n</div>');
$templateCache.put('app/components/bridge/partials/bridge-config-interface-olt.html','<div class="combo-title">\n    <span data-translate="bridgeModal.oltInterface">Interface OLT</span>\n</div>\n\n<div class="content-block">\n    <div class="form-group">\n        <label class="col-xs-8 control-label" data-translate="bridgeModal.type">Tipo</label>\n        <div class="col-xs-16">\n            <ui-select name="bridge-type" ng-model="vmBridgeAdd.bridge.type" on-select="vmBridgeAdd.setType($item)" search-enabled="false" required>\n                <ui-select-match>{{vmBridgeAdd.bridge.type.label}}</ui-select-match>\n                <ui-select-choices repeat="type in vmBridgeAdd.typesList[vmBridgeAdd.bridge.interface.value]">{{type.label}}</ui-select-choices>\n            </ui-select>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="control-label" ng-class="{\'OLT\': \'col-xs-24\', \'ONU\': \'col-xs-8\'}[vmBridgeAdd.bridge.interface.value]">\n            <span data-translate="bridgeModal.vlanMode">Modo LAN</span>\n        </label>\n        <div class="col-xs-8 col-radio radio-options" ng-class="{\'col-xs-16 text-right\': !vmBridgeAdd.isAdvanced}">\n            <span class="status-item-value">\n                <label class="radio" ng-class="{checked: vmBridgeAdd.bridge.vlanMode == \'tagged\'}">\n                    <input type="radio" id="modeTagged" name="bridge-vlanmode" ng-model="vmBridgeAdd.bridge.vlanMode" ng-value="\'tagged\'">\n                </label>\n            </span>\n            <label for="modeTagged" class="status-item-label" data-translate="bridgeModal.tagged">Tagged</label>\n        </div>\n        <div class="col-xs-8 col-radio radio-options text-center" ng-if="vmBridgeAdd.bridge.interface.value == \'OLT\'">\n            <span class="status-item-value">\n                <label class="radio" ng-class="{checked: vmBridgeAdd.bridge.vlanMode == \'untagged\'}">\n                    <input type="radio" id="modeUntagged" name="bridge-vlanmode" ng-model="vmBridgeAdd.bridge.vlanMode" ng-value="\'untagged\'">\n                </label>\n            </span>\n            <label for="modeUntagged" class="status-item-label" data-translate="bridgeModal.untagged">Untagged</label>\n        </div>\n        <div class="col-xs-8 col-radio radio-options text-right" ng-if="vmBridgeAdd.isAdvanced">\n            <span class="status-item-value">\n                <label class="radio" ng-class="{checked: vmBridgeAdd.bridge.vlanMode == \'stagged\', \n                    disabled: vmBridgeAdd.bridge.olt.model.model == \'Intelbras8820i\'}">\n                    <input type="radio" id="modeStagged" name="bridge-vlanmode" ng-model="vmBridgeAdd.bridge.vlanMode" ng-value="\'stagged\'"\n                           ng-disabled="vmBridgeAdd.bridge.olt.model.model == \'Intelbras8820i\'">\n                </label>\n            </span>\n            <label for="modeStagged" class="status-item-label" data-translate="bridgeModal.stagged" \n                   ng-class="{\'text-disabled\': vmBridgeAdd.bridge.olt.model.model == \'Intelbras8820i\'}">Stagged</label>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-xs-16 control-label" data-translate="bridgeModal.vlan">VLAN</label>\n        <div class="col-xs-8">\n            <input type="number" class="form-control" name="bridge-vlan" ng-model="vmBridgeAdd.bridge.vlan.value"\n                   min="{{vmBridgeAdd.bridge.vlan.min}}" max="{{vmBridgeAdd.bridge.vlan.max}}" maxlength="4"\n                   pattern="\\d+" placeholder="{{\'bridgeModal.placeholder.number\'| translate}}" required\n                   uib-tooltip="{{vmBridgeAdd.bridge.vlan.tooltip}}" tooltip-placement="right" tooltip-trigger="focus">\n        </div>\n    </div>\n\n    <div ng-if="vmBridgeAdd.isAdvanced">\n        <div class="form-group">\n            <label class="col-xs-16 control-label" data-translate="bridgeModal.cos">COS</label>\n            <div class="col-xs-8">\n                <input type="number" class="form-control" name="bridge-cos" ng-model="vmBridgeAdd.bridge.cos" min="0" max="7" maxlength="1"\n                       pattern="\\d+" placeholder="{{\'bridgeModal.placeholder.number\'| translate}}"\n                       uib-tooltip="{{\'tooltip.cos\'| translate}}" tooltip-placement="right" tooltip-trigger="focus">\n            </div>\n        </div>\n\n        <div class="form-group">\n            <label class="col-xs-16 control-label" data-translate="bridgeModal.outcosall">OUTCOSALL</label>\n            <div class="col-xs-8">\n                <input type="number" class="form-control" name="bridge-outcosall" ng-model="vmBridgeAdd.bridge.outcosall" min="0" max="7" maxlength="1"\n                       pattern="\\d+" placeholder="{{\'bridgeModal.placeholder.number\'| translate}}"\n                       ng-disabled="vmBridgeAdd.bridge.olt.model.model == \'Intelbras8820i\'"\n                       uib-tooltip="{{\'tooltip.outcosall\'| translate}}" tooltip-placement="right" tooltip-trigger="focus">\n            </div>\n        </div>\n\n        <div class="form-group">\n            <label class="col-xs-16 control-label" data-translate="bridgeModal.slan">SLAN</label>\n            <div class="col-xs-8">\n                <input type="number" class="form-control" name="bridge-slan" ng-model="vmBridgeAdd.bridge.slan.value" min="0" max="4094" maxlength="4"\n                       pattern="\\d+" placeholder="{{\'bridgeModal.placeholder.number\'| translate}}"\n                       ng-disabled="vmBridgeAdd.bridge.vlanMode != \'stagged\'" ng-required="vmBridgeAdd.bridge.vlanMode==\'stagged\'"\n                       uib-tooltip="{{vmBridgeAdd.bridge.slan.tooltip}}" tooltip-placement="right" tooltip-trigger="focus">\n            </div>\n        </div>\n\n        <div class="form-group">\n            <label class="col-xs-16 control-label" data-translate="bridgeModal.scos">SCOS</label>\n            <div class="col-xs-8">\n                <input type="number" class="form-control" name="bridge-scos" ng-model="vmBridgeAdd.bridge.scos" min="0" max="7" maxlength="1"\n                       pattern="\\d+" placeholder="{{\'bridgeModal.placeholder.number\'| translate}}"\n                       ng-disabled="vmBridgeAdd.bridge.vlanMode != \'stagged\'"\n                       uib-tooltip="{{\'tooltip.scos\'| translate}}" tooltip-placement="right" tooltip-trigger="focus">\n            </div>\n        </div>\n\n        <div class="form-group">\n            <label class="col-xs-16 control-label" data-translate="bridgeModal.soutcosall">SOUTCOSALL</label>\n            <div class="col-xs-8">\n                <input type="number" class="form-control" name="bridge-soutcosall" ng-model="vmBridgeAdd.bridge.soutcosall" min="0" max="7" maxlength="1"\n                       pattern="\\d+" placeholder="{{\'bridgeModal.placeholder.number\'| translate}}"\n                       ng-disabled="vmBridgeAdd.bridge.vlanMode != \'stagged\'"\n                       uib-tooltip="{{\'tooltip.soutcosall\'| translate}}" tooltip-placement="right" tooltip-trigger="focus">\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/components/bridge/partials/bridge-config-interface-onu.html','<div class="combo-title">\n    <span data-translate="bridgeModal.onuInterface">Interface ONU</span>\n</div>\n\n<div class="content-block">\n    <div class="form-group">\n        <label class="col-xs-7 control-label" data-translate="bridgeModal.rgMode">Modo RG</label>\n        <div class="col-xs-17">\n            <ui-select name="bridge-rgmode" ng-model="vmBridgeAdd.bridge.rgMode.model" on-select="vmBridgeAdd.setRgMode($item)" search-enabled="false"\n                       ng-disabled="vmBridgeAdd.bridge.rgMode.disabled">\n                <ui-select-match placeholder="Selecione o Modo">{{vmBridgeAdd.bridge.rgMode.model.label}}</ui-select-match>\n                <ui-select-choices repeat="rgMode in vmBridgeAdd.rgModeList">{{rgMode.label}}</ui-select-choices>\n            </ui-select>\n        </div>\n    </div>\n\n\n    <div ng-if="vmBridgeAdd.isAdvanced">\n        <div class="router" ng-if="vmBridgeAdd.checkRgMode(\'RG_BROUTED\')">\n            <div class="content-block">\n\n\n                <div class="form-group">\n                    <label class="col-xs-12 control-label" data-translate="bridgeModal.ipMode">Modo IP</label>\n                    <div class="col-xs-12">\n                        <ui-select name="ipMode" ng-model="vmBridgeAdd.bridge.ipMode.model" \n                                   ng-change="vmBridgeAdd.changeModoRouted()" search-enabled="false" required>\n                            <ui-select-match placeholder="Selecione o Modo">{{$select.selected.profileName}}</ui-select-match>\n                            <ui-select-choices repeat="profile in vmBridgeAdd.cpeVoipIpProfileList">{{profile.profileName}}\n                            </ui-select-choices>\n                        </ui-select>\n                    </div>\n                </div>\n\n                <div class="form-group">\n                    <label class="col-xs-12 control-label">Profiles</label>\n\n                    <div class="col-xs-12" ng-show="vmBridgeAdd.bridge.ipMode.model.profileName == \'DHCP\'">\n                        <ui-select name="profiles" ng-model="vmBridgeAdd.bridge.ipProfile.model" \n                                   search-enabled="false" \n                                   ng-required="vmBridgeAdd.is8820G()" ng-disabled="!vmBridgeAdd.featuresProfileList.length">\n                            <ui-select-match placeholder="{{vmBridgeAdd.bridge.profiles.placeholder| translate}}">{{vmBridgeAdd.bridge.ipProfile.model.profileName}}</ui-select-match>\n                            <ui-select-choices repeat="featuresProfile in vmBridgeAdd.featuresProfileList">{{featuresProfile.profileName}}</ui-select-choices>\n                        </ui-select>\n                    </div>\n\n                    <div class="col-xs-12" ng-show="vmBridgeAdd.bridge.ipMode.model.profileName != \'DHCP\'">\n                        <ui-select name="profiles" ng-model="vmBridgeAdd.bridge.ipProfile.model" \n                                   search-enabled="false"\n                                   ng-required="vmBridgeAdd.is8820G()" ng-disabled="!vmBridgeAdd.featuresProfileList.length">\n                            <ui-select-match placeholder="{{vmBridgeAdd.bridge.profiles.placeholder| translate}}">{{vmBridgeAdd.bridge.ipProfile.model.profileName}}</ui-select-match>\n                            <ui-select-choices repeat="featuresProfile in vmBridgeAdd.featuresStaticProfileList">{{featuresProfile.profileName}}</ui-select-choices>\n                        </ui-select>\n                    </div>\n                </div>   \n\n                <div class="form-group">\n                    <label class="col-xs-12 control-label" data-translate="bridgeModal.ipAddress">Endere\xE7o IP</label>\n                    <div class="col-xs-12">\n                        <input type="text" class="form-control" name="ipAddress" ng-model="vmBridgeAdd.bridge.ipAddress.value" maxlength="15"\n                               pattern="^((25[0-4]|2[0-4][0-9]|[01]?[0-9][0-9]?){1}(\\.)){3}(25[0-4]|2[0-4][0-9]|[01]?[0-9][0-9]?){1}$"\n                               ng-disabled="vmBridgeAdd.bridge.ipMode.model.profileName != \'STATIC\'"\n                               ng-required="!vmBridgeAdd.bridge.ipAddress.disabled"\n                               placeholder="XXX.XXX.XXX.XXX" uib-tooltip="{{\'tooltip.ip.invalid\'| translate}}" tooltip-trigger="focus"\n                               tooltip-placement="left">\n\n                    </div>\n                </div>\n\n                <div class="form-group">\n                    <label class="col-xs-12 control-label" data-translate="bridgeModal.subnetMask">M\xE1scara de subrede</label>\n                    <div class="col-xs-12">\n                        <input type="text" class="form-control" name="subnetMask" ng-model="vmBridgeAdd.bridge.ipProfile.model.netmask" maxlength="15"\n                               pattern="^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?){1}(\\.)){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?){1}$"\n                               ng-disabled="vmBridgeAdd.bridge.subnetMask.disabled" ng-required="!vmBridgeAdd.bridge.subnetMask.disabled"\n                               placeholder="XXX.XXX.XXX.XXX"\n                               uib-tooltip="{{\'tooltip.subnetMask\'| translate}}" tooltip-trigger="focus" tooltip-placement="left">\n                    </div>\n                </div>\n\n                <div class="form-group">\n                    <label class="col-xs-12 control-label" data-translate="bridgeModal.gateway">Gateway</label>\n                    <div class="col-xs-12">\n                        <input type="text" class="form-control" name="defaultGateway" ng-model="vmBridgeAdd.bridge.ipProfile.model.gateway" maxlength="15"\n                               pattern="^((25[0-4]|2[0-4][0-9]|[01]?[0-9][0-9]?){1}(\\.)){3}(25[0-4]|2[0-4][0-9]|[01]?[0-9][0-9]?){1}$"\n                               ng-disabled="vmBridgeAdd.bridge.gateway.disabled" ng-required="!vmBridgeAdd.bridge.gateway.disabled"\n                               placeholder="XXX.XXX.XXX.XXX"\n                               uib-tooltip="{{\'tooltip.gateway\'| translate}}" tooltip-trigger="focus" tooltip-placement="left">\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class="ppoe" ng-if="vmBridgeAdd.checkRgMode(\'RG_BPPPOE\')">\n            <div class="content-block">\n                <div class="form-group">\n                    <label class="col-xs-12 control-label" data-translate="bridgeModal.user">Usu\xE1rio</label>\n                    <div class="col-xs-12">\n                        <input type="text" class="form-control" name="user" ng-model="vmBridgeAdd.bridge.user" maxlength="50" required\n                               placeholder="{{\'bridgeModal.placeholder.user\'| translate}}">\n                    </div>\n                </div>\n                <div class="form-group">\n                    <label class="col-xs-12 control-label" data-translate="bridgeModal.password">Senha</label>\n                    <div class="col-xs-12">\n                        <input type="password" class="form-control" name="password" ng-model="vmBridgeAdd.bridge.password" required\n                               placeholder="{{\'bridgeModal.placeholder.password\'| translate}}" autocomplete="new-password">\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class="form-group" >\n            <label class="col-xs-7 control-label" data-translate="bridgeModal.lanPort">LAN Port</label>\n            <div class="col-xs-17 col-radio radio-options text-right">\n                <span class="status-item" ng-repeat="(index, value) in vmBridgeAdd.bridge.lanPort.model">\n\n                    <label class="checkbox-select-item" ng-class="{checked: vmBridgeAdd.bridge.lanPort.model[index], disabled: vmBridgeAdd.isLanPortDisabled(index)}">\n                        <input type="checkbox" name="bridge-unilan" id="unilan{{index}}" ng-model="vmBridgeAdd.bridge.lanPort.model[index]"\n                               ng-disabled="vmBridgeAdd.isLanPortDisabled(index)" ng-change="vmBridgeAdd.setUniPort(index)"  ng-click="vmBridgeAdd.showAlert(this)" >\n\n                    </label>\n                    <label for="unilan{{index}}" ng-class="{\'text-disabled\': vmBridgeAdd.isLanPortDisabled(index)}">{{index}}</label>\n                </span>\n            </div>\n        </div>\n\n\n        <div class="form-group">\n            <label class="col-xs-7 control-label" data-translate="bridgeModal.wlan">WLAN</label>\n            <div class="col-xs-17 col-radio radio-options text-right">\n                <span class="status-item" ng-repeat="(index, value) in vmBridgeAdd.bridge.wlan.model">\n                    <label class="checkbox-select-item" ng-class="{checked: vmBridgeAdd.bridge.wlan.model[index], disabled: vmBridgeAdd.bridge.wlan.disabled}">\n                        <input type="checkbox" name="bridge-uniwlan" id="uniwlan{{index}}" ng-model="vmBridgeAdd.bridge.wlan.model[index]"\n                               ng-disabled="vmBridgeAdd.bridge.wlan.disabled">\n                    </label>\n                    <label for="uniwlan{{index}}" ng-class="{\'text-disabled\': vmBridgeAdd.bridge.wlan.disabled}">{{index}}</label>\n                </span>\n            </div>\n        </div>\n\n    </div>\n</div>\n\n<div class="combo-title" ng-if="vmBridgeAdd.isAdvanced">\n    <span data-translate="bridgeModal.vlanMode">Modo LAN</span>\n</div>\n\n<div class="content-block" ng-if="vmBridgeAdd.isAdvanced">\n\n    <div>\n\n        <div class="form-group">            \n\n            <div class="col-xs-8 col-radio radio-options">\n                <span class="status-item-value">\n                    <label class="radio" ng-class="{checked: vmBridgeAdd.bridge.uniVlanMode == \'tagged\', disabled: vmBridgeAdd.bridge.onuInterface.disabled}">\n                        <input type="radio" id="rgModeTagged" name="bridge-lanmode" ng-model="vmBridgeAdd.bridge.uniVlanMode" ng-value="\'tagged\'"\n                               ng-disabled="vmBridgeAdd.bridge.onuInterface.disabled">\n                    </label>\n                </span>\n                <label for="rgModeTagged" class="status-item-label" ng-class="{\'text-disabled\': vmBridgeAdd.bridge.onuInterface.disabled}"\n                       data-translate="bridgeModal.tagged">Tagged</label>\n            </div>\n            <div class="col-xs-8 col-radio radio-options text-center">\n                <span class="status-item-value">\n                    <label class="radio" ng-class="{checked: vmBridgeAdd.bridge.uniVlanMode == \'untagged\', disabled: vmBridgeAdd.bridge.onuInterface.disabled}">\n                        <input type="radio" id="rgModeUntagged" name="bridge-lanmode" ng-model="vmBridgeAdd.bridge.uniVlanMode" ng-value="\'untagged\'"\n                               ng-disabled="vmBridgeAdd.bridge.onuInterface.disabled">\n                    </label>\n                </span>\n                <label for="rgModeUntagged" class="status-item-label" ng-class="{\'text-disabled\': vmBridgeAdd.bridge.onuInterface.disabled}"\n                       data-translate="bridgeModal.untagged">Untagged</label>\n            </div>\n            <div class="col-xs-8 col-radio radio-options text-right">\n                <span class="status-item-value">\n                    <label class="radio" ng-class="{checked: vmBridgeAdd.bridge.uniVlanMode == \'stagged\', disabled: vmBridgeAdd.bridge.onuInterface.disabled}">\n                        <input type="radio" id="rgModeStagged" name="bridge-lanmode" ng-model="vmBridgeAdd.bridge.uniVlanMode" ng-value="\'stagged\'"\n                               ng-disabled="vmBridgeAdd.bridge.onuInterface.disabled || vmBridgeAdd.bridge.olt.model.model == \'Intelbras8820i\'">\n                    </label>\n                </span>\n                <label for="rgModeStagged" class="status-item-label" ng-class="{\'text-disabled\': vmBridgeAdd.bridge.onuInterface.disabled || vmBridgeAdd.bridge.olt.model.model == \'Intelbras8820i\'}"\n                       data-translate="bridgeModal.stagged">Stagged</label>\n            </div>\n        </div>\n\n        <div class="form-group">\n            <label class="col-xs-16 control-label" data-translate="bridgeModal.vlan">VLAN</label>\n            <div class="col-xs-8">\n                <input type="number" class="form-control" name="bridge-univlan" ng-model="vmBridgeAdd.bridge.uniVlan" min="0" max="4094"\n                       pattern="\\d+" placeholder="{{\'bridgeModal.placeholder.number\'| translate}}"\n                       ng-disabled="vmBridgeAdd.bridge.uniVlanMode == \'untagged\' || vmBridgeAdd.bridge.onuInterface.disabled"\n                       ng-required="vmBridgeAdd.bridge.uniVlanMode!=\'untagged\' && !vmBridgeAdd.bridge.onuInterface.disabled"\n                       uib-tooltip="{{\'tooltip.univlan\'| translate}}" tooltip-placement="left" tooltip-trigger="focus">\n            </div>\n        </div>\n\n        <div class="form-group">\n            <label class="col-xs-16 control-label" data-translate="bridgeModal.slan">SLAN</label>\n            <div class="col-xs-8">\n                <input type="number" class="form-control" name="bridge-unislan" ng-model="vmBridgeAdd.bridge.uniSlan" min="0" max="4094"\n                       pattern="\\d+" placeholder="{{\'bridgeModal.placeholder.number\'| translate}}"\n                       ng-disabled="vmBridgeAdd.bridge.uniVlanMode != \'stagged\' || vmBridgeAdd.bridge.onuInterface.disabled || vmBridgeAdd.bridge.olt.model.model == \'Intelbras8820i\'"\n                       ng-required="vmBridgeAdd.bridge.uniVlanMode==\'stagged\' && !vmBridgeAdd.bridge.onuInterface.disabled"\n                       uib-tooltip="{{\'tooltip.unislan\'| translate}}" tooltip-placement="left" tooltip-trigger="focus">\n            </div>\n        </div>\n\n    </div>\n\n\n\n</div>\n');
$templateCache.put('app/components/bridge/partials/bridge-config-interface.html','<div class="combo-title">\n    <div class="row">\n        <div class="col-xs-8">\n            <span data-translate="bridgeModal.interface">Interface</span>\n        </div>\n        <div class="col-xs-16 text-right radio-options">\n            <span class="status-item">\n                <span class="status-item-value">\n                    <label class="radio" ng-class="{checked: vmBridgeAdd.bridge.interface.value == \'OLT\', disabled: vmBridgeAdd.bridge.interface.disabled}">\n                        <input type="radio" id="interfaceOLT" name="bridge-interface" ng-model="vmBridgeAdd.bridge.interface.value"ng-value="\'OLT\'"\n                               ng-change="vmBridgeAdd.setInterface()" ng-disabled="vmBridgeAdd.bridge.interface.disabled">\n                    </label>\n                </span>\n                <label for="interfaceOLT" class="status-item-label" ng-class="{\'text-disabled\': vmBridgeAdd.bridge.interface.disabled}" data-translate="bridgeModal.olt">OLT</label>\n            </span>\n            <span class="status-item">\n                <span class="status-item-value">\n                    <label class="radio" ng-class="{checked: vmBridgeAdd.bridge.interface.value == \'ONU\', disabled: vmBridgeAdd.bridge.interface.disabled}">\n                        <input type="radio" id="interfaceONU" name="bridge-interface" ng-model="vmBridgeAdd.bridge.interface.value" ng-value="\'ONU\'"\n                               ng-change="vmBridgeAdd.setInterface()" ng-disabled="vmBridgeAdd.bridge.interface.disabled">\n                    </label>\n                </span>\n                <label for="interfaceONU" class="status-item-label" ng-class="{\'text-disabled\': vmBridgeAdd.bridge.interface.disabled}" data-translate="bridgeModal.onu">ONU</label>\n            </span>\n        </div>\n    </div>\n</div>\n\n<div class="content-block">\n    <div class="form-group">\n        <label class="col-xs-8 control-label" data-translate="bridgeModal.olt">OLT</label>\n        <div class="col-xs-16">\n            <ui-select name="bridge-olt" ng-model="vmBridgeAdd.bridge.olt.model" on-select="vmBridgeAdd.setOlt($item)" search-enabled="false"\n                       ng-disabled="vmBridgeAdd.bridge.olt.disabled" ng-required="!vmBridgeAdd.bridge.olt.disabled">\n                <ui-select-match placeholder="{{\'global.common.select\'| translate}}">{{vmBridgeAdd.bridge.olt.model.name}}</ui-select-match>\n                <ui-select-choices repeat="olt in vmBridgeAdd.oltList | orderBy:\'id\'">{{olt.name}}</ui-select-choices>\n            </ui-select>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-xs-8 control-label" data-translate="bridgeModal.oltPort">Porta da OLT</label>\n        <div class="col-xs-16">\n            <ui-select name="bridge-port" ng-model="vmBridgeAdd.bridge.port.model" on-select="vmBridgeAdd.setPort($item, $select)" search-enabled="false"\n                       ng-disabled="vmBridgeAdd.bridge.port.disabled" required>\n                <ui-select-match placeholder="{{vmBridgeAdd.bridge.port.placeholder| translate}}">{{vmBridgeAdd.bridge.port.model.label}}</ui-select-match>\n                <ui-select-choices repeat="port in vmBridgeAdd.portList[vmBridgeAdd.bridge.interface.value]">{{port.label}}</ui-select-choices>\n            </ui-select>\n        </div>\n    </div>\n\n    <div class="form-group" ng-if="vmBridgeAdd.bridge.interface.value == \'ONU\'">\n        <label class="col-xs-8 control-label" data-translate="bridgeModal.onu">ONU</label>\n        <div class="col-xs-16">\n            <ui-select name="bridge-onu" ng-model="vmBridgeAdd.bridge.onu.model" on-select="vmBridgeAdd.setOnu($item, $select)" search-enabled="false"\n                       ng-disabled="vmBridgeAdd.bridge.onu.disabled" required>\n                <ui-select-match placeholder="{{vmBridgeAdd.bridge.onu.placeholder| translate}}">{{vmBridgeAdd.bridge.onu.model.name}}</ui-select-match>\n                <ui-select-choices repeat="onu in vmBridgeAdd.onuList">{{onu.name}} ({{onu.meProfile}})</ui-select-choices>\n            </ui-select>\n        </div>\n    </div>\n\n    <div ng-include="vmBridgeAdd.partial(\'gemport\')"></div>\n</div>\n');
$templateCache.put('app/components/bridge/partials/bridge-config-name.html','<div class="form-group">\n    <label class="col-xs-8 control-label" data-translate="bridgeModal.name">Nome</label>\n    <div class="col-xs-16">\n        <input type="text" class="form-control field-bridge-name" name="bridge-name" maxlength="{{vmBridgeAdd.bridge.name.maxlength}}" required\n               ng-model="vmBridgeAdd.bridge.name.value" placeholder="{{\'bridgeModal.placeholder.name\'| translate}}"\n               uib-tooltip="{{vmBridgeAdd.bridge.name.tooltip}}" tooltip-placement="right" tooltip-trigger="focus">\n    </div>\n</div>\n');
$templateCache.put('app/components/bridge/partials/bridge-config-rules.html','<div class="combo-title">\n    <span data-translate="bridgeModal.rules">Regras de pacote</span>\n</div>\n\n<div class="content-block">\n    <div class="form-group">\n        <label class="col-xs-18 control-label" data-translate="bridgeModal.ingressPacketRule">Regras de Entrada de Pacote</label>\n        <div class="col-xs-6">\n            <ui-select name="bridge-irule" ng-model="vmBridgeAdd.bridge.iPacketRule.model" on-select="vmBridgeAdd.setIPacketRule($item)" search-enabled="false"\n                       ng-disabled="vmBridgeAdd.bridge.iPacketRule.disabled">\n                <ui-select-match>{{vmBridgeAdd.bridge.iPacketRule.model.groupIdEquipment}}</ui-select-match>\n                <ui-select-choices repeat="packetRule in vmBridgeAdd.packetRuleList">{{packetRule.groupIdEquipment}}</ui-select-choices>\n            </ui-select>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-xs-18 control-label" data-translate="bridgeModal.egressPacketRule">Regras de Saida de Pacote</label>\n        <div class="col-xs-6">\n            <ui-select name="bridge-erule" ng-model="vmBridgeAdd.bridge.ePacketRule.model" on-select="vmBridgeAdd.setEPacketRule($item)" search-enabled="false"\n                       ng-disabled="vmBridgeAdd.bridge.ePacketRule.disabled">\n                <ui-select-match>{{vmBridgeAdd.bridge.ePacketRule.model.groupIdEquipment}}</ui-select-match>\n                <ui-select-choices repeat="packetRule in vmBridgeAdd.packetRuleList">{{packetRule.groupIdEquipment}}</ui-select-choices>\n            </ui-select>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/components/bridge/partials/bridge-config-service.html','<div class="combo-title">\n    <span data-translate="bridgeModal.service">Servi\xE7o</span>\n</div>\n\n<div class="content-block row">\n    <div class="col-xs-8 col-radio radio-options" ng-class="{\'col-xs-12\': !vmBridgeAdd.isAdvanced}">\n        <span class="status-item-value">\n            <label class="radio" ng-class="{checked: vmBridgeAdd.bridge.service == \'data\'}">\n                <input type="radio" id="serviceData" name="bridge-service" ng-model="vmBridgeAdd.bridge.service" ng-value="\'data\'" ng-change="vmBridgeAdd.setService()">\n            </label>\n        </span>\n        <label for="serviceData" class="status-item-label" data-translate="bridgeModal.data">Dados</label>\n    </div>\n    <div class="col-xs-8 col-radio radio-options" ng-class="{\'text-center\': vmBridgeAdd.isAdvanced}">\n        <span class="status-item-value">\n            <label class="radio" ng-class="{checked: vmBridgeAdd.bridge.service == \'video\', disabled: vmBridgeAdd.bridge.video.disabled ||\n                        vmBridgeAdd.bridge.olt.model.model == \'Intelbras8820i\'}">\n                <input type="radio" id="serviceVideo" name="bridge-service" ng-model="vmBridgeAdd.bridge.service" ng-value="\'video\'"\n                       ng-disabled="vmBridgeAdd.bridge.video.disabled || vmBridgeAdd.bridge.olt.model.model == \'Intelbras8820i\'" ng-change="vmBridgeAdd.setService()">\n            </label>\n        </span>\n        <label for="serviceVideo" class="status-item-label" data-translate="bridgeModal.video" ng-class="{\'text-disabled\': vmBridgeAdd.bridge.video.disabled || vmBridgeAdd.bridge.olt.model.model == \'Intelbras8820i\'}">V\xEDdeo</label>\n    </div>\n    <div class="col-xs-8 col-radio radio-options text-right" ng-if="vmBridgeAdd.isAdvanced">\n        <span class="status-item-value">\n            <label class="radio" ng-class="{checked: vmBridgeAdd.bridge.service == \'voice\', disabled: vmBridgeAdd.bridge.voice.disabled}">\n                <input type="radio" id="serviceVoice" name="bridge-service" ng-model="vmBridgeAdd.bridge.service" ng-value="\'voice\'"\n                       ng-disabled="vmBridgeAdd.bridge.voice.disabled" ng-change="vmBridgeAdd.setService()">\n            </label>\n        </span>\n        <label for="serviceVoice" class="status-item-label" data-translate="bridgeModal.voice" ng-class="{\'text-disabled\': vmBridgeAdd.bridge.voice.disabled}">Voz</label>\n    </div>\n</div>\n');
$templateCache.put('app/components/bridge/partials/bridge-config-simple-interface.html','<div class="combo-title">\n    <div class="row">\n        <div class="col-xs-8">\n            <span data-translate="bridgeModal.interface">Interface</span>\n        </div>\n        <div class="col-xs-16 text-right radio-options">\n            <span class="status-item">\n                <span class="status-item-value">\n                    <label class="radio" ng-class="{checked: vmBridgeAdd.bridge.interface.value == \'OLT\', disabled: vmBridgeAdd.bridge.interface.disabled && vmBridgeAdd.bridge.interface.value != \'OLT\'}">\n                        <input type="radio" id="interfaceOLT" name="bridge-interface" ng-model="vmBridgeAdd.bridge.interface.value" ng-value="\'OLT\'" disabled>\n                    </label>\n                </span>\n                <label for="interfaceOLT" class="status-item-label" ng-class="{\'text-disabled\': vmBridgeAdd.bridge.interface.disabled && vmBridgeAdd.bridge.interface.value != \'OLT\'}" data-translate="bridgeModal.olt">OLT</label>\n            </span>\n            <span class="status-item">\n                <span class="status-item-value">\n                    <label class="radio" ng-class="{checked: vmBridgeAdd.bridge.interface.value == \'ONU\', disabled: vmBridgeAdd.bridge.interface.disabled && vmBridgeAdd.bridge.interface.value != \'ONU\'}">\n                        <input type="radio" id="interfaceONU" name="bridge-interface" ng-model="vmBridgeAdd.bridge.interface.value" ng-value="\'ONU\'" disabled>\n                    </label>\n                </span>\n                <label for="interfaceONU" class="status-item-label" ng-class="{\'text-disabled\': vmBridgeAdd.bridge.interface.disabled && vmBridgeAdd.bridge.interface.value != \'ONU\'}" data-translate="bridgeModal.onu">ONU</label>\n            </span>\n        </div>\n    </div>\n</div>\n<div class="content-block">\n    <div class="form-group">\n        <label class="col-xs-8 control-label" data-translate="bridgeModal.olt">OLT</label>\n        <div class="col-xs-16">\n            <input type="text" class="form-control" ng-model="vmBridgeAdd.bridge.olt.model.name" readonly>\n        </div>\n    </div>\n    <div class="form-group">\n        <label class="col-xs-8 control-label" data-translate="bridgeModal.oltPort">Porta da OLT</label>\n        <div class="col-xs-16">\n            <input type="text" class="form-control" ng-model="vmBridgeAdd.bridge.port.model.label" readonly>\n        </div>\n    </div>\n    <div class="form-group" ng-if="vmBridgeAdd.bridge.interface.value == \'ONU\'">\n        <label class="col-xs-8 control-label" data-translate="bridgeModal.onu">ONU</label>\n        <div class="col-xs-16">\n            <input type="text" class="form-control" ng-model="vmBridgeAdd.bridge.onu.model.name" readonly>\n        </div>\n    </div>\n    <div ng-include="vmBridgeAdd.partial(\'gemport\')" ng-if="vmBridgeAdd.isAdvanced"></div>\n</div>');
$templateCache.put('app/components/bridge/partials/bridge-config-sip.html','<div class="combo-title">\r\n    <span data-translate="bridgeModal.onuInterface">Interface ONU</span>\r\n</div>\r\n\r\n<div class="content-block">\r\n\r\n    <div class="form-group">\r\n        <label class="col-xs-12 control-label">Modo</label>\r\n        <div class="col-xs-12">\r\n            <ui-select name="{{profile.profileName}}" ng-model="vmBridgeAdd.cpeVoipIpProfile"  ng-change="vmBridgeAdd.changeConfigIndex(vmBridgeAdd.cpeVoipIpProfile)" \r\n                       search-enabled="false">\r\n                <ui-select-match placeholder="Selecione o profile">{{$select.selected.profileName}}</ui-select-match>\r\n                <ui-select-choices repeat="profile in vmBridgeAdd.cpeVoipIpProfileList">{{profile.profileName}}</ui-select-choices>\r\n            </ui-select>\r\n        </div>\r\n    </div>\r\n    <div class="form-group">\r\n        <label class="col-xs-12 control-label">IP</label>\r\n        <div class="col-xs-12">\r\n            <input type="text" class="form-control" id="field-access-ip" name="accessIp" ng-model="vmBridgeAdd.cpeVoipIpProfile.gateway"\r\n                   maxlength="15" pattern="^((25[0-4]|2[0-4][0-9]|[01]?[0-9][0-9]?){1}(\\.)){3}(25[0-4]|2[0-4][0-9]|[01]?[0-9][0-9]?){1}$"\r\n                   placeholder="XXX.XXX.XXX.XXX" ng-disabled="vmBridgeAdd.cpeVoipIpProfile.index == 1" required\r\n                   uib-tooltip="{{\'tooltip.ip.invalid\'| translate}}"\r\n                   tooltip-trigger="focus"\r\n                   tooltip-placement="right">    \r\n        </div>\r\n    </div>\r\n\r\n    <div class="form-group">\r\n        <label class="col-xs-12 control-label" data-translate="bridgeModal.serverIndex">Index Servidor</label>\r\n        <div class="col-xs-12">                \r\n            <ui-select name="bridge-fxs-serverProfile" ng-model="vmBridgeAdd.serverProfile" search-enabled="false"\r\n                       required ng-disabled="!vmBridgeAdd.serverProfileList.length">\r\n                <ui-select-match placeholder="{{vmBridgeAdd.bridge.profiles.placeholder| translate}}">{{vmBridgeAdd.serverProfile.profileName}}</ui-select-match>\r\n                <ui-select-choices repeat="serverProfile in vmBridgeAdd.serverProfileList">{{serverProfile.profileName}}</ui-select-choices>\r\n            </ui-select>\r\n\r\n        </div>\r\n    </div>\r\n\r\n    <div class="form-group">\r\n        <label class="col-xs-12 control-label">Index IP-COM</label>\r\n\r\n        <div class="col-xs-12" ng-show="vmBridgeAdd.cpeVoipIpProfile.profileName == \'DHCP\'">\r\n            <ui-select name="bridge-fxs-featuresProfile" ng-model="vmBridgeAdd.featuresProfile" search-enabled="false"\r\n                       ng-required="vmBridgeAdd.is8820G()" ng-disabled="!vmBridgeAdd.featuresProfileList.length">\r\n                <ui-select-match placeholder="{{vmBridgeAdd.bridge.profiles.placeholder| translate}}">{{vmBridgeAdd.featuresProfile.profileName}}</ui-select-match>\r\n                <ui-select-choices repeat="featuresProfile in vmBridgeAdd.featuresProfileList">{{featuresProfile.profileName}}</ui-select-choices>\r\n            </ui-select>\r\n        </div>\r\n\r\n        <div class="col-xs-12" ng-show="vmBridgeAdd.cpeVoipIpProfile.profileName != \'DHCP\'">\r\n            <ui-select name="bridge-fxs-featuresProfile" ng-model="vmBridgeAdd.featuresProfile" search-enabled="false"\r\n                       ng-required="vmBridgeAdd.is8820G()" ng-disabled="!vmBridgeAdd.featuresStaticProfileList.length">\r\n                <ui-select-match placeholder="{{vmBridgeAdd.bridge.profiles.placeholder| translate}}">{{vmBridgeAdd.featuresProfile.profileName}}</ui-select-match>\r\n                <ui-select-choices repeat="featuresProfile in vmBridgeAdd.featuresStaticProfileList">{{featuresProfile.profileName}}</ui-select-choices>\r\n            </ui-select>\r\n        </div>\r\n    </div>    \r\n\r\n    <div class="form-group">\r\n        <label class="col-xs-12 control-label" data-translate="bridgeModal.mediaIndex">Index M\xEDdia</label>\r\n        <div class="col-xs-12">\r\n            <ui-select name="bridge-fxs-mediaProfile" ng-model="vmBridgeAdd.mediaProfile" search-enabled="false"\r\n                       required ng-disabled="!vmBridgeAdd.mediaProfileList.length">\r\n                <ui-select-match placeholder="{{vmBridgeAdd.bridge.profiles.placeholder| translate}}">{{vmBridgeAdd.mediaProfile.profileName}}</ui-select-match>\r\n                <ui-select-choices repeat="mediaProfile in vmBridgeAdd.mediaProfileList">{{mediaProfile.profileName}}</ui-select-choices>\r\n            </ui-select>\r\n        </div>\r\n    </div>\r\n\r\n    <div class="form-group" ng-show="vmBridgeAdd.is8820G()"">\r\n        <label class="col-xs-12 control-label">Index Features</label>\r\n        <div class="col-xs-12">\r\n            <ui-select name="bridge-fxs-zhoneFeatures" ng-model="vmBridgeAdd.zhoneFeatures" search-enabled="false">\r\n                <ui-select-match placeholder="{{vmBridgeAdd.bridge.profiles.placeholder| translate}}">{{vmBridgeAdd.zhoneFeatures.profileName}}</ui-select-match>\r\n                <ui-select-choices repeat="zhoneFeatures in vmBridgeAdd.zhoneFeaturesList">{{zhoneFeatures.profileName}}</ui-select-choices>\r\n            </ui-select>\r\n        </div>\r\n    </div>\r\n\r\n    <div class="content-block">\r\n\r\n        <div class="form-group text-center">\r\n            <button type="button" class="btn btn-default" ng-class="{\'btn-primary\': vmBridgeAdd.bridge.fxs[0].enablePort, \'btn-danger\': vmBridgeAdd.bridge.fxs[0].invalid}"\r\n                    ng-model="vmBridgeAdd.selectedFxs" uib-btn-radio="1">Fxs 1</button>\r\n            <button type="button" class="btn btn-default" ng-class="{\'btn-primary\': vmBridgeAdd.bridge.fxs[1].enablePort, \'btn-danger\': vmBridgeAdd.bridge.fxs[1].invalid}"\r\n                    ng-model="vmBridgeAdd.selectedFxs" uib-btn-radio="2">Fxs 2</button>\r\n        </div>\r\n\r\n        <div ng-repeat="fxsPort in vmBridgeAdd.bridge.fxs" ng-show="vmBridgeAdd.selectedFxs == fxsPort.portNumber">\r\n            <div class="form-group">\r\n                <label class="col-xs-12 control-label" data-translate="bridgeModal.enablePort">Habilitar porta</label>\r\n                <div class="col-xs-12 col-switch">\r\n                    <switch name="bridge-fxs{{fxsPort.portNumber}}-enablePort" ng-model="fxsPort.enablePort"></switch>\r\n                </div>\r\n            </div>\r\n\r\n            <div class="form-group">\r\n                <label class="col-xs-12 control-label" data-translate="bridgeModal.phoneNumber">N\xFAmero do telefone</label>\r\n                <div class="col-xs-12">\r\n                    <input type="text" class="form-control" name="bridge-fxs{{fxsPort.portNumber}}-phoneNumber"\r\n                           ng-model="fxsPort.dialNumber" pattern="^[\\d\\*#]{1,50}$" maxlength="50" \r\n                           placeholder="{{\'bridgeModal.placeholder.phoneNumber\'| translate}}"\r\n                           ng-required="vmBridgeAdd.is8820G() && vmBridgeAdd.validateSaveSipFx({{fxsPort.portNumber}})" ng-disabled="!vmBridgeAdd.is8820G()"\r\n                           uib-tooltip="{{\'tooltip.phoneNumber\'| translate}}" tooltip-placement="left" tooltip-trigger="focus">\r\n                </div>\r\n            </div>\r\n\r\n            <div class="form-group">\r\n                <label class="col-xs-12 control-label" data-translate="bridgeModal.user">Usu\xE1rio</label>\r\n                <div class="col-xs-12">\r\n                    <input type="text" class="form-control" name="bridge-fxs{{fxsPort.portNumber}}-username" ng-model="fxsPort.username" maxlength="50" ng-required="vmBridgeAdd.validateSaveSipFx({{fxsPort.portNumber}})"\r\n                           pattern="{{vmBridgeAdd.fxsCredentials.pattern}}" placeholder="{{\'bridgeModal.placeholder.user\'| translate}}"\r\n                           uib-tooltip="{{vmBridgeAdd.fxsCredentials.username.tooltip}}" tooltip-placement="left" tooltip-trigger="focus">\r\n                </div>\r\n            </div>\r\n\r\n            <div class="form-group">\r\n                <label class="col-xs-12 control-label" data-translate="bridgeModal.password">Senha</label>\r\n                <div class="col-xs-12">\r\n                    <input type="password" class="form-control" name="bridge-fxs{{fxsPort.portNumber}}-password" ng-model="fxsPort.password" maxlength="50" ng-required="vmBridgeAdd.validateSaveSipFx({{fxsPort.portNumber}})"\r\n                           pattern="{{vmBridgeAdd.fxsCredentials.pattern}}" placeholder="{{\'bridgeModal.placeholder.password\'| translate}}" autocomplete="new-password"\r\n                           uib-tooltip="{{vmBridgeAdd.fxsCredentials.password.tooltip}}" tooltip-placement="left" tooltip-trigger="focus">\r\n                </div>\r\n            </div>\r\n\r\n            <div class="form-group">\r\n                <label class="col-xs-16 control-label"><span data-translate="bridgeModal.rxGain">Ganho Rx</span>(dB)</label>\r\n                <div class="col-xs-8">\r\n                    <input type="number" class="form-control" name="bridge-fxs{{fxsPort.portNumber}}-rxGain" ng-model="fxsPort.rxGain" required\r\n                           pattern="\\-?\\d+" min="-12" max="6" placeholder="{{\'bridgeModal.placeholder.number\'| translate}}"\r\n                           uib-tooltip="{{\'tooltip.rxGain\'| translate}}" tooltip-placement="left" tooltip-trigger="focus">\r\n                </div>\r\n            </div>\r\n\r\n            <div class="form-group">\r\n                <label class="col-xs-16 control-label"><span data-translate="bridgeModal.txGain">Ganho Tx</span>(dB)</label>\r\n                <div class="col-xs-8">\r\n                    <input type="number" class="form-control" name="bridge-fxs{{fxsPort.portNumber}}-txGain" ng-model="fxsPort.txGain" required\r\n                           pattern="\\-?\\d+" min="-12" max="6" placeholder="{{\'bridgeModal.placeholder.number\'| translate}}"\r\n                           uib-tooltip="{{\'tooltip.txGain\'| translate}}" tooltip-placement="left" tooltip-trigger="focus">\r\n                </div>\r\n            </div>\r\n\r\n        </div>\r\n    </div>    \r\n\r\n</div>\r\n');
$templateCache.put('app/components/bridge/partials/bridge-config-stp.html','<div class="combo-title">\n    <span data-translate="bridgeModal.spanningTreeProtocol">Spanning Tree Protocol</span>\n</div>\n\n<div class="content-block">\n    <div class="form-group">\n        <label class="col-xs-12 control-label" data-translate="bridgeModal.stp">STP</label>\n        <div class="col-xs-12 col-switch">\n            <switch class="green" name="bridge-stp" ng-model="vmBridgeAdd.bridge.stp.value" disabled="vmBridgeAdd.bridge.stp.disabled"></switch>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/components/bridge/partials/bridge-config-video.html','<div class="combo-title">\n    <span data-translate="bridgeModal.videoSettings">Configura\xE7\xF5es de Video</span>\n</div>\n\n<div class="content-block" ng-if="vmBridgeAdd.bridge.interface.value == \'OLT\'">\n    <div class="form-group">\n        <label class="col-xs-12 control-label" data-translate="bridgeModal.igmpproxy">IGMPPROXY</label>\n        <div class="col-xs-12 col-switch">\n            <switch class="green" name="bridge-igmpproxy" ng-model="vmBridgeAdd.bridge.igmpProxy.value" disabled="vmBridgeAdd.bridge.igmpProxy.disabled"></switch>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-xs-12 control-label" data-translate="bridgeModal.igmpsendip">IGMP Send IP</label>\n        <div class="col-xs-12">\n            <input type="text" class="form-control" name="bridge-igmpsendip" ng-model="vmBridgeAdd.bridge.igmpSendIp.value" maxlength="15" placeholder="XXX.XXX.XXX.XXX"\n                   pattern="^((25[0-4]|2[0-4][0-9]|[01]?[0-9][0-9]?){1}(\\.)){3}(25[0-4]|2[0-4][0-9]|[01]?[0-9][0-9]?)$"\n                   ng-disabled="vmBridgeAdd.bridge.igmpSendIp.disabled"\n                   uib-tooltip="{{\'tooltip.ip.invalid\'| translate}}" tooltip-trigger="focus" tooltip-placement="right">\n        </div>\n    </div>\n</div>\n\n<div class="content-block" ng-if="vmBridgeAdd.bridge.interface.value == \'ONU\'">\n    <div class="form-group">\n        <label class="col-xs-18 control-label" data-translate="bridgeModal.multicastControlList">Lista de controle de Multicast</label>\n        <div class="col-xs-6">\n            <ui-select name="bridge-multicastlist" ng-model="vmBridgeAdd.bridge.multicastList.model" search-enabled="false"\n                       ng-disabled="vmBridgeAdd.bridge.multicastList.disabled">\n                <ui-select-match>{{vmBridgeAdd.bridge.multicastList.model.listId}}</ui-select-match>\n                <ui-select-choices repeat="multicastList in vmBridgeAdd.multicastList">{{multicastList.listId}}</ui-select-choices>\n            </ui-select>\n        </div>\n    </div>\n\n    <div class="form-group">\n        <label class="col-xs-18 control-label multiline" data-translate="bridgeModal.maxMulticastStreams">N\xFAmero m\xE1ximo de Multicast Streams</label>\n        <div class="col-xs-6">\n            <input type="number" class="form-control" name="bridge-maxmulticast" ng-model="vmBridgeAdd.bridge.maxMulticastStreams.value"\n                   min="{{vmBridgeAdd.bridge.maxMulticastStreams.min}}" max="{{vmBridgeAdd.bridge.maxMulticastStreams.max}}" maxlength="3"\n                   pattern="\\d+" placeholder="{{\'bridgeModal.placeholder.number\'| translate}}"\n                   ng-disabled="vmBridgeAdd.bridge.maxMulticastStreams.disabled" ng-required="!vmBridgeAdd.bridge.maxMulticastStreams.disabled"\n                   uib-tooltip="{{vmBridgeAdd.bridge.maxMulticastStreams.tooltip}}" tooltip-trigger="focus" tooltip-placement="right">\n        </div>\n    </div>\n</div>');
$templateCache.put('app/components/onu/templates/pager.html','<ul class="pager">\n    <li ng-class="{disabled: noPrevious() || ngDisabled, previous: align}"><a href ng-click="selectPage(page - 1, $event)">{{::getText(\'previous\')}}</a></li>\n    <li class="page-number">OLT {{page}}/{{totalPages}}</li>\n    <li ng-class="{disabled: noNext() || ngDisabled, next: align}"><a href ng-click="selectPage(page + 1, $event)">{{::getText(\'next\')}}</a></li>\n</ul>');
$templateCache.put('app/shared/layout/main/main.html','<div ui-view="navbar" class="navbar-container" ng-cloak></div>\n\n<div class="container-fluid main-container" ui-view="content"></div>\n');
$templateCache.put('app/shared/layout/navbar/navbar.html','<header>\n    <nav class="navbar">\n\n        <div class="navbar-header clearfix">\n\n            <a class="navbar-brand" href="#"><img src="assets/images/logo.png" alt="Intelbras GPon"></a>\n            <button type="button" class="btn btn-primary btn-logout" data-translate="global.button.logout" ng-click="vmNavbar.logout()">Sair</button>\n            <ul class="nav navbar-nav navbar-right nav-lang">\n                <li><span data-translate="global.version"></span></li>\n                <li>|</li>\n                <li><span data-translate="global.menu.language">Linguagem</span></li>\n                <li ng-cloak uib-dropdown class="dropdown-default pointer" ng-controller="LanguageController as languageVm">\n                    <a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1">\n                        <span data-translate="global.menu.lang">PT</span>\n                        <b class="caret"></b>\n                    </a>\n                    <ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1">\n                        <li active-menu="{{language}}" ng-repeat="language in languageVm.languages">\n                            <a href="" ng-click="languageVm.changeLanguage(language);">{{language| findLanguageFromKey}}</a>\n                        </li>\n                    </ul>\n                </li>\n            </ul>\n\n        </div>\n\n        <div class="navbar-menu">\n            <ul class="nav navbar-nav clearfix">\n                <li class="menu-item" ui-sref-active="active">\n                    <a href="/olt" ui-sref="olt" id="btn-olt" data-translate="global.menu.olt">OLT</a>\n                </li>\n                <li class="menu-item" ui-sref-active="active">\n                    <a href="/onu" ui-sref="onu" id="btn-onu" data-translate="global.menu.onu">ONU</a>\n                </li>\n                <li class="menu-item" ui-sref-active="active">\n                    <a href="/provisioning" ui-sref="provisioning" id="btn-servico" data-translate="global.menu.service">Servi\xE7o</a>\n                </li>\n                <!--<li class="menu-item" ui-sref-active="active">\n                    <a href="/alarms" ui-sref="alarms" id="btn-alarm" data-translate="global.menu.alarm">Alarmes</a>\n                </li> -->\n                <li class="menu-item" ui-sref-active="active">\n                    <a href="/config" ui-sref="config" id="btn-config" data-translate="global.menu.config">Usu\xE1rio</a>\n                </li>\n            </ul>\n        </div>\n\n    </nav>\n</header>');}]);})();